import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Money: any;
  Timestamp: any;
  Upload: any;
  _FieldSet: any;
};

export type ActivitiesResult = {
  __typename?: 'ActivitiesResult';
  activities: Array<Activity>;
};

export type Activity = {
  __typename?: 'Activity';
  change?: Maybe<ActivityChangeDetail>;
  courierId: Scalars['ID'];
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: ActivityEntityType;
  id: Scalars['ID'];
  infoType: ActivityInfoType;
  time: Scalars['Timestamp'];
  updatedByDriver?: Maybe<Driver>;
  updatedByEndCustomer?: Maybe<EndCustomer>;
  updatedByEndUser?: Maybe<EndUser>;
  updatedByUser?: Maybe<CourieUser>;
};

export type ActivityChangeDetail = {
  __typename?: 'ActivityChangeDetail';
  new?: Maybe<ActivitySnapshot>;
  old?: Maybe<ActivitySnapshot>;
};

export enum ActivityEntityType {
  Driver = 'DRIVER',
  EndCustomer = 'END_CUSTOMER',
  Invoice = 'INVOICE',
  Shipment = 'SHIPMENT'
}

export enum ActivityInfoType {
  Danger = 'DANGER',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type ActivitySnapshot = {
  __typename?: 'ActivitySnapshot';
  entries?: Maybe<Array<Maybe<ActivitySnapshotEntry>>>;
  value?: Maybe<Scalars['String']>;
};

export type ActivitySnapshotEntry = {
  __typename?: 'ActivitySnapshotEntry';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type AddressBookEntry = {
  __typename?: 'AddressBookEntry';
  companyName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  endCustomer?: Maybe<EndCustomer>;
  endCustomerId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  location: Location;
  phone?: Maybe<Scalars['String']>;
  suite?: Maybe<Scalars['String']>;
};

export type AddressBookEntryConnection = {
  __typename?: 'AddressBookEntryConnection';
  edges?: Maybe<Array<Maybe<AddressBookEntryEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AddressBookEntryEdge = {
  __typename?: 'AddressBookEntryEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AddressBookEntry>;
};

export enum AddressBookSortField {
  CompanyName = 'COMPANY_NAME',
  ContactName = 'CONTACT_NAME',
  CreatedAt = 'CREATED_AT',
  EndCustomer = 'END_CUSTOMER'
}

export type AddressBookSorting = {
  direction: SortingDirection;
  field: AddressBookSortField;
};

export type AddressPrediction = {
  __typename?: 'AddressPrediction';
  description: Scalars['String'];
  googlePlaceId: Scalars['String'];
  matchedSubstrings: Array<MatchedSubstring>;
};

export type AdjustmentOverrideInput = {
  adjustmentId: Scalars['ID'];
  amount: Scalars['Money'];
};

export type AlternateUniverseDriverDayOverview = {
  __typename?: 'AlternateUniverseDriverDayOverview';
  routeWithShipmentAssignmentOrder: RouteOverview;
};

export enum ApiProvider {
  QuickbookOnline = 'QUICKBOOK_ONLINE'
}

export type Artifact = {
  __typename?: 'Artifact';
  actions: Array<ArtifactAction>;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  publicUrl?: Maybe<Scalars['String']>;
  shipmentId?: Maybe<Scalars['ID']>;
  stopId?: Maybe<Scalars['ID']>;
  taskId?: Maybe<Scalars['ID']>;
  type: ArtifactType;
  value?: Maybe<Scalars['String']>;
};

export type ArtifactAction = {
  __typename?: 'ArtifactAction';
  artifactId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  stopId?: Maybe<Scalars['ID']>;
  taskId?: Maybe<Scalars['ID']>;
  type: ArtifactActionType;
};

export enum ArtifactActionType {
  ConfirmScan = 'CONFIRM_SCAN',
  CreateScan = 'CREATE_SCAN',
  Sign = 'SIGN',
  TakePhoto = 'TAKE_PHOTO',
  UploadDocument = 'UPLOAD_DOCUMENT'
}

export enum ArtifactType {
  BarCode = 'BAR_CODE',
  DocumentFile = 'DOCUMENT_FILE',
  PhotoFile = 'PHOTO_FILE',
  QrCode = 'QR_CODE',
  SignatureFile = 'SIGNATURE_FILE'
}

export type BankAccountDetail = {
  __typename?: 'BankAccountDetail';
  bankCode: Scalars['String'];
  maskedAccountNumber: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type BiWeeklySchedule = {
  __typename?: 'BiWeeklySchedule';
  startDateISO8601: Scalars['String'];
};

export type BiWeeklyScheduleInput = {
  startDateISO8601: Scalars['String'];
};

export type BulkInvoiceApprovalFailure = {
  __typename?: 'BulkInvoiceApprovalFailure';
  invoiceId: Scalars['ID'];
  message: Scalars['String'];
};

export type BulkInvoiceApprovalResult = {
  __typename?: 'BulkInvoiceApprovalResult';
  approved: Array<Invoice>;
  failures: Array<BulkInvoiceApprovalFailure>;
};

export type BulkMultiplyPricingRulesResult = {
  __typename?: 'BulkMultiplyPricingRulesResult';
  numSuccess: Scalars['Int'];
};

export type BulkUploadEndCustomersResult = {
  __typename?: 'BulkUploadEndCustomersResult';
  errors?: Maybe<Array<BulkUploadEndCustomersRowError>>;
  numSuccess: Scalars['Int'];
};

export type BulkUploadEndCustomersRowError = {
  __typename?: 'BulkUploadEndCustomersRowError';
  messages: Array<Scalars['String']>;
  rowNumber: Scalars['Int'];
};

export type BulkUploadOrdersResult = {
  __typename?: 'BulkUploadOrdersResult';
  error?: Maybe<CsvValidationError>;
  numSuccess: Scalars['Int'];
};

export type BulkUploadPricingRulesResult = {
  __typename?: 'BulkUploadPricingRulesResult';
  errors?: Maybe<Array<BulkUploadPricingRulesRowError>>;
  numSuccess: Scalars['Int'];
};

export type BulkUploadPricingRulesRowError = {
  __typename?: 'BulkUploadPricingRulesRowError';
  messages: Array<Scalars['String']>;
  rowNumber: Scalars['Int'];
};

export type CityStateCountryCreate = {
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
};

export enum CommunicationTypeId {
  DropOffOtw = 'DROP_OFF_OTW',
  Invoice = 'INVOICE',
  OrderClosed = 'ORDER_CLOSED',
  OrderCreated = 'ORDER_CREATED',
  OrderDelivered = 'ORDER_DELIVERED',
  PickUpOtw = 'PICK_UP_OTW'
}

export type CompleteTaskInput = {
  driverNote?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
};

export type CostCenter = {
  __typename?: 'CostCenter';
  email?: Maybe<Scalars['String']>;
  endCustomerId: Scalars['ID'];
  id: Scalars['ID'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  suite?: Maybe<Scalars['String']>;
};

export type CostCenterCreate = {
  email?: InputMaybe<Scalars['String']>;
  endCustomerId: Scalars['ID'];
  googlePlaceId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
};

export type CourieUser = {
  __typename?: 'CourieUser';
  courierId?: Maybe<Scalars['ID']>;
  email: Scalars['String'];
  firebaseUid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  profilePhotoUrl?: Maybe<Scalars['String']>;
};

export type CourieUserConnection = {
  __typename?: 'CourieUserConnection';
  edges?: Maybe<Array<Maybe<CourieUserEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CourieUserEdge = {
  __typename?: 'CourieUserEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CourieUser>;
};

export type Courier = {
  __typename?: 'Courier';
  customFields: Array<CustomField>;
  customerLoginImageUrl?: Maybe<Scalars['String']>;
  customerPortalAdditionalRequiredFields: Array<CustomerPortalAdditionalRequiredFields>;
  customerPortalOrderEntryType: CustomerPortalOrderEntryType;
  customerPortalPath?: Maybe<Scalars['String']>;
  defaultCurrency?: Maybe<Scalars['String']>;
  dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>;
  displayName: Scalars['String'];
  driverPodRequirementType: DriverPodRequirementType;
  driverPriceVisibilityType: DriverPriceVisibilityType;
  driverTaskVisibilityType: DriverTaskVisibilityType;
  enabledCommunicationTypes: Array<CommunicationTypeId>;
  endCustomerPriceVisibilityType: EndCustomerPriceVisibilityType;
  finixMerchantId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  packageTypes: Array<PackageType>;
  primaryEmail?: Maybe<Scalars['String']>;
  primaryLocation?: Maybe<Location>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  timeZoneId: Scalars['String'];
  vehicleTypes: Array<VehicleType>;
};

export type CourierHoliday = {
  __typename?: 'CourierHoliday';
  id: Scalars['ID'];
  name: Scalars['String'];
  recurrenceRule: Scalars['String'];
};

export type CreditCardDetail = {
  __typename?: 'CreditCardDetail';
  brand: Scalars['String'];
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  lastFour: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type CsvValidationCellError = {
  __typename?: 'CsvValidationCellError';
  columnName?: Maybe<Scalars['String']>;
  errorMessage: Scalars['String'];
};

export type CsvValidationError = {
  __typename?: 'CsvValidationError';
  errorMessages: Array<Scalars['String']>;
  lineErrors: Array<CsvValidationLineError>;
};

export type CsvValidationLineError = {
  __typename?: 'CsvValidationLineError';
  cellErrors: Array<CsvValidationCellError>;
  lineNumber: Scalars['Int'];
};

export type CustomField = {
  __typename?: 'CustomField';
  customerSpecificityType: CustomFieldCustomerSpecificity;
  customerVisibilityType: CustomFieldCustomerVisibilityType;
  id: Scalars['ID'];
  name: Scalars['String'];
  requirementType: CustomFieldCustomerRequirementType;
  type: CustomFieldType;
};

export enum CustomFieldCustomerRequirementType {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export enum CustomFieldCustomerSpecificity {
  EndCustomerSpecific = 'END_CUSTOMER_SPECIFIC',
  Public = 'PUBLIC'
}

export enum CustomFieldCustomerVisibilityType {
  CustomerCreatable = 'CUSTOMER_CREATABLE',
  CustomerReadOnly = 'CUSTOMER_READ_ONLY',
  DispatcherOnly = 'DISPATCHER_ONLY'
}

export enum CustomFieldType {
  Text = 'TEXT'
}

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue';
  courierId: Scalars['ID'];
  entityId: Scalars['String'];
  field: CustomField;
  fieldId: Scalars['ID'];
  valueDisplay: Scalars['String'];
  valueText?: Maybe<Scalars['String']>;
};

export type CustomFieldValueInput = {
  fieldId: Scalars['ID'];
  valueText?: InputMaybe<Scalars['String']>;
};

export enum CustomerPortalAdditionalRequiredFields {
  PackageDescription = 'PACKAGE_DESCRIPTION',
  PackageQuantity = 'PACKAGE_QUANTITY',
  PackageSize = 'PACKAGE_SIZE',
  PackageType = 'PACKAGE_TYPE',
  PackageWeight = 'PACKAGE_WEIGHT',
  ReferenceNumber = 'REFERENCE_NUMBER',
  ServiceType = 'SERVICE_TYPE'
}

export enum CustomerPortalOrderEntryType {
  Form = 'FORM',
  Wizard = 'WIZARD'
}

export enum DayOfTheWeek {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export enum DispatchPageType {
  DriverSchedule = 'DRIVER_SCHEDULE',
  Fleet = 'FLEET',
  Orders = 'ORDERS'
}

export type DispatchPreview = {
  __typename?: 'DispatchPreview';
  distanceAdditionalInMeters?: Maybe<Scalars['Float']>;
  distanceInMeters?: Maybe<Scalars['Float']>;
  driver: Driver;
  durationAdditionalInSeconds?: Maybe<Scalars['Float']>;
  durationInSeconds?: Maybe<Scalars['Float']>;
  numCurrentTasks: Scalars['Int'];
  remainingWorkloadInSeconds?: Maybe<Scalars['Float']>;
  shipment: Shipment;
  shipmentDate: Scalars['Date'];
  shipmentId: Scalars['ID'];
  tags: Array<DispatchPreviewTag>;
};

export enum DispatchPreviewReadyStatus {
  ReadyLater = 'READY_LATER',
  ReadyNow = 'READY_NOW',
  ReadySoon = 'READY_SOON'
}

export type DispatchPreviewSaveInput = {
  distanceAdditionalInMeters?: InputMaybe<Scalars['Float']>;
  distanceInMeters?: InputMaybe<Scalars['Float']>;
  driverId: Scalars['ID'];
  durationAdditionalInSeconds?: InputMaybe<Scalars['Float']>;
  durationInSeconds?: InputMaybe<Scalars['Float']>;
  numCurrentTasks: Scalars['Int'];
  remainingWorkloadInSeconds?: InputMaybe<Scalars['Float']>;
  section?: InputMaybe<Scalars['String']>;
  shipmentId: Scalars['ID'];
  tags: Array<DispatchPreviewTag>;
};

export enum DispatchPreviewTag {
  Closest = 'CLOSEST',
  FastestDelivery = 'FASTEST_DELIVERY',
  LeastDeviation = 'LEAST_DEVIATION',
  LeastTasks = 'LEAST_TASKS',
  LeastWorkload = 'LEAST_WORKLOAD',
  NoTask = 'NO_TASK'
}

export enum DispatchSource {
  Dispatcher = 'DISPATCHER',
  Driver = 'DRIVER'
}

export type DispatchStopsOnDayInput = {
  autoRoutedStopIds?: InputMaybe<Array<Scalars['ID']>>;
  orderingAlgorithmType: OrderingAlgorithmType;
  stopDate: Scalars['Date'];
  stopIds: Array<Scalars['ID']>;
};

export enum DispatcherOrderEntryAdditionalField {
  ReadyTime = 'READY_TIME',
  ReferenceNumber = 'REFERENCE_NUMBER',
  ServiceType = 'SERVICE_TYPE'
}

export type Driver = {
  __typename?: 'Driver';
  baseWorkSchedule?: Maybe<DriverWorkSchedule>;
  commission?: Maybe<Scalars['Money']>;
  courier: Courier;
  courierId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  employmentType?: Maybe<DriverEmploymentType>;
  firstName: Scalars['String'];
  homeLocation?: Maybe<Location>;
  homeLocationId?: Maybe<Scalars['ID']>;
  hourlyRateOvertime: Scalars['Money'];
  hourlyRateRegular: Scalars['Money'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  lastName: Scalars['String'];
  lastReportedLocation?: Maybe<DriverLocation>;
  locationHistory: Array<DriverLocation>;
  middleName?: Maybe<Scalars['String']>;
  mileageRate: Scalars['Money'];
  numRecurringStops: Scalars['Int'];
  phone: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  remoteEntities: Array<RemoteEntity>;
  selfRoutingType: DriverSelfRoutingType;
  speed: Scalars['Float'];
  tasks: Array<Task>;
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['ID']>;
  vehicleType?: Maybe<VehicleType>;
  workType: DriverWorkType;
};


export type DriverLocationHistoryArgs = {
  after?: InputMaybe<Scalars['Timestamp']>;
  before?: InputMaybe<Scalars['Timestamp']>;
  date?: InputMaybe<Scalars['Date']>;
};


export type DriverNumRecurringStopsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type DriverTasksArgs = {
  date?: InputMaybe<Scalars['Date']>;
  maxDate?: InputMaybe<Scalars['Date']>;
  minDate?: InputMaybe<Scalars['Date']>;
  statusFilter?: InputMaybe<Array<TaskStatus>>;
};

export type DriverBreadcrumb = {
  __typename?: 'DriverBreadcrumb';
  curves: Array<DriverBreadcrumbCurve>;
  driverId: Scalars['ID'];
};

export type DriverBreadcrumbCurve = {
  __typename?: 'DriverBreadcrumbCurve';
  locations: Array<DriverLocation>;
};

export type DriverCompensation = {
  commission?: InputMaybe<Scalars['Money']>;
  hourlyRateOvertime: Scalars['Money'];
  hourlyRateRegular: Scalars['Money'];
  mileageRate: Scalars['Money'];
};

export type DriverConnection = {
  __typename?: 'DriverConnection';
  edges?: Maybe<Array<Maybe<DriverEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type DriverDailyWork = {
  __typename?: 'DriverDailyWork';
  dailyOvertimeWorkDuration: Scalars['Int'];
  dailyRegularWorkDuration: Scalars['Int'];
  date: Scalars['Date'];
  isConsistentEvents: Scalars['Boolean'];
  milesByOdometer: Scalars['Int'];
  workDurationInMinutes: Scalars['Int'];
};

export type DriverDayOverview = {
  __typename?: 'DriverDayOverview';
  alternateUniverseDay: AlternateUniverseDriverDayOverview;
  date: Scalars['Date'];
  distanceSavedInMeters?: Maybe<Scalars['Float']>;
  driverId: Scalars['ID'];
  durationSavedInSeconds?: Maybe<Scalars['Float']>;
  routeOverview: RouteOverview;
};

export type DriverDaysOverview = {
  __typename?: 'DriverDaysOverview';
  distanceSavedInMeters: Scalars['Float'];
  driverId: Scalars['ID'];
  durationSavedInSeconds: Scalars['Float'];
  overviews: Array<DriverDayOverview>;
  totalDistanceInMeters: Scalars['Float'];
  totalDistanceInMetersAlternate: Scalars['Float'];
  totalDurationInSeconds: Scalars['Float'];
  totalDurationInSecondsAlternate: Scalars['Float'];
};

export type DriverDefaultRoutingConfiguration = {
  __typename?: 'DriverDefaultRoutingConfiguration';
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  endLocation?: Maybe<Location>;
  endLocationId?: Maybe<Scalars['ID']>;
  endTime?: Maybe<Scalars['Timestamp']>;
  isWorkDay?: Maybe<Scalars['Boolean']>;
  startLocation?: Maybe<Location>;
  startLocationId?: Maybe<Scalars['ID']>;
  startTime?: Maybe<Scalars['Timestamp']>;
  useCurrentLocationAtStart?: Maybe<Scalars['Boolean']>;
};

export type DriverEdge = {
  __typename?: 'DriverEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Driver>;
};

export enum DriverEmploymentType {
  Employee = 'EMPLOYEE',
  IndependentContractor = 'INDEPENDENT_CONTRACTOR'
}

export type DriverFullUpdate = {
  commission?: InputMaybe<Scalars['Money']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  homeLocationId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  selfRoutingType?: InputMaybe<DriverSelfRoutingType>;
  speed?: InputMaybe<Scalars['Float']>;
  workType?: InputMaybe<DriverWorkType>;
};

export type DriverLocation = {
  __typename?: 'DriverLocation';
  lastReportedTime: Scalars['Timestamp'];
  lngLat: LngLat;
};

export type DriverPayAllocation = {
  __typename?: 'DriverPayAllocation';
  allocationRate: Scalars['Money'];
  driverId: Scalars['ID'];
  id: Scalars['ID'];
  shipmentId: Scalars['ID'];
};

export type DriverPayAllocationInput = {
  allocationRate: Scalars['Money'];
  driverId: Scalars['ID'];
};

export type DriverPayAllocationReplacement = {
  allocations: Array<DriverPayAllocationInput>;
  shipmentId: Scalars['ID'];
};

export type DriverPayDeduction = {
  __typename?: 'DriverPayDeduction';
  amount: Scalars['Money'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DriverPayDeductionValueInput = {
  amount: Scalars['Money'];
  name: Scalars['String'];
};

export type DriverPayEntry = {
  __typename?: 'DriverPayEntry';
  amountTotal: Scalars['Money'];
  deductionsTotal: Scalars['Money'];
  driver: Driver;
  driverId: Scalars['ID'];
  endDate: Scalars['Date'];
  id: Scalars['ID'];
  ordersCount: Scalars['Int'];
  pdfFile: PayrollReportFile;
  remoteEntities: Array<RemoteEntity>;
  startDate: Scalars['Date'];
  status: DriverPayStatus;
};

export enum DriverPayStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING'
}

export enum DriverPayrollSortField {
  AmountTotal = 'AMOUNT_TOTAL',
  DriverFirstName = 'DRIVER_FIRST_NAME',
  DriverLastName = 'DRIVER_LAST_NAME',
  NumOrders = 'NUM_ORDERS'
}

export type DriverPayrollSorting = {
  direction: SortingDirection;
  field: DriverPayrollSortField;
};

export enum DriverPodRequirementType {
  DropOffOnly = 'DROP_OFF_ONLY',
  DropOffOnlyPhotoAndSignature = 'DROP_OFF_ONLY_PHOTO_AND_SIGNATURE',
  None = 'NONE',
  PickupAndDropOff = 'PICKUP_AND_DROP_OFF',
  PickupAndDropOffPhotoAndSignature = 'PICKUP_AND_DROP_OFF_PHOTO_AND_SIGNATURE'
}

export enum DriverPriceVisibilityType {
  None = 'NONE',
  ShowDriverPay = 'SHOW_DRIVER_PAY',
  ShowFullPrice = 'SHOW_FULL_PRICE'
}

export enum DriverReportColumnId {
  Driver = 'DRIVER',
  MileageReimbursement = 'MILEAGE_REIMBURSEMENT',
  MileageReimbursementMethod = 'MILEAGE_REIMBURSEMENT_METHOD',
  NumCompletedOrder = 'NUM_COMPLETED_ORDER',
  NumDaysWorked = 'NUM_DAYS_WORKED',
  OvertimeHourlyRate = 'OVERTIME_HOURLY_RATE',
  OvertimeWorkDuration = 'OVERTIME_WORK_DURATION',
  RegularHourlyRate = 'REGULAR_HOURLY_RATE',
  RegularWorkDuration = 'REGULAR_WORK_DURATION',
  ReimbursementPerMile = 'REIMBURSEMENT_PER_MILE',
  SuggestedBonus = 'SUGGESTED_BONUS',
  TotalCommission = 'TOTAL_COMMISSION',
  TotalMilesByGps = 'TOTAL_MILES_BY_GPS',
  TotalMilesByOdometer = 'TOTAL_MILES_BY_ODOMETER',
  TotalPay = 'TOTAL_PAY',
  TotalWorkDuration = 'TOTAL_WORK_DURATION',
  WageOvertime = 'WAGE_OVERTIME',
  WageRegular = 'WAGE_REGULAR',
  WageTotal = 'WAGE_TOTAL',
  WageTotalWithMileageReimbursement = 'WAGE_TOTAL_WITH_MILEAGE_REIMBURSEMENT'
}

export type DriverReportItem = {
  __typename?: 'DriverReportItem';
  deductions: Array<PayrollDeductionAmount>;
  driver: Driver;
  driverId: Scalars['String'];
  endDate: Scalars['Date'];
  mileageReimbursement: Scalars['Money'];
  mileageReimbursementMethod: DriversMileageReimbursementMethod;
  numCompletedOrder: Scalars['Int'];
  numDaysWorked: Scalars['Int'];
  overtimeDailyCalculatedWorkDurationInMinutes: Scalars['Int'];
  overtimeHourlyRate: Scalars['Money'];
  regularDailyCalculatedWorkDurationInMinutes: Scalars['Int'];
  regularHourlyRate: Scalars['Money'];
  reimbursementPerMile: Scalars['Money'];
  startDate: Scalars['Date'];
  suggestedBonus: Scalars['Money'];
  totalCommission: Scalars['Money'];
  totalMilesByGPS: Scalars['Int'];
  totalMilesByOdometer: Scalars['Int'];
  totalPay: Scalars['Money'];
  totalWorkDurationInMinutes: Scalars['Int'];
  wageOvertime: Scalars['Money'];
  wageRegular: Scalars['Money'];
  wageTotal: Scalars['Money'];
  wageTotalWithMileageReimbursement: Scalars['Money'];
  workDurations: Array<DriverDailyWork>;
};

export type DriverScheduleForDate = {
  __typename?: 'DriverScheduleForDate';
  completedShipments: Array<Shipment>;
  confirmedAt?: Maybe<Scalars['Timestamp']>;
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  emailSentAt?: Maybe<Scalars['Timestamp']>;
  hasWorkloadChanged?: Maybe<Scalars['Boolean']>;
  labels: Array<Scalars['String']>;
  shipmentTemplates: Array<ShipmentTemplate>;
  shipments: Array<Shipment>;
  timeBlocks: Array<DriverScheduleTimeBlock>;
};

export type DriverScheduleForDates = {
  __typename?: 'DriverScheduleForDates';
  driver: Driver;
  schedule: Array<DriverScheduleForDate>;
};

export type DriverScheduleTimeBlock = {
  __typename?: 'DriverScheduleTimeBlock';
  end: Scalars['Timestamp'];
  start: Scalars['Timestamp'];
};

export type DriverScheduleTimeBlockInput = {
  end: Scalars['Timestamp'];
  start: Scalars['Timestamp'];
};

export type DriverScheduleWeekDaily = {
  __typename?: 'DriverScheduleWeekDaily';
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type DriverScheduleWeekDailyInput = {
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type DriverSchedulesResult = {
  __typename?: 'DriverSchedulesResult';
  driverSchedules: Array<DriverScheduleForDates>;
  unassignedShipments: Array<UnassignedShipmentsForDate>;
};

export enum DriverSelfRoutingType {
  CanSelfRoute = 'CAN_SELF_ROUTE',
  None = 'NONE'
}

export enum DriverSortField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  IsActive = 'IS_ACTIVE',
  LastName = 'LAST_NAME',
  WorkType = 'WORK_TYPE'
}

export type DriverSorting = {
  direction: SortingDirection;
  field: DriverSortField;
};

export enum DriverTaskVisibilityType {
  AllTasks = 'ALL_TASKS',
  OnlyNextTask = 'ONLY_NEXT_TASK'
}

export type DriverTimeEvent = {
  __typename?: 'DriverTimeEvent';
  courierId: Scalars['ID'];
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  eventAt: Scalars['Timestamp'];
  eventType: DriverTimeEventType;
  id: Scalars['ID'];
  odometerInMiles?: Maybe<Scalars['Int']>;
  reason?: Maybe<DriverTimeEventReason>;
  updatedBy: Scalars['ID'];
};

export type DriverTimeEventCreateInput = {
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  eventAt: Scalars['Timestamp'];
  eventType: DriverTimeEventType;
  odometerInMiles?: InputMaybe<Scalars['Int']>;
  reason: DriverTimeEventReason;
};

export enum DriverTimeEventReason {
  LunchBreak = 'LUNCH_BREAK',
  WorkStartEnd = 'WORK_START_END'
}

export enum DriverTimeEventType {
  TimeIn = 'TIME_IN',
  TimeOut = 'TIME_OUT'
}

export type DriverTimeEventUpdateInput = {
  eventAt: Scalars['Timestamp'];
  eventType: DriverTimeEventType;
  id: Scalars['ID'];
  odometerInMiles?: InputMaybe<Scalars['Int']>;
  reason: DriverTimeEventReason;
};

export type DriverWorkSchedule = {
  __typename?: 'DriverWorkSchedule';
  weekDailyList: Array<DriverScheduleWeekDaily>;
};

export type DriverWorkScheduleInput = {
  weekDailyList: Array<DriverScheduleWeekDailyInput>;
};

export enum DriverWorkType {
  Regular = 'REGULAR',
  Specialized = 'SPECIALIZED'
}

export enum DriversMileageReimbursementMethod {
  ByGps = 'BY_GPS',
  ByOdometer = 'BY_ODOMETER',
  NoMileageReimbursement = 'NO_MILEAGE_REIMBURSEMENT'
}

export type EndCustomer = {
  __typename?: 'EndCustomer';
  additionalRequiredFields?: Maybe<Array<CustomerPortalAdditionalRequiredFields>>;
  billingEmails: Array<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  costCenters: Array<CostCenter>;
  courier: Courier;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  customFields?: Maybe<Array<CustomField>>;
  dispatcherOrderEntryAdditionalFields?: Maybe<Array<DispatcherOrderEntryAdditionalField>>;
  displayId: Scalars['Int'];
  enabledCommunicationTypes: Array<CommunicationTypeId>;
  endCustomerCreatedSource?: Maybe<EndCustomerCreatedSource>;
  firebaseUid?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoicePdfTemplate?: Maybe<InvoicePdfTemplate>;
  invoicingFrequency?: Maybe<InvoicingFrequency>;
  lastName?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  newCustomerConfirmationStatus: NewCustomerConfirmationStatus;
  note?: Maybe<Scalars['String']>;
  podEmails?: Maybe<Array<Scalars['ID']>>;
  pricingList?: Maybe<PricingList>;
  pricingListId?: Maybe<Scalars['ID']>;
  remoteEntities: Array<RemoteEntity>;
  scanRequirementType: ScanRequirement;
  suite?: Maybe<Scalars['String']>;
  taxCode?: Maybe<Scalars['String']>;
  totalPricingMultiplier: Scalars['Money'];
  visibleServiceTypeIds?: Maybe<Array<Scalars['ID']>>;
};

export type EndCustomerCommunication = {
  __typename?: 'EndCustomerCommunication';
  communicationTypeId?: Maybe<CommunicationTypeId>;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  dateCreated: Scalars['Date'];
  emailId?: Maybe<Scalars['ID']>;
  endCustomerId: Scalars['ID'];
  id: Scalars['ID'];
  idempotencyToken?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  shipmentId?: Maybe<Scalars['ID']>;
  stopId?: Maybe<Scalars['ID']>;
};

export type EndCustomerConnection = {
  __typename?: 'EndCustomerConnection';
  edges?: Maybe<Array<Maybe<EndCustomerEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type EndCustomerCreateInput = {
  companyName?: InputMaybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  courierId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
};

export enum EndCustomerCreatedSource {
  CustomerPortal = 'CUSTOMER_PORTAL',
  User = 'USER'
}

export type EndCustomerEdge = {
  __typename?: 'EndCustomerEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<EndCustomer>;
};

export type EndCustomerFullUpdate = {
  billingEmails?: InputMaybe<Array<Scalars['String']>>;
  companyName?: InputMaybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  invoicePdfTemplateId?: InputMaybe<Scalars['ID']>;
  invoicingFrequency: InvoicingFrequency;
  lastName?: InputMaybe<Scalars['String']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  scanRequirementType?: InputMaybe<ScanRequirement>;
  suite?: InputMaybe<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
  totalPricingMultiplier?: InputMaybe<Scalars['Money']>;
};

export enum EndCustomerPriceVisibilityType {
  None = 'NONE',
  ShowFullPrice = 'SHOW_FULL_PRICE'
}

export enum EndCustomerSortField {
  CompanyName = 'COMPANY_NAME',
  ContactEmail = 'CONTACT_EMAIL',
  CreatedAt = 'CREATED_AT',
  DisplayId = 'DISPLAY_ID',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type EndCustomerSorting = {
  direction: SortingDirection;
  field: EndCustomerSortField;
};

export type EndCustomersOverview = {
  __typename?: 'EndCustomersOverview';
  numUnconfirmedCustomerPortalEndCustomers: Scalars['Int'];
};

/**  Types */
export type EndUser = {
  __typename?: 'EndUser';
  courierId: Scalars['String'];
  email: Scalars['String'];
  endCustomerId: Scalars['String'];
  firebaseUid?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export enum EntityType {
  Bill = 'Bill',
  Company = 'Company',
  CostCenter = 'CostCenter',
  Customer = 'Customer',
  DeductionItem = 'DeductionItem',
  Invoice = 'Invoice',
  Service = 'Service',
  Vendor = 'Vendor'
}

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN'
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN'
}

export type FcmToken = {
  __typename?: 'FcmToken';
  driverId: Scalars['ID'];
  fcmToken: Scalars['String'];
};

export enum FileType {
  Document = 'DOCUMENT',
  Photo = 'PHOTO',
  Signature = 'SIGNATURE'
}

export type GenerateResetPasswordLinkResult = {
  __typename?: 'GenerateResetPasswordLinkResult';
  link?: Maybe<Scalars['String']>;
};

export enum HolidayBehavior {
  Cancel = 'CANCEL',
  NextBusinessDay = 'NEXT_BUSINESS_DAY',
  PreviousBusinessDay = 'PREVIOUS_BUSINESS_DAY'
}

export type HolidaySchedule = {
  __typename?: 'HolidaySchedule';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type HolidayScheduleBehavior = {
  __typename?: 'HolidayScheduleBehavior';
  behavior: HolidayBehavior;
  courierHolidayId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
  name: Scalars['String'];
  recurrenceRule: Scalars['String'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amountTotal: Scalars['Money'];
  communications: Array<EndCustomerCommunication>;
  costCenter?: Maybe<CostCenter>;
  costCenterId?: Maybe<Scalars['String']>;
  courierId: Scalars['String'];
  displayId: Scalars['Int'];
  endCustomer: EndCustomer;
  endCustomerId: Scalars['String'];
  endCustomerPayLink?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  id: Scalars['ID'];
  invoicePaymentStatus: InvoicePaymentStatus;
  isForceGenerated: Scalars['Boolean'];
  paymentSource?: Maybe<InvoicePaymentResource>;
  remoteEntities: Array<RemoteEntity>;
  separateGenerationKey?: Maybe<Scalars['String']>;
  separateGenerationType?: Maybe<SeparateInvoiceGenerationType>;
  startDate: Scalars['Date'];
  status: InvoiceStatus;
};

export type InvoiceBalance = {
  __typename?: 'InvoiceBalance';
  invoiceId: Scalars['ID'];
  remainingBalance: Scalars['Money'];
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum InvoiceDetailColumnFields {
  AllCustomFields = 'ALL_CUSTOM_FIELDS',
  DeliveredAt = 'DELIVERED_AT',
  DeliveryInstruction = 'DELIVERY_INSTRUCTION',
  Destination = 'DESTINATION',
  Distance = 'DISTANCE',
  DriverName = 'DRIVER_NAME',
  EndCustomerReferenceNumber = 'END_CUSTOMER_REFERENCE_NUMBER',
  OrderPlacedBy = 'ORDER_PLACED_BY',
  Origin = 'ORIGIN',
  PackageCount = 'PACKAGE_COUNT',
  PackageSize = 'PACKAGE_SIZE',
  PackageType = 'PACKAGE_TYPE',
  PackageWeight = 'PACKAGE_WEIGHT',
  PickedUpAt = 'PICKED_UP_AT',
  PickupInstruction = 'PICKUP_INSTRUCTION',
  PodSignName = 'POD_SIGN_NAME',
  RoundTripIfApplicable = 'ROUND_TRIP_IF_APPLICABLE',
  SurchargesVisible = 'SURCHARGES_VISIBLE',
  TrackingNumber = 'TRACKING_NUMBER'
}

export type InvoiceDocument = {
  __typename?: 'InvoiceDocument';
  id: Scalars['ID'];
  invoiceId: Scalars['ID'];
  invoicePdfTemplateId?: Maybe<Scalars['ID']>;
  url: Scalars['String'];
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Invoice>;
};

export type InvoiceEmailSendInput = {
  attachCsv: Scalars['Boolean'];
  attachPdf: Scalars['Boolean'];
  emailRecipientsCommaSeparated: Scalars['String'];
  invoiceId: Scalars['ID'];
};

export type InvoiceExtendedDetail = {
  __typename?: 'InvoiceExtendedDetail';
  amountTotal: Scalars['Money'];
  invoice: Invoice;
  shipments: Array<Shipment>;
};

export type InvoicePayment = {
  __typename?: 'InvoicePayment';
  allocatedAmount: Scalars['Money'];
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  invoice: Invoice;
  invoiceId: Scalars['ID'];
  paymentTransferId: Scalars['ID'];
};

export enum InvoicePaymentResource {
  CouriePayment = 'COURIE_PAYMENT',
  Manual = 'MANUAL',
  QuickbookOnlineSync = 'QUICKBOOK_ONLINE_SYNC'
}

export enum InvoicePaymentStatus {
  Paid = 'PAID',
  PartialPaid = 'PARTIAL_PAID',
  PaymentProcessing = 'PAYMENT_PROCESSING',
  Unpaid = 'UNPAID'
}

export enum InvoicePdfColumn {
  Amount = 'AMOUNT',
  CustomDetails = 'CUSTOM_DETAILS',
  Date = 'DATE',
  DateReadyServiceTypeDeliverDate = 'DATE_READY_SERVICE_TYPE_DELIVER_DATE',
  Destination = 'DESTINATION',
  DestinationShortCompanyName = 'DESTINATION_SHORT_COMPANY_NAME',
  DestinationWithTime = 'DESTINATION_WITH_TIME',
  FullBreakdown = 'FULL_BREAKDOWN',
  OrderId = 'ORDER_ID',
  OrderIdCaller = 'ORDER_ID_CALLER',
  Origin = 'ORIGIN',
  OriginShortCompanyName = 'ORIGIN_SHORT_COMPANY_NAME',
  OriginWithTime = 'ORIGIN_WITH_TIME',
  Package = 'PACKAGE',
  ReferencesCostCenter = 'REFERENCES_COST_CENTER',
  ServiceAbbreviated = 'SERVICE_ABBREVIATED',
  ServiceFull = 'SERVICE_FULL',
  SurchargesVisible = 'SURCHARGES_VISIBLE',
  TrackingNumber = 'TRACKING_NUMBER'
}

export type InvoicePdfColumnWithWidth = {
  __typename?: 'InvoicePdfColumnWithWidth';
  column: InvoicePdfColumn;
  widthPercentage: Scalars['Money'];
};

export type InvoicePdfColumnWithWidthInput = {
  column: InvoicePdfColumn;
  widthPercentage: Scalars['Money'];
};

export type InvoicePdfTemplate = {
  __typename?: 'InvoicePdfTemplate';
  borderSize: Scalars['Float'];
  brandColor: Scalars['String'];
  columnsWithWidth: Array<InvoicePdfColumnWithWidth>;
  courierId: Scalars['String'];
  detailColumnFields: Array<InvoiceDetailColumnFields>;
  finalMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  labelColor: Scalars['String'];
  largeTextFontSize: Scalars['Float'];
  marginLeft: Scalars['Float'];
  name: Scalars['String'];
  returnSlipType: InvoiceReturnSlipType;
  separateGenerationType: SeparateInvoiceGenerationType;
  showTableBorder: Scalars['Boolean'];
  smallTextFontSize: Scalars['Float'];
  subtotalGroupedByCustomField?: Maybe<CustomField>;
  subtotalGroupedByCustomFieldId?: Maybe<Scalars['String']>;
  subtotalGroupedByType: InvoiceSubtotalGroupByType;
  subtotalPageBreakType: InvoiceSubtotalPageBreakType;
  summaryDisplayType: InvoiceSummaryDisplayType;
  tableContentFontSize: Scalars['Float'];
};

export type InvoicePdfTemplateConnection = {
  __typename?: 'InvoicePdfTemplateConnection';
  edges?: Maybe<Array<Maybe<InvoicePdfTemplateEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type InvoicePdfTemplateCreateInput = {
  brandColor: Scalars['String'];
  columnsWithWidth: Array<InvoicePdfColumnWithWidthInput>;
  detailColumnFields: Array<InvoiceDetailColumnFields>;
  finalMessage?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  returnSlipType?: InputMaybe<InvoiceReturnSlipType>;
  separateGenerationType: SeparateInvoiceGenerationType;
  subtotalGroupedByCustomFieldId?: InputMaybe<Scalars['String']>;
  subtotalGroupedByType: InvoiceSubtotalGroupByType;
  subtotalPageBreakType: InvoiceSubtotalPageBreakType;
  summaryDisplayType: InvoiceSummaryDisplayType;
};

export type InvoicePdfTemplateEdge = {
  __typename?: 'InvoicePdfTemplateEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<InvoicePdfTemplate>;
};

export type InvoicePdfTemplateUpdateInput = {
  brandColor: Scalars['String'];
  columnsWithWidth: Array<InvoicePdfColumnWithWidthInput>;
  detailColumnFields: Array<InvoiceDetailColumnFields>;
  finalMessage?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  returnSlipType?: InputMaybe<InvoiceReturnSlipType>;
  separateGenerationType: SeparateInvoiceGenerationType;
  subtotalGroupedByCustomFieldId?: InputMaybe<Scalars['String']>;
  subtotalGroupedByType: InvoiceSubtotalGroupByType;
  subtotalPageBreakType: InvoiceSubtotalPageBreakType;
  summaryDisplayType: InvoiceSummaryDisplayType;
};

export enum InvoiceReturnSlipType {
  IncludeInTheBeginning = 'INCLUDE_IN_THE_BEGINNING',
  None = 'NONE'
}

export enum InvoiceSortField {
  DisplayId = 'DISPLAY_ID',
  EndCustomerName = 'END_CUSTOMER_NAME',
  EndDate = 'END_DATE',
  StartDate = 'START_DATE'
}

export type InvoiceSorting = {
  direction: SortingDirection;
  field: InvoiceSortField;
};

export enum InvoiceStatus {
  Approved = 'APPROVED',
  ToReview = 'TO_REVIEW',
  Voided = 'VOIDED'
}

export enum InvoiceSubtotalGroupByType {
  CostCenter = 'COST_CENTER',
  CustomField = 'CUSTOM_FIELD',
  EndCustomerReferenceNumber = 'END_CUSTOMER_REFERENCE_NUMBER',
  None = 'NONE'
}

export enum InvoiceSubtotalPageBreakType {
  None = 'NONE',
  PageBreakEachSubtotal = 'PAGE_BREAK_EACH_SUBTOTAL'
}

export enum InvoiceSummaryDisplayType {
  ByGroupedByField = 'BY_GROUPED_BY_FIELD',
  None = 'NONE'
}

export type InvoicesOverview = {
  __typename?: 'InvoicesOverview';
  numPartialPaid: Scalars['Int'];
  numPaymentProcessing: Scalars['Int'];
  numToReview: Scalars['Int'];
  numUnpaid: Scalars['Int'];
};

export enum InvoicingFrequency {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  PerOrder = 'PER_ORDER',
  SemiMonthly = 'SEMI_MONTHLY',
  Weekly = 'WEEKLY'
}

export type LinkedAccount = {
  __typename?: 'LinkedAccount';
  accountExpiresAt?: Maybe<Scalars['Timestamp']>;
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  isValid: Scalars['Boolean'];
  isValidAndFresh: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  provider: ApiProvider;
  remoteId: Scalars['String'];
};

export type LinkedAccountCreate = {
  accessToken: Scalars['String'];
  accessTokenExpiresInSeconds?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  provider: ApiProvider;
  refreshToken?: InputMaybe<Scalars['String']>;
  refreshTokenExpiresInSeconds?: InputMaybe<Scalars['Int']>;
  remoteId: Scalars['String'];
};

export type LngLat = {
  __typename?: 'LngLat';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type LngLatInput = {
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
};

export type Location = {
  __typename?: 'Location';
  city: Scalars['String'];
  country: Scalars['String'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lngLat: LngLat;
  state: Scalars['String'];
  streetAddress: Scalars['String'];
  zipCode?: Maybe<Scalars['String']>;
};

export type LocationResult = {
  __typename?: 'LocationResult';
  location?: Maybe<Location>;
};

export type LocationsResultOverview = {
  __typename?: 'LocationsResultOverview';
  locations: Array<Location>;
  totalDistanceInMiles?: Maybe<Scalars['Float']>;
};

export type MatchedSubstring = {
  __typename?: 'MatchedSubstring';
  length: Scalars['Int'];
  offset: Scalars['Int'];
};

export type MemorizationOnDay = {
  __typename?: 'MemorizationOnDay';
  dayOfWeek: DayOfTheWeek;
  stopTemplateSequenceNumbers: Array<ScheduledStopTemplateSequenceNumber>;
  unmemorizedShipmentTemplates: Array<ShipmentTemplate>;
};

export type MemorizationResult = {
  __typename?: 'MemorizationResult';
  days: Array<MemorizationOnDay>;
};

export type MonthlySchedule = {
  __typename?: 'MonthlySchedule';
  days: Array<Scalars['Int']>;
};

export type MonthlyScheduleInput = {
  days: Array<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  approveDriverPay: DriverPayEntry;
  approveInvoice: Invoice;
  approveInvoices: BulkInvoiceApprovalResult;
  approveRoutingJob: RoutingJob;
  approveShipmentDetails: Shipment;
  assignDefaultDriverId?: Maybe<Scalars['ID']>;
  assignDriverForShipmentTemplates: Array<ShipmentTemplate>;
  assignDriverVehicleType?: Maybe<Driver>;
  assignPricingListToEndCustomer: EndCustomer;
  autocompleteAddress: Array<AddressPrediction>;
  bulkMultiplyPricingRules: BulkMultiplyPricingRulesResult;
  bulkUnassignDriversFromShipment: Array<Shipment>;
  bulkUploadEndCustomers: BulkUploadEndCustomersResult;
  bulkUploadOrders: BulkUploadOrdersResult;
  bulkUploadPricingRules: BulkUploadPricingRulesResult;
  cancelRoutingJob: RoutingJob;
  changePasswordEndCustomer: EndCustomer;
  completeTaskV1: Task;
  completeTasksInBulkV1: Array<Task>;
  createAddressBook: AddressBookEntry;
  createCostCenter: CostCenter;
  createCustomField: CustomField;
  createDriver: Driver;
  createEndCustomer: EndCustomer;
  createEndUser: EndUser;
  createHolidaySchedule: HolidaySchedule;
  createInvoicePdfTemplate: InvoicePdfTemplate;
  createLiveOrder: Order;
  createOneOffOrder?: Maybe<Scalars['ID']>;
  createOrderAttachments: Array<OrderAttachment>;
  createPackageType: PackageType;
  createPaymentInstrument: PaymentInstrument;
  createPayrollDeductionRule: PayrollDeductionRule;
  createPricingList: PricingList;
  createPricingRule: PricingRule;
  createRecurringOrder?: Maybe<Scalars['ID']>;
  createRoutingJob: RoutingJob;
  createServiceType: ServiceType;
  createSurchargePricingRule: SurchargePricingRule;
  createUser: CourieUser;
  createVehicleType: VehicleType;
  createZipGroup: ZipGroup;
  createZone: Zone;
  createZones: Array<Zone>;
  deleteAddressBook?: Maybe<Scalars['Boolean']>;
  deleteDriver: Driver;
  deleteFirebaseUserForDriver: Driver;
  deleteFirebaseUserForEndCustomer: EndCustomer;
  deleteHolidaySchedule: Scalars['Boolean'];
  deleteHolidayScheduleBehavior: Scalars['Boolean'];
  deleteInvoicePdfTemplate: Scalars['Boolean'];
  deleteLinkedAccount: Scalars['Boolean'];
  deletePackageType: PackageType;
  deletePayrollDeductionRule: PayrollDeductionRule;
  deletePricingList: Scalars['Boolean'];
  deletePricingRule: Scalars['Boolean'];
  deleteServiceType: ServiceType;
  deleteSurchargePricingRule: Scalars['Boolean'];
  deleteVehicleType: VehicleType;
  dispatchDriverForShipment?: Maybe<Scalars['ID']>;
  dispatchDriverForShipmentMultiDay?: Maybe<Scalars['ID']>;
  forceCompleteShipment: Shipment;
  forceCompleteStops: Shipment;
  forceExportDriverPay: DriverPayEntry;
  forceGenerateInvoices: Array<Invoice>;
  forceInstantiateRecurringOrders: Array<Order>;
  fullUpdateAddressBook: AddressBookEntry;
  fullUpdateColumnVisibility: VisibleColumnsConfig;
  fullUpdateCustomField: CustomField;
  fullUpdateDriver: Driver;
  fullUpdateEndCustomer: EndCustomer;
  fullUpdateInvoicePdfTemplate: InvoicePdfTemplate;
  fullUpdateLocation: LocationResult;
  fullUpdateOrder: Order;
  fullUpdatePackageType: PackageType;
  fullUpdatePayrollDeductionRule: PayrollDeductionRule;
  fullUpdatePricingRule: PricingRule;
  fullUpdateRecurringOrder: Order;
  fullUpdateServiceType: ServiceType;
  fullUpdateSurchargePricingRule: SurchargePricingRule;
  fullUpdateUser: CourieUser;
  fullUpdateVehicleType: VehicleType;
  fullUpdateZipGroup: ZipGroup;
  generateCsvForInvoices: Scalars['String'];
  generateOrdersPdf: OrdersFile;
  generatePayrollReport?: Maybe<PayrollReportFile>;
  generatePdfForInvoice: InvoiceDocument;
  generateResetPasswordLink: GenerateResetPasswordLinkResult;
  generateSalesReportCsv?: Maybe<SalesReportFile>;
  getOrCreateLocationFromCoordinate: LocationResult;
  getOrCreateLocations: Array<LocationResult>;
  getOrCreateLocationsWithOverview: LocationsResultOverview;
  getOrForceInstantiateRecurringOrders: Array<Order>;
  getOrGenerateDriverPayEntries: Array<DriverPayEntry>;
  initiateInvoicePayment: InvoicePayment;
  initiateInvoiceRefund: InvoicePayment;
  markAsArrivedV1: Task;
  markCostCenterDeleted?: Maybe<Scalars['Boolean']>;
  markCustomFieldAsDeleted: Scalars['Boolean'];
  markEndCustomerConfirmedAsNew: EndCustomer;
  markEndCustomerDeleted?: Maybe<Scalars['Boolean']>;
  markEndUserAsDeleted: Scalars['ID'];
  markInvoiceAsPaidManually: Array<Invoice>;
  markInvoicePdfTemplateAsDefault: InvoicePdfTemplate;
  markShipmentAsClosed: Shipment;
  markShipmentAsDeleted: Shipment;
  markShipmentAsFailed: Shipment;
  markShipmentTemplatesAsDeleted: Array<ShipmentTemplate>;
  markShipmentsAsClosed: Array<Shipment>;
  markShipmentsAsConfirmed: Array<Shipment>;
  mergeEndCustomers: EndCustomer;
  modifyDriverPayDeductions: DriverPayEntry;
  modifyDriverTimeEvents: Array<DriverTimeEvent>;
  modifyOrderPricing: OrderPrice;
  optimizeRouteForDispatch: OptimizeRouteForDispatchResult;
  overrideAdjustmentAmount: PricingAdjustment;
  overridePodMetadata: Shipment;
  overridePricingDetail: Shipment;
  previewInvoicePdfFromCreate: InvoiceDocument;
  previewInvoicePdfFromUpdate: InvoiceDocument;
  previewOrderPricingModification: PreviewOrderPricingModificationResult;
  previewPrice: PreviewPriceResult;
  proposeShipmentDetails: Shipment;
  randomizeTimes: Scalars['ID'];
  recordDriverLocation: Scalars['ID'];
  recordMobileAppError: Scalars['Boolean'];
  recordOrderClick: Scalars['Boolean'];
  recordPromptAction: PromptAction;
  refreshDispatchPreviews: RefreshDispatchPreviewsResult;
  refreshEtaStale: Driver;
  replaceAllocation: Array<DriverPayAllocation>;
  replaceRoute: Array<Task>;
  replaceRoutingVehicleSequence: Array<RoutingNode>;
  resetShipment: Shipment;
  scanCreate: Artifact;
  scanVerify: Artifact;
  sendCommunicationToEndCustomer?: Maybe<EndCustomerCommunication>;
  sendDriverScheduleConfirmationEmails: Array<Scalars['ID']>;
  sendEmailToDrivers: PayrollEmail;
  sendInvoiceEmail?: Maybe<EndCustomerCommunication>;
  sendPasswordResetEmail?: Maybe<Scalars['Int']>;
  setDriverScheduleOverride: DriverScheduleForDate;
  setEndCustomerRequiredFields: EndCustomer;
  startTaskV1: Task;
  syncDriverWithFirebase: SyncDriverWithFirebaseResult;
  syncEndCustomerWithFirebase: SyncEndCustomerWithFirebaseResult;
  syncUserWithFirebase: SyncUserWithFirebaseResult;
  transferShipment: Array<RoutingNode>;
  unassignDriverFromShipment: Shipment;
  uncloseShipment: Shipment;
  uncloseShipments: Array<Shipment>;
  updateDriverAvailabilityV1: Driver;
  updateDriverBaseWorkSchedule: Driver;
  updateDriverCompensation: Driver;
  updateDriverPayOverride: Order;
  updateDriverReportedWaitTime: Stop;
  updateEnabledEndCustomerCommunicationsTypes: Array<Maybe<CommunicationTypeId>>;
  updateEndCustomerCustomFields: EndCustomer;
  updateEndCustomerNote: EndCustomer;
  updateEndCustomerVisibleServiceTypeIds: EndCustomer;
  updateHolidaySchedule: Scalars['Boolean'];
  updateInternalNote: Shipment;
  updatePodEmails: EndCustomer;
  updatePriceOverrideForRecurringOrder: Order;
  updateReadyTimeSchedule: ServiceType;
  updateZones: Array<Zone>;
  uploadDriverPhoto: Driver;
  uploadFileV1: Artifact;
  upsertFcmTokenV1: FcmToken;
  upsertHolidayScheduleBehavior: Scalars['Boolean'];
  upsertLinkedAccount: LinkedAccount;
  upsertPayrollSettings: PayrollSetting;
  upsertRemoteEntityLinkage: RemoteEntity;
  upsertStopTemplateSequenceNumbers: Array<ScheduledStopTemplateSequenceNumber>;
  voidInvoices: Array<Invoice>;
};


export type MutationApproveDriverPayArgs = {
  driverPayEntryId: Scalars['ID'];
};


export type MutationApproveInvoiceArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationApproveInvoicesArgs = {
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']>;
};


export type MutationApproveRoutingJobArgs = {
  approvedBy: Scalars['String'];
  jobId: Scalars['ID'];
};


export type MutationApproveShipmentDetailsArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  updatedBy: Scalars['String'];
};


export type MutationAssignDefaultDriverIdArgs = {
  newDriverId: Scalars['ID'];
  orderId: Scalars['ID'];
  orderingAlgorithmType: OrderingAlgorithmType;
  stopTemplateIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationAssignDriverForShipmentTemplatesArgs = {
  driverId?: InputMaybe<Scalars['ID']>;
  shipmentTemplateIds: Array<Scalars['ID']>;
};


export type MutationAssignDriverVehicleTypeArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};


export type MutationAssignPricingListToEndCustomerArgs = {
  endCustomerId: Scalars['ID'];
  newPricingListId?: InputMaybe<Scalars['ID']>;
};


export type MutationAutocompleteAddressArgs = {
  text: Scalars['String'];
};


export type MutationBulkMultiplyPricingRulesArgs = {
  courierId: Scalars['ID'];
  isBasePricingList: Scalars['Boolean'];
  multiplier: Scalars['Float'];
  pricingListId?: InputMaybe<Scalars['ID']>;
};


export type MutationBulkUnassignDriversFromShipmentArgs = {
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationBulkUploadEndCustomersArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
  ignoreInvalidAddresses?: InputMaybe<Scalars['Boolean']>;
  ignoreInvalidInvoiceFrequencies?: InputMaybe<Scalars['Boolean']>;
  ignoreInvalidPricingLists?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBulkUploadOrdersArgs = {
  acquisitionType?: InputMaybe<OrderAcquisitionType>;
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  file: Scalars['Upload'];
};


export type MutationBulkUploadPricingRulesArgs = {
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationCancelRoutingJobArgs = {
  canceledBy: Scalars['String'];
  jobId: Scalars['ID'];
};


export type MutationChangePasswordEndCustomerArgs = {
  endCustomerId: Scalars['ID'];
  password: Scalars['String'];
};


export type MutationCompleteTaskV1Args = {
  driverId: Scalars['ID'];
  driverNote?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
};


export type MutationCompleteTasksInBulkV1Args = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  inputs: Array<CompleteTaskInput>;
};


export type MutationCreateAddressBookArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  instruction?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
};


export type MutationCreateCostCenterArgs = {
  costCenterCreate: CostCenterCreate;
};


export type MutationCreateCustomFieldArgs = {
  courierId: Scalars['ID'];
  customerSpecificityType?: InputMaybe<CustomFieldCustomerSpecificity>;
  name: Scalars['String'];
  requirementType?: InputMaybe<CustomFieldCustomerRequirementType>;
  type: CustomFieldType;
  visibilityType?: InputMaybe<CustomFieldCustomerVisibilityType>;
};


export type MutationCreateDriverArgs = {
  courierId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  homeLocationId?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  photoUrl?: InputMaybe<Scalars['String']>;
  speed?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateEndCustomerArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  courierId: Scalars['ID'];
  endCustomerCreatedSource?: InputMaybe<EndCustomerCreatedSource>;
  firstName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  suite?: InputMaybe<Scalars['String']>;
};


export type MutationCreateEndUserArgs = {
  courierId: Scalars['String'];
  email: Scalars['String'];
  endCustomerId: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type MutationCreateHolidayScheduleArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreateInvoicePdfTemplateArgs = {
  courierId: Scalars['ID'];
  input: InvoicePdfTemplateCreateInput;
  updatedBy: Scalars['String'];
};


export type MutationCreateLiveOrderArgs = {
  acquisitionType: OrderAcquisitionType;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  branchId?: InputMaybe<Scalars['ID']>;
  caller?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerCreate?: InputMaybe<EndCustomerCreateInput>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  endUserId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  orderTypeId?: InputMaybe<Scalars['ID']>;
  originalOrderId?: InputMaybe<Scalars['ID']>;
  pricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate>>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipments: Array<ShipmentCreateInput>;
};


export type MutationCreateOneOffOrderArgs = {
  acquisitionType: OrderAcquisitionType;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  branchId?: InputMaybe<Scalars['ID']>;
  caller?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerCreate?: InputMaybe<EndCustomerCreateInput>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  endUserId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  orderTypeId?: InputMaybe<Scalars['ID']>;
  originalOrderId?: InputMaybe<Scalars['ID']>;
  pricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate>>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipments: Array<ShipmentCreateInput>;
};


export type MutationCreateOrderAttachmentsArgs = {
  courierId: Scalars['ID'];
  orderAttachmentUploads: Array<OrderAttachmentCreate>;
};


export type MutationCreatePackageTypeArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreatePaymentInstrumentArgs = {
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  source: PaymentInstrumentAcquisitionSource;
  token: Scalars['String'];
};


export type MutationCreatePayrollDeductionRuleArgs = {
  amount: Scalars['Money'];
  amountType: PayrollDeductionAmountType;
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  ruleType: PayrollDeductionRuleType;
};


export type MutationCreatePricingListArgs = {
  copyBasePricingRules?: InputMaybe<Scalars['Boolean']>;
  courierId: Scalars['ID'];
  name: Scalars['String'];
  pricingListIdToCopyFrom?: InputMaybe<Scalars['ID']>;
  pricingRulesValueMultiplier?: InputMaybe<Scalars['Float']>;
};


export type MutationCreatePricingRuleArgs = {
  pricingRuleCreate: PricingRuleCreate;
};


export type MutationCreateRecurringOrderArgs = {
  acquisitionType: OrderAcquisitionType;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  branchId?: InputMaybe<Scalars['ID']>;
  caller?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerCreate?: InputMaybe<EndCustomerCreateInput>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  orderTypeId?: InputMaybe<Scalars['ID']>;
  recurrenceDetail: RecurrenceDetailInput;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipmentTemplates: Array<ShipmentTemplateCreateInput>;
};


export type MutationCreateRoutingJobArgs = {
  jobCreate: RoutingJobCreate;
  vehicleCreates: Array<RoutingVehicleCreate>;
};


export type MutationCreateServiceTypeArgs = {
  courierId: Scalars['ID'];
  deliveryRoutedDaysAfter?: InputMaybe<Scalars['Int']>;
  deliveryTimeInMinutes?: InputMaybe<Scalars['Int']>;
  dueTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  dueTimeSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  dueTimeType?: InputMaybe<ServiceTypeDueTimeType>;
  name: Scalars['String'];
  visibilityType?: InputMaybe<ServiceTypeVisibilityType>;
};


export type MutationCreateSurchargePricingRuleArgs = {
  surchargePricingRuleCreate: SurchargePricingRuleCreate;
};


export type MutationCreateUserArgs = {
  courierId: Scalars['String'];
  email: Scalars['String'];
  firebaseUserId?: InputMaybe<Scalars['String']>;
  profilePhotoUrl?: InputMaybe<Scalars['String']>;
};


export type MutationCreateVehicleTypeArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
  shortCode: Scalars['String'];
};


export type MutationCreateZipGroupArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
  zipCodes: Array<Scalars['String']>;
};


export type MutationCreateZoneArgs = {
  courierId: Scalars['ID'];
  name: Scalars['String'];
  polygon: PolygonInput;
  type: ZoneType;
};


export type MutationCreateZonesArgs = {
  courierId: Scalars['ID'];
  zones: Array<ZoneCreate>;
};


export type MutationDeleteAddressBookArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteDriverArgs = {
  driverId: Scalars['ID'];
};


export type MutationDeleteFirebaseUserForDriverArgs = {
  driverId: Scalars['ID'];
};


export type MutationDeleteFirebaseUserForEndCustomerArgs = {
  endCustomerId: Scalars['ID'];
};


export type MutationDeleteHolidayScheduleArgs = {
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
};


export type MutationDeleteHolidayScheduleBehaviorArgs = {
  courierHolidayId: Scalars['ID'];
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
};


export type MutationDeleteInvoicePdfTemplateArgs = {
  courierId: Scalars['ID'];
  deletedBy: Scalars['String'];
  invoicePdfTemplateId: Scalars['ID'];
};


export type MutationDeleteLinkedAccountArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePackageTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePayrollDeductionRuleArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeletePricingListArgs = {
  pricingListId: Scalars['ID'];
};


export type MutationDeletePricingRuleArgs = {
  courierId: Scalars['ID'];
  pricingRuleId: Scalars['ID'];
};


export type MutationDeleteServiceTypeArgs = {
  serviceTypeId: Scalars['ID'];
};


export type MutationDeleteSurchargePricingRuleArgs = {
  courierId: Scalars['ID'];
  surchargePricingRuleId: Scalars['ID'];
};


export type MutationDeleteVehicleTypeArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDispatchDriverForShipmentArgs = {
  autoRoutedStopIds?: InputMaybe<Array<Scalars['ID']>>;
  dispatchedBy?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  orderingAlgorithmType?: InputMaybe<OrderingAlgorithmType>;
  shipmentId: Scalars['ID'];
  stopIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationDispatchDriverForShipmentMultiDayArgs = {
  days: Array<DispatchStopsOnDayInput>;
  dispatchPageType?: InputMaybe<DispatchPageType>;
  dispatchPreviewSection?: InputMaybe<Scalars['String']>;
  dispatchPreviewSortingType?: InputMaybe<Scalars['String']>;
  dispatchPreviews?: InputMaybe<Array<DispatchPreviewSaveInput>>;
  dispatchSource?: InputMaybe<DispatchSource>;
  dispatchedBy?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  driverRank?: InputMaybe<Scalars['Int']>;
  orderingAlgorithmType: OrderingAlgorithmType;
  shipmentId: Scalars['ID'];
};


export type MutationForceCompleteShipmentArgs = {
  completedBy: Scalars['String'];
  dateCompletedOverride?: InputMaybe<Scalars['Date']>;
  shipmentId: Scalars['ID'];
};


export type MutationForceCompleteStopsArgs = {
  completedBy: Scalars['String'];
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  stopIds: Array<Scalars['ID']>;
};


export type MutationForceExportDriverPayArgs = {
  driverPayEntryId: Scalars['ID'];
  provider: ApiProvider;
};


export type MutationForceGenerateInvoicesArgs = {
  courierId: Scalars['String'];
  endCustomerIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type MutationForceInstantiateRecurringOrdersArgs = {
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']>;
  targetDate: Scalars['Date'];
};


export type MutationFullUpdateAddressBookArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  instruction?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
};


export type MutationFullUpdateColumnVisibilityArgs = {
  courierId: Scalars['String'];
  driverReportColumnIds?: InputMaybe<Array<DriverReportColumnId>>;
  salesReportColumnIds?: InputMaybe<Array<SalesReportColumnId>>;
  updatedBy: Scalars['String'];
  userOrEmployeeId: Scalars['String'];
};


export type MutationFullUpdateCustomFieldArgs = {
  courierId: Scalars['ID'];
  customerSpecificityType: CustomFieldCustomerSpecificity;
  id: Scalars['ID'];
  name: Scalars['String'];
  requirementType?: InputMaybe<CustomFieldCustomerRequirementType>;
  type: CustomFieldType;
  visibilityType: CustomFieldCustomerVisibilityType;
};


export type MutationFullUpdateDriverArgs = {
  fullUpdate: DriverFullUpdate;
};


export type MutationFullUpdateEndCustomerArgs = {
  fullUpdate: EndCustomerFullUpdate;
};


export type MutationFullUpdateInvoicePdfTemplateArgs = {
  courierId: Scalars['ID'];
  input: InvoicePdfTemplateUpdateInput;
  updatedBy: Scalars['String'];
};


export type MutationFullUpdateLocationArgs = {
  city: Scalars['String'];
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  streetAddress: Scalars['String'];
};


export type MutationFullUpdateOrderArgs = {
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  caller?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  customFieldValuesToReplace?: InputMaybe<Array<CustomFieldValueInput>>;
  endCustomerId: Scalars['ID'];
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipmentUpdates: Array<ShipmentFullUpdate>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationFullUpdatePackageTypeArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationFullUpdatePayrollDeductionRuleArgs = {
  amount: Scalars['Money'];
  amountType: PayrollDeductionAmountType;
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ruleType: PayrollDeductionRuleType;
};


export type MutationFullUpdatePricingRuleArgs = {
  pricingRuleFullUpdate: PricingRuleFullUpdate;
};


export type MutationFullUpdateRecurringOrderArgs = {
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  endCustomerId: Scalars['ID'];
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  recurrenceDetail: RecurrenceDetailInput;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  shipmentTemplateUpdates: Array<ShipmentTemplateFullUpdate>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationFullUpdateServiceTypeArgs = {
  fullUpdate: ServiceTypeFullUpdate;
};


export type MutationFullUpdateSurchargePricingRuleArgs = {
  surchargePricingRuleFullUpdate: SurchargePricingRuleFullUpdate;
};


export type MutationFullUpdateUserArgs = {
  fullUpdate: UserFullUpdate;
};


export type MutationFullUpdateVehicleTypeArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shortCode: Scalars['String'];
};


export type MutationFullUpdateZipGroupArgs = {
  name: Scalars['String'];
  zipCodes: Array<Scalars['String']>;
  zipGroupId: Scalars['ID'];
};


export type MutationGenerateCsvForInvoicesArgs = {
  courierId: Scalars['String'];
  invoiceIds: Array<Scalars['ID']>;
};


export type MutationGenerateOrdersPdfArgs = {
  orderIds: Array<Scalars['ID']>;
};


export type MutationGeneratePayrollReportArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type MutationGeneratePdfForInvoiceArgs = {
  courierId: Scalars['String'];
  invoiceId: Scalars['ID'];
};


export type MutationGenerateResetPasswordLinkArgs = {
  email: Scalars['String'];
};


export type MutationGenerateSalesReportCsvArgs = {
  courierId: Scalars['ID'];
  includeAllSurcharge?: InputMaybe<Scalars['Boolean']>;
  maxDate?: InputMaybe<Scalars['Date']>;
  minDate?: InputMaybe<Scalars['Date']>;
};


export type MutationGetOrCreateLocationFromCoordinateArgs = {
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  lngLat: LngLatInput;
};


export type MutationGetOrCreateLocationsArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  googlePlaceIds: Array<Scalars['String']>;
  targetShipmentDate?: InputMaybe<Scalars['Date']>;
};


export type MutationGetOrCreateLocationsWithOverviewArgs = {
  googlePlaceIds: Array<Scalars['String']>;
};


export type MutationGetOrForceInstantiateRecurringOrdersArgs = {
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']>;
  shouldUseTemplateDriver: Scalars['Boolean'];
  targetDate: Scalars['Date'];
};


export type MutationGetOrGenerateDriverPayEntriesArgs = {
  courierId: Scalars['ID'];
  driverSearch?: InputMaybe<Scalars['String']>;
  endDate: Scalars['Date'];
  sortFields?: InputMaybe<Array<DriverPayrollSorting>>;
  startDate: Scalars['Date'];
};


export type MutationInitiateInvoicePaymentArgs = {
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  emailRecipients?: InputMaybe<Array<Scalars['String']>>;
  fraudSessionId?: InputMaybe<Scalars['String']>;
  idempotencyToken: Scalars['String'];
  invoiceId: Scalars['ID'];
  paymentInstrumentId: Scalars['ID'];
};


export type MutationInitiateInvoiceRefundArgs = {
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  idempotencyToken: Scalars['String'];
  parentPaymentTransferId: Scalars['ID'];
};


export type MutationMarkAsArrivedV1Args = {
  taskId: Scalars['ID'];
};


export type MutationMarkCostCenterDeletedArgs = {
  costCenterId: Scalars['ID'];
  courierId: Scalars['ID'];
};


export type MutationMarkCustomFieldAsDeletedArgs = {
  courierId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationMarkEndCustomerConfirmedAsNewArgs = {
  endCustomerId: Scalars['ID'];
};


export type MutationMarkEndCustomerDeletedArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
};


export type MutationMarkEndUserAsDeletedArgs = {
  endUserId: Scalars['ID'];
};


export type MutationMarkInvoiceAsPaidManuallyArgs = {
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']>;
  markedBy: Scalars['String'];
};


export type MutationMarkInvoicePdfTemplateAsDefaultArgs = {
  courierId: Scalars['ID'];
  invoicePdfTemplateId: Scalars['ID'];
  updatedBy: Scalars['String'];
};


export type MutationMarkShipmentAsClosedArgs = {
  closedBy?: InputMaybe<Scalars['String']>;
  shipmentId: Scalars['ID'];
};


export type MutationMarkShipmentAsDeletedArgs = {
  shipmentId: Scalars['ID'];
};


export type MutationMarkShipmentAsFailedArgs = {
  shipmentId: Scalars['ID'];
};


export type MutationMarkShipmentTemplatesAsDeletedArgs = {
  shipmentTemplateIds: Array<Scalars['ID']>;
};


export type MutationMarkShipmentsAsClosedArgs = {
  closedBy?: InputMaybe<Scalars['String']>;
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationMarkShipmentsAsConfirmedArgs = {
  driverId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationMergeEndCustomersArgs = {
  courierId: Scalars['ID'];
  sourceEndCustomerId: Scalars['ID'];
  targetEndCustomerId: Scalars['ID'];
};


export type MutationModifyDriverPayDeductionsArgs = {
  deductionIdsToRemove: Array<Scalars['ID']>;
  deductionsToAdd: Array<DriverPayDeductionValueInput>;
  driverPayEntryId: Scalars['ID'];
};


export type MutationModifyDriverTimeEventsArgs = {
  courierId: Scalars['ID'];
  eventIdsToDelete: Array<Scalars['ID']>;
  newEvent?: InputMaybe<DriverTimeEventCreateInput>;
  updatedBy: Scalars['ID'];
  updates: Array<DriverTimeEventUpdateInput>;
};


export type MutationModifyOrderPricingArgs = {
  adjustmentIdsToRemove?: InputMaybe<Array<Scalars['ID']>>;
  adjustmentOverrides?: InputMaybe<Array<AdjustmentOverrideInput>>;
  adjustmentsToAdd?: InputMaybe<Array<PricingAdjustmentCreate>>;
  basePriceOverride?: InputMaybe<Scalars['Money']>;
  orderId: Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
  priceOverrideBreakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput>>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationOptimizeRouteForDispatchArgs = {
  baseTime?: InputMaybe<Scalars['Timestamp']>;
  driverId: Scalars['ID'];
  endLocationId?: InputMaybe<Scalars['ID']>;
  newShipmentId: Scalars['ID'];
  orderingAlgorithmType: OrderingAlgorithmType;
  startLocationId?: InputMaybe<Scalars['ID']>;
  stopDate?: InputMaybe<Scalars['Date']>;
};


export type MutationOverrideAdjustmentAmountArgs = {
  adjustmentId: Scalars['ID'];
  amountOverride?: InputMaybe<Scalars['Money']>;
};


export type MutationOverridePodMetadataArgs = {
  deliveredAt?: InputMaybe<Scalars['Timestamp']>;
  shipmentId: Scalars['ID'];
  signedBy?: InputMaybe<Scalars['String']>;
  updatedBy: Scalars['String'];
};


export type MutationOverridePricingDetailArgs = {
  adjustmentUpdates?: InputMaybe<Array<PricingAdjustmentUpdate>>;
  adjustmentsToAdd?: InputMaybe<Array<PricingAdjustmentCreate>>;
  shipmentId: Scalars['ID'];
  unfreeWaitTimeInMinutes?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationPreviewInvoicePdfFromCreateArgs = {
  courierId: Scalars['ID'];
  template: InvoicePdfTemplateCreateInput;
};


export type MutationPreviewInvoicePdfFromUpdateArgs = {
  courierId: Scalars['ID'];
  template: InvoicePdfTemplateUpdateInput;
};


export type MutationPreviewOrderPricingModificationArgs = {
  adjustmentIdsToRemove?: InputMaybe<Array<Scalars['ID']>>;
  adjustmentsToAdd?: InputMaybe<Array<PricingAdjustmentCreate>>;
  orderId: Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
};


export type MutationPreviewPriceArgs = {
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  googlePlaceIds: Array<Scalars['String']>;
  packageCount?: InputMaybe<Scalars['Int']>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeight?: InputMaybe<Scalars['Float']>;
  requestedPricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate>>;
  serviceTypeId?: InputMaybe<Scalars['String']>;
  shipmentType?: InputMaybe<ShipmentType>;
};


export type MutationProposeShipmentDetailsArgs = {
  courierId: Scalars['ID'];
  proposedNumPackages: Scalars['Int'];
  proposedPackageWeightInPounds: Scalars['Float'];
  shipmentId: Scalars['ID'];
  updatedBy: Scalars['String'];
};


export type MutationRandomizeTimesArgs = {
  courierId: Scalars['ID'];
};


export type MutationRecordDriverLocationArgs = {
  detailsAsJson?: InputMaybe<Scalars['String']>;
  driverId: Scalars['ID'];
  lastReportedTime?: InputMaybe<Scalars['Timestamp']>;
  lastReportedTimeString?: InputMaybe<Scalars['String']>;
  lngLat: LngLatInput;
};


export type MutationRecordMobileAppErrorArgs = {
  driverEmail?: InputMaybe<Scalars['String']>;
  driverId?: InputMaybe<Scalars['ID']>;
  payloadAsJson?: InputMaybe<Scalars['String']>;
};


export type MutationRecordOrderClickArgs = {
  input: RecordOrderClickInput;
};


export type MutationRecordPromptActionArgs = {
  input: RecordPromptActionInput;
};


export type MutationRefreshDispatchPreviewsArgs = {
  courierId?: InputMaybe<Scalars['ID']>;
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  shipmentDate?: InputMaybe<Scalars['Date']>;
  shipmentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationRefreshEtaStaleArgs = {
  driverId: Scalars['ID'];
};


export type MutationReplaceAllocationArgs = {
  replacement: DriverPayAllocationReplacement;
};


export type MutationReplaceRouteArgs = {
  autoRoutedStopIds?: InputMaybe<Array<Scalars['ID']>>;
  dispatchSource?: InputMaybe<DispatchSource>;
  driverId: Scalars['ID'];
  newStopIds: Array<Scalars['ID']>;
  orderingAlgorithmType?: InputMaybe<OrderingAlgorithmType>;
  replacedBy?: InputMaybe<Scalars['String']>;
  shipmentDate: Scalars['Date'];
};


export type MutationReplaceRoutingVehicleSequenceArgs = {
  routingNodeIds: Array<Scalars['ID']>;
  routingVehicleId: Scalars['ID'];
};


export type MutationResetShipmentArgs = {
  resetBy: Scalars['String'];
  shipmentId: Scalars['ID'];
};


export type MutationScanCreateArgs = {
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['ID']>;
  scanType: ScanType;
  taskId?: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
};


export type MutationScanVerifyArgs = {
  scanType: ScanType;
  taskId?: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
};


export type MutationSendCommunicationToEndCustomerArgs = {
  communicationTypeId?: InputMaybe<CommunicationTypeId>;
  courierId: Scalars['ID'];
  emailRecipientsCommaSeparated?: InputMaybe<Scalars['String']>;
  shipmentId?: InputMaybe<Scalars['ID']>;
  stopId?: InputMaybe<Scalars['ID']>;
};


export type MutationSendDriverScheduleConfirmationEmailsArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate: Scalars['Date'];
  forceSend?: InputMaybe<Scalars['Boolean']>;
  startDate: Scalars['Date'];
};


export type MutationSendEmailToDriversArgs = {
  driverPayEntryId: Scalars['ID'];
  recipients: Array<Scalars['String']>;
};


export type MutationSendInvoiceEmailArgs = {
  courierId: Scalars['ID'];
  invoiceEmailSendInput: InvoiceEmailSendInput;
};


export type MutationSendPasswordResetEmailArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
  endUserIds?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationSetDriverScheduleOverrideArgs = {
  courierId: Scalars['ID'];
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  isDayOff: Scalars['Boolean'];
  labels: Array<Scalars['String']>;
  timeBlocks: Array<DriverScheduleTimeBlockInput>;
};


export type MutationSetEndCustomerRequiredFieldsArgs = {
  additionalFields?: InputMaybe<Array<CustomerPortalAdditionalRequiredFields>>;
  courierId: Scalars['ID'];
  dispatchAdditionalFields?: InputMaybe<Array<DispatcherOrderEntryAdditionalField>>;
  endCustomerId: Scalars['ID'];
};


export type MutationStartTaskV1Args = {
  driverId: Scalars['ID'];
  taskId: Scalars['ID'];
};


export type MutationSyncDriverWithFirebaseArgs = {
  email: Scalars['String'];
  firebaseUid: Scalars['String'];
};


export type MutationSyncEndCustomerWithFirebaseArgs = {
  courierId: Scalars['ID'];
  email: Scalars['String'];
  firebaseUid: Scalars['String'];
};


export type MutationSyncUserWithFirebaseArgs = {
  email: Scalars['String'];
  firebaseUid: Scalars['String'];
};


export type MutationTransferShipmentArgs = {
  routingJobId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  targetDriverId: Scalars['ID'];
};


export type MutationUnassignDriverFromShipmentArgs = {
  shipmentId: Scalars['ID'];
};


export type MutationUncloseShipmentArgs = {
  shipmentId: Scalars['ID'];
};


export type MutationUncloseShipmentsArgs = {
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']>;
};


export type MutationUpdateDriverAvailabilityV1Args = {
  driverId: Scalars['ID'];
  isAvailable: Scalars['Boolean'];
};


export type MutationUpdateDriverBaseWorkScheduleArgs = {
  driverId: Scalars['ID'];
  workSchedule: DriverWorkScheduleInput;
};


export type MutationUpdateDriverCompensationArgs = {
  compensation: DriverCompensation;
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  employmentType: DriverEmploymentType;
};


export type MutationUpdateDriverPayOverrideArgs = {
  driverPayOverride?: InputMaybe<Scalars['Money']>;
  orderId: Scalars['ID'];
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDriverReportedWaitTimeArgs = {
  courierId: Scalars['ID'];
  stopId: Scalars['ID'];
  waitTimeInMinutes: Scalars['Int'];
};


export type MutationUpdateEnabledEndCustomerCommunicationsTypesArgs = {
  enabledCommunicationTypeIds: Array<CommunicationTypeId>;
  endCustomerId: Scalars['ID'];
};


export type MutationUpdateEndCustomerCustomFieldsArgs = {
  courierId: Scalars['ID'];
  customFieldIds: Array<Scalars['ID']>;
  endCustomerId: Scalars['ID'];
};


export type MutationUpdateEndCustomerNoteArgs = {
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateEndCustomerVisibleServiceTypeIdsArgs = {
  endCustomerId: Scalars['ID'];
  visibleServiceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationUpdateHolidayScheduleArgs = {
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateInternalNoteArgs = {
  internalNote: Scalars['String'];
  shipmentId: Scalars['ID'];
  updatedBy: Scalars['String'];
};


export type MutationUpdatePodEmailsArgs = {
  endCustomerId: Scalars['ID'];
  podEmails?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationUpdatePriceOverrideForRecurringOrderArgs = {
  breakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput>>;
  orderId: Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateReadyTimeScheduleArgs = {
  readyTimeSchedule: TimeScheduleInput;
  serviceTypeId: Scalars['ID'];
};


export type MutationUpdateZonesArgs = {
  courierId: Scalars['ID'];
  zones: Array<ZoneUpdate>;
};


export type MutationUploadDriverPhotoArgs = {
  driverId: Scalars['ID'];
  file: Scalars['Upload'];
};


export type MutationUploadFileV1Args = {
  courierId: Scalars['ID'];
  createdBy?: InputMaybe<Scalars['ID']>;
  file: Scalars['Upload'];
  taskId?: InputMaybe<Scalars['ID']>;
  type: FileType;
  value?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertFcmTokenV1Args = {
  driverId: Scalars['ID'];
  fcmToken: Scalars['String'];
};


export type MutationUpsertHolidayScheduleBehaviorArgs = {
  courierHolidayId: Scalars['ID'];
  courierId: Scalars['ID'];
  holidayBehavior: HolidayBehavior;
  holidayScheduleId: Scalars['ID'];
};


export type MutationUpsertLinkedAccountArgs = {
  linkedAccountCreate: LinkedAccountCreate;
};


export type MutationUpsertPayrollSettingsArgs = {
  courierId: Scalars['ID'];
  defaultCommission: Scalars['Float'];
  payPeriodType: PayPeriodType;
};


export type MutationUpsertRemoteEntityLinkageArgs = {
  upsert: RemoteEntityLinkageUpsert;
};


export type MutationUpsertStopTemplateSequenceNumbersArgs = {
  upserts: Array<ScheduledStopTemplateSequenceNumberUpsert>;
};


export type MutationVoidInvoicesArgs = {
  invoiceIds: Array<Scalars['ID']>;
};

export enum NewCustomerConfirmationStatus {
  Confirmed = 'CONFIRMED',
  Unconfirmed = 'UNCONFIRMED'
}

export type OptimizeRouteForDispatchResult = {
  __typename?: 'OptimizeRouteForDispatchResult';
  stops: Array<Stop>;
};

export type Order = {
  __typename?: 'Order';
  acquisitionType: OrderAcquisitionType;
  additionalEmailRecipients?: Maybe<Array<Scalars['String']>>;
  caller?: Maybe<Scalars['String']>;
  costCenter?: Maybe<CostCenter>;
  costCenterId?: Maybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdByEndCustomer?: Maybe<EndCustomer>;
  createdByEndUser?: Maybe<EndUser>;
  createdByUser?: Maybe<CourieUser>;
  customFieldValues: Array<CustomFieldValue>;
  displayId: Scalars['Int'];
  driverPayOverride?: Maybe<Scalars['Money']>;
  endCustomer: EndCustomer;
  endCustomerReferenceNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  orderAttachments: Array<OrderAttachment>;
  /**  Deprecated. Use orderPayBreakDownWithAllocation instead. */
  orderPayBreakDown?: Maybe<OrderPayBreakDown>;
  orderPayBreakDownWithAllocation?: Maybe<OrderPayBreakDownWithAllocationResult>;
  price: OrderPrice;
  priceOverride?: Maybe<Scalars['Money']>;
  priceOverrideBreakdown?: Maybe<Array<PriceOverrideBreakdownItem>>;
  pricingStopIds?: Maybe<Array<Scalars['ID']>>;
  recurrenceDetail?: Maybe<RecurrenceDetail>;
  recurrenceType: RecurrenceType;
  serviceType?: Maybe<ServiceType>;
  shipment?: Maybe<Shipment>;
  userHasClicked: Scalars['Boolean'];
};


export type OrderUserHasClickedArgs = {
  userId: Scalars['ID'];
};

export enum OrderAcquisitionType {
  Api = 'API',
  BulkUpload = 'BULK_UPLOAD',
  CustomerPortal = 'CUSTOMER_PORTAL',
  User = 'USER'
}

export type OrderAttachment = {
  __typename?: 'OrderAttachment';
  fileName: Scalars['String'];
  id: Scalars['ID'];
  publicUrl: Scalars['String'];
};

export type OrderAttachmentCreate = {
  file: Scalars['Upload'];
  orderId: Scalars['ID'];
};

export type OrderClick = {
  __typename?: 'OrderClick';
  clickedBy: Scalars['String'];
  id: Scalars['ID'];
  orderId: Scalars['ID'];
};

export type OrderPayBreakDown = {
  __typename?: 'OrderPayBreakDown';
  items: Array<OrderPayBreakDownItem>;
  total: Scalars['Money'];
};

export type OrderPayBreakDownItem = {
  __typename?: 'OrderPayBreakDownItem';
  amount: Scalars['Money'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type OrderPayBreakDownWithAllocation = {
  __typename?: 'OrderPayBreakDownWithAllocation';
  allocationRate: Scalars['Money'];
  breakdown: OrderPayBreakDown;
  driver?: Maybe<Driver>;
  driverId?: Maybe<Scalars['ID']>;
};

export type OrderPayBreakDownWithAllocationResult = {
  __typename?: 'OrderPayBreakDownWithAllocationResult';
  allocations: Array<OrderPayBreakDownWithAllocation>;
  isOverride: Scalars['Boolean'];
  total: Scalars['Money'];
};

export type OrderPrice = {
  __typename?: 'OrderPrice';
  basePriceOverride?: Maybe<Scalars['Money']>;
  customSurchargeAdjustments?: Maybe<Array<PricingAdjustment>>;
  isBasePriceOverride: Scalars['Boolean'];
  isFinalized: Scalars['Boolean'];
  isPriceOverride: Scalars['Boolean'];
  priceOverride?: Maybe<Scalars['Money']>;
  priceOverrideBreakdown?: Maybe<Array<PriceOverrideBreakdownItem>>;
  pricingBreakDown: PricingBreakDown;
  total: Scalars['Money'];
};

export enum OrderingAlgorithmType {
  Beginning = 'BEGINNING',
  End = 'END',
  LeastDeviation = 'LEAST_DEVIATION',
  Manual = 'MANUAL',
  OnTimeFirstReoptimized = 'ON_TIME_FIRST_REOPTIMIZED',
  Reoptimized = 'REOPTIMIZED',
  ReoptimizedMileage = 'REOPTIMIZED_MILEAGE'
}

export type OrdersFile = {
  __typename?: 'OrdersFile';
  url: Scalars['String'];
};

export type PackageItem = {
  __typename?: 'PackageItem';
  height?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export enum PackageSize {
  L = 'L',
  M = 'M',
  S = 'S',
  Xl = 'XL',
  Xs = 'XS',
  Xxl = 'XXL'
}

export type PackageType = {
  __typename?: 'PackageType';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PayPeriod = {
  __typename?: 'PayPeriod';
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

export enum PayPeriodType {
  Biweekly = 'BIWEEKLY',
  Semimonthly = 'SEMIMONTHLY',
  Weekly = 'WEEKLY'
}

export type PaymentInstrument = {
  __typename?: 'PaymentInstrument';
  bankAccountDetail?: Maybe<BankAccountDetail>;
  costCenterId?: Maybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  creditCardDetail?: Maybe<CreditCardDetail>;
  endCustomerId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  paymentInstrumentType: PaymentInstrumentType;
};

export enum PaymentInstrumentAcquisitionSource {
  CustomerPortal = 'CUSTOMER_PORTAL',
  Onboarding = 'ONBOARDING',
  Web = 'WEB'
}

export enum PaymentInstrumentType {
  BankAccount = 'BANK_ACCOUNT',
  CanadianBankAccount = 'CANADIAN_BANK_ACCOUNT',
  CreditCard = 'CREDIT_CARD',
  PlaidBankAccount = 'PLAID_BANK_ACCOUNT'
}

export type PaymentSettlement = {
  __typename?: 'PaymentSettlement';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  merchantId: Scalars['String'];
  netAmount: Scalars['Money'];
  providerCreatedAt: Scalars['Timestamp'];
  remoteId: Scalars['String'];
  status: SettlementStatus;
  totalAmount: Scalars['Money'];
  totalFee: Scalars['Money'];
  totalFeeIncludingSubscriptionBilling: Scalars['Money'];
  type: Scalars['String'];
};

export type PaymentSettlementConnection = {
  __typename?: 'PaymentSettlementConnection';
  edges?: Maybe<Array<Maybe<PaymentSettlementEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaymentSettlementEdge = {
  __typename?: 'PaymentSettlementEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PaymentSettlement>;
};

export type PaymentTransfer = {
  __typename?: 'PaymentTransfer';
  amount: Scalars['Money'];
  courierId: Scalars['ID'];
  currency: Scalars['String'];
  displayId: Scalars['Int'];
  endCustomer?: Maybe<EndCustomer>;
  endCustomerId?: Maybe<Scalars['ID']>;
  failureCode?: Maybe<Scalars['String']>;
  failureMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoicePayments: Array<InvoicePayment>;
  parentPaymentTransfer?: Maybe<PaymentTransfer>;
  refundType: PaymentTransferRefundType;
  sourcePaymentInstrument?: Maybe<PaymentInstrument>;
  status: PaymentTransferStatus;
};

export type PaymentTransferConnection = {
  __typename?: 'PaymentTransferConnection';
  edges?: Maybe<Array<Maybe<PaymentTransferEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaymentTransferEdge = {
  __typename?: 'PaymentTransferEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PaymentTransfer>;
};

export enum PaymentTransferRefundType {
  None = 'NONE',
  Refund = 'REFUND'
}

export enum PaymentTransferStatus {
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Pending = 'PENDING',
  ProviderCanceled = 'PROVIDER_CANCELED',
  Returned = 'RETURNED',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export type PayrollDeductionAmount = {
  __typename?: 'PayrollDeductionAmount';
  amountTotal: Scalars['Money'];
  name: Scalars['String'];
};

export enum PayrollDeductionAmountType {
  PerDay = 'PER_DAY',
  PerWeekRoundCeiling = 'PER_WEEK_ROUND_CEILING',
  PerWeekRoundFloor = 'PER_WEEK_ROUND_FLOOR',
  SemiMonthly = 'SEMI_MONTHLY'
}

export type PayrollDeductionRule = {
  __typename?: 'PayrollDeductionRule';
  amount?: Maybe<Scalars['Money']>;
  amountType: PayrollDeductionAmountType;
  courierId: Scalars['ID'];
  driverIds?: Maybe<Array<Scalars['ID']>>;
  drivers: Array<Driver>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ruleType: PayrollDeductionRuleType;
};

export type PayrollDeductionRuleConnection = {
  __typename?: 'PayrollDeductionRuleConnection';
  edges?: Maybe<Array<Maybe<PayrollDeductionRuleEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PayrollDeductionRuleEdge = {
  __typename?: 'PayrollDeductionRuleEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PayrollDeductionRule>;
};

export enum PayrollDeductionRuleSortField {
  Amount = 'AMOUNT',
  Name = 'NAME',
  WhenToApply = 'WHEN_TO_APPLY'
}

export type PayrollDeductionRuleSorting = {
  direction: SortingDirection;
  field: PayrollDeductionRuleSortField;
};

export enum PayrollDeductionRuleType {
  AlwaysApply = 'ALWAYS_APPLY',
  DriverSpecific = 'DRIVER_SPECIFIC'
}

export type PayrollEmail = {
  __typename?: 'PayrollEmail';
  driverId: Scalars['ID'];
  driverPayEntryId: Scalars['ID'];
  emailId?: Maybe<Scalars['String']>;
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  recipients: Array<Scalars['String']>;
};

export type PayrollReport = {
  __typename?: 'PayrollReport';
  amountTotal: Scalars['Money'];
  driver: Driver;
  driverId: Scalars['ID'];
  endDate: Scalars['Date'];
  ordersCount: Scalars['Int'];
  pdfFile: PayrollReportFile;
  startDate: Scalars['Date'];
};

export type PayrollReportFile = {
  __typename?: 'PayrollReportFile';
  url: Scalars['String'];
};

export type PayrollSetting = {
  __typename?: 'PayrollSetting';
  courierId: Scalars['ID'];
  defaultCommission: Scalars['Money'];
  payPeriodType: PayPeriodType;
};

export type Polygon = {
  __typename?: 'Polygon';
  points: Array<LngLat>;
};

export type PolygonInput = {
  points: Array<LngLatInput>;
};

export type PreviewEtaForRouteResult = {
  __typename?: 'PreviewEtaForRouteResult';
  stopEtas: Array<StopEta>;
};

export type PreviewOrderPricingModificationResult = {
  __typename?: 'PreviewOrderPricingModificationResult';
  total: Scalars['Money'];
};

export type PreviewPriceResult = {
  __typename?: 'PreviewPriceResult';
  breakdown: PricingBreakDown;
  pricingList?: Maybe<PricingList>;
  pricingListId?: Maybe<Scalars['ID']>;
  total: Scalars['Money'];
};

export type PriceOverrideBreakdownItem = {
  __typename?: 'PriceOverrideBreakdownItem';
  amount: Scalars['Money'];
  description: Scalars['String'];
};

export type PriceOverrideBreakdownItemInput = {
  amount: Scalars['Money'];
  description: Scalars['String'];
};

export type PricingAdjustment = {
  __typename?: 'PricingAdjustment';
  amount: Scalars['Money'];
  id: Scalars['ID'];
  isAmountOverride: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  surchargePricingRule?: Maybe<SurchargePricingRule>;
  surchargePricingRuleId?: Maybe<Scalars['ID']>;
  type?: Maybe<PricingAdjustmentType>;
};

export type PricingAdjustmentCreate = {
  amount_total?: InputMaybe<Scalars['Money']>;
  note?: InputMaybe<Scalars['String']>;
  surchargePricingRuleId?: InputMaybe<Scalars['ID']>;
  type: PricingAdjustmentType;
};

export enum PricingAdjustmentType {
  Custom = 'CUSTOM',
  RuleBased = 'RULE_BASED'
}

export type PricingAdjustmentUpdate = {
  amountTotal: Scalars['Money'];
  id: Scalars['ID'];
};

export enum PricingBoundaryType {
  City = 'CITY',
  Zip = 'ZIP',
  ZipGroup = 'ZIP_GROUP',
  ZoneId = 'ZONE_ID'
}

export type PricingBreakDown = {
  __typename?: 'PricingBreakDown';
  items: Array<PricingBreakDownItem>;
};

export type PricingBreakDownItem = {
  __typename?: 'PricingBreakDownItem';
  adjustmentId?: Maybe<Scalars['ID']>;
  amount: Scalars['Money'];
  description?: Maybe<Scalars['String']>;
  isAdjustmentOverride: Scalars['Boolean'];
  name: Scalars['String'];
};

export type PricingList = {
  __typename?: 'PricingList';
  courierId: Scalars['ID'];
  displayId: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PricingRule = {
  __typename?: 'PricingRule';
  basePrice: Scalars['Money'];
  courierId: Scalars['ID'];
  destination?: Maybe<Scalars['String']>;
  destinationDisplay: Scalars['String'];
  destinationType?: Maybe<PricingBoundaryType>;
  driverCommission?: Maybe<Scalars['Money']>;
  driverPayFixed?: Maybe<Scalars['Money']>;
  freeMiles?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  maxMiles?: Maybe<Scalars['Float']>;
  maxTrips?: Maybe<Scalars['Int']>;
  maxWeight?: Maybe<Scalars['Float']>;
  minMiles?: Maybe<Scalars['Float']>;
  minTrips?: Maybe<Scalars['Int']>;
  minWeight?: Maybe<Scalars['Float']>;
  minimumPrice: Scalars['Money'];
  origin?: Maybe<Scalars['String']>;
  originDisplay: Scalars['String'];
  originType?: Maybe<PricingBoundaryType>;
  packageType?: Maybe<PackageType>;
  pricePerLbs?: Maybe<Scalars['Money']>;
  pricePerMile: Scalars['Money'];
  pricingList?: Maybe<PricingList>;
  pricingListId?: Maybe<Scalars['ID']>;
  serviceType?: Maybe<ServiceType>;
  serviceTypeId?: Maybe<Scalars['String']>;
};

export type PricingRuleConnection = {
  __typename?: 'PricingRuleConnection';
  edges?: Maybe<Array<Maybe<PricingRuleEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PricingRuleCreate = {
  basePrice?: InputMaybe<Scalars['Money']>;
  courierId: Scalars['ID'];
  destinationCity?: InputMaybe<CityStateCountryCreate>;
  destinationType?: InputMaybe<PricingBoundaryType>;
  destinationZip?: InputMaybe<Scalars['String']>;
  destinationZipGroupId?: InputMaybe<Scalars['ID']>;
  destinationZoneId?: InputMaybe<Scalars['ID']>;
  driverCommission?: InputMaybe<Scalars['Money']>;
  driverPayFixed?: InputMaybe<Scalars['Money']>;
  freeMiles?: InputMaybe<Scalars['Float']>;
  maxMiles?: InputMaybe<Scalars['Float']>;
  maxTrips?: InputMaybe<Scalars['Int']>;
  minMiles?: InputMaybe<Scalars['Float']>;
  minTrips?: InputMaybe<Scalars['Int']>;
  minimumPrice?: InputMaybe<Scalars['Money']>;
  originCity?: InputMaybe<CityStateCountryCreate>;
  originType?: InputMaybe<PricingBoundaryType>;
  originZip?: InputMaybe<Scalars['String']>;
  originZipGroupId?: InputMaybe<Scalars['ID']>;
  originZoneId?: InputMaybe<Scalars['ID']>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  pricePerMile?: InputMaybe<Scalars['Money']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  serviceTypeId?: InputMaybe<Scalars['String']>;
};

export type PricingRuleEdge = {
  __typename?: 'PricingRuleEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PricingRule>;
};

export type PricingRuleFullUpdate = {
  basePrice: Scalars['Money'];
  driverCommission?: InputMaybe<Scalars['Money']>;
  driverPayFixed?: InputMaybe<Scalars['Money']>;
  freeMiles?: InputMaybe<Scalars['Float']>;
  minimumPrice: Scalars['Money'];
  pricePerMile: Scalars['Money'];
  pricingRuleId: Scalars['ID'];
};

export enum PricingRulesSortField {
  BasePrice = 'BASE_PRICE',
  CreatedAt = 'CREATED_AT',
  DestinationName = 'DESTINATION_NAME',
  MaxMiles = 'MAX_MILES',
  MaxTrips = 'MAX_TRIPS',
  MinimumPrice = 'MINIMUM_PRICE',
  MinMiles = 'MIN_MILES',
  MinTrips = 'MIN_TRIPS',
  OriginName = 'ORIGIN_NAME',
  PricePerMile = 'PRICE_PER_MILE',
  ServiceTypeName = 'SERVICE_TYPE_NAME'
}

export type PricingRulesSorting = {
  direction: SortingDirection;
  field: PricingRulesSortField;
};

export type PromptAction = {
  __typename?: 'PromptAction';
  action: PromptActionType;
  endCustomerId: Scalars['ID'];
  endUserId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  type: PromptType;
};

export enum PromptActionType {
  Accepted = 'ACCEPTED',
  Dismissed = 'DISMISSED'
}

export enum PromptType {
  InviteColleaguePrompt = 'INVITE_COLLEAGUE_PROMPT'
}

export type Query = {
  __typename?: 'Query';
  _service?: Maybe<_Service>;
  activities: ActivitiesResult;
  addressBookEntries?: Maybe<AddressBookEntryConnection>;
  breadcrumb: DriverBreadcrumb;
  costCenters: Array<CostCenter>;
  courier?: Maybe<Courier>;
  courierByPath?: Maybe<Courier>;
  courierHolidays: Array<CourierHoliday>;
  couriers: Array<Courier>;
  customDeductions: Array<DriverPayDeduction>;
  customFields: Array<CustomField>;
  dispatchPreviews: Array<DispatchPreview>;
  dispatchPreviewsByDriverId: Array<DispatchPreview>;
  driverById: Driver;
  driverDaysOverview: Array<DriverDaysOverview>;
  driverDefaultRoutingConfigurations: Array<DriverDefaultRoutingConfiguration>;
  driverReportItems: Array<DriverReportItem>;
  driverScheduleForDateRange: DriverSchedulesResult;
  driverTimeEvents: Array<DriverTimeEvent>;
  drivers?: Maybe<DriverConnection>;
  endCustomers: EndCustomerConnection;
  endCustomersOverview: EndCustomersOverview;
  endUsers: Array<EndUser>;
  getInvoicePdfTemplateSkeleton: InvoicePdfTemplate;
  getVisibleColumns?: Maybe<VisibleColumnsConfig>;
  holidayScheduleBehaviors: Array<HolidayScheduleBehavior>;
  holidaySchedules: Array<HolidaySchedule>;
  invoiceBalances: Array<InvoiceBalance>;
  invoiceByDisplayId: Invoice;
  invoiceExtendedDetail: InvoiceExtendedDetail;
  invoicePdfTemplatesPaginated: InvoicePdfTemplateConnection;
  invoicesOverview: InvoicesOverview;
  invoicesPaginated: InvoiceConnection;
  linkedAccounts: Array<LinkedAccount>;
  memorizations: MemorizationResult;
  /**  Deprecated. Use orderPayBreakDownWithAllocations instead. */
  orderPayBreakDown?: Maybe<OrderPayBreakDown>;
  orderPayBreakDownWithAllocations: OrderPayBreakDownWithAllocationResult;
  orderPrice: OrderPrice;
  packageTypes: Array<PackageType>;
  payPeriods: Array<PayPeriod>;
  paymentInstruments: Array<PaymentInstrument>;
  paymentSettlementsPaginated: PaymentSettlementConnection;
  paymentTransfersPaginated: PaymentTransferConnection;
  payrollDeductionRules: Array<PayrollDeductionRule>;
  payrollDeductionRulesPaginated: PayrollDeductionRuleConnection;
  payrollReports: Array<PayrollReport>;
  payrollSettings: PayrollSetting;
  previewEtaForRoute?: Maybe<PreviewEtaForRouteResult>;
  previewEtaForRoutingVehicle: Array<RoutingNodeEta>;
  pricingLists: Array<PricingList>;
  pricingRules: Array<PricingRule>;
  pricingRulesPaginated: PricingRuleConnection;
  promptActions: Array<PromptAction>;
  quickbookCustomer?: Maybe<QuickbookCustomer>;
  quickbookVendor?: Maybe<QuickbookVendor>;
  routingJobById: RoutingJob;
  routingJobs: RoutingJobConnection;
  salesItemsPaginated?: Maybe<SalesItemConnection>;
  salesOverview: SalesOverview;
  searchEndCustomer: Array<EndCustomer>;
  searchFromAddressBook: Array<AddressBookEntry>;
  serviceTypes: Array<ServiceType>;
  shipmentById: Shipment;
  shipmentByTrackingNumber?: Maybe<Shipment>;
  shipmentTemplatesPaginated?: Maybe<ShipmentTemplateConnection>;
  shipments?: Maybe<ShipmentConnection>;
  shipmentsOverview: ShipmentsOverview;
  shipmentsWithoutPagination: Array<Shipment>;
  surchargePricingRules: Array<SurchargePricingRule>;
  surchargePricingRulesPaginated: SurchargePricingRuleConnection;
  taskById: Task;
  uniqueStopDates: Array<Scalars['Date']>;
  users: CourieUserConnection;
  vehicleTypes: Array<VehicleType>;
  zipGroups: Array<ZipGroup>;
  zones: Array<Zone>;
};


export type QueryActivitiesArgs = {
  courierId: Scalars['ID'];
  entityId: Scalars['ID'];
};


export type QueryAddressBookEntriesArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  endCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<AddressBookSorting>>;
};


export type QueryBreadcrumbArgs = {
  date?: InputMaybe<Scalars['Date']>;
  driverId: Scalars['ID'];
  maxTime?: InputMaybe<Scalars['Timestamp']>;
  minTime?: InputMaybe<Scalars['Timestamp']>;
};


export type QueryCostCentersArgs = {
  endCustomerIds: Array<Scalars['ID']>;
};


export type QueryCourierArgs = {
  courierId: Scalars['ID'];
};


export type QueryCourierByPathArgs = {
  customerPortalPath: Scalars['String'];
};


export type QueryCourierHolidaysArgs = {
  courierId: Scalars['ID'];
};


export type QueryCustomDeductionsArgs = {
  driverPayEntryId: Scalars['ID'];
};


export type QueryCustomFieldsArgs = {
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  visibleToSelectedEndCustomerOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDispatchPreviewsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  shipmentId: Scalars['ID'];
  workType?: InputMaybe<DriverWorkType>;
};


export type QueryDispatchPreviewsByDriverIdArgs = {
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  readyStatus: DispatchPreviewReadyStatus;
  targetDate: Scalars['Date'];
};


export type QueryDriverByIdArgs = {
  driverId: Scalars['ID'];
};


export type QueryDriverDaysOverviewArgs = {
  datesFilter: Array<Scalars['Date']>;
  driverIds: Array<Scalars['ID']>;
};


export type QueryDriverDefaultRoutingConfigurationsArgs = {
  dates: Array<Scalars['Date']>;
  driverIds: Array<Scalars['ID']>;
};


export type QueryDriverReportItemsArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type QueryDriverScheduleForDateRangeArgs = {
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type QueryDriverTimeEventsArgs = {
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type QueryDriversArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  isLateFilter?: InputMaybe<Scalars['Boolean']>;
  isLateSoonFilter?: InputMaybe<Scalars['Boolean']>;
  isLikelyLateFilter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<DriverSorting>>;
};


export type QueryEndCustomersArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<EndCustomerSorting>>;
};


export type QueryEndCustomersOverviewArgs = {
  courierId: Scalars['ID'];
};


export type QueryEndUsersArgs = {
  courierId: Scalars['String'];
  endCustomerIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetInvoicePdfTemplateSkeletonArgs = {
  courierId: Scalars['String'];
};


export type QueryGetVisibleColumnsArgs = {
  courierId: Scalars['String'];
  userOrEmployeeId: Scalars['String'];
};


export type QueryHolidayScheduleBehaviorsArgs = {
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
};


export type QueryHolidaySchedulesArgs = {
  courierId: Scalars['ID'];
};


export type QueryInvoiceBalancesArgs = {
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']>;
};


export type QueryInvoiceByDisplayIdArgs = {
  courierId: Scalars['ID'];
  displayId: Scalars['Int'];
  endCustomerId: Scalars['ID'];
};


export type QueryInvoiceExtendedDetailArgs = {
  invoiceId: Scalars['ID'];
};


export type QueryInvoicePdfTemplatesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryInvoicesOverviewArgs = {
  courierId: Scalars['String'];
};


export type QueryInvoicesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  costCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  courierId: Scalars['String'];
  endCustomerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  invoicingFrequency?: InputMaybe<Array<InputMaybe<InvoicingFrequency>>>;
  limit?: InputMaybe<Scalars['Int']>;
  maxEndDate?: InputMaybe<Scalars['Date']>;
  minEndDate?: InputMaybe<Scalars['Date']>;
  paymentStatuses?: InputMaybe<Array<InputMaybe<InvoicePaymentStatus>>>;
  sortFields?: InputMaybe<Array<InvoiceSorting>>;
  statuses?: InputMaybe<Array<InputMaybe<InvoiceStatus>>>;
};


export type QueryLinkedAccountsArgs = {
  courierId: Scalars['ID'];
};


export type QueryMemorizationsArgs = {
  courierId: Scalars['ID'];
  dayOfWeeks?: InputMaybe<Array<DayOfTheWeek>>;
  driverIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryOrderPayBreakDownArgs = {
  orderId: Scalars['ID'];
};


export type QueryOrderPayBreakDownWithAllocationsArgs = {
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryOrderPriceArgs = {
  orderId: Scalars['ID'];
};


export type QueryPackageTypesArgs = {
  courierId: Scalars['ID'];
};


export type QueryPayPeriodsArgs = {
  courierId: Scalars['ID'];
  maxDate: Scalars['Date'];
  minDate: Scalars['Date'];
};


export type QueryPaymentInstrumentsArgs = {
  courierId: Scalars['ID'];
  endCustomerIds: Array<Scalars['ID']>;
};


export type QueryPaymentSettlementsPaginatedArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
};


export type QueryPaymentTransfersPaginatedArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  invoiceIds?: InputMaybe<Array<Scalars['ID']>>;
  limit: Scalars['Int'];
  refundTypes?: InputMaybe<Array<PaymentTransferRefundType>>;
  statusFilter?: InputMaybe<Array<PaymentTransferStatus>>;
};


export type QueryPayrollDeductionRulesArgs = {
  courierId: Scalars['ID'];
};


export type QueryPayrollDeductionRulesPaginatedArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  sortFields?: InputMaybe<Array<PayrollDeductionRuleSorting>>;
};


export type QueryPayrollReportsArgs = {
  courierId: Scalars['ID'];
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type QueryPayrollSettingsArgs = {
  courierId: Scalars['ID'];
};


export type QueryPreviewEtaForRouteArgs = {
  baseTime?: InputMaybe<Scalars['Timestamp']>;
  driverId: Scalars['ID'];
  stopIds: Array<Scalars['ID']>;
};


export type QueryPreviewEtaForRoutingVehicleArgs = {
  routingVehicleId: Scalars['ID'];
};


export type QueryPricingListsArgs = {
  courierId: Scalars['ID'];
};


export type QueryPricingRulesArgs = {
  courierId: Scalars['ID'];
  defaultOnly?: InputMaybe<Scalars['Boolean']>;
  locationBasedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPricingRulesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  defaultOnly?: InputMaybe<Scalars['Boolean']>;
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  destinationCityFilter?: InputMaybe<CityStateCountryCreate>;
  destinationZipFilter?: InputMaybe<Scalars['String']>;
  destinationZipGroupIdFilter?: InputMaybe<Scalars['ID']>;
  destinationZoneIdFilter?: InputMaybe<Scalars['ID']>;
  distanceBasedOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  locationBasedOnly?: InputMaybe<Scalars['Boolean']>;
  originCityFilter?: InputMaybe<CityStateCountryCreate>;
  originZipFilter?: InputMaybe<Scalars['String']>;
  originZipGroupIdFilter?: InputMaybe<Scalars['ID']>;
  originZoneIdFilter?: InputMaybe<Scalars['ID']>;
  pricingListIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  serviceTypeIdsFilter?: InputMaybe<Array<Scalars['String']>>;
  sortFields?: InputMaybe<Array<PricingRulesSorting>>;
  tripBasedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPromptActionsArgs = {
  endCustomerId: Scalars['ID'];
  endUserId?: InputMaybe<Scalars['ID']>;
  promptType?: InputMaybe<PromptType>;
};


export type QueryQuickbookCustomerArgs = {
  courierId: Scalars['ID'];
  remoteId: Scalars['ID'];
};


export type QueryQuickbookVendorArgs = {
  courierId: Scalars['ID'];
  remoteId: Scalars['ID'];
};


export type QueryRoutingJobByIdArgs = {
  id: Scalars['ID'];
};


export type QueryRoutingJobsArgs = {
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};


export type QuerySalesItemsPaginatedArgs = {
  after: Scalars['Int'];
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  maxDate?: InputMaybe<Scalars['Date']>;
  minDate?: InputMaybe<Scalars['Date']>;
};


export type QuerySalesOverviewArgs = {
  courierId: Scalars['ID'];
  maxDate?: InputMaybe<Scalars['Date']>;
  minDate?: InputMaybe<Scalars['Date']>;
};


export type QuerySearchEndCustomerArgs = {
  courierId: Scalars['ID'];
  searchTerm: Scalars['String'];
};


export type QuerySearchFromAddressBookArgs = {
  companyNameSearch?: InputMaybe<Scalars['String']>;
  contactNameSearch?: InputMaybe<Scalars['String']>;
  courierId?: InputMaybe<Scalars['ID']>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerIdBias?: InputMaybe<Scalars['ID']>;
  phoneSearch?: InputMaybe<Scalars['String']>;
  streetAddressSearch?: InputMaybe<Scalars['String']>;
};


export type QueryServiceTypesArgs = {
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  showForEndCustomer?: InputMaybe<Scalars['Boolean']>;
};


export type QueryShipmentByIdArgs = {
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};


export type QueryShipmentByTrackingNumberArgs = {
  courierId: Scalars['ID'];
  trackingNumber: Scalars['String'];
};


export type QueryShipmentTemplatesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<ShipmentTemplatesSorting>>;
};


export type QueryShipmentsArgs = {
  after?: InputMaybe<Scalars['Int']>;
  branchIds?: InputMaybe<Array<Scalars['ID']>>;
  courierId: Scalars['ID'];
  dateFilter?: InputMaybe<Scalars['Date']>;
  displayIdsFilter?: InputMaybe<Array<Scalars['Int']>>;
  driverIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
  hasDriverNoteOnly?: InputMaybe<Scalars['Boolean']>;
  hasMultipleDriverPayOnly?: InputMaybe<Scalars['Boolean']>;
  hasOrderInternalNote?: InputMaybe<Scalars['Boolean']>;
  hasUnapprovedDriverPackageReportOnly?: InputMaybe<Scalars['Boolean']>;
  hasWaitTimeOrOverride?: InputMaybe<Scalars['Boolean']>;
  isAssignedFilter?: InputMaybe<Scalars['Boolean']>;
  isClosedFilter?: InputMaybe<Scalars['Boolean']>;
  isDeliveredOnTime?: InputMaybe<Scalars['Boolean']>;
  lateByFilter?: InputMaybe<Scalars['Timestamp']>;
  likelyLateOnlyFilter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minClosingTimeFilter?: InputMaybe<Scalars['Timestamp']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  minShipmentDate?: InputMaybe<Scalars['Date']>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<ShipmentsSorting>>;
  statusFilter?: InputMaybe<ShipmentStatus>;
  statusListFilter?: InputMaybe<Array<ShipmentStatus>>;
  trackingNumbersFilter?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryShipmentsOverviewArgs = {
  branchIds?: InputMaybe<Array<Scalars['ID']>>;
  courierId?: InputMaybe<Scalars['ID']>;
  dateFilter?: InputMaybe<Scalars['Date']>;
  maxExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  minShipmentDate?: InputMaybe<Scalars['Date']>;
};


export type QueryShipmentsWithoutPaginationArgs = {
  invoiceId?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};


export type QuerySurchargePricingRulesArgs = {
  amountTypes?: InputMaybe<Array<SurchargeAmountType>>;
  applyType?: InputMaybe<SurchargeApplyType>;
  courierId: Scalars['ID'];
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  pricingListIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QuerySurchargePricingRulesPaginatedArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  pricingListIdsFilter?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryTaskByIdArgs = {
  taskId: Scalars['ID'];
};


export type QueryUniqueStopDatesArgs = {
  courierId: Scalars['ID'];
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  shipmentStatusFilter?: InputMaybe<Array<ShipmentStatus>>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Int']>;
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryVehicleTypesArgs = {
  courierId: Scalars['ID'];
};


export type QueryZipGroupsArgs = {
  courierId: Scalars['ID'];
};


export type QueryZonesArgs = {
  courierId: Scalars['ID'];
  type?: InputMaybe<ZoneType>;
};

export type QuickbookCustomer = {
  __typename?: 'QuickbookCustomer';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type QuickbookVendor = {
  __typename?: 'QuickbookVendor';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type RecordOrderClickInput = {
  clickedBy: Scalars['ID'];
  orderId: Scalars['ID'];
};

export type RecordPromptActionInput = {
  action: PromptActionType;
  endCustomerId: Scalars['ID'];
  endUserId?: InputMaybe<Scalars['ID']>;
  type: PromptType;
};

export type RecurrenceDetail = {
  __typename?: 'RecurrenceDetail';
  biweeklySchedule?: Maybe<BiWeeklySchedule>;
  endDate?: Maybe<Scalars['Date']>;
  endDateISO8601?: Maybe<Scalars['String']>;
  monthlySchedule?: Maybe<MonthlySchedule>;
  scheduleType: RecurrenceScheduleType;
  startDate?: Maybe<Scalars['Date']>;
  startDateISO8601?: Maybe<Scalars['String']>;
  weeklySchedule?: Maybe<WeeklySchedule>;
};

export type RecurrenceDetailInput = {
  biweeklySchedule?: InputMaybe<BiWeeklyScheduleInput>;
  endDateISO8601?: InputMaybe<Scalars['String']>;
  monthlySchedule?: InputMaybe<MonthlyScheduleInput>;
  scheduleType: RecurrenceScheduleType;
  startDateISO8601?: InputMaybe<Scalars['String']>;
  /**  At most one of the following is present */
  weeklySchedule?: InputMaybe<WeeklyScheduleInput>;
};

export enum RecurrenceScheduleType {
  Biweekly = 'BIWEEKLY',
  CustomDaysOfTheMonth = 'CUSTOM_DAYS_OF_THE_MONTH',
  CustomDaysOfTheWeek = 'CUSTOM_DAYS_OF_THE_WEEK',
  Daily = 'DAILY',
  MonthlyOnFirst = 'MONTHLY_ON_FIRST',
  MonthlyOnLast = 'MONTHLY_ON_LAST'
}

export enum RecurrenceType {
  OneOff = 'ONE_OFF',
  RecurringInstance = 'RECURRING_INSTANCE',
  RecurringTemplate = 'RECURRING_TEMPLATE'
}

export type RefreshDispatchPreviewsResult = {
  __typename?: 'RefreshDispatchPreviewsResult';
  numDispatchPreviews: Scalars['Int'];
};

export type RemoteEntity = {
  __typename?: 'RemoteEntity';
  courierId: Scalars['ID'];
  externalUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalId: Scalars['ID'];
  provider: ApiProvider;
  remoteId: Scalars['ID'];
  type: EntityType;
};

export type RemoteEntityLinkageUpsert = {
  courierId: Scalars['ID'];
  internalId: Scalars['ID'];
  provider: ApiProvider;
  remoteId: Scalars['ID'];
  type: EntityType;
};

export enum RouteOptimizationObjectiveType {
  Distance = 'DISTANCE',
  DistanceAndOnTime = 'DISTANCE_AND_ON_TIME',
  OnTime = 'ON_TIME'
}

export enum RouteOptimizationVehicleDistributionType {
  BalancedDistribution = 'BALANCED_DISTRIBUTION',
  None = 'NONE'
}

export type RouteOverview = {
  __typename?: 'RouteOverview';
  distanceTotalInMeters: Scalars['Float'];
  durationTotalInSeconds: Scalars['Float'];
};

export type RoutingDayResult = {
  __typename?: 'RoutingDayResult';
  date: Scalars['Date'];
  jobId: Scalars['ID'];
  vehicles: Array<RoutingVehicle>;
};

export type RoutingJob = {
  __typename?: 'RoutingJob';
  courierId: Scalars['ID'];
  dateCreated: Scalars['Date'];
  displayId: Scalars['Int'];
  driverIds: Array<Scalars['ID']>;
  id: Scalars['ID'];
  objectiveType: RouteOptimizationObjectiveType;
  /**
   * # one result per each day
   * # null when pending state
   */
  results?: Maybe<Array<RoutingDayResult>>;
  shipmentIds: Array<Scalars['ID']>;
  status: RoutingJobStatus;
  vehicleDistributionType: RouteOptimizationVehicleDistributionType;
};

export type RoutingJobConnection = {
  __typename?: 'RoutingJobConnection';
  edges?: Maybe<Array<Maybe<RoutingJobEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type RoutingJobCreate = {
  courierId: Scalars['ID'];
  createdBy: Scalars['String'];
  /** # Ranges from 0 to 10 */
  earlyPenaltyLevel: Scalars['Int'];
  /** # Ranges from 0 to 10 */
  latePenaltyLevel: Scalars['Int'];
  objectiveType?: InputMaybe<RouteOptimizationObjectiveType>;
  shipmentIds: Array<Scalars['ID']>;
  shipmentSelector?: InputMaybe<RoutingJobShipmentSelector>;
  vehicleDistributionType?: InputMaybe<RouteOptimizationVehicleDistributionType>;
  workflowType?: InputMaybe<RoutingWorkflowType>;
};

export type RoutingJobEdge = {
  __typename?: 'RoutingJobEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<RoutingJob>;
};

export type RoutingJobShipmentSelector = {
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  type: RoutingJobShipmentSelectorType;
};

export enum RoutingJobShipmentSelectorType {
  Unassigned = 'UNASSIGNED'
}

export enum RoutingJobStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  OptimizationFailed = 'OPTIMIZATION_FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export type RoutingNode = {
  __typename?: 'RoutingNode';
  assignedRouteSequenceNumber?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isNewAssignment: Scalars['Boolean'];
  jobId: Scalars['ID'];
  stop?: Maybe<Stop>;
};

export type RoutingNodeEta = {
  __typename?: 'RoutingNodeEta';
  eta: Scalars['Timestamp'];
  isLikelyEarly: Scalars['Boolean'];
  isLikelyLate: Scalars['Boolean'];
  likelyEarlyByInMinutes?: Maybe<Scalars['Int']>;
  likelyLateByInMinutes?: Maybe<Scalars['Int']>;
  routingNodeId: Scalars['ID'];
};

export type RoutingVehicle = {
  __typename?: 'RoutingVehicle';
  driver: Driver;
  endLocation?: Maybe<Location>;
  endTime?: Maybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  jobId: Scalars['ID'];
  nodes: Array<RoutingNode>;
  startLocation?: Maybe<Location>;
  startTime?: Maybe<Scalars['Timestamp']>;
  useDriverCurrentLocationAtStart: Scalars['Boolean'];
};

export type RoutingVehicleCreate = {
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  driverSpeed: Scalars['Float'];
  endLocationId?: InputMaybe<Scalars['ID']>;
  endTime?: InputMaybe<Scalars['Timestamp']>;
  startLocationId?: InputMaybe<Scalars['ID']>;
  startTime?: InputMaybe<Scalars['Timestamp']>;
  useCurrentLocationIdAtStart: Scalars['Boolean'];
};

export enum RoutingWorkflowType {
  HighVolume = 'HIGH_VOLUME',
  QuickDispatchWithMinimalOptimization = 'QUICK_DISPATCH_WITH_MINIMAL_OPTIMIZATION',
  SingleDriverSync = 'SINGLE_DRIVER_SYNC'
}

export type SalesItem = {
  __typename?: 'SalesItem';
  amount: Scalars['Money'];
  customerDisplay: Scalars['String'];
  customerDisplayId: Scalars['String'];
  destination: Scalars['String'];
  displayId: Scalars['ID'];
  driverName?: Maybe<Scalars['String']>;
  origin: Scalars['String'];
  pricingListDisplayName: Scalars['String'];
  shipmentDate: Scalars['Date'];
  trackingNumber: Scalars['String'];
};

export type SalesItemConnection = {
  __typename?: 'SalesItemConnection';
  edges?: Maybe<Array<Maybe<SalesItemEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type SalesItemEdge = {
  __typename?: 'SalesItemEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<SalesItem>;
};

export type SalesOverview = {
  __typename?: 'SalesOverview';
  amountForCompletedShipments: Scalars['Money'];
  amountTotal: Scalars['Money'];
  courierId: Scalars['ID'];
  maxDate?: Maybe<Scalars['Date']>;
  minDate?: Maybe<Scalars['Date']>;
  numShipmentsCompleted: Scalars['Int'];
  numShipmentsTotal: Scalars['Int'];
};

export enum SalesReportColumnId {
  BasePrice = 'BASE_PRICE',
  CostCenters = 'COST_CENTERS',
  CustomerDisplayName = 'CUSTOMER_DISPLAY_NAME',
  CustomFields = 'CUSTOM_FIELDS',
  DeliverBy = 'DELIVER_BY',
  Destination = 'DESTINATION',
  DispatcherNote = 'DISPATCHER_NOTE',
  Distance = 'DISTANCE',
  DriverCompensation = 'DRIVER_COMPENSATION',
  DriverName = 'DRIVER_NAME',
  DriverNote = 'DRIVER_NOTE',
  EndCustomerReferenceNumber = 'END_CUSTOMER_REFERENCE_NUMBER',
  Instructions = 'INSTRUCTIONS',
  OnTimeStatus = 'ON_TIME_STATUS',
  OrderDisplayId = 'ORDER_DISPLAY_ID',
  Origin = 'ORIGIN',
  Package = 'PACKAGE',
  Pod = 'POD',
  ReadyTime = 'READY_TIME',
  ServiceType = 'SERVICE_TYPE',
  ShipmentDate = 'SHIPMENT_DATE',
  Status = 'STATUS',
  Surcharges = 'SURCHARGES',
  TotalPrice = 'TOTAL_PRICE',
  TrackingNumber = 'TRACKING_NUMBER',
  WaitTime = 'WAIT_TIME'
}

export type SalesReportFile = {
  __typename?: 'SalesReportFile';
  url: Scalars['String'];
};

export enum ScanRequirement {
  None = 'NONE',
  OptionalButMustMatchShippingLabel = 'OPTIONAL_BUT_MUST_MATCH_SHIPPING_LABEL',
  PickUpAndDropOff = 'PICK_UP_AND_DROP_OFF',
  PickUpAndDropOffMustMatchShippingLabel = 'PICK_UP_AND_DROP_OFF_MUST_MATCH_SHIPPING_LABEL'
}

export enum ScanType {
  BarCode = 'BAR_CODE',
  QrCode = 'QR_CODE'
}

export type ScheduledStopTemplateSequenceNumber = {
  __typename?: 'ScheduledStopTemplateSequenceNumber';
  courierId: Scalars['ID'];
  dayOfWeek?: Maybe<DayOfTheWeek>;
  id: Scalars['ID'];
  sequenceNumber?: Maybe<Scalars['Int']>;
  stopTemplate: StopTemplate;
  stopTemplateId: Scalars['ID'];
};

export type ScheduledStopTemplateSequenceNumberUpsert = {
  courierId: Scalars['ID'];
  dayOfWeek: DayOfTheWeek;
  stopSequenceNumber?: InputMaybe<Scalars['Int']>;
  stopTemplateId: Scalars['ID'];
};

export enum SeparateInvoiceGenerationType {
  ByCostCenter = 'BY_COST_CENTER',
  ByEachOrder = 'BY_EACH_ORDER',
  ByReferenceNumber = 'BY_REFERENCE_NUMBER',
  None = 'NONE'
}

export type ServiceType = {
  __typename?: 'ServiceType';
  allowOrdersWith: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  courierId: Scalars['ID'];
  customMessage?: Maybe<Scalars['String']>;
  deliveryRoutedDaysAfter: Scalars['Int'];
  deliveryTimeInMinutes?: Maybe<Scalars['Int']>;
  displayId: Scalars['Int'];
  dueTimeInBusinessDaysAfter?: Maybe<Scalars['Int']>;
  dueTimeSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  dueTimeType: ServiceTypeDueTimeType;
  id: Scalars['ID'];
  name: Scalars['String'];
  readyTimeSchedule?: Maybe<TimeSchedule>;
  visibilityType: ServiceTypeVisibilityType;
};


export type ServiceTypeAllowOrdersWithArgs = {
  readyTime?: InputMaybe<Scalars['Timestamp']>;
};

export enum ServiceTypeDueTimeType {
  Fixed = 'FIXED',
  RelativeToPickup = 'RELATIVE_TO_PICKUP'
}

export type ServiceTypeFullUpdate = {
  color?: InputMaybe<Scalars['String']>;
  customMessage?: InputMaybe<Scalars['String']>;
  deliveryRoutedDaysAfter?: InputMaybe<Scalars['Int']>;
  deliveryTimeInMinutes?: InputMaybe<Scalars['Int']>;
  dueTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  dueTimeSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  dueTimeType?: InputMaybe<ServiceTypeDueTimeType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  visibilityType?: InputMaybe<ServiceTypeVisibilityType>;
};

export enum ServiceTypeVisibilityType {
  ConfiguredForCustomer = 'CONFIGURED_FOR_CUSTOMER',
  Public = 'PUBLIC'
}

export enum SettlementStatus {
  Approved = 'APPROVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Pending = 'PENDING'
}

export type Shipment = {
  __typename?: 'Shipment';
  artifacts: Array<Artifact>;
  assignedAt?: Maybe<Scalars['Timestamp']>;
  branchId?: Maybe<Scalars['ID']>;
  closedAt?: Maybe<Scalars['Timestamp']>;
  completedDate?: Maybe<Scalars['Date']>;
  completedDateOverriddenBy?: Maybe<Scalars['ID']>;
  courierId: Scalars['ID'];
  createdAt: Scalars['Timestamp'];
  deliveredAtOverride?: Maybe<Scalars['Timestamp']>;
  dispatchedByUser?: Maybe<CourieUser>;
  distancesInMeters: Scalars['Float'];
  driver?: Maybe<Driver>;
  driverConfirmedAt?: Maybe<Scalars['Timestamp']>;
  driverId?: Maybe<Scalars['ID']>;
  driverPayAllocations: Array<DriverPayAllocation>;
  driverReportedWaitTimeInMinutes?: Maybe<Scalars['Float']>;
  firstEffectiveStopDate: Scalars['Date'];
  hasCompletedDateOverride: Scalars['Boolean'];
  id: Scalars['ID'];
  internalNote?: Maybe<Scalars['String']>;
  isClosed: Scalars['Boolean'];
  isForceCompleted: Scalars['Boolean'];
  numPackages?: Maybe<Scalars['Int']>;
  order: Order;
  packageDescription?: Maybe<Scalars['String']>;
  packageItems?: Maybe<Array<PackageItem>>;
  packageSize?: Maybe<PackageSize>;
  packageType?: Maybe<PackageType>;
  packageWeightInPounds?: Maybe<Scalars['Float']>;
  proposedNumPackages?: Maybe<Scalars['Int']>;
  proposedPackageWeightInPounds?: Maybe<Scalars['Float']>;
  routingJob?: Maybe<RoutingJob>;
  routingJobId?: Maybe<Scalars['ID']>;
  shipmentDate: Scalars['Date'];
  shipmentTemplate?: Maybe<ShipmentTemplate>;
  signedByOverride?: Maybe<Scalars['String']>;
  status: ShipmentStatus;
  stops: Array<Stop>;
  trackingNumber: Scalars['String'];
  type: ShipmentType;
  vehicleType?: Maybe<VehicleType>;
  waitTimeInMinutes?: Maybe<Scalars['Float']>;
  waitTimeUnfreeMinutesOverride?: Maybe<Scalars['Float']>;
};

export type ShipmentConnection = {
  __typename?: 'ShipmentConnection';
  edges?: Maybe<Array<Maybe<ShipmentEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ShipmentCreateInput = {
  numPackages?: InputMaybe<Scalars['Int']>;
  packageDescription?: InputMaybe<Scalars['String']>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeightInPounds?: InputMaybe<Scalars['Float']>;
  shipmentDate: Scalars['Date'];
  stops: Array<StopCreateInput>;
  transportationTypeRequirement?: InputMaybe<TransportationType>;
  type?: InputMaybe<ShipmentType>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};

export type ShipmentEdge = {
  __typename?: 'ShipmentEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Shipment>;
};

export type ShipmentFullUpdate = {
  id: Scalars['ID'];
  numPackages?: InputMaybe<Scalars['Int']>;
  packageDescription?: InputMaybe<Scalars['String']>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeightInPounds?: InputMaybe<Scalars['Float']>;
  shipmentDate: Scalars['Date'];
  stopIdsToDelete?: InputMaybe<Array<Scalars['ID']>>;
  stops: Array<StopFullUpdate>;
  stopsToCreate?: InputMaybe<Array<StopCreateInput>>;
  type?: InputMaybe<ShipmentType>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};

export enum ShipmentStatus {
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  InTransit = 'IN_TRANSIT',
  Paused = 'PAUSED',
  Routed = 'ROUTED'
}

export enum ShipmentStopType {
  DropOff = 'DROP_OFF',
  PickUp = 'PICK_UP',
  Return = 'RETURN'
}

export type ShipmentTemplate = {
  __typename?: 'ShipmentTemplate';
  courierId: Scalars['ID'];
  driver?: Maybe<Driver>;
  id: Scalars['ID'];
  numPackages?: Maybe<Scalars['Int']>;
  order: Order;
  orderId: Scalars['ID'];
  packageSize?: Maybe<PackageSize>;
  packageType?: Maybe<PackageType>;
  packageTypeId?: Maybe<Scalars['ID']>;
  packageWeightInPounds?: Maybe<Scalars['Float']>;
  stopTemplates: Array<StopTemplate>;
  type: ShipmentType;
  vehicleType?: Maybe<VehicleType>;
  vehicleTypeId?: Maybe<Scalars['ID']>;
};

export type ShipmentTemplateConnection = {
  __typename?: 'ShipmentTemplateConnection';
  edges?: Maybe<Array<Maybe<ShipmentTemplateEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ShipmentTemplateCreateInput = {
  driverId?: InputMaybe<Scalars['ID']>;
  numPackages?: InputMaybe<Scalars['Int']>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeightInPounds?: InputMaybe<Scalars['Float']>;
  stopTemplates: Array<StopTemplateCreateInput>;
  transportationTypeRequirement?: InputMaybe<TransportationType>;
  type?: InputMaybe<ShipmentType>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};

export type ShipmentTemplateEdge = {
  __typename?: 'ShipmentTemplateEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ShipmentTemplate>;
};

export type ShipmentTemplateFullUpdate = {
  driverId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  numPackages?: InputMaybe<Scalars['Int']>;
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  packageWeightInPounds?: InputMaybe<Scalars['Float']>;
  stopTemplateFullUpdates: Array<StopTemplateFullUpdate>;
  stopTemplateIdsToDelete?: InputMaybe<Array<Scalars['ID']>>;
  stopTemplatesToCreate?: InputMaybe<Array<StopTemplateCreateInput>>;
  type?: InputMaybe<ShipmentType>;
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
};

export enum ShipmentTemplatesSortField {
  CreatedTime = 'CREATED_TIME',
  DestinationCity = 'DESTINATION_CITY',
  DestinationStreetAddress = 'DESTINATION_STREET_ADDRESS',
  DriverName = 'DRIVER_NAME',
  DropOffCompanyName = 'DROP_OFF_COMPANY_NAME',
  DropOffDueTime = 'DROP_OFF_DUE_TIME',
  DropOffReadyTime = 'DROP_OFF_READY_TIME',
  EndCustomerName = 'END_CUSTOMER_NAME',
  OrderDisplayId = 'ORDER_DISPLAY_ID',
  OriginCity = 'ORIGIN_CITY',
  OriginStreetAddress = 'ORIGIN_STREET_ADDRESS',
  PickUpCompanyName = 'PICK_UP_COMPANY_NAME',
  PickUpDueTime = 'PICK_UP_DUE_TIME',
  PickUpReadyTime = 'PICK_UP_READY_TIME'
}

export type ShipmentTemplatesSorting = {
  direction: SortingDirection;
  field: ShipmentTemplatesSortField;
};

export enum ShipmentType {
  MultiDropOff = 'MULTI_DROP_OFF',
  MultiDropOffRoundTrip = 'MULTI_DROP_OFF_ROUND_TRIP',
  MultiPickUp = 'MULTI_PICK_UP',
  RoundTrip = 'ROUND_TRIP',
  Simple = 'SIMPLE'
}

export type ShipmentsOverview = {
  __typename?: 'ShipmentsOverview';
  numActive?: Maybe<Scalars['Int']>;
  numAssigned?: Maybe<Scalars['Int']>;
  numClosed?: Maybe<Scalars['Int']>;
  numDelivered?: Maybe<Scalars['Int']>;
  numLateBy?: Maybe<Scalars['Int']>;
  numLikelyLate?: Maybe<Scalars['Int']>;
  numUnassigned?: Maybe<Scalars['Int']>;
};


export type ShipmentsOverviewNumLateByArgs = {
  lateBy: Scalars['Timestamp'];
  minClosingTime?: InputMaybe<Scalars['Timestamp']>;
};


export type ShipmentsOverviewNumLikelyLateArgs = {
  minClosingTime?: InputMaybe<Scalars['Timestamp']>;
};

export enum ShipmentsSortField {
  CreatedTime = 'CREATED_TIME',
  DestinationCity = 'DESTINATION_CITY',
  DestinationDispatchZone = 'DESTINATION_DISPATCH_ZONE',
  DestinationStreetAddress = 'DESTINATION_STREET_ADDRESS',
  DestinationZip = 'DESTINATION_ZIP',
  DriverName = 'DRIVER_NAME',
  DropOffCompanyName = 'DROP_OFF_COMPANY_NAME',
  DropOffDueTime = 'DROP_OFF_DUE_TIME',
  DropOffReadyTime = 'DROP_OFF_READY_TIME',
  EndCustomerName = 'END_CUSTOMER_NAME',
  IsCompleted = 'IS_COMPLETED',
  OrderDisplayId = 'ORDER_DISPLAY_ID',
  OriginCity = 'ORIGIN_CITY',
  OriginDispatchZone = 'ORIGIN_DISPATCH_ZONE',
  OriginStreetAddress = 'ORIGIN_STREET_ADDRESS',
  OriginZip = 'ORIGIN_ZIP',
  PickUpCompanyName = 'PICK_UP_COMPANY_NAME',
  PickUpDueTime = 'PICK_UP_DUE_TIME',
  PickUpReadyTime = 'PICK_UP_READY_TIME',
  Status = 'STATUS'
}

export type ShipmentsSorting = {
  direction: SortingDirection;
  field: ShipmentsSortField;
};

export enum SortingDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Stop = {
  __typename?: 'Stop';
  artifacts: Array<Artifact>;
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['Timestamp']>;
  contactName?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  dispatchZone?: Maybe<Scalars['String']>;
  dispatchZoneLine2?: Maybe<Scalars['String']>;
  driverNote?: Maybe<Scalars['String']>;
  effectiveStopDate: Scalars['Date'];
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  lngLat: LngLat;
  locationId: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  shipment: Shipment;
  shipmentId: Scalars['ID'];
  state: Scalars['String'];
  stopDate?: Maybe<Scalars['Date']>;
  streetAddress: Scalars['String'];
  suite?: Maybe<Scalars['String']>;
  tasks: Array<Task>;
  timeStatus?: Maybe<StopTimeStatus>;
  timeWindow: TimeWindow;
  type: ShipmentStopType;
  wasLateByInMinutes?: Maybe<Scalars['Int']>;
  zipCode: Scalars['String'];
};

export type StopCreateInput = {
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stopDate?: InputMaybe<Scalars['Date']>;
  stopTemplateId?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  timeWindow: TimeWindowInput;
  type: ShipmentStopType;
};

export type StopEta = {
  __typename?: 'StopEta';
  eta: Scalars['Timestamp'];
  isLikelyLate: Scalars['Boolean'];
  likelyLateByInMinutes?: Maybe<Scalars['Float']>;
  stopId: Scalars['ID'];
};

export type StopFullUpdate = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  instruction?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  stopDate?: InputMaybe<Scalars['Date']>;
  suite?: InputMaybe<Scalars['String']>;
  timeWindow: TimeWindowInput;
  type: ShipmentStopType;
};

export type StopTemplate = {
  __typename?: 'StopTemplate';
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  dispatchZone?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  lngLat: LngLat;
  phone?: Maybe<Scalars['String']>;
  shipmentTemplate: ShipmentTemplate;
  shipmentTemplateId: Scalars['ID'];
  state: Scalars['String'];
  streetAddress: Scalars['String'];
  suite?: Maybe<Scalars['String']>;
  timeWindow: TimeWindowTimeOfDay;
  timeZoneId?: Maybe<Scalars['String']>;
  type: ShipmentStopType;
  zipCode: Scalars['String'];
};

export type StopTemplateCreateInput = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  googlePlaceId: Scalars['String'];
  instruction?: InputMaybe<Scalars['String']>;
  numDaysAfterShipmentDate?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  timeWindow: TimeWindowTemplateInput;
  timeZoneId?: InputMaybe<Scalars['String']>;
  type: ShipmentStopType;
};

export type StopTemplateFullUpdate = {
  companyName?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  googlePlaceId: Scalars['String'];
  id: Scalars['ID'];
  instruction?: InputMaybe<Scalars['String']>;
  numDaysAfterShipmentDate?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  timeWindow: TimeWindowTemplateInput;
  timeZoneId?: InputMaybe<Scalars['String']>;
  type: ShipmentStopType;
};

/**
 * # See more details at
 * # https://www.notion.so/courie/MVP-Engineering-Design-Overview-d147ddfa1d46463b9d8fcb1463610a3e?pvs=4#ca8b7c9d0a19420d8a0cfafa2c2adcb0
 */
export enum StopTimeStatus {
  Completed = 'COMPLETED',
  Late = 'LATE',
  LateSoon = 'LATE_SOON',
  LikelyLate = 'LIKELY_LATE',
  NotReady = 'NOT_READY',
  OnTime = 'ON_TIME'
}

export enum SurchargeAmountType {
  CustomAmount = 'CUSTOM_AMOUNT',
  Fixed = 'FIXED',
  PercentageOnMilesCharge = 'PERCENTAGE_ON_MILES_CHARGE',
  PercentageOnTotalExceptSpecifiedSurcharges = 'PERCENTAGE_ON_TOTAL_EXCEPT_SPECIFIED_SURCHARGES',
  PerMile = 'PER_MILE',
  PerMilesOutOfPerimeter = 'PER_MILES_OUT_OF_PERIMETER',
  PerPackageLbs = 'PER_PACKAGE_LBS',
  PerPackagePiece = 'PER_PACKAGE_PIECE',
  PerWaitTimeMinutes = 'PER_WAIT_TIME_MINUTES'
}

export enum SurchargeApplyType {
  Always = 'ALWAYS',
  ManualOnly = 'MANUAL_ONLY',
  MileageBased = 'MILEAGE_BASED',
  PackageCount = 'PACKAGE_COUNT',
  PackageSize = 'PACKAGE_SIZE',
  PackageType = 'PACKAGE_TYPE',
  PackageWeightInLbs = 'PACKAGE_WEIGHT_IN_LBS',
  ReadyTime = 'READY_TIME'
}

export type SurchargePricingRule = {
  __typename?: 'SurchargePricingRule';
  amount: Scalars['Money'];
  amountDisplay: Scalars['String'];
  amountType: SurchargeAmountType;
  applyType: SurchargeApplyType;
  courierId: Scalars['ID'];
  daysOfTheWeek?: Maybe<Array<DayOfTheWeek>>;
  driverCommission?: Maybe<Scalars['Money']>;
  freeMiles?: Maybe<Scalars['Float']>;
  freePackageCount?: Maybe<Scalars['Int']>;
  freeWeight?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  maxMiles?: Maybe<Scalars['Int']>;
  maxPackageCount?: Maybe<Scalars['Int']>;
  maxReadyTimeInSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  maxWeight?: Maybe<Scalars['Float']>;
  minMiles?: Maybe<Scalars['Int']>;
  minPackageCount?: Maybe<Scalars['Int']>;
  minReadyTimeInSecondsSinceMidnight?: Maybe<Scalars['Int']>;
  minWeight?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  packageSize?: Maybe<PackageSize>;
  packageType?: Maybe<PackageType>;
  packageTypeId?: Maybe<Scalars['ID']>;
  percent: Scalars['Float'];
  perimeterZone?: Maybe<Zone>;
  pricingList?: Maybe<PricingList>;
  pricingListId?: Maybe<Scalars['ID']>;
  serviceType?: Maybe<ServiceType>;
  showInInvoice: Scalars['Boolean'];
  surchargePricingRuleIdsToExclude?: Maybe<Array<Scalars['ID']>>;
  surchargePricingRulesToExclude?: Maybe<Array<SurchargePricingRule>>;
  timeZoneId?: Maybe<Scalars['String']>;
};

export type SurchargePricingRuleConnection = {
  __typename?: 'SurchargePricingRuleConnection';
  edges?: Maybe<Array<Maybe<SurchargePricingRuleEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type SurchargePricingRuleCreate = {
  amount?: InputMaybe<Scalars['Money']>;
  amountType: SurchargeAmountType;
  applyType: SurchargeApplyType;
  courierId: Scalars['ID'];
  daysOfTheWeek?: InputMaybe<Array<DayOfTheWeek>>;
  driverCommission?: InputMaybe<Scalars['Money']>;
  freeMiles?: InputMaybe<Scalars['Float']>;
  freePackageCount?: InputMaybe<Scalars['Int']>;
  freeWeight?: InputMaybe<Scalars['Float']>;
  maxMiles?: InputMaybe<Scalars['Int']>;
  maxPackageCount?: InputMaybe<Scalars['Int']>;
  maxReadyTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  maxWeight?: InputMaybe<Scalars['Float']>;
  minMiles?: InputMaybe<Scalars['Int']>;
  minPackageCount?: InputMaybe<Scalars['Int']>;
  minReadyTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  minWeight?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  percent?: InputMaybe<Scalars['Float']>;
  perimeterZoneId?: InputMaybe<Scalars['ID']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  showInInvoice?: InputMaybe<Scalars['Boolean']>;
  surchargePricingRuleIdsToExclude?: InputMaybe<Array<Scalars['ID']>>;
  timeZoneId?: InputMaybe<Scalars['String']>;
};

export type SurchargePricingRuleEdge = {
  __typename?: 'SurchargePricingRuleEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<SurchargePricingRule>;
};

export type SurchargePricingRuleFullUpdate = {
  amount?: InputMaybe<Scalars['Money']>;
  amountType: SurchargeAmountType;
  applyType: SurchargeApplyType;
  daysOfTheWeek?: InputMaybe<Array<DayOfTheWeek>>;
  driverCommission?: InputMaybe<Scalars['Money']>;
  freeMiles?: InputMaybe<Scalars['Float']>;
  freePackageCount?: InputMaybe<Scalars['Int']>;
  freeWeight?: InputMaybe<Scalars['Float']>;
  maxMiles?: InputMaybe<Scalars['Int']>;
  maxPackageCount?: InputMaybe<Scalars['Int']>;
  maxReadyTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  maxWeight?: InputMaybe<Scalars['Float']>;
  minMiles?: InputMaybe<Scalars['Int']>;
  minPackageCount?: InputMaybe<Scalars['Int']>;
  minReadyTimeInSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  minWeight?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  packageSize?: InputMaybe<PackageSize>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
  percent?: InputMaybe<Scalars['Float']>;
  perimeterZoneId?: InputMaybe<Scalars['ID']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  showInInvoice?: InputMaybe<Scalars['Boolean']>;
  surchargePricingRuleId: Scalars['ID'];
  surchargePricingRuleIdsToExclude?: InputMaybe<Array<Scalars['ID']>>;
  timeZoneId?: InputMaybe<Scalars['String']>;
};

export enum SyncDriverWithFirebaseError {
  DriverNotFound = 'DRIVER_NOT_FOUND'
}

export type SyncDriverWithFirebaseResult = {
  __typename?: 'SyncDriverWithFirebaseResult';
  driver?: Maybe<Driver>;
  error?: Maybe<SyncDriverWithFirebaseError>;
};

export enum SyncEndCustomerWithFirebaseError {
  EndCustomerNotFound = 'END_CUSTOMER_NOT_FOUND'
}

export type SyncEndCustomerWithFirebaseResult = {
  __typename?: 'SyncEndCustomerWithFirebaseResult';
  endCustomer?: Maybe<EndCustomer>;
  endUser?: Maybe<EndUser>;
  error?: Maybe<SyncEndCustomerWithFirebaseError>;
};

export enum SyncUserWithFirebaseError {
  UserNotFound = 'USER_NOT_FOUND'
}

export type SyncUserWithFirebaseResult = {
  __typename?: 'SyncUserWithFirebaseResult';
  employeeId?: Maybe<Scalars['ID']>;
  error?: Maybe<SyncUserWithFirebaseError>;
  isEmployee: Scalars['Boolean'];
  user?: Maybe<CourieUser>;
};

export type Task = {
  __typename?: 'Task';
  arrivedAt?: Maybe<Scalars['Timestamp']>;
  arrivedByGps?: Maybe<Scalars['Timestamp']>;
  arrivedMarkedManuallyAt?: Maybe<Scalars['Timestamp']>;
  artifacts: Array<Artifact>;
  bundleType: TaskBundleType;
  bundledTasks: Array<Task>;
  date: Scalars['Date'];
  driverId: Scalars['ID'];
  etaEpochSeconds?: Maybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  sequenceNumber: Scalars['Float'];
  status: TaskStatus;
  stop: Stop;
};

export enum TaskBundleType {
  BundleFollower = 'BUNDLE_FOLLOWER',
  BundleLead = 'BUNDLE_LEAD',
  None = 'NONE'
}

export enum TaskStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Started = 'STARTED'
}

export type TimeSchedule = {
  __typename?: 'TimeSchedule';
  weekDailyList?: Maybe<Array<Maybe<TimeScheduleWeekDaily>>>;
};

export type TimeScheduleInput = {
  weekDailyList: Array<TimeScheduleWeekDailyInput>;
};

export type TimeScheduleWeekDaily = {
  __typename?: 'TimeScheduleWeekDaily';
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type TimeScheduleWeekDailyInput = {
  days: Array<DayOfTheWeek>;
  endTimeSecondsSinceMidnight: Scalars['Int'];
  startTimeSecondsSinceMidnight: Scalars['Int'];
};

export type TimeWindow = {
  __typename?: 'TimeWindow';
  close?: Maybe<Scalars['Timestamp']>;
  open?: Maybe<Scalars['Timestamp']>;
};

export type TimeWindowInput = {
  close?: InputMaybe<Scalars['Timestamp']>;
  open?: InputMaybe<Scalars['Timestamp']>;
};

export type TimeWindowTemplateInput = {
  closeSecondsSinceMidnightUtc?: InputMaybe<Scalars['Int']>;
  openSecondsSinceMidnightUtc?: InputMaybe<Scalars['Int']>;
};

export type TimeWindowTimeOfDay = {
  __typename?: 'TimeWindowTimeOfDay';
  closeSecondsSinceMidnightUtc?: Maybe<Scalars['Int']>;
  openSecondsSinceMidnightUtc?: Maybe<Scalars['Int']>;
};

export enum TransportationType {
  Bike = 'BIKE',
  Car = 'CAR',
  Other = 'OTHER',
  PublicTransportation = 'PUBLIC_TRANSPORTATION',
  Truck = 'TRUCK',
  Van = 'VAN',
  Walking = 'WALKING'
}

export type UnassignedShipmentsForDate = {
  __typename?: 'UnassignedShipmentsForDate';
  date: Scalars['Date'];
  shipmentTemplates: Array<ShipmentTemplate>;
  shipments: Array<Shipment>;
};

export type UserFullUpdate = {
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type Vehicle = {
  __typename?: 'Vehicle';
  color?: Maybe<Scalars['String']>;
  driverId: Scalars['ID'];
  id: Scalars['ID'];
  licensePlate?: Maybe<Scalars['String']>;
  licensePlateState?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  transportationType: TransportationType;
  year?: Maybe<Scalars['Int']>;
};

export type VehicleType = {
  __typename?: 'VehicleType';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shortCode: Scalars['String'];
};

export type VisibleColumnsConfig = {
  __typename?: 'VisibleColumnsConfig';
  driverReportColumnIds?: Maybe<Array<DriverReportColumnId>>;
  id: Scalars['ID'];
  salesReportColumnIds?: Maybe<Array<SalesReportColumnId>>;
  userOrEmployeeId: Scalars['String'];
};

export type WeeklySchedule = {
  __typename?: 'WeeklySchedule';
  weekDays: Array<DayOfTheWeek>;
};

export type WeeklyScheduleInput = {
  weekDays: Array<DayOfTheWeek>;
};

export type ZipGroup = {
  __typename?: 'ZipGroup';
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  zipCodes: Array<Scalars['String']>;
};

export type Zone = {
  __typename?: 'Zone';
  courierId: Scalars['ID'];
  displayId: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  polygon: Polygon;
  type: ZoneType;
};

export type ZoneCreate = {
  name: Scalars['String'];
  polygon: PolygonInput;
  type: ZoneType;
};

export enum ZoneType {
  Dispatch = 'DISPATCH',
  Pricing = 'PRICING'
}

export type ZoneUpdate = {
  id: Scalars['ID'];
  name: Scalars['String'];
  polygon: PolygonInput;
  type: ZoneType;
};

export type _Service = {
  __typename?: '_Service';
  sdl: Scalars['String'];
};

export type ActivityFragmentFragment = { __typename?: 'Activity', id: string, courierId: string, entityId: string, entityType: ActivityEntityType, infoType: ActivityInfoType, description?: string | null, time: any, date: any };

export type ActivitySnapshotFragmentFragment = { __typename?: 'ActivitySnapshot', value?: string | null, entries?: Array<{ __typename?: 'ActivitySnapshotEntry', key: string, value: string } | null> | null };

export type ActivitySnapshotEntryFragmentFragment = { __typename?: 'ActivitySnapshotEntry', key: string, value: string };

export type ActivitiesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  entityId: Scalars['ID'];
}>;


export type ActivitiesQuery = { __typename?: 'Query', activities: { __typename?: 'ActivitiesResult', activities: Array<{ __typename?: 'Activity', id: string, courierId: string, entityId: string, entityType: ActivityEntityType, infoType: ActivityInfoType, description?: string | null, time: any, date: any, change?: { __typename?: 'ActivityChangeDetail', old?: { __typename?: 'ActivitySnapshot', value?: string | null, entries?: Array<{ __typename?: 'ActivitySnapshotEntry', key: string, value: string } | null> | null } | null, new?: { __typename?: 'ActivitySnapshot', value?: string | null, entries?: Array<{ __typename?: 'ActivitySnapshotEntry', key: string, value: string } | null> | null } | null } | null, updatedByUser?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null } | null, updatedByEndCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } | null, updatedByEndUser?: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null } | null, updatedByDriver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null }> } };

export type AddressBookFragmentFragment = { __typename?: 'AddressBookEntry', id: string, endCustomerId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, suite?: string | null, instruction?: string | null, location: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } };

export type CreateAddressBookMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  contactName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
}>;


export type CreateAddressBookMutation = { __typename?: 'Mutation', createAddressBook: { __typename?: 'AddressBookEntry', id: string, endCustomerId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, suite?: string | null, instruction?: string | null, location: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } } };

export type FullUpdateAddressBookMutationVariables = Exact<{
  id: Scalars['ID'];
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  contactName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
}>;


export type FullUpdateAddressBookMutation = { __typename?: 'Mutation', fullUpdateAddressBook: { __typename?: 'AddressBookEntry', id: string, endCustomerId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, suite?: string | null, instruction?: string | null, location: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } } };

export type DeleteAddressBookMutationVariables = Exact<{
  id: Scalars['ID'];
  courierId: Scalars['ID'];
}>;


export type DeleteAddressBookMutation = { __typename?: 'Mutation', deleteAddressBook?: boolean | null };

export type SearchFromAddressBookQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerIdBias?: InputMaybe<Scalars['ID']>;
  contactNameSearch?: InputMaybe<Scalars['String']>;
  companyNameSearch?: InputMaybe<Scalars['String']>;
  phoneSearch?: InputMaybe<Scalars['String']>;
  streetAddressSearch?: InputMaybe<Scalars['String']>;
}>;


export type SearchFromAddressBookQuery = { __typename?: 'Query', searchFromAddressBook: Array<{ __typename?: 'AddressBookEntry', id: string, endCustomerId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, suite?: string | null, instruction?: string | null, location: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } }> };

export type AddressBookEntriesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<AddressBookSorting> | AddressBookSorting>;
}>;


export type AddressBookEntriesQuery = { __typename?: 'Query', addressBookEntries?: { __typename?: 'AddressBookEntryConnection', edges?: Array<{ __typename?: 'AddressBookEntryEdge', node?: { __typename?: 'AddressBookEntry', id: string, endCustomerId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, suite?: string | null, instruction?: string | null, endCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } | null, location: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } | null };

export type ArtifactFragmentFragment = { __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any };

export type GenerateResetPasswordLinkMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type GenerateResetPasswordLinkMutation = { __typename?: 'Mutation', generateResetPasswordLink: { __typename?: 'GenerateResetPasswordLinkResult', link?: string | null } };

export type SendPasswordResetEmailMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  endUserIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  emails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SendPasswordResetEmailMutation = { __typename?: 'Mutation', sendPasswordResetEmail?: number | null };

export type BulkUploadOrdersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type BulkUploadOrdersMutation = { __typename?: 'Mutation', bulkUploadOrders: { __typename?: 'BulkUploadOrdersResult', numSuccess: number, error?: { __typename?: 'CsvValidationError', errorMessages: Array<string>, lineErrors: Array<{ __typename?: 'CsvValidationLineError', lineNumber: number, cellErrors: Array<{ __typename?: 'CsvValidationCellError', columnName?: string | null, errorMessage: string }> }> } | null } };

export type BulkUploadEndCustomersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
  ignoreInvalidAddresses?: InputMaybe<Scalars['Boolean']>;
  ignoreInvalidPricingLists?: InputMaybe<Scalars['Boolean']>;
  ignoreInvalidInvoiceFrequencies?: InputMaybe<Scalars['Boolean']>;
}>;


export type BulkUploadEndCustomersMutation = { __typename?: 'Mutation', bulkUploadEndCustomers: { __typename?: 'BulkUploadEndCustomersResult', numSuccess: number, errors?: Array<{ __typename?: 'BulkUploadEndCustomersRowError', rowNumber: number, messages: Array<string> }> | null } };

export type CostCenterFragmentFragment = { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null };

export type CreateCostCenterMutationVariables = Exact<{
  endCustomerId: Scalars['ID'];
  name: Scalars['String'];
  googlePlaceId?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type CreateCostCenterMutation = { __typename?: 'Mutation', createCostCenter: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type MarkCostCenterDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  costCenterId: Scalars['ID'];
}>;


export type MarkCostCenterDeletedMutation = { __typename?: 'Mutation', markCostCenterDeleted?: boolean | null };

export type GetCostCentersQueryVariables = Exact<{
  endCustomerIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetCostCentersQuery = { __typename?: 'Query', costCenters: Array<{ __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> };

export type CourierFragmentFragment = { __typename?: 'Courier', id: string, name: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, enabledCommunicationTypes: Array<CommunicationTypeId>, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, packageTypes: Array<{ __typename?: 'PackageType', id: string, courierId: string, name: string }>, vehicleTypes: Array<{ __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string }>, customFields: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType }>, primaryLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null };

export type GetCourierQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetCourierQuery = { __typename?: 'Query', courier?: { __typename?: 'Courier', id: string, name: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, enabledCommunicationTypes: Array<CommunicationTypeId>, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, packageTypes: Array<{ __typename?: 'PackageType', id: string, courierId: string, name: string }>, vehicleTypes: Array<{ __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string }>, customFields: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType }>, primaryLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } | null };

export type GetCouriersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCouriersQuery = { __typename?: 'Query', couriers: Array<{ __typename?: 'Courier', id: string, name: string, primaryPhoneNumber?: string | null, primaryEmail?: string | null, enabledCommunicationTypes: Array<CommunicationTypeId>, logoUrl: string, timeZoneId: string, finixMerchantId?: string | null, defaultCurrency?: string | null, dispatcherOrderEntryAdditionalFields: Array<DispatcherOrderEntryAdditionalField>, packageTypes: Array<{ __typename?: 'PackageType', id: string, courierId: string, name: string }>, vehicleTypes: Array<{ __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string }>, customFields: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType }>, primaryLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> };

export type CustomFieldFragmentFragment = { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType };

export type CustomFieldValueFragmentFragment = { __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null };

export type CreateCustomFieldMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  type: CustomFieldType;
  visibilityType?: InputMaybe<CustomFieldCustomerVisibilityType>;
  customerSpecificityType?: InputMaybe<CustomFieldCustomerSpecificity>;
  requirementType?: InputMaybe<CustomFieldCustomerRequirementType>;
}>;


export type CreateCustomFieldMutation = { __typename?: 'Mutation', createCustomField: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType } };

export type FullUpdateCustomFieldMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: CustomFieldType;
  visibilityType: CustomFieldCustomerVisibilityType;
  customerSpecificityType: CustomFieldCustomerSpecificity;
  requirementType: CustomFieldCustomerRequirementType;
}>;


export type FullUpdateCustomFieldMutation = { __typename?: 'Mutation', fullUpdateCustomField: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType } };

export type MarkCustomFieldAsDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type MarkCustomFieldAsDeletedMutation = { __typename?: 'Mutation', markCustomFieldAsDeleted: boolean };

export type GetCustomFieldsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  visibleToSelectedEndCustomerOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCustomFieldsQuery = { __typename?: 'Query', customFields: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType }> };

export type DispatchPreviewFragmentFragment = { __typename?: 'DispatchPreview', shipmentId: string, shipmentDate: any, distanceInMeters?: number | null, durationInSeconds?: number | null, distanceAdditionalInMeters?: number | null, durationAdditionalInSeconds?: number | null, remainingWorkloadInSeconds?: number | null, numCurrentTasks: number, tags: Array<DispatchPreviewTag> };

export type DispatchDriverForShipmentMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
  driverId: Scalars['ID'];
  orderingAlgorithmType?: InputMaybe<OrderingAlgorithmType>;
  stopIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  dispatchedBy?: InputMaybe<Scalars['ID']>;
  autoRoutedStopIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type DispatchDriverForShipmentMutation = { __typename?: 'Mutation', dispatchDriverForShipment?: string | null };

export type OptimizeRouteForDispatchMutationVariables = Exact<{
  newShipmentId: Scalars['ID'];
  driverId: Scalars['ID'];
  orderingAlgorithmType: OrderingAlgorithmType;
  stopDate?: InputMaybe<Scalars['Date']>;
  baseTime?: InputMaybe<Scalars['Timestamp']>;
  startLocationId?: InputMaybe<Scalars['ID']>;
  endLocationId?: InputMaybe<Scalars['ID']>;
}>;


export type OptimizeRouteForDispatchMutation = { __typename?: 'Mutation', optimizeRouteForDispatch: { __typename?: 'OptimizeRouteForDispatchResult', stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, shipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } }> } };

export type DispatchDriverForShipmentMultiDayMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
  driverId: Scalars['ID'];
  orderingAlgorithmType: OrderingAlgorithmType;
  dispatchedBy?: InputMaybe<Scalars['ID']>;
  days: Array<DispatchStopsOnDayInput> | DispatchStopsOnDayInput;
  dispatchSource?: InputMaybe<DispatchSource>;
  dispatchPreviewSortingType?: InputMaybe<Scalars['String']>;
  dispatchPreviewSection?: InputMaybe<Scalars['String']>;
  driverRank?: InputMaybe<Scalars['Int']>;
  dispatchPreviews?: InputMaybe<Array<DispatchPreviewSaveInput> | DispatchPreviewSaveInput>;
  dispatchPageType?: InputMaybe<DispatchPageType>;
}>;


export type DispatchDriverForShipmentMultiDayMutation = { __typename?: 'Mutation', dispatchDriverForShipmentMultiDay?: string | null };

export type GetDispatchPreviewsQueryVariables = Exact<{
  shipmentId: Scalars['ID'];
  taskStatusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
  shipmentDate: Scalars['Date'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  workType?: InputMaybe<DriverWorkType>;
}>;


export type GetDispatchPreviewsQuery = { __typename?: 'Query', dispatchPreviews: Array<{ __typename?: 'DispatchPreview', shipmentId: string, shipmentDate: any, distanceInMeters?: number | null, durationInSeconds?: number | null, distanceAdditionalInMeters?: number | null, durationAdditionalInSeconds?: number | null, remainingWorkloadInSeconds?: number | null, numCurrentTasks: number, tags: Array<DispatchPreviewTag>, driver: { __typename?: 'Driver', workType: DriverWorkType, id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, lastReportedLocation?: { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any, stop: { __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, shipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, shipmentTemplate?: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } } | null }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } } }>, vehicle?: { __typename?: 'Vehicle', id: string, driverId: string, transportationType: TransportationType } | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } }> };

export type DispatchPreviewsByDriverIdQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  targetDate: Scalars['Date'];
  readyStatus: DispatchPreviewReadyStatus;
}>;


export type DispatchPreviewsByDriverIdQuery = { __typename?: 'Query', dispatchPreviewsByDriverId: Array<{ __typename?: 'DispatchPreview', shipmentId: string, shipmentDate: any, distanceInMeters?: number | null, durationInSeconds?: number | null, distanceAdditionalInMeters?: number | null, durationAdditionalInSeconds?: number | null, remainingWorkloadInSeconds?: number | null, numCurrentTasks: number, tags: Array<DispatchPreviewTag>, shipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, createdByUser?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null } | null, createdByEndCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } | null, createdByEndUser?: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null } | null, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } } }> };

export type DriverDailyWorkFragmentFragment = { __typename?: 'DriverDailyWork', date: any, workDurationInMinutes: number, isConsistentEvents: boolean, milesByOdometer: number, dailyRegularWorkDuration: number, dailyOvertimeWorkDuration: number };

export type DriverReportItemFragmentFragment = { __typename?: 'DriverReportItem', driverId: string, startDate: any, endDate: any, regularHourlyRate: any, overtimeHourlyRate: any, reimbursementPerMile: any, totalMilesByGPS: number, mileageReimbursementMethod: DriversMileageReimbursementMethod, numCompletedOrder: number, totalCommission: any, totalMilesByOdometer: number, totalWorkDurationInMinutes: number, regularDailyCalculatedWorkDurationInMinutes: number, overtimeDailyCalculatedWorkDurationInMinutes: number, numDaysWorked: number, wageRegular: any, wageOvertime: any, wageTotal: any, mileageReimbursement: any, wageTotalWithMileageReimbursement: any, totalPay: any, suggestedBonus: any, workDurations: Array<{ __typename?: 'DriverDailyWork', date: any, workDurationInMinutes: number, isConsistentEvents: boolean, milesByOdometer: number, dailyRegularWorkDuration: number, dailyOvertimeWorkDuration: number }>, deductions: Array<{ __typename?: 'PayrollDeductionAmount', name: string, amountTotal: any }> };

export type DriverReportItemsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type DriverReportItemsQuery = { __typename?: 'Query', driverReportItems: Array<{ __typename?: 'DriverReportItem', driverId: string, startDate: any, endDate: any, regularHourlyRate: any, overtimeHourlyRate: any, reimbursementPerMile: any, totalMilesByGPS: number, mileageReimbursementMethod: DriversMileageReimbursementMethod, numCompletedOrder: number, totalCommission: any, totalMilesByOdometer: number, totalWorkDurationInMinutes: number, regularDailyCalculatedWorkDurationInMinutes: number, overtimeDailyCalculatedWorkDurationInMinutes: number, numDaysWorked: number, wageRegular: any, wageOvertime: any, wageTotal: any, mileageReimbursement: any, wageTotalWithMileageReimbursement: any, totalPay: any, suggestedBonus: any, driver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null }, workDurations: Array<{ __typename?: 'DriverDailyWork', date: any, workDurationInMinutes: number, isConsistentEvents: boolean, milesByOdometer: number, dailyRegularWorkDuration: number, dailyOvertimeWorkDuration: number }>, deductions: Array<{ __typename?: 'PayrollDeductionAmount', name: string, amountTotal: any }> }> };

export type DriverFragmentFragment = { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null };

export type VehicleFragmentFragment = { __typename?: 'Vehicle', id: string, driverId: string, transportationType: TransportationType };

export type DriverLocationFragmentFragment = { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } };

export type BreadcrumbCurveFragmentFragment = { __typename?: 'DriverBreadcrumbCurve', locations: Array<{ __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } }> };

export type DriverScheduleForDateFragmentFragment = { __typename?: 'DriverScheduleForDate', driverId: string, date: any, labels: Array<string>, emailSentAt?: any | null, confirmedAt?: any | null, hasWorkloadChanged?: boolean | null };

export type DriverScheduleTimeBlockFragmentFragment = { __typename?: 'DriverScheduleTimeBlock', start: any, end: any };

export type DriverTimeEventFragmentFragment = { __typename?: 'DriverTimeEvent', id: string, date: any, driverId: string, courierId: string, eventType: DriverTimeEventType, reason?: DriverTimeEventReason | null, odometerInMiles?: number | null, updatedBy: string, eventAt: any };

export type AssignDriverVehicleTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  vehicleTypeId?: InputMaybe<Scalars['ID']>;
}>;


export type AssignDriverVehicleTypeMutation = { __typename?: 'Mutation', assignDriverVehicleType?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null };

export type CreateDriverMutationVariables = Exact<{
  courierId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  speed?: InputMaybe<Scalars['Float']>;
  homeLocationId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateDriverMutation = { __typename?: 'Mutation', createDriver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type FullUpdateDriverMutationVariables = Exact<{
  fullUpdate: DriverFullUpdate;
}>;


export type FullUpdateDriverMutation = { __typename?: 'Mutation', fullUpdateDriver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type DeleteDriverMutationVariables = Exact<{
  driverId: Scalars['ID'];
}>;


export type DeleteDriverMutation = { __typename?: 'Mutation', deleteDriver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type UpdateDriverAvailabilityV1MutationVariables = Exact<{
  driverId: Scalars['ID'];
  isAvailable: Scalars['Boolean'];
}>;


export type UpdateDriverAvailabilityV1Mutation = { __typename?: 'Mutation', updateDriverAvailabilityV1: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type UpdateDriverBaseWorkScheduleMutationVariables = Exact<{
  driverId: Scalars['ID'];
  workSchedule: DriverWorkScheduleInput;
}>;


export type UpdateDriverBaseWorkScheduleMutation = { __typename?: 'Mutation', updateDriverBaseWorkSchedule: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type SetDriverScheduleOverrideMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  date: Scalars['Date'];
  isDayOff: Scalars['Boolean'];
  timeBlocks: Array<DriverScheduleTimeBlockInput> | DriverScheduleTimeBlockInput;
  labels: Array<Scalars['String']> | Scalars['String'];
}>;


export type SetDriverScheduleOverrideMutation = { __typename?: 'Mutation', setDriverScheduleOverride: { __typename?: 'DriverScheduleForDate', driverId: string, date: any, labels: Array<string>, emailSentAt?: any | null, confirmedAt?: any | null, hasWorkloadChanged?: boolean | null, timeBlocks: Array<{ __typename?: 'DriverScheduleTimeBlock', start: any, end: any }> } };

export type ModifyDriverTimeEventsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  updates: Array<DriverTimeEventUpdateInput> | DriverTimeEventUpdateInput;
  newEvent?: InputMaybe<DriverTimeEventCreateInput>;
  eventIdsToDelete: Array<Scalars['ID']> | Scalars['ID'];
  updatedBy: Scalars['ID'];
}>;


export type ModifyDriverTimeEventsMutation = { __typename?: 'Mutation', modifyDriverTimeEvents: Array<{ __typename?: 'DriverTimeEvent', id: string, date: any, driverId: string, courierId: string, eventType: DriverTimeEventType, reason?: DriverTimeEventReason | null, odometerInMiles?: number | null, updatedBy: string, eventAt: any }> };

export type SendDriverScheduleConfirmationEmailsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  forceSend?: InputMaybe<Scalars['Boolean']>;
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SendDriverScheduleConfirmationEmailsMutation = { __typename?: 'Mutation', sendDriverScheduleConfirmationEmails: Array<string> };

export type UpdateDriverCompensationMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverId: Scalars['ID'];
  employmentType: DriverEmploymentType;
  compensation: DriverCompensation;
}>;


export type UpdateDriverCompensationMutation = { __typename?: 'Mutation', updateDriverCompensation: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type GetBreadcrumbByDriverIdQueryVariables = Exact<{
  driverId: Scalars['ID'];
  minTime?: InputMaybe<Scalars['Timestamp']>;
  maxTime?: InputMaybe<Scalars['Timestamp']>;
  date?: InputMaybe<Scalars['Date']>;
}>;


export type GetBreadcrumbByDriverIdQuery = { __typename?: 'Query', breadcrumb: { __typename?: 'DriverBreadcrumb', driverId: string, curves: Array<{ __typename?: 'DriverBreadcrumbCurve', locations: Array<{ __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } }> }> } };

export type GetDriverTasksByDriverIdQueryVariables = Exact<{
  driverId: Scalars['ID'];
  date: Scalars['Date'];
  statusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
}>;


export type GetDriverTasksByDriverIdQuery = { __typename?: 'Query', driverById: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any, stop: { __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, shipment: { __typename?: 'Shipment', id: string, status: ShipmentStatus, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, invoicePdfTemplate?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } }, shipmentTemplate?: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null } | null }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } } }>, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type GetDriversQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<DriverSorting> | DriverSorting>;
  simpleSearch?: InputMaybe<Scalars['String']>;
}>;


export type GetDriversQuery = { __typename?: 'Query', drivers?: { __typename?: 'DriverConnection', edges?: Array<{ __typename?: 'DriverEdge', node?: { __typename?: 'Driver', homeLocationId?: string | null, id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, baseWorkSchedule?: { __typename?: 'DriverWorkSchedule', weekDailyList: Array<{ __typename?: 'DriverScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number }> } | null, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }>, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } | null };

export type GetFleetQueryQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  date: Scalars['Date'];
  statusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
}>;


export type GetFleetQueryQuery = { __typename?: 'Query', drivers?: { __typename?: 'DriverConnection', edges?: Array<{ __typename?: 'DriverEdge', node?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, lastReportedLocation?: { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any, stop: { __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } } }>, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null } | null> | null } | null };

export type GetDriverByIdQueryVariables = Exact<{
  driverId: Scalars['ID'];
  date: Scalars['Date'];
  statusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
}>;


export type GetDriverByIdQuery = { __typename?: 'Query', driverById: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, lastReportedLocation?: { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any, stop: { __typename?: 'Stop', completedAt?: any | null, id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, shipment: { __typename?: 'Shipment', id: string, status: ShipmentStatus, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, invoicePdfTemplate?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, shipmentTemplate?: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } } | null }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } } }>, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type FetchDriverTasksByDateAndStatusQueryVariables = Exact<{
  courierId: Scalars['ID'];
  date: Scalars['Date'];
  statusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type FetchDriverTasksByDateAndStatusQuery = { __typename?: 'Query', drivers?: { __typename?: 'DriverConnection', edges?: Array<{ __typename?: 'DriverEdge', node?: { __typename?: 'Driver', homeLocationId?: string | null, numRecurringStops: number, id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any, stop: { __typename?: 'Stop', completedAt?: any | null, id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, shipment: { __typename?: 'Shipment', id: string, status: ShipmentStatus }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } } }>, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null } | null> | null } | null };

export type GetDriverCurrentLocationQueryVariables = Exact<{
  driverId: Scalars['ID'];
}>;


export type GetDriverCurrentLocationQuery = { __typename?: 'Query', driverById: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, lastReportedLocation?: { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type GetDriverTasksOnlyByDriverIdQueryVariables = Exact<{
  driverId: Scalars['ID'];
  statusFilter?: InputMaybe<Array<TaskStatus> | TaskStatus>;
  minDate?: InputMaybe<Scalars['Date']>;
  maxDate?: InputMaybe<Scalars['Date']>;
}>;


export type GetDriverTasksOnlyByDriverIdQuery = { __typename?: 'Query', driverById: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any }>, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type GetDriverDefaultRoutingConfigurationsQueryVariables = Exact<{
  driverIds: Array<Scalars['ID']> | Scalars['ID'];
  dates: Array<Scalars['Date']> | Scalars['Date'];
}>;


export type GetDriverDefaultRoutingConfigurationsQuery = { __typename?: 'Query', driverDefaultRoutingConfigurations: Array<{ __typename?: 'DriverDefaultRoutingConfiguration', driverId: string, date: any, startLocationId?: string | null, endLocationId?: string | null, useCurrentLocationAtStart?: boolean | null, startTime?: any | null, endTime?: any | null, isWorkDay?: boolean | null, startLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, endLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> };

export type GetDriverScheduleForDateRangeQueryVariables = Exact<{
  courierId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
}>;


export type GetDriverScheduleForDateRangeQuery = { __typename?: 'Query', driverScheduleForDateRange: { __typename?: 'DriverSchedulesResult', driverSchedules: Array<{ __typename?: 'DriverScheduleForDates', driver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null }, schedule: Array<{ __typename?: 'DriverScheduleForDate', driverId: string, date: any, labels: Array<string>, emailSentAt?: any | null, confirmedAt?: any | null, hasWorkloadChanged?: boolean | null, timeBlocks: Array<{ __typename?: 'DriverScheduleTimeBlock', start: any, end: any }>, shipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, shipmentTemplate?: { __typename?: 'ShipmentTemplate', order: { __typename?: 'Order', displayId: number, name?: string | null } } | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } }> }>, completedShipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, shipmentTemplate?: { __typename?: 'ShipmentTemplate', order: { __typename?: 'Order', displayId: number, name?: string | null } } | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } }> }>, shipmentTemplates: Array<{ __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, stopTemplates: Array<{ __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null } }>, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null }> }> }>, unassignedShipments: Array<{ __typename?: 'UnassignedShipmentsForDate', date: any, shipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } }>, shipmentTemplates: Array<{ __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, field: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType } }>, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null, stopTemplates: Array<{ __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null } }> }> }> } };

export type GetDriverWorkingTimesForDateQueryVariables = Exact<{
  courierId: Scalars['ID'];
  date: Scalars['Date'];
}>;


export type GetDriverWorkingTimesForDateQuery = { __typename?: 'Query', driverScheduleForDateRange: { __typename?: 'DriverSchedulesResult', driverSchedules: Array<{ __typename?: 'DriverScheduleForDates', driver: { __typename?: 'Driver', id: string }, schedule: Array<{ __typename?: 'DriverScheduleForDate', date: any, timeBlocks: Array<{ __typename?: 'DriverScheduleTimeBlock', start: any, end: any }> }> }> } };

export type GetDriverTimeEventsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type GetDriverTimeEventsQuery = { __typename?: 'Query', driverTimeEvents: Array<{ __typename?: 'DriverTimeEvent', id: string, date: any, driverId: string, courierId: string, eventType: DriverTimeEventType, reason?: DriverTimeEventReason | null, odometerInMiles?: number | null, updatedBy: string, eventAt: any }> };

export type EndUserFragmentFragment = { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null };

export type CreateEndUserMutationVariables = Exact<{
  courierId: Scalars['String'];
  endCustomerId: Scalars['String'];
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
}>;


export type CreateEndUserMutation = { __typename?: 'Mutation', createEndUser: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null } };

export type MarkEndUserAsDeletedMutationVariables = Exact<{
  endUserId: Scalars['ID'];
}>;


export type MarkEndUserAsDeletedMutation = { __typename?: 'Mutation', markEndUserAsDeleted: string };

export type GetEndUsersQueryVariables = Exact<{
  courierId: Scalars['String'];
  endCustomerIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetEndUsersQuery = { __typename?: 'Query', endUsers: Array<{ __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null }> };

export type EndCustomerCommunicationFragmentFragment = { __typename?: 'EndCustomerCommunication', id: string, courierId: string, endCustomerId: string, orderId?: string | null, shipmentId?: string | null, stopId?: string | null, communicationTypeId?: CommunicationTypeId | null, emailId?: string | null, idempotencyToken?: string | null, createdAt: any, dateCreated: any };

export type SendCommunicationToEndCustomerMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId?: InputMaybe<Scalars['ID']>;
  stopId?: InputMaybe<Scalars['ID']>;
  communicationTypeId?: InputMaybe<CommunicationTypeId>;
  emailRecipientsCommaSeparated?: InputMaybe<Scalars['String']>;
}>;


export type SendCommunicationToEndCustomerMutation = { __typename?: 'Mutation', sendCommunicationToEndCustomer?: { __typename?: 'EndCustomerCommunication', id: string, courierId: string, endCustomerId: string, orderId?: string | null, shipmentId?: string | null, stopId?: string | null, communicationTypeId?: CommunicationTypeId | null, emailId?: string | null, idempotencyToken?: string | null, createdAt: any, dateCreated: any } | null };

export type SendInvoiceEmailMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceEmailSendInput: InvoiceEmailSendInput;
}>;


export type SendInvoiceEmailMutation = { __typename?: 'Mutation', sendInvoiceEmail?: { __typename?: 'EndCustomerCommunication', id: string, courierId: string, endCustomerId: string, orderId?: string | null, shipmentId?: string | null, stopId?: string | null, communicationTypeId?: CommunicationTypeId | null, emailId?: string | null, idempotencyToken?: string | null, createdAt: any, dateCreated: any } | null };

export type EndCustomerFragmentFragment = { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null };

export type CreateEndCustomerMutationVariables = Exact<{
  courierId: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber: Scalars['String'];
  contactEmail: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  pricingListId?: InputMaybe<Scalars['ID']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  suite?: InputMaybe<Scalars['String']>;
  endCustomerCreatedSource?: InputMaybe<EndCustomerCreatedSource>;
}>;


export type CreateEndCustomerMutation = { __typename?: 'Mutation', createEndCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null } };

export type FullUpdateEndCustomerMutationVariables = Exact<{
  id: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  contactPhoneNumber: Scalars['String'];
  contactEmail: Scalars['String'];
  billingEmails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  pricingListId?: InputMaybe<Scalars['ID']>;
  suite?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  invoicingFrequency: InvoicingFrequency;
  taxCode?: InputMaybe<Scalars['String']>;
  totalPricingMultiplier?: InputMaybe<Scalars['Money']>;
  invoicePdfTemplateId?: InputMaybe<Scalars['ID']>;
  scanRequirementType?: InputMaybe<ScanRequirement>;
}>;


export type FullUpdateEndCustomerMutation = { __typename?: 'Mutation', fullUpdateEndCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, invoicePdfTemplate?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type UpdateEndCustomerVisibleServiceTypeIdsMutationVariables = Exact<{
  endCustomerId: Scalars['ID'];
  visibleServiceTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateEndCustomerVisibleServiceTypeIdsMutation = { __typename?: 'Mutation', updateEndCustomerVisibleServiceTypeIds: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type UpdatePodEmailsMutationVariables = Exact<{
  endCustomerId: Scalars['ID'];
  podEmails?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdatePodEmailsMutation = { __typename?: 'Mutation', updatePodEmails: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type MergeEndCustomersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  sourceEndCustomerId: Scalars['ID'];
  targetEndCustomerId: Scalars['ID'];
}>;


export type MergeEndCustomersMutation = { __typename?: 'Mutation', mergeEndCustomers: { __typename?: 'EndCustomer', id: string } };

export type DeleteFirebaseUserForEndCustomerMutationVariables = Exact<{
  endCustomerId: Scalars['ID'];
}>;


export type DeleteFirebaseUserForEndCustomerMutation = { __typename?: 'Mutation', deleteFirebaseUserForEndCustomer: { __typename?: 'EndCustomer', id: string } };

export type ChangePasswordEndCustomerMutationVariables = Exact<{
  endCustomerId: Scalars['ID'];
  password: Scalars['String'];
}>;


export type ChangePasswordEndCustomerMutation = { __typename?: 'Mutation', changePasswordEndCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type MarkEndCustomerConfirmedAsNewMutationVariables = Exact<{
  endCustomerId: Scalars['ID'];
}>;


export type MarkEndCustomerConfirmedAsNewMutation = { __typename?: 'Mutation', markEndCustomerConfirmedAsNew: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type UpdateEnabledEndCustomerCommunicationsTypesMutationVariables = Exact<{
  endCustomerId: Scalars['ID'];
  enabledCommunicationTypeIds: Array<CommunicationTypeId> | CommunicationTypeId;
}>;


export type UpdateEnabledEndCustomerCommunicationsTypesMutation = { __typename?: 'Mutation', updateEnabledEndCustomerCommunicationsTypes: Array<CommunicationTypeId | null> };

export type MarkEndCustomerDeletedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
}>;


export type MarkEndCustomerDeletedMutation = { __typename?: 'Mutation', markEndCustomerDeleted?: boolean | null };

export type UpdateEndCustomerCustomFieldsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  customFieldIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateEndCustomerCustomFieldsMutation = { __typename?: 'Mutation', updateEndCustomerCustomFields: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type UpdateEndCustomerNoteMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type UpdateEndCustomerNoteMutation = { __typename?: 'Mutation', updateEndCustomerNote: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type SearchEndCustomerQueryVariables = Exact<{
  courierId: Scalars['ID'];
  searchTerm: Scalars['String'];
}>;


export type SearchEndCustomerQuery = { __typename?: 'Query', searchEndCustomer: Array<{ __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }>, costCenters: Array<{ __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }>, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null }> };

export type GetEndCustomersQueryVariables = Exact<{
  courierId: Scalars['ID'];
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<EndCustomerSorting> | EndCustomerSorting>;
}>;


export type GetEndCustomersQuery = { __typename?: 'Query', endCustomers: { __typename?: 'EndCustomerConnection', edges?: Array<{ __typename?: 'EndCustomerEdge', node?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }>, costCenters: Array<{ __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }>, invoicePdfTemplate?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null, customFields?: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType }> | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetEndCustomersLengthQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetEndCustomersLengthQuery = { __typename?: 'Query', endCustomers: { __typename?: 'EndCustomerConnection', edges?: Array<{ __typename?: 'EndCustomerEdge', node?: { __typename?: 'EndCustomer', id: string } | null } | null> | null } };

export type GetEndCustomersOverviewQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetEndCustomersOverviewQuery = { __typename?: 'Query', endCustomersOverview: { __typename?: 'EndCustomersOverview', numUnconfirmedCustomerPortalEndCustomers: number } };

export type CourierHolidayFragmentFragment = { __typename?: 'CourierHoliday', id: string, name: string, recurrenceRule: string };

export type HolidayScheduleFragmentFragment = { __typename?: 'HolidaySchedule', id: string, name: string };

export type HolidayScheduleBehaviorFragmentFragment = { __typename?: 'HolidayScheduleBehavior', holidayScheduleId: string, courierHolidayId: string, behavior: HolidayBehavior, name: string, recurrenceRule: string };

export type CreateHolidayScheduleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type CreateHolidayScheduleMutation = { __typename?: 'Mutation', createHolidaySchedule: { __typename?: 'HolidaySchedule', id: string, name: string } };

export type DeleteHolidayScheduleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
}>;


export type DeleteHolidayScheduleMutation = { __typename?: 'Mutation', deleteHolidaySchedule: boolean };

export type DeleteHolidayScheduleBehaviorMutationVariables = Exact<{
  courierId: Scalars['ID'];
  courierHolidayId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
}>;


export type DeleteHolidayScheduleBehaviorMutation = { __typename?: 'Mutation', deleteHolidayScheduleBehavior: boolean };

export type UpdateHolidayScheduleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type UpdateHolidayScheduleMutation = { __typename?: 'Mutation', updateHolidaySchedule: boolean };

export type UpsertHolidayScheduleBehaviorMutationVariables = Exact<{
  courierId: Scalars['ID'];
  courierHolidayId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
  holidayBehavior: HolidayBehavior;
}>;


export type UpsertHolidayScheduleBehaviorMutation = { __typename?: 'Mutation', upsertHolidayScheduleBehavior: boolean };

export type GetCourierHolidaysQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetCourierHolidaysQuery = { __typename?: 'Query', courierHolidays: Array<{ __typename?: 'CourierHoliday', id: string, name: string, recurrenceRule: string }> };

export type GetHolidaySchedulesQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetHolidaySchedulesQuery = { __typename?: 'Query', holidaySchedules: Array<{ __typename?: 'HolidaySchedule', id: string, name: string }> };

export type GetHolidayScheduleBehaviorsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  holidayScheduleId: Scalars['ID'];
}>;


export type GetHolidayScheduleBehaviorsQuery = { __typename?: 'Query', holidayScheduleBehaviors: Array<{ __typename?: 'HolidayScheduleBehavior', holidayScheduleId: string, courierHolidayId: string, behavior: HolidayBehavior, name: string, recurrenceRule: string }> };

export type InvoiceFragmentFragment = { __typename?: 'Invoice', id: string, displayId: number, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null };

export type InvoiceDocumentFragmentFragment = { __typename?: 'InvoiceDocument', id: string, invoiceId: string, invoicePdfTemplateId?: string | null, url: string };

export type InvoicePdfTemplateFragmentFragment = { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> };

export type ApproveInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type ApproveInvoiceMutation = { __typename?: 'Mutation', approveInvoice: { __typename?: 'Invoice', id: string, displayId: number, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null } };

export type ApproveInvoicesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ApproveInvoicesMutation = { __typename?: 'Mutation', approveInvoices: { __typename?: 'BulkInvoiceApprovalResult', approved: Array<{ __typename?: 'Invoice', id: string, displayId: number, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null }>, failures: Array<{ __typename?: 'BulkInvoiceApprovalFailure', invoiceId: string, message: string }> } };

export type ForceGenerateInvoicesMutationVariables = Exact<{
  courierId: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  endCustomerIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ForceGenerateInvoicesMutation = { __typename?: 'Mutation', forceGenerateInvoices: Array<{ __typename?: 'Invoice', id: string, displayId: number, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null }> };

export type VoidInvoicesMutationVariables = Exact<{
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type VoidInvoicesMutation = { __typename?: 'Mutation', voidInvoices: Array<{ __typename?: 'Invoice', id: string, displayId: number, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null }> };

export type GenerateCsvForInvoicesMutationVariables = Exact<{
  courierId: Scalars['String'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GenerateCsvForInvoicesMutation = { __typename?: 'Mutation', generateCsvForInvoices: string };

export type MarkInvoiceAsPaidManuallyMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
  markedBy: Scalars['String'];
}>;


export type MarkInvoiceAsPaidManuallyMutation = { __typename?: 'Mutation', markInvoiceAsPaidManually: Array<{ __typename?: 'Invoice', id: string, displayId: number, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null }> };

export type GeneratePdfForInvoiceMutationVariables = Exact<{
  courierId: Scalars['String'];
  invoiceId: Scalars['ID'];
}>;


export type GeneratePdfForInvoiceMutation = { __typename?: 'Mutation', generatePdfForInvoice: { __typename?: 'InvoiceDocument', id: string, invoiceId: string, invoicePdfTemplateId?: string | null, url: string } };

export type PreviewInvoicePdfFromCreateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  template: InvoicePdfTemplateCreateInput;
}>;


export type PreviewInvoicePdfFromCreateMutation = { __typename?: 'Mutation', previewInvoicePdfFromCreate: { __typename?: 'InvoiceDocument', id: string, invoiceId: string, invoicePdfTemplateId?: string | null, url: string } };

export type PreviewInvoicePdfFromUpdateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  template: InvoicePdfTemplateUpdateInput;
}>;


export type PreviewInvoicePdfFromUpdateMutation = { __typename?: 'Mutation', previewInvoicePdfFromUpdate: { __typename?: 'InvoiceDocument', id: string, invoiceId: string, invoicePdfTemplateId?: string | null, url: string } };

export type CreateInvoicePdfTemplateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  input: InvoicePdfTemplateCreateInput;
  updatedBy: Scalars['String'];
}>;


export type CreateInvoicePdfTemplateMutation = { __typename?: 'Mutation', createInvoicePdfTemplate: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } };

export type FullUpdateInvoicePdfTemplateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  input: InvoicePdfTemplateUpdateInput;
  updatedBy: Scalars['String'];
}>;


export type FullUpdateInvoicePdfTemplateMutation = { __typename?: 'Mutation', fullUpdateInvoicePdfTemplate: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } };

export type DeleteInvoicePdfTemplateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoicePdfTemplateId: Scalars['ID'];
  deletedBy: Scalars['String'];
}>;


export type DeleteInvoicePdfTemplateMutation = { __typename?: 'Mutation', deleteInvoicePdfTemplate: boolean };

export type MarkInvoicePdfTemplateAsDefaultMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoicePdfTemplateId: Scalars['ID'];
  updatedBy: Scalars['String'];
}>;


export type MarkInvoicePdfTemplateAsDefaultMutation = { __typename?: 'Mutation', markInvoicePdfTemplateAsDefault: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } };

export type GetInvoicesPaginatedQueryVariables = Exact<{
  courierId: Scalars['String'];
  endCustomerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  costCenterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  minEndDate?: InputMaybe<Scalars['Date']>;
  maxEndDate?: InputMaybe<Scalars['Date']>;
  invoicingFrequency?: InputMaybe<Array<InputMaybe<InvoicingFrequency>> | InputMaybe<InvoicingFrequency>>;
  statuses?: InputMaybe<Array<InputMaybe<InvoiceStatus>> | InputMaybe<InvoiceStatus>>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<InvoiceSorting> | InvoiceSorting>;
  paymentStatuses?: InputMaybe<Array<InputMaybe<InvoicePaymentStatus>> | InputMaybe<InvoicePaymentStatus>>;
}>;


export type GetInvoicesPaginatedQuery = { __typename?: 'Query', invoicesPaginated: { __typename?: 'InvoiceConnection', edges?: Array<{ __typename?: 'InvoiceEdge', node?: { __typename?: 'Invoice', id: string, displayId: number, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }>, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, communications: Array<{ __typename?: 'EndCustomerCommunication', id: string, courierId: string, endCustomerId: string, orderId?: string | null, shipmentId?: string | null, stopId?: string | null, communicationTypeId?: CommunicationTypeId | null, emailId?: string | null, idempotencyToken?: string | null, createdAt: any, dateCreated: any }> } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetInvoiceExtendedDetailQueryVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type GetInvoiceExtendedDetailQuery = { __typename?: 'Query', invoiceExtendedDetail: { __typename?: 'InvoiceExtendedDetail', amountTotal: any, invoice: { __typename?: 'Invoice', id: string, displayId: number, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }>, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null }, shipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, artifacts: Array<{ __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, price: { __typename?: 'OrderPrice', total: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null }, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } }> } };

export type InvoicesOverviewQueryVariables = Exact<{
  courierId: Scalars['String'];
}>;


export type InvoicesOverviewQuery = { __typename?: 'Query', invoicesOverview: { __typename?: 'InvoicesOverview', numToReview: number, numUnpaid: number, numPaymentProcessing: number, numPartialPaid: number } };

export type GetInvoicePdfTemplatesPaginatedQueryVariables = Exact<{
  courierId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
}>;


export type GetInvoicePdfTemplatesPaginatedQuery = { __typename?: 'Query', invoicePdfTemplatesPaginated: { __typename?: 'InvoicePdfTemplateConnection', edges?: Array<{ __typename?: 'InvoicePdfTemplateEdge', node?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, subtotalGroupedByCustomField?: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType } | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetInvoicePdfTemplateSkeletonQueryVariables = Exact<{
  courierId: Scalars['String'];
}>;


export type GetInvoicePdfTemplateSkeletonQuery = { __typename?: 'Query', getInvoicePdfTemplateSkeleton: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, subtotalGroupedByCustomField?: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType } | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } };

export type InitiateInvoicePaymentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceId: Scalars['ID'];
  paymentInstrumentId: Scalars['ID'];
  amount: Scalars['Money'];
  idempotencyToken: Scalars['String'];
  fraudSessionId?: InputMaybe<Scalars['String']>;
  createdBy: Scalars['String'];
  emailRecipients: Array<Scalars['String']> | Scalars['String'];
}>;


export type InitiateInvoicePaymentMutation = { __typename?: 'Mutation', initiateInvoicePayment: { __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any, invoice: { __typename?: 'Invoice', id: string, displayId: number, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null } } };

export type InvoiceBalancesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type InvoiceBalancesQuery = { __typename?: 'Query', invoiceBalances: Array<{ __typename?: 'InvoiceBalance', invoiceId: string, remainingBalance: any }> };

export type LinkedAccountFragmentFragment = { __typename?: 'LinkedAccount', id: string, courierId: string, remoteId: string, name?: string | null, provider: ApiProvider, accountExpiresAt?: any | null, isValid: boolean };

export type UpsertLinkedAccountMutationVariables = Exact<{
  courierId: Scalars['ID'];
  remoteId: Scalars['String'];
  provider: ApiProvider;
  refreshToken?: InputMaybe<Scalars['String']>;
  accessToken: Scalars['String'];
  accessTokenExpiresInSeconds?: InputMaybe<Scalars['Int']>;
  refreshTokenExpiresInSeconds?: InputMaybe<Scalars['Int']>;
}>;


export type UpsertLinkedAccountMutation = { __typename?: 'Mutation', upsertLinkedAccount: { __typename?: 'LinkedAccount', id: string, courierId: string, remoteId: string, name?: string | null, provider: ApiProvider, accountExpiresAt?: any | null, isValid: boolean } };

export type DeleteLinkedAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLinkedAccountMutation = { __typename?: 'Mutation', deleteLinkedAccount: boolean };

export type GetLinkedAccountsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetLinkedAccountsQuery = { __typename?: 'Query', linkedAccounts: Array<{ __typename?: 'LinkedAccount', isValidAndFresh: boolean, id: string, courierId: string, remoteId: string, name?: string | null, provider: ApiProvider, accountExpiresAt?: any | null, isValid: boolean }> };

export type LinkedAccountsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type LinkedAccountsQuery = { __typename?: 'Query', linkedAccounts: Array<{ __typename?: 'LinkedAccount', isValidAndFresh: boolean, id: string, courierId: string, remoteId: string, name?: string | null, provider: ApiProvider, accountExpiresAt?: any | null, isValid: boolean }> };

export type LngLatFragmentFragment = { __typename?: 'LngLat', lng?: number | null, lat?: number | null };

export type LocationFragmentFragment = { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } };

export type GetOrCreateLocationsMutationVariables = Exact<{
  googlePlaceIds: Array<Scalars['String']> | Scalars['String'];
  courierId?: InputMaybe<Scalars['ID']>;
  targetShipmentDate?: InputMaybe<Scalars['Date']>;
}>;


export type GetOrCreateLocationsMutation = { __typename?: 'Mutation', getOrCreateLocations: Array<{ __typename?: 'LocationResult', location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> };

export type GetOrCreateLocationsWithOverviewMutationVariables = Exact<{
  googlePlaceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetOrCreateLocationsWithOverviewMutation = { __typename?: 'Mutation', getOrCreateLocationsWithOverview: { __typename?: 'LocationsResultOverview', totalDistanceInMiles?: number | null, locations: Array<{ __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } }> } };

export type GetOrCreateLocationFromCoordinateMutationVariables = Exact<{
  courierId: Scalars['ID'];
  lngLat: LngLatInput;
  createdBy: Scalars['String'];
}>;


export type GetOrCreateLocationFromCoordinateMutation = { __typename?: 'Mutation', getOrCreateLocationFromCoordinate: { __typename?: 'LocationResult', location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type FullUpdateLocationMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  streetAddress: Scalars['String'];
  city: Scalars['String'];
}>;


export type FullUpdateLocationMutation = { __typename?: 'Mutation', fullUpdateLocation: { __typename?: 'LocationResult', location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } };

export type RoutingNodeFragmentFragment = { __typename?: 'RoutingNode', id: string, jobId: string, isNewAssignment: boolean, assignedRouteSequenceNumber?: number | null };

export type RoutingVehicleFragmentFragment = { __typename?: 'RoutingVehicle', id: string, jobId: string, startTime?: any | null, endTime?: any | null, useDriverCurrentLocationAtStart: boolean, startLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, endLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null };

export type RoutingDayResultFragmentFragment = { __typename?: 'RoutingDayResult', date: any, jobId: string, vehicles: Array<{ __typename?: 'RoutingVehicle', id: string, jobId: string, startTime?: any | null, endTime?: any | null, useDriverCurrentLocationAtStart: boolean, startLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, endLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> };

export type RoutingJobFragmentFragment = { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string> };

export type RoutingNodeEtaFragmentFragment = { __typename?: 'RoutingNodeEta', routingNodeId: string, eta: any, isLikelyLate: boolean, isLikelyEarly: boolean, likelyLateByInMinutes?: number | null, likelyEarlyByInMinutes?: number | null };

export type CreateRoutingJobMutationVariables = Exact<{
  jobCreate: RoutingJobCreate;
  vehicleCreates: Array<RoutingVehicleCreate> | RoutingVehicleCreate;
}>;


export type CreateRoutingJobMutation = { __typename?: 'Mutation', createRoutingJob: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string> } };

export type ApproveRoutingJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
  approvedBy: Scalars['String'];
}>;


export type ApproveRoutingJobMutation = { __typename?: 'Mutation', approveRoutingJob: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string> } };

export type CancelRoutingJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
  canceledBy: Scalars['String'];
}>;


export type CancelRoutingJobMutation = { __typename?: 'Mutation', cancelRoutingJob: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string> } };

export type ReplaceRoutingVehicleSequenceMutationVariables = Exact<{
  routingVehicleId: Scalars['ID'];
  routingNodeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReplaceRoutingVehicleSequenceMutation = { __typename?: 'Mutation', replaceRoutingVehicleSequence: Array<{ __typename?: 'RoutingNode', id: string, jobId: string, isNewAssignment: boolean, assignedRouteSequenceNumber?: number | null }> };

export type TransferShipmentMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
  targetDriverId: Scalars['ID'];
  routingJobId: Scalars['ID'];
}>;


export type TransferShipmentMutation = { __typename?: 'Mutation', transferShipment: Array<{ __typename?: 'RoutingNode', id: string, jobId: string, isNewAssignment: boolean, assignedRouteSequenceNumber?: number | null }> };

export type RoutingJobsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type RoutingJobsQuery = { __typename?: 'Query', routingJobs: { __typename?: 'RoutingJobConnection', edges?: Array<{ __typename?: 'RoutingJobEdge', node?: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string> } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type RoutingJobByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RoutingJobByIdQuery = { __typename?: 'Query', routingJobById: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string>, results?: Array<{ __typename?: 'RoutingDayResult', date: any, jobId: string, vehicles: Array<{ __typename?: 'RoutingVehicle', id: string, jobId: string, startTime?: any | null, endTime?: any | null, useDriverCurrentLocationAtStart: boolean, driver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, lastReportedLocation?: { __typename?: 'DriverLocation', lastReportedTime: any, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null }, nodes: Array<{ __typename?: 'RoutingNode', id: string, jobId: string, isNewAssignment: boolean, assignedRouteSequenceNumber?: number | null, stop?: { __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, shipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } } | null }>, startLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, endLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }> }> | null } };

export type PreviewEtaForRoutingVehicleQueryVariables = Exact<{
  routingVehicleId: Scalars['ID'];
}>;


export type PreviewEtaForRoutingVehicleQuery = { __typename?: 'Query', previewEtaForRoutingVehicle: Array<{ __typename?: 'RoutingNodeEta', routingNodeId: string, eta: any, isLikelyLate: boolean, isLikelyEarly: boolean, likelyLateByInMinutes?: number | null, likelyEarlyByInMinutes?: number | null }> };

export type OrderAttachmentFragmentFragment = { __typename?: 'OrderAttachment', id: string, fileName: string, publicUrl: string };

export type CreateOrderAttachmentsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderAttachmentUploads: Array<OrderAttachmentCreate> | OrderAttachmentCreate;
}>;


export type CreateOrderAttachmentsMutation = { __typename?: 'Mutation', createOrderAttachments: Array<{ __typename?: 'OrderAttachment', id: string, fileName: string, publicUrl: string }> };

export type OrderFragmentFragment = { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null };

export type CreateOneOffOrderMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderTypeId?: InputMaybe<Scalars['ID']>;
  endCustomerId: Scalars['ID'];
  acquisitionType: OrderAcquisitionType;
  shipments: Array<ShipmentCreateInput> | ShipmentCreateInput;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  caller?: InputMaybe<Scalars['String']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  pricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate> | PricingAdjustmentCreate>;
  createdBy?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput> | CustomFieldValueInput>;
  originalOrderId?: InputMaybe<Scalars['ID']>;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateOneOffOrderMutation = { __typename?: 'Mutation', createOneOffOrder?: string | null };

export type FullUpdateOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  courierId: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  shipmentUpdates: Array<ShipmentFullUpdate> | ShipmentFullUpdate;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  caller?: InputMaybe<Scalars['String']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  customFieldValuesToReplace?: InputMaybe<Array<CustomFieldValueInput> | CustomFieldValueInput>;
  updatedBy?: InputMaybe<Scalars['String']>;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FullUpdateOrderMutation = { __typename?: 'Mutation', fullUpdateOrder: { __typename?: 'Order', id: string, courierId: string, displayId: number, recurrenceType: RecurrenceType, endCustomerReferenceNumber?: string | null, caller?: string | null, costCenterId?: string | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } };

export type CreateRecurringOrderMutationVariables = Exact<{
  courierId: Scalars['ID'];
  orderTypeId?: InputMaybe<Scalars['ID']>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerCreate?: InputMaybe<EndCustomerCreateInput>;
  acquisitionType: OrderAcquisitionType;
  recurrenceDetail: RecurrenceDetailInput;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  caller?: InputMaybe<Scalars['String']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  shipmentTemplates: Array<ShipmentTemplateCreateInput> | ShipmentTemplateCreateInput;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput> | CustomFieldValueInput>;
  name?: InputMaybe<Scalars['String']>;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateRecurringOrderMutation = { __typename?: 'Mutation', createRecurringOrder?: string | null };

export type FullUpdateRecurringOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  endCustomerId: Scalars['ID'];
  recurrenceDetail: RecurrenceDetailInput;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  shipmentTemplateUpdates: Array<ShipmentTemplateFullUpdate> | ShipmentTemplateFullUpdate;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
}>;


export type FullUpdateRecurringOrderMutation = { __typename?: 'Mutation', fullUpdateRecurringOrder: { __typename?: 'Order', id: string } };

export type ForceInstantiateRecurringOrdersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']> | Scalars['ID'];
  targetDate: Scalars['Date'];
}>;


export type ForceInstantiateRecurringOrdersMutation = { __typename?: 'Mutation', forceInstantiateRecurringOrders: Array<{ __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }> };

export type GetOrForceInstantiateRecurringOrdersMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentTemplateIds: Array<Scalars['ID']> | Scalars['ID'];
  targetDate: Scalars['Date'];
  shouldUseTemplateDriver: Scalars['Boolean'];
}>;


export type GetOrForceInstantiateRecurringOrdersMutation = { __typename?: 'Mutation', getOrForceInstantiateRecurringOrders: Array<{ __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, shipment?: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } } | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }> };

export type GenerateOrdersPdfMutationVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GenerateOrdersPdfMutation = { __typename?: 'Mutation', generateOrdersPdf: { __typename?: 'OrdersFile', url: string } };

export type RecordOrderClickMutationVariables = Exact<{
  input: RecordOrderClickInput;
}>;


export type RecordOrderClickMutation = { __typename?: 'Mutation', recordOrderClick: boolean };

export type CreateLiveOrderMutationVariables = Exact<{
  courierId: Scalars['ID'];
  branchId?: InputMaybe<Scalars['ID']>;
  orderTypeId?: InputMaybe<Scalars['ID']>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  endCustomerCreate?: InputMaybe<EndCustomerCreateInput>;
  acquisitionType: OrderAcquisitionType;
  shipments: Array<ShipmentCreateInput> | ShipmentCreateInput;
  endCustomerReferenceNumber?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  caller?: InputMaybe<Scalars['String']>;
  serviceTypeId?: InputMaybe<Scalars['ID']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  pricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate> | PricingAdjustmentCreate>;
  additionalEmailRecipients?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  customFieldValues?: InputMaybe<Array<CustomFieldValueInput> | CustomFieldValueInput>;
  endUserId?: InputMaybe<Scalars['ID']>;
  originalOrderId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateLiveOrderMutation = { __typename?: 'Mutation', createLiveOrder: { __typename?: 'Order', endCustomer: { __typename?: 'EndCustomer', companyName?: string | null }, shipment?: { __typename?: 'Shipment', id: string, trackingNumber: string } | null } };

export type PackageTypeFragmentFragment = { __typename?: 'PackageType', id: string, courierId: string, name: string };

export type FullUpdatePackageTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type FullUpdatePackageTypeMutation = { __typename?: 'Mutation', fullUpdatePackageType: { __typename?: 'PackageType', id: string, courierId: string, name: string } };

export type CreatePackageTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type CreatePackageTypeMutation = { __typename?: 'Mutation', createPackageType: { __typename?: 'PackageType', id: string, courierId: string, name: string } };

export type DeletePackageTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePackageTypeMutation = { __typename?: 'Mutation', deletePackageType: { __typename?: 'PackageType', id: string, courierId: string, name: string } };

export type PageInfoFragmentFragment = { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null };

export type PaymentTransferFragmentFragment = { __typename?: 'PaymentTransfer', id: string, displayId: number, courierId: string, endCustomerId?: string | null, amount: any, currency: string, status: PaymentTransferStatus, failureCode?: string | null, failureMessage?: string | null, refundType: PaymentTransferRefundType };

export type PaymentInstrumentFragmentFragment = { __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode: string } | null };

export type CreditCardDetailFragmentFragment = { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string };

export type BankAccountDetailFragmentFragment = { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode: string };

export type InvoicePaymentFragmentFragment = { __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any };

export type PaymentSettlementFragmentFragment = { __typename?: 'PaymentSettlement', id: string, remoteId: string, courierId: string, merchantId: string, status: SettlementStatus, providerCreatedAt: any, netAmount: any, totalAmount: any, totalFee: any, totalFeeIncludingSubscriptionBilling: any, type: string };

export type CreatePaymentInstrumentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
  costCenterId?: InputMaybe<Scalars['ID']>;
  token: Scalars['String'];
  source: PaymentInstrumentAcquisitionSource;
  createdBy: Scalars['String'];
}>;


export type CreatePaymentInstrumentMutation = { __typename?: 'Mutation', createPaymentInstrument: { __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode: string } | null } };

export type PaymentTransfersPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  statusFilter?: InputMaybe<Array<PaymentTransferStatus> | PaymentTransferStatus>;
  refundTypes?: InputMaybe<Array<PaymentTransferRefundType> | PaymentTransferRefundType>;
  invoiceIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit: Scalars['Int'];
  after: Scalars['Int'];
}>;


export type PaymentTransfersPaginatedQuery = { __typename?: 'Query', paymentTransfersPaginated: { __typename?: 'PaymentTransferConnection', edges?: Array<{ __typename?: 'PaymentTransferEdge', node?: { __typename?: 'PaymentTransfer', id: string, displayId: number, courierId: string, endCustomerId?: string | null, amount: any, currency: string, status: PaymentTransferStatus, failureCode?: string | null, failureMessage?: string | null, refundType: PaymentTransferRefundType, sourcePaymentInstrument?: { __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode: string } | null } | null, invoicePayments: Array<{ __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any, invoice: { __typename?: 'Invoice', id: string, displayId: number, courierId: string, endCustomerId: string, costCenterId?: string | null, startDate: any, endDate: any, status: InvoiceStatus, amountTotal: any, isForceGenerated: boolean, invoicePaymentStatus: InvoicePaymentStatus, paymentSource?: InvoicePaymentResource | null, separateGenerationType?: SeparateInvoiceGenerationType | null, separateGenerationKey?: string | null, endCustomerPayLink?: string | null } }>, parentPaymentTransfer?: { __typename?: 'PaymentTransfer', id: string, displayId: number, courierId: string, endCustomerId?: string | null, amount: any, currency: string, status: PaymentTransferStatus, failureCode?: string | null, failureMessage?: string | null, refundType: PaymentTransferRefundType } | null, endCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type PaymentInstrumentsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PaymentInstrumentsQuery = { __typename?: 'Query', paymentInstruments: Array<{ __typename?: 'PaymentInstrument', id: string, courierId: string, endCustomerId?: string | null, costCenterId?: string | null, paymentInstrumentType: PaymentInstrumentType, isDefault: boolean, creditCardDetail?: { __typename?: 'CreditCardDetail', name?: string | null, lastFour: string, expirationMonth: number, expirationYear: number, brand: string } | null, bankAccountDetail?: { __typename?: 'BankAccountDetail', name?: string | null, maskedAccountNumber: string, bankCode: string } | null }> };

export type PaymentSettlementsPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  after: Scalars['Int'];
}>;


export type PaymentSettlementsPaginatedQuery = { __typename?: 'Query', paymentSettlementsPaginated: { __typename?: 'PaymentSettlementConnection', edges?: Array<{ __typename?: 'PaymentSettlementEdge', node?: { __typename?: 'PaymentSettlement', id: string, remoteId: string, courierId: string, merchantId: string, status: SettlementStatus, providerCreatedAt: any, netAmount: any, totalAmount: any, totalFee: any, totalFeeIncludingSubscriptionBilling: any, type: string } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type InvoicePaymentFieldsFragment = { __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any };

export type InvoiceBalanceFieldsFragment = { __typename?: 'InvoiceBalance', invoiceId: string, remainingBalance: any };

export type InitiateInvoiceRefundMutationVariables = Exact<{
  courierId: Scalars['ID'];
  parentPaymentTransferId: Scalars['ID'];
  amount: Scalars['Money'];
  idempotencyToken: Scalars['String'];
  createdBy: Scalars['String'];
}>;


export type InitiateInvoiceRefundMutation = { __typename?: 'Mutation', initiateInvoiceRefund: { __typename?: 'InvoicePayment', id: string, courierId: string, invoiceId: string, paymentTransferId: string, allocatedAmount: any } };

export type GetInvoiceBalancesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  invoiceIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetInvoiceBalancesQuery = { __typename?: 'Query', invoiceBalances: Array<{ __typename?: 'InvoiceBalance', invoiceId: string, remainingBalance: any }> };

export type DriverPayEntryFragmentFragment = { __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus };

export type PayPeriodFragmentFragment = { __typename?: 'PayPeriod', startDate: any, endDate: any };

export type PayrollReportFileFragmentFragment = { __typename?: 'PayrollReportFile', url: string };

export type PayrollSettingFragmentFragment = { __typename?: 'PayrollSetting', courierId: string, defaultCommission: any, payPeriodType: PayPeriodType };

export type OrderPayBreakDownFragmentFragment = { __typename?: 'OrderPayBreakDown', total: any };

export type OrderPayBreakDownItemFragmentFragment = { __typename?: 'OrderPayBreakDownItem', name: string, description?: string | null, amount: any };

export type PayrollDeductionRuleFragmentFragment = { __typename?: 'PayrollDeductionRule', id: string, name: string, amount?: any | null, amountType: PayrollDeductionAmountType, ruleType: PayrollDeductionRuleType, drivers: Array<{ __typename?: 'Driver', id: string, firstName: string, lastName: string }> };

export type UpsertPayrollSettingsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  defaultCommission: Scalars['Float'];
  payPeriodType: PayPeriodType;
}>;


export type UpsertPayrollSettingsMutation = { __typename?: 'Mutation', upsertPayrollSettings: { __typename?: 'PayrollSetting', courierId: string, defaultCommission: any, payPeriodType: PayPeriodType } };

export type GetOrGenerateDriverPayEntriesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  driverSearch?: InputMaybe<Scalars['String']>;
  sortFields?: InputMaybe<Array<DriverPayrollSorting> | DriverPayrollSorting>;
}>;


export type GetOrGenerateDriverPayEntriesMutation = { __typename?: 'Mutation', getOrGenerateDriverPayEntries: Array<{ __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus, driver: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null }, remoteEntities: Array<{ __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null }> }> };

export type GeneratePayrollReportMutationVariables = Exact<{
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
}>;


export type GeneratePayrollReportMutation = { __typename?: 'Mutation', generatePayrollReport?: { __typename?: 'PayrollReportFile', url: string } | null };

export type SendEmailToDriversMutationVariables = Exact<{
  driverPayEntryId: Scalars['ID'];
  recipients: Array<Scalars['String']> | Scalars['String'];
}>;


export type SendEmailToDriversMutation = { __typename?: 'Mutation', sendEmailToDrivers: { __typename?: 'PayrollEmail', id: string, driverPayEntryId: string, driverId: string, fileId: string, recipients: Array<string>, emailId?: string | null } };

export type ApproveDriverPayMutationVariables = Exact<{
  driverPayEntryId: Scalars['ID'];
}>;


export type ApproveDriverPayMutation = { __typename?: 'Mutation', approveDriverPay: { __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus } };

export type ModifyDriverPayDeductionsMutationVariables = Exact<{
  driverPayEntryId: Scalars['ID'];
  deductionsToAdd: Array<DriverPayDeductionValueInput> | DriverPayDeductionValueInput;
  deductionIdsToRemove: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ModifyDriverPayDeductionsMutation = { __typename?: 'Mutation', modifyDriverPayDeductions: { __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus } };

export type ForceExportDriverPayMutationVariables = Exact<{
  driverPayEntryId: Scalars['ID'];
  provider: ApiProvider;
}>;


export type ForceExportDriverPayMutation = { __typename?: 'Mutation', forceExportDriverPay: { __typename?: 'DriverPayEntry', id: string, driverId: string, startDate: any, endDate: any, amountTotal: any, ordersCount: number, status: DriverPayStatus } };

export type CreatePayrollDeductionRuleMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  amount: Scalars['Money'];
  amountType: PayrollDeductionAmountType;
  ruleType: PayrollDeductionRuleType;
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CreatePayrollDeductionRuleMutation = { __typename?: 'Mutation', createPayrollDeductionRule: { __typename?: 'PayrollDeductionRule', id: string, name: string, amount?: any | null, amountType: PayrollDeductionAmountType, ruleType: PayrollDeductionRuleType, drivers: Array<{ __typename?: 'Driver', id: string, firstName: string, lastName: string }> } };

export type FullUpdatePayrollDeductionRuleMutationVariables = Exact<{
  id: Scalars['ID'];
  courierId: Scalars['ID'];
  name: Scalars['String'];
  amount: Scalars['Money'];
  amountType: PayrollDeductionAmountType;
  ruleType: PayrollDeductionRuleType;
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type FullUpdatePayrollDeductionRuleMutation = { __typename?: 'Mutation', fullUpdatePayrollDeductionRule: { __typename?: 'PayrollDeductionRule', id: string, name: string, amount?: any | null, amountType: PayrollDeductionAmountType, ruleType: PayrollDeductionRuleType, drivers: Array<{ __typename?: 'Driver', id: string, firstName: string, lastName: string }> } };

export type DeletePayrollDeductionRuleMutationVariables = Exact<{
  id: Scalars['ID'];
  courierId: Scalars['ID'];
}>;


export type DeletePayrollDeductionRuleMutation = { __typename?: 'Mutation', deletePayrollDeductionRule: { __typename?: 'PayrollDeductionRule', id: string, name: string, amount?: any | null, amountType: PayrollDeductionAmountType, ruleType: PayrollDeductionRuleType, drivers: Array<{ __typename?: 'Driver', id: string, firstName: string, lastName: string }> } };

export type GetPayPeriodsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  minDate: Scalars['Date'];
  maxDate: Scalars['Date'];
}>;


export type GetPayPeriodsQuery = { __typename?: 'Query', payPeriods: Array<{ __typename?: 'PayPeriod', startDate: any, endDate: any }> };

export type GetPayrollSettingsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetPayrollSettingsQuery = { __typename?: 'Query', payrollSettings: { __typename?: 'PayrollSetting', courierId: string, defaultCommission: any, payPeriodType: PayPeriodType } };

export type CustomDeductionsQueryVariables = Exact<{
  driverPayEntryId: Scalars['ID'];
}>;


export type CustomDeductionsQuery = { __typename?: 'Query', customDeductions: Array<{ __typename?: 'DriverPayDeduction', id: string, name: string, amount: any }> };

export type PayrollDeductionRulesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit: Scalars['Int'];
  after: Scalars['Int'];
  sortFields?: InputMaybe<Array<PayrollDeductionRuleSorting> | PayrollDeductionRuleSorting>;
}>;


export type PayrollDeductionRulesPaginatedQuery = { __typename?: 'Query', payrollDeductionRulesPaginated: { __typename?: 'PayrollDeductionRuleConnection', edges?: Array<{ __typename?: 'PayrollDeductionRuleEdge', node?: { __typename?: 'PayrollDeductionRule', id: string, name: string, amount?: any | null, amountType: PayrollDeductionAmountType, ruleType: PayrollDeductionRuleType, drivers: Array<{ __typename?: 'Driver', id: string, firstName: string, lastName: string }> } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type OrderPayBreakDownWithAllocationsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type OrderPayBreakDownWithAllocationsQuery = { __typename?: 'Query', orderPayBreakDownWithAllocations: { __typename?: 'OrderPayBreakDownWithAllocationResult', isOverride: boolean, total: any, allocations: Array<{ __typename?: 'OrderPayBreakDownWithAllocation', driverId?: string | null, allocationRate: any, breakdown: { __typename?: 'OrderPayBreakDown', total: any, items: Array<{ __typename?: 'OrderPayBreakDownItem', name: string, description?: string | null, amount: any }> }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string } | null }> } };

export type PricingListFragmentFragment = { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string };

export type PricingRuleFragmentFragment = { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, pricePerMile: any, driverPayFixed?: any | null, driverCommission?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null };

export type SurchargePricingRuleFragmentFragment = { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null };

export type OrderPriceFragmentFragment = { __typename?: 'OrderPrice', total: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null };

export type PricingBreakDownFragmentFragment = { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean }> };

export type ZipGroupFragmentFragment = { __typename?: 'ZipGroup', id: string, courierId: string, name: string, zipCodes: Array<string> };

export type PricingAdjustmentFragmentFragment = { __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null } | null };

export type PreviewPriceMutationVariables = Exact<{
  courierId: Scalars['ID'];
  googlePlaceIds: Array<Scalars['String']> | Scalars['String'];
  serviceTypeId?: InputMaybe<Scalars['String']>;
  requestedPricingAdjustments?: InputMaybe<Array<PricingAdjustmentCreate> | PricingAdjustmentCreate>;
  endCustomerId?: InputMaybe<Scalars['ID']>;
  shipmentType?: InputMaybe<ShipmentType>;
  packageSize?: InputMaybe<PackageSize>;
  packageWeight?: InputMaybe<Scalars['Float']>;
  packageCount?: InputMaybe<Scalars['Int']>;
  packageTypeId?: InputMaybe<Scalars['ID']>;
}>;


export type PreviewPriceMutation = { __typename?: 'Mutation', previewPrice: { __typename?: 'PreviewPriceResult', total: any, pricingListId?: string | null, breakdown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean }> }, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null } };

export type CreatePricingRuleMutationVariables = Exact<{
  pricingRuleCreate: PricingRuleCreate;
}>;


export type CreatePricingRuleMutation = { __typename?: 'Mutation', createPricingRule: { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, pricePerMile: any, driverPayFixed?: any | null, driverCommission?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null } };

export type CreateSurchargePricingRuleMutationVariables = Exact<{
  surchargePricingRuleCreate: SurchargePricingRuleCreate;
}>;


export type CreateSurchargePricingRuleMutation = { __typename?: 'Mutation', createSurchargePricingRule: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null } };

export type DeletePricingRuleMutationVariables = Exact<{
  pricingRuleId: Scalars['ID'];
  courierId: Scalars['ID'];
}>;


export type DeletePricingRuleMutation = { __typename?: 'Mutation', deletePricingRule: boolean };

export type DeleteSurchargePricingRuleMutationVariables = Exact<{
  surchargePricingRuleId: Scalars['ID'];
  courierId: Scalars['ID'];
}>;


export type DeleteSurchargePricingRuleMutation = { __typename?: 'Mutation', deleteSurchargePricingRule: boolean };

export type CreatePricingListMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  copyBasePricingRules?: InputMaybe<Scalars['Boolean']>;
  pricingListIdToCopyFrom?: InputMaybe<Scalars['ID']>;
  pricingRulesValueMultiplier?: InputMaybe<Scalars['Float']>;
}>;


export type CreatePricingListMutation = { __typename?: 'Mutation', createPricingList: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } };

export type DeletePricingListMutationVariables = Exact<{
  pricingListId: Scalars['ID'];
}>;


export type DeletePricingListMutation = { __typename?: 'Mutation', deletePricingList: boolean };

export type FullUpdatePricingRuleMutationVariables = Exact<{
  pricingRuleFullUpdate: PricingRuleFullUpdate;
}>;


export type FullUpdatePricingRuleMutation = { __typename?: 'Mutation', fullUpdatePricingRule: { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, pricePerMile: any, driverPayFixed?: any | null, driverCommission?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null } };

export type FullUpdateSurchargePricingRuleMutationVariables = Exact<{
  surchargePricingRuleFullUpdate: SurchargePricingRuleFullUpdate;
}>;


export type FullUpdateSurchargePricingRuleMutation = { __typename?: 'Mutation', fullUpdateSurchargePricingRule: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, amountDisplay: string, minMiles?: number | null, maxMiles?: number | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null } };

export type ModifyOrderPricingMutationVariables = Exact<{
  orderId: Scalars['ID'];
  adjustmentsToAdd?: InputMaybe<Array<PricingAdjustmentCreate> | PricingAdjustmentCreate>;
  adjustmentIdsToRemove?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  priceOverride?: InputMaybe<Scalars['Money']>;
  basePriceOverride?: InputMaybe<Scalars['Money']>;
  adjustmentOverrides?: InputMaybe<Array<AdjustmentOverrideInput> | AdjustmentOverrideInput>;
  updatedBy?: InputMaybe<Scalars['String']>;
  priceOverrideBreakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput> | PriceOverrideBreakdownItemInput>;
}>;


export type ModifyOrderPricingMutation = { __typename?: 'Mutation', modifyOrderPricing: { __typename?: 'OrderPrice', total: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null } };

export type PreviewOrderPricingModificationMutationVariables = Exact<{
  orderId: Scalars['ID'];
  adjustmentsToAdd: Array<PricingAdjustmentCreate> | PricingAdjustmentCreate;
  adjustmentIdsToRemove: Array<Scalars['ID']> | Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
}>;


export type PreviewOrderPricingModificationMutation = { __typename?: 'Mutation', previewOrderPricingModification: { __typename?: 'PreviewOrderPricingModificationResult', total: any } };

export type UpdatePriceOverrideForRecurringOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  priceOverride?: InputMaybe<Scalars['Money']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  breakdown?: InputMaybe<Array<PriceOverrideBreakdownItemInput> | PriceOverrideBreakdownItemInput>;
}>;


export type UpdatePriceOverrideForRecurringOrderMutation = { __typename?: 'Mutation', updatePriceOverrideForRecurringOrder: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } };

export type UpdateDriverPayOverrideMutationVariables = Exact<{
  orderId: Scalars['ID'];
  driverPayOverride?: InputMaybe<Scalars['Money']>;
  updatedBy?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDriverPayOverrideMutation = { __typename?: 'Mutation', updateDriverPayOverride: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null } };

export type CreateZipGroupMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  zipCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateZipGroupMutation = { __typename?: 'Mutation', createZipGroup: { __typename?: 'ZipGroup', id: string, name: string, zipCodes: Array<string> } };

export type FullUpdateZipGroupMutationVariables = Exact<{
  zipGroupId: Scalars['ID'];
  name: Scalars['String'];
  zipCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type FullUpdateZipGroupMutation = { __typename?: 'Mutation', fullUpdateZipGroup: { __typename?: 'ZipGroup', id: string, name: string, zipCodes: Array<string> } };

export type OverrideAdjustmentAmountMutationVariables = Exact<{
  adjustmentId: Scalars['ID'];
  amountOverride?: InputMaybe<Scalars['Money']>;
}>;


export type OverrideAdjustmentAmountMutation = { __typename?: 'Mutation', overrideAdjustmentAmount: { __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null } | null } };

export type BulkUploadPricingRulesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  file: Scalars['Upload'];
}>;


export type BulkUploadPricingRulesMutation = { __typename?: 'Mutation', bulkUploadPricingRules: { __typename?: 'BulkUploadPricingRulesResult', numSuccess: number, errors?: Array<{ __typename?: 'BulkUploadPricingRulesRowError', rowNumber: number, messages: Array<string> }> | null } };

export type BulkMultiplyPricingRulesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  pricingListId?: InputMaybe<Scalars['ID']>;
  multiplier: Scalars['Float'];
  isBasePricingList: Scalars['Boolean'];
}>;


export type BulkMultiplyPricingRulesMutation = { __typename?: 'Mutation', bulkMultiplyPricingRules: { __typename?: 'BulkMultiplyPricingRulesResult', numSuccess: number } };

export type GetOrderPriceQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type GetOrderPriceQuery = { __typename?: 'Query', orderPrice: { __typename?: 'OrderPrice', total: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null } };

export type GetPricingRulesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  defaultOnly?: InputMaybe<Scalars['Boolean']>;
  locationBasedOnly?: InputMaybe<Scalars['Boolean']>;
  pricingListIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  distanceBasedOnly?: InputMaybe<Scalars['Boolean']>;
  tripBasedOnly?: InputMaybe<Scalars['Boolean']>;
  sortFields?: InputMaybe<Array<PricingRulesSorting> | PricingRulesSorting>;
  originZoneIdFilter?: InputMaybe<Scalars['ID']>;
  originCityFilter?: InputMaybe<CityStateCountryCreate>;
  originZipFilter?: InputMaybe<Scalars['String']>;
  originZipGroupIdFilter?: InputMaybe<Scalars['ID']>;
  destinationZoneIdFilter?: InputMaybe<Scalars['ID']>;
  destinationCityFilter?: InputMaybe<CityStateCountryCreate>;
  destinationZipFilter?: InputMaybe<Scalars['String']>;
  destinationZipGroupIdFilter?: InputMaybe<Scalars['ID']>;
  serviceTypeIdsFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
}>;


export type GetPricingRulesPaginatedQuery = { __typename?: 'Query', pricingRulesPaginated: { __typename?: 'PricingRuleConnection', edges?: Array<{ __typename?: 'PricingRuleEdge', node?: { __typename?: 'PricingRule', id: string, courierId: string, pricingListId?: string | null, origin?: string | null, originDisplay: string, originType?: PricingBoundaryType | null, destination?: string | null, destinationDisplay: string, destinationType?: PricingBoundaryType | null, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, serviceTypeId?: string | null, basePrice: any, minimumPrice: any, pricePerMile: any, driverPayFixed?: any | null, driverCommission?: any | null, freeMiles?: number | null, minTrips?: number | null, maxTrips?: number | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetSurchargePricingRuleQueryVariables = Exact<{
  courierId: Scalars['ID'];
  surchargeApplyType?: InputMaybe<SurchargeApplyType>;
  pricingListIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  amountTypes?: InputMaybe<Array<SurchargeAmountType> | SurchargeAmountType>;
}>;


export type GetSurchargePricingRuleQuery = { __typename?: 'Query', surchargePricingRules: Array<{ __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, surchargePricingRulesToExclude?: Array<{ __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null }> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null }> };

export type GetSurchargePricingRulesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  pricingListIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  defaultPricingListOnly?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  after: Scalars['Int'];
}>;


export type GetSurchargePricingRulesPaginatedQuery = { __typename?: 'Query', surchargePricingRulesPaginated: { __typename?: 'SurchargePricingRuleConnection', edges?: Array<{ __typename?: 'SurchargePricingRuleEdge', node?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, surchargePricingRulesToExclude?: Array<{ __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null }> | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetPricingListsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetPricingListsQuery = { __typename?: 'Query', pricingLists: Array<{ __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string }> };

export type GetZipGroupsQueryVariables = Exact<{
  courierId: Scalars['ID'];
}>;


export type GetZipGroupsQuery = { __typename?: 'Query', zipGroups: Array<{ __typename?: 'ZipGroup', id: string, courierId: string, name: string, zipCodes: Array<string> }> };

export type RemoteEntityFragmentFragment = { __typename?: 'RemoteEntity', id: string, courierId: string, provider: ApiProvider, remoteId: string, internalId: string, type: EntityType, externalUrl?: string | null };

export type UpsertRemoteEntityLinkageMutationVariables = Exact<{
  upsert: RemoteEntityLinkageUpsert;
}>;


export type UpsertRemoteEntityLinkageMutation = { __typename?: 'Mutation', upsertRemoteEntityLinkage: { __typename?: 'RemoteEntity', id: string, externalUrl?: string | null } };

export type QuickbookCustomerQueryVariables = Exact<{
  courierId: Scalars['ID'];
  remoteId: Scalars['ID'];
}>;


export type QuickbookCustomerQuery = { __typename?: 'Query', quickbookCustomer?: { __typename?: 'QuickbookCustomer', id: string, name: string, email?: string | null, phone?: string | null } | null };

export type QuickbookVendorQueryVariables = Exact<{
  courierId: Scalars['ID'];
  remoteId: Scalars['ID'];
}>;


export type QuickbookVendorQuery = { __typename?: 'Query', quickbookVendor?: { __typename?: 'QuickbookVendor', id: string, name: string, email?: string | null, phone?: string | null } | null };

export type SalesReportFileFragmentFragment = { __typename?: 'SalesReportFile', url: string };

export type SalesOverviewFragmentFragment = { __typename?: 'SalesOverview', courierId: string, minDate?: any | null, maxDate?: any | null, amountTotal: any, amountForCompletedShipments: any, numShipmentsTotal: number, numShipmentsCompleted: number };

export type GenerateSalesReportCsvMutationVariables = Exact<{
  courierId: Scalars['ID'];
  minDate: Scalars['Date'];
  maxDate: Scalars['Date'];
  includeAllSurcharge?: InputMaybe<Scalars['Boolean']>;
}>;


export type GenerateSalesReportCsvMutation = { __typename?: 'Mutation', generateSalesReportCsv?: { __typename?: 'SalesReportFile', url: string } | null };

export type SalesOverviewQueryVariables = Exact<{
  courierId: Scalars['ID'];
  minDate: Scalars['Date'];
  maxDate: Scalars['Date'];
}>;


export type SalesOverviewQuery = { __typename?: 'Query', salesOverview: { __typename?: 'SalesOverview', courierId: string, minDate?: any | null, maxDate?: any | null, amountTotal: any, amountForCompletedShipments: any, numShipmentsTotal: number, numShipmentsCompleted: number } };

export type ServiceTypeFragmentFragment = { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null };

export type CreateServiceTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  deliveryTimeInMinutes?: InputMaybe<Scalars['Int']>;
  dueTimeType?: InputMaybe<ServiceTypeDueTimeType>;
  dueTimeSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  dueTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  deliveryRoutedDaysAfter?: InputMaybe<Scalars['Int']>;
}>;


export type CreateServiceTypeMutation = { __typename?: 'Mutation', createServiceType: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type FullUpdateServiceTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  deliveryTimeInMinutes?: InputMaybe<Scalars['Int']>;
  color?: InputMaybe<Scalars['String']>;
  visibilityType?: InputMaybe<ServiceTypeVisibilityType>;
  dueTimeType?: InputMaybe<ServiceTypeDueTimeType>;
  dueTimeSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
  dueTimeInBusinessDaysAfter?: InputMaybe<Scalars['Int']>;
  deliveryRoutedDaysAfter?: InputMaybe<Scalars['Int']>;
  customMessage?: InputMaybe<Scalars['String']>;
}>;


export type FullUpdateServiceTypeMutation = { __typename?: 'Mutation', fullUpdateServiceType: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type UpdateReadyTimeScheduleMutationVariables = Exact<{
  serviceTypeId: Scalars['ID'];
  readyTimeSchedule: TimeScheduleInput;
}>;


export type UpdateReadyTimeScheduleMutation = { __typename?: 'Mutation', updateReadyTimeSchedule: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type DeleteServiceTypeMutationVariables = Exact<{
  serviceTypeId: Scalars['ID'];
}>;


export type DeleteServiceTypeMutation = { __typename?: 'Mutation', deleteServiceType: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } };

export type GetServiceTypesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerId?: InputMaybe<Scalars['ID']>;
}>;


export type GetServiceTypesQuery = { __typename?: 'Query', serviceTypes: Array<{ __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null }> };

export type ShipmentFragmentFragment = { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null };

export type ShipmentTemplateFragmentFragment = { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null };

export type DriverPayAllocationFragmentFragment = { __typename?: 'DriverPayAllocation', id: string, driverId: string, shipmentId: string, allocationRate: any };

export type UnassignDriverFromShipmentMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
}>;


export type UnassignDriverFromShipmentMutation = { __typename?: 'Mutation', unassignDriverFromShipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type MarkShipmentAsFailedMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
}>;


export type MarkShipmentAsFailedMutation = { __typename?: 'Mutation', markShipmentAsFailed: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type MarkShipmentAsDeletedMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
}>;


export type MarkShipmentAsDeletedMutation = { __typename?: 'Mutation', markShipmentAsDeleted: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type MarkShipmentAsClosedMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
}>;


export type MarkShipmentAsClosedMutation = { __typename?: 'Mutation', markShipmentAsClosed: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type ResetShipmentMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
  resetBy: Scalars['String'];
}>;


export type ResetShipmentMutation = { __typename?: 'Mutation', resetShipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type UncloseShipmentMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
}>;


export type UncloseShipmentMutation = { __typename?: 'Mutation', uncloseShipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type ForceCompleteShipmentMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
  completedBy: Scalars['String'];
  dateCompletedOverride?: InputMaybe<Scalars['Date']>;
}>;


export type ForceCompleteShipmentMutation = { __typename?: 'Mutation', forceCompleteShipment: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type UpdateInternalNoteMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
  internalNote: Scalars['String'];
  updatedBy: Scalars['String'];
}>;


export type UpdateInternalNoteMutation = { __typename?: 'Mutation', updateInternalNote: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type AssignDriverForShipmentTemplatesMutationVariables = Exact<{
  shipmentTemplateIds: Array<Scalars['ID']> | Scalars['ID'];
  driverId?: InputMaybe<Scalars['ID']>;
}>;


export type AssignDriverForShipmentTemplatesMutation = { __typename?: 'Mutation', assignDriverForShipmentTemplates: Array<{ __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null }> };

export type OverridePodMetadataMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
  updatedBy: Scalars['String'];
  signedBy?: InputMaybe<Scalars['String']>;
  deliveredAt?: InputMaybe<Scalars['Timestamp']>;
}>;


export type OverridePodMetadataMutation = { __typename?: 'Mutation', overridePodMetadata: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type OverridePricingDetailMutationVariables = Exact<{
  shipmentId: Scalars['ID'];
  unfreeWaitTimeInMinutes?: InputMaybe<Scalars['Float']>;
  adjustmentUpdates?: InputMaybe<Array<PricingAdjustmentUpdate> | PricingAdjustmentUpdate>;
  adjustmentsToAdd?: InputMaybe<Array<PricingAdjustmentCreate> | PricingAdjustmentCreate>;
  updatedBy?: InputMaybe<Scalars['String']>;
}>;


export type OverridePricingDetailMutation = { __typename?: 'Mutation', overridePricingDetail: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type MarkShipmentTemplatesAsDeletedMutationVariables = Exact<{
  shipmentTemplateIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkShipmentTemplatesAsDeletedMutation = { __typename?: 'Mutation', markShipmentTemplatesAsDeleted: Array<{ __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null }> };

export type ReplaceAllocationMutationVariables = Exact<{
  replacement: DriverPayAllocationReplacement;
}>;


export type ReplaceAllocationMutation = { __typename?: 'Mutation', replaceAllocation: Array<{ __typename?: 'DriverPayAllocation', id: string, driverId: string, shipmentId: string, allocationRate: any }> };

export type BulkUnassignDriversFromShipmentMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BulkUnassignDriversFromShipmentMutation = { __typename?: 'Mutation', bulkUnassignDriversFromShipment: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null }> };

export type MarkShipmentsAsClosedMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
  closedBy?: InputMaybe<Scalars['String']>;
}>;


export type MarkShipmentsAsClosedMutation = { __typename?: 'Mutation', markShipmentsAsClosed: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null }> };

export type UncloseShipmentsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UncloseShipmentsMutation = { __typename?: 'Mutation', uncloseShipments: Array<{ __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null }> };

export type ApproveShipmentDetailsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  updatedBy: Scalars['String'];
}>;


export type ApproveShipmentDetailsMutation = { __typename?: 'Mutation', approveShipmentDetails: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type GetShipmentsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  isAssignedFilter?: InputMaybe<Scalars['Boolean']>;
  statusFilter?: InputMaybe<ShipmentStatus>;
  statusListFilter?: InputMaybe<Array<ShipmentStatus> | ShipmentStatus>;
  lateByFilter?: InputMaybe<Scalars['Timestamp']>;
  minClosingTimeFilter?: InputMaybe<Scalars['Timestamp']>;
  likelyLateOnlyFilter?: InputMaybe<Scalars['Boolean']>;
  isClosedFilter?: InputMaybe<Scalars['Boolean']>;
  driverIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  trackingNumbersFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  displayIdsFilter?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  sortFields?: InputMaybe<Array<ShipmentsSorting> | ShipmentsSorting>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
}>;


export type GetShipmentsQuery = { __typename?: 'Query', shipments?: { __typename?: 'ShipmentConnection', edges?: Array<{ __typename?: 'ShipmentEdge', node?: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, dispatchedByUser?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null } | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null, packageItems?: Array<{ __typename?: 'PackageItem', width?: number | null, height?: number | null, length?: number | null, weight?: number | null }> | null, routingJob?: { __typename?: 'RoutingJob', id: string, courierId: string, displayId: number, status: RoutingJobStatus, dateCreated: any, shipmentIds: Array<string>, driverIds: Array<string> } | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any }>, shipment: { __typename?: 'Shipment', status: ShipmentStatus, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null }, shipmentTemplate?: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } } | null }, artifacts: Array<{ __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any }>, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } }>, order: { __typename?: 'Order', userHasClicked: boolean, acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, createdByUser?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null } | null, createdByEndCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } | null, createdByEndUser?: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null } | null, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, invoicePdfTemplate?: { __typename?: 'InvoicePdfTemplate', id: string, courierId: string, name: string, isDefault: boolean, separateGenerationType: SeparateInvoiceGenerationType, subtotalGroupedByType: InvoiceSubtotalGroupByType, subtotalGroupedByCustomFieldId?: string | null, subtotalPageBreakType: InvoiceSubtotalPageBreakType, summaryDisplayType: InvoiceSummaryDisplayType, detailColumnFields: Array<InvoiceDetailColumnFields>, returnSlipType: InvoiceReturnSlipType, marginLeft: number, tableContentFontSize: number, largeTextFontSize: number, smallTextFontSize: number, showTableBorder: boolean, brandColor: string, labelColor: string, borderSize: number, finalMessage?: string | null, columnsWithWidth: Array<{ __typename?: 'InvoicePdfColumnWithWidth', column: InvoicePdfColumn, widthPercentage: any }> } | null, customFields?: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType }> | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, field: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType } }>, orderAttachments: Array<{ __typename?: 'OrderAttachment', id: string, fileName: string, publicUrl: string }>, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null, driverPayAllocations: Array<{ __typename?: 'DriverPayAllocation', id: string, driverId: string, shipmentId: string, allocationRate: any }>, shipmentTemplate?: { __typename?: 'ShipmentTemplate', order: { __typename?: 'Order', name?: string | null } } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } | null };

export type GetShipmentCountsForFiltersQueryVariables = Exact<{
  courierId: Scalars['ID'];
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  now: Scalars['Timestamp'];
  in15Minutes: Scalars['Timestamp'];
  in30Minutes: Scalars['Timestamp'];
  in60Minutes: Scalars['Timestamp'];
}>;


export type GetShipmentCountsForFiltersQuery = { __typename?: 'Query', shipmentsOverview: { __typename?: 'ShipmentsOverview', numActive?: number | null, numUnassigned?: number | null, numAssigned?: number | null, numDelivered?: number | null, numClosed?: number | null, numLate?: number | null, numLateIn15Minutes?: number | null, numLateIn30Minutes?: number | null, numLateIn60Minutes?: number | null, numLikelyLate?: number | null } };

export type ShipmentTemplatesPaginatedQueryVariables = Exact<{
  courierId: Scalars['ID'];
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<ShipmentTemplatesSorting> | ShipmentTemplatesSorting>;
}>;


export type ShipmentTemplatesPaginatedQuery = { __typename?: 'Query', shipmentTemplatesPaginated?: { __typename?: 'ShipmentTemplateConnection', edges?: Array<{ __typename?: 'ShipmentTemplateEdge', node?: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, stopTemplates: Array<{ __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null } }>, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, customFields?: Array<{ __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType }> | null, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, field: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType } }>, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } | null };

export type ShipmentByIdQueryVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
}>;


export type ShipmentByIdQuery = { __typename?: 'Query', shipmentById: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null, stops: Array<{ __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, artifacts: Array<{ __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any }>, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } }>, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, field: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType } }>, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, dispatchedByUser?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null } | null } };

export type GetShipmentsForSalesReportQueryVariables = Exact<{
  courierId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
  isAssignedFilter?: InputMaybe<Scalars['Boolean']>;
  statusFilter?: InputMaybe<ShipmentStatus>;
  statusListFilter?: InputMaybe<Array<ShipmentStatus> | ShipmentStatus>;
  lateByFilter?: InputMaybe<Scalars['Timestamp']>;
  minClosingTimeFilter?: InputMaybe<Scalars['Timestamp']>;
  likelyLateOnlyFilter?: InputMaybe<Scalars['Boolean']>;
  isClosedFilter?: InputMaybe<Scalars['Boolean']>;
  driverIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  endCustomerIdsFilter?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  trackingNumbersFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  displayIdsFilter?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  sortFields?: InputMaybe<Array<ShipmentsSorting> | ShipmentsSorting>;
  simpleSearch?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  hasOrderInternalNote?: InputMaybe<Scalars['Boolean']>;
  hasDriverNoteOnly?: InputMaybe<Scalars['Boolean']>;
  hasWaitTimeOrOverride?: InputMaybe<Scalars['Boolean']>;
  hasMultipleDriverPayOnly?: InputMaybe<Scalars['Boolean']>;
  hasUnapprovedDriverPackageReportOnly?: InputMaybe<Scalars['Boolean']>;
  isDeliveredOnTime?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetShipmentsForSalesReportQuery = { __typename?: 'Query', shipments?: { __typename?: 'ShipmentConnection', edges?: Array<{ __typename?: 'ShipmentEdge', node?: { __typename?: 'Shipment', distancesInMeters: number, id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null, packageType?: { __typename?: 'PackageType', id: string, courierId: string, name: string } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null, packageItems?: Array<{ __typename?: 'PackageItem', width?: number | null, height?: number | null, length?: number | null, weight?: number | null }> | null, stops: Array<{ __typename?: 'Stop', wasLateByInMinutes?: number | null, id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, tasks: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any }>, shipment: { __typename?: 'Shipment', status: ShipmentStatus, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } }, artifacts: Array<{ __typename?: 'Artifact', id: string, value?: string | null, courierId: string, stopId?: string | null, taskId?: string | null, type: ArtifactType, publicUrl?: string | null, createdAt: any }>, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } }>, order: { __typename?: 'Order', userHasClicked: boolean, acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, orderPayBreakDownWithAllocation?: { __typename?: 'OrderPayBreakDownWithAllocationResult', isOverride: boolean, total: any, allocations: Array<{ __typename?: 'OrderPayBreakDownWithAllocation', driverId?: string | null, allocationRate: any, breakdown: { __typename?: 'OrderPayBreakDown', total: any, items: Array<{ __typename?: 'OrderPayBreakDownItem', name: string, description?: string | null, amount: any }> }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null }> } | null, createdByEndCustomer?: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null } | null, createdByEndUser?: { __typename?: 'EndUser', id: string, courierId: string, endCustomerId: string, email: string, phone?: string | null, firstName?: string | null, lastName?: string | null, firebaseUid?: string | null } | null, costCenter?: { __typename?: 'CostCenter', id: string, endCustomerId: string, name: string, locationId?: string | null, suite?: string | null, email?: string | null, phone?: string | null } | null, endCustomer: { __typename?: 'EndCustomer', id: string, courierId: string, companyName?: string | null, contactPhoneNumber: string, contactEmail: string, firstName?: string | null, lastName?: string | null, displayId: number, suite?: string | null, invoicingFrequency?: InvoicingFrequency | null, pricingListId?: string | null, visibleServiceTypeIds?: Array<string> | null, podEmails?: Array<string> | null, firebaseUid?: string | null, taxCode?: string | null, newCustomerConfirmationStatus: NewCustomerConfirmationStatus, endCustomerCreatedSource?: EndCustomerCreatedSource | null, enabledCommunicationTypes: Array<CommunicationTypeId>, totalPricingMultiplier: any, billingEmails: Array<string>, note?: string | null, scanRequirementType: ScanRequirement, pricingList?: { __typename?: 'PricingList', id: string, displayId: number, courierId: string, name: string } | null, location?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null }, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null, orderAttachments: Array<{ __typename?: 'OrderAttachment', id: string, fileName: string, publicUrl: string }>, price: { __typename?: 'OrderPrice', total: any, isPriceOverride: boolean, isBasePriceOverride: boolean, priceOverride?: any | null, basePriceOverride?: any | null, isFinalized: boolean, pricingBreakDown: { __typename?: 'PricingBreakDown', items: Array<{ __typename?: 'PricingBreakDownItem', name: string, amount: any, description?: string | null, adjustmentId?: string | null, isAdjustmentOverride: boolean }> }, customSurchargeAdjustments?: Array<{ __typename?: 'PricingAdjustment', id: string, orderId: string, surchargePricingRuleId?: string | null, type?: PricingAdjustmentType | null, amount: any, note?: string | null, surchargePricingRule?: { __typename?: 'SurchargePricingRule', id: string, courierId: string, pricingListId?: string | null, name: string, amount: any, amountDisplay: string, percent: number, amountType: SurchargeAmountType, applyType: SurchargeApplyType, minMiles?: number | null, maxMiles?: number | null, minWeight?: number | null, maxWeight?: number | null, minPackageCount?: number | null, maxPackageCount?: number | null, packageSize?: PackageSize | null, driverCommission?: any | null, showInInvoice: boolean, minReadyTimeInSecondsSinceMidnight?: number | null, maxReadyTimeInSecondsSinceMidnight?: number | null, timeZoneId?: string | null, daysOfTheWeek?: Array<DayOfTheWeek> | null, freeMiles?: number | null, freePackageCount?: number | null, freeWeight?: number | null, surchargePricingRuleIdsToExclude?: Array<string> | null, perimeterZone?: { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string } | null } | null }> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null }, customFieldValues: Array<{ __typename?: 'CustomFieldValue', fieldId: string, entityId: string, courierId: string, valueDisplay: string, valueText?: string | null, field: { __typename?: 'CustomField', id: string, name: string, type: CustomFieldType, customerVisibilityType: CustomFieldCustomerVisibilityType, customerSpecificityType: CustomFieldCustomerSpecificity, requirementType: CustomFieldCustomerRequirementType } }>, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null, driverPayAllocations: Array<{ __typename?: 'DriverPayAllocation', id: string, driverId: string, shipmentId: string, allocationRate: any }>, dispatchedByUser?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null } | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } | null };

export type StopFragmentFragment = { __typename?: 'Stop', id: string, shipmentId: string, type: ShipmentStopType, streetAddress: string, googlePlaceId?: string | null, suite?: string | null, city: string, state: string, country: string, dispatchZone?: string | null, driverNote?: string | null, zipCode: string, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, timeStatus?: StopTimeStatus | null, completedAt?: any | null, stopDate?: any | null, dispatchZoneLine2?: string | null, effectiveStopDate: any, locationId: string, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindow', open?: any | null, close?: any | null } };

export type StopTemplateFragmentFragment = { __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null } };

export type UpsertStopTemplateSequenceNumbersMutationVariables = Exact<{
  upserts: Array<ScheduledStopTemplateSequenceNumberUpsert> | ScheduledStopTemplateSequenceNumberUpsert;
}>;


export type UpsertStopTemplateSequenceNumbersMutation = { __typename?: 'Mutation', upsertStopTemplateSequenceNumbers: Array<{ __typename?: 'ScheduledStopTemplateSequenceNumber', id: string, courierId: string, stopTemplateId: string, dayOfWeek?: DayOfTheWeek | null, sequenceNumber?: number | null, stopTemplate: { __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null } } }> };

export type ForceCompleteStopsMutationVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentId: Scalars['ID'];
  stopIds: Array<Scalars['ID']> | Scalars['ID'];
  completedBy: Scalars['String'];
}>;


export type ForceCompleteStopsMutation = { __typename?: 'Mutation', forceCompleteStops: { __typename?: 'Shipment', id: string, courierId: string, shipmentDate: any, driverId?: string | null, status: ShipmentStatus, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, numPackages?: number | null, trackingNumber: string, isClosed: boolean, isForceCompleted: boolean, type: ShipmentType, internalNote?: string | null, assignedAt?: any | null, createdAt: any, driverConfirmedAt?: any | null, signedByOverride?: string | null, deliveredAtOverride?: any | null, waitTimeInMinutes?: number | null, packageDescription?: string | null, routingJobId?: string | null, firstEffectiveStopDate: any, driverReportedWaitTimeInMinutes?: number | null, waitTimeUnfreeMinutesOverride?: number | null, completedDate?: any | null, completedDateOverriddenBy?: string | null, hasCompletedDateOverride: boolean, proposedNumPackages?: number | null, proposedPackageWeightInPounds?: number | null } };

export type MemorizationsQueryVariables = Exact<{
  courierId: Scalars['ID'];
  driverIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  dayOfWeeks?: InputMaybe<Array<DayOfTheWeek> | DayOfTheWeek>;
}>;


export type MemorizationsQuery = { __typename?: 'Query', memorizations: { __typename?: 'MemorizationResult', days: Array<{ __typename?: 'MemorizationOnDay', dayOfWeek: DayOfTheWeek, stopTemplateSequenceNumbers: Array<{ __typename?: 'ScheduledStopTemplateSequenceNumber', id: string, courierId: string, stopTemplateId: string, dayOfWeek?: DayOfTheWeek | null, sequenceNumber?: number | null, stopTemplate: { __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, shipmentTemplate: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null } } }>, unmemorizedShipmentTemplates: Array<{ __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, order: { __typename?: 'Order', acquisitionType: OrderAcquisitionType, caller?: string | null, costCenterId?: string | null, courierId: string, displayId: number, driverPayOverride?: any | null, endCustomerReferenceNumber?: string | null, id: string, priceOverride?: any | null, recurrenceType: RecurrenceType, name?: string | null, pricingStopIds?: Array<string> | null, additionalEmailRecipients?: Array<string> | null, priceOverrideBreakdown?: Array<{ __typename?: 'PriceOverrideBreakdownItem', description: string, amount: any }> | null, recurrenceDetail?: { __typename?: 'RecurrenceDetail', endDateISO8601?: string | null, scheduleType: RecurrenceScheduleType, startDateISO8601?: string | null, biweeklySchedule?: { __typename?: 'BiWeeklySchedule', startDateISO8601: string } | null, monthlySchedule?: { __typename?: 'MonthlySchedule', days: Array<number> } | null, weeklySchedule?: { __typename?: 'WeeklySchedule', weekDays: Array<DayOfTheWeek> } | null } | null }, stopTemplates: Array<{ __typename?: 'StopTemplate', id: string, shipmentTemplateId: string, type: ShipmentStopType, streetAddress: string, suite?: string | null, city: string, state: string, country: string, zipCode: string, googlePlaceId?: string | null, contactName?: string | null, companyName?: string | null, phone?: string | null, instruction?: string | null, dispatchZone?: string | null, timeZoneId?: string | null, shipmentTemplate: { __typename?: 'ShipmentTemplate', id: string, courierId: string, orderId: string, packageSize?: PackageSize | null, packageWeightInPounds?: number | null, type: ShipmentType, numPackages?: number | null, packageTypeId?: string | null, vehicleTypeId?: string | null, order: { __typename?: 'Order', id: string, serviceType?: { __typename?: 'ServiceType', id: string, courierId: string, name: string, displayId: number, deliveryTimeInMinutes?: number | null, color?: string | null, visibilityType: ServiceTypeVisibilityType, dueTimeType: ServiceTypeDueTimeType, dueTimeSecondsSinceMidnight?: number | null, dueTimeInBusinessDaysAfter?: number | null, deliveryRoutedDaysAfter: number, customMessage?: string | null, readyTimeSchedule?: { __typename?: 'TimeSchedule', weekDailyList?: Array<{ __typename?: 'TimeScheduleWeekDaily', days: Array<DayOfTheWeek>, startTimeSecondsSinceMidnight: number, endTimeSecondsSinceMidnight: number } | null> | null } | null } | null } }, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null }, timeWindow: { __typename?: 'TimeWindowTimeOfDay', openSecondsSinceMidnightUtc?: number | null, closeSecondsSinceMidnightUtc?: number | null } }>, driver?: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } | null }> }> } };

export type UniqueStopDatesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  shipmentStatusFilter?: InputMaybe<Array<ShipmentStatus> | ShipmentStatus>;
  maxShipmentDate?: InputMaybe<Scalars['Date']>;
  minExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
}>;


export type UniqueStopDatesQuery = { __typename?: 'Query', uniqueStopDates: Array<any> };

export type TaskFragmentFragment = { __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any };

export type StopEtaFragmentFragment = { __typename?: 'StopEta', stopId: string, eta: any, isLikelyLate: boolean, likelyLateByInMinutes?: number | null };

export type ReplaceRouteMutationVariables = Exact<{
  driverId: Scalars['ID'];
  newStopIds: Array<Scalars['ID']> | Scalars['ID'];
  shipmentDate: Scalars['Date'];
  replacedBy?: InputMaybe<Scalars['String']>;
  orderingAlgorithmType?: InputMaybe<OrderingAlgorithmType>;
  autoRoutedStopIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  dispatchSource?: InputMaybe<DispatchSource>;
}>;


export type ReplaceRouteMutation = { __typename?: 'Mutation', replaceRoute: Array<{ __typename?: 'Task', id: string, driverId: string, sequenceNumber: number, status: TaskStatus, arrivedAt?: any | null, etaEpochSeconds?: any | null, date: any }> };

export type RefreshEtaStaleMutationVariables = Exact<{
  driverId: Scalars['ID'];
}>;


export type RefreshEtaStaleMutation = { __typename?: 'Mutation', refreshEtaStale: { __typename?: 'Driver', id: string, firstName: string, lastName: string, photoUrl?: string | null, phone: string, email?: string | null, isActive: boolean, commission?: any | null, workType: DriverWorkType, selfRoutingType: DriverSelfRoutingType, speed: number, employmentType?: DriverEmploymentType | null, hourlyRateRegular: any, hourlyRateOvertime: any, mileageRate: any, homeLocation?: { __typename?: 'Location', id: string, streetAddress: string, city: string, state: string, zipCode?: string | null, country: string, googlePlaceId?: string | null, lngLat: { __typename?: 'LngLat', lng?: number | null, lat?: number | null } } | null, vehicleType?: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } | null } };

export type PreviewEtaForRouteQueryVariables = Exact<{
  driverId: Scalars['ID'];
  stopIds: Array<Scalars['ID']> | Scalars['ID'];
  baseTime?: InputMaybe<Scalars['Timestamp']>;
}>;


export type PreviewEtaForRouteQuery = { __typename?: 'Query', previewEtaForRoute?: { __typename?: 'PreviewEtaForRouteResult', stopEtas: Array<{ __typename?: 'StopEta', stopId: string, eta: any, isLikelyLate: boolean, likelyLateByInMinutes?: number | null }> } | null };

export type VisibleColumnsConfigFragmentFragment = { __typename?: 'VisibleColumnsConfig', id: string, salesReportColumnIds?: Array<SalesReportColumnId> | null, driverReportColumnIds?: Array<DriverReportColumnId> | null, userOrEmployeeId: string };

export type FullUpdateColumnVisibilityMutationVariables = Exact<{
  courierId: Scalars['String'];
  salesReportColumnIds?: InputMaybe<Array<SalesReportColumnId> | SalesReportColumnId>;
  driverReportColumnIds?: InputMaybe<Array<DriverReportColumnId> | DriverReportColumnId>;
  userOrEmployeeId: Scalars['String'];
  updatedBy: Scalars['String'];
}>;


export type FullUpdateColumnVisibilityMutation = { __typename?: 'Mutation', fullUpdateColumnVisibility: { __typename?: 'VisibleColumnsConfig', id: string, salesReportColumnIds?: Array<SalesReportColumnId> | null, driverReportColumnIds?: Array<DriverReportColumnId> | null, userOrEmployeeId: string } };

export type GetVisibleColumnsQueryVariables = Exact<{
  courierId: Scalars['String'];
  userOrEmployeeId: Scalars['String'];
}>;


export type GetVisibleColumnsQuery = { __typename?: 'Query', getVisibleColumns?: { __typename?: 'VisibleColumnsConfig', id: string, salesReportColumnIds?: Array<SalesReportColumnId> | null, driverReportColumnIds?: Array<DriverReportColumnId> | null, userOrEmployeeId: string } | null };

export type CourieUserFragmentFragment = { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null };

export type SyncUserWithFirebaseMutationVariables = Exact<{
  email: Scalars['String'];
  firebaseUid: Scalars['String'];
}>;


export type SyncUserWithFirebaseMutation = { __typename?: 'Mutation', syncUserWithFirebase: { __typename?: 'SyncUserWithFirebaseResult', isEmployee: boolean, error?: SyncUserWithFirebaseError | null, employeeId?: string | null, user?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null } | null } };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String'];
  courierId: Scalars['String'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null } };

export type GetUsersQueryVariables = Exact<{
  courierId: Scalars['ID'];
  after: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'CourieUserConnection', edges?: Array<{ __typename?: 'CourieUserEdge', node?: { __typename?: 'CourieUser', id: string, email: string, courierId?: string | null, firebaseUid?: string | null, profilePhotoUrl?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type VehicleTypeFragmentFragment = { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string };

export type FullUpdateVehicleTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shortCode: Scalars['String'];
}>;


export type FullUpdateVehicleTypeMutation = { __typename?: 'Mutation', fullUpdateVehicleType: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } };

export type CreateVehicleTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  name: Scalars['String'];
  shortCode: Scalars['String'];
}>;


export type CreateVehicleTypeMutation = { __typename?: 'Mutation', createVehicleType: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } };

export type DeleteVehicleTypeMutationVariables = Exact<{
  courierId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteVehicleTypeMutation = { __typename?: 'Mutation', deleteVehicleType: { __typename?: 'VehicleType', id: string, courierId: string, name: string, shortCode: string } };

export type ZoneFragmentFragment = { __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> } };

export type CreateZonesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  zones: Array<ZoneCreate> | ZoneCreate;
}>;


export type CreateZonesMutation = { __typename?: 'Mutation', createZones: Array<{ __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> } }> };

export type UpdateZonesMutationVariables = Exact<{
  courierId: Scalars['ID'];
  zones: Array<ZoneUpdate> | ZoneUpdate;
}>;


export type UpdateZonesMutation = { __typename?: 'Mutation', updateZones: Array<{ __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> } }> };

export type ZonesQueryVariables = Exact<{
  courierId: Scalars['ID'];
  type: ZoneType;
}>;


export type ZonesQuery = { __typename?: 'Query', zones: Array<{ __typename?: 'Zone', id: string, courierId: string, displayId: number, type: ZoneType, name: string, polygon: { __typename?: 'Polygon', points: Array<{ __typename?: 'LngLat', lng?: number | null, lat?: number | null }> } }> };

export const ActivityFragmentFragmentDoc = gql`
    fragment ActivityFragment on Activity {
  id
  courierId
  entityId
  entityType
  infoType
  description
  time
  date
}
    `;
export const ActivitySnapshotEntryFragmentFragmentDoc = gql`
    fragment ActivitySnapshotEntryFragment on ActivitySnapshotEntry {
  key
  value
}
    `;
export const ActivitySnapshotFragmentFragmentDoc = gql`
    fragment ActivitySnapshotFragment on ActivitySnapshot {
  value
  entries {
    ...ActivitySnapshotEntryFragment
  }
}
    ${ActivitySnapshotEntryFragmentFragmentDoc}`;
export const LngLatFragmentFragmentDoc = gql`
    fragment LngLatFragment on LngLat {
  lng
  lat
}
    `;
export const LocationFragmentFragmentDoc = gql`
    fragment LocationFragment on Location {
  id
  streetAddress
  city
  state
  zipCode
  country
  lngLat {
    ...LngLatFragment
  }
  googlePlaceId
}
    ${LngLatFragmentFragmentDoc}`;
export const AddressBookFragmentFragmentDoc = gql`
    fragment AddressBookFragment on AddressBookEntry {
  id
  endCustomerId
  contactName
  companyName
  phone
  suite
  location {
    ...LocationFragment
  }
  instruction
}
    ${LocationFragmentFragmentDoc}`;
export const ArtifactFragmentFragmentDoc = gql`
    fragment ArtifactFragment on Artifact {
  id
  value
  courierId
  stopId
  taskId
  type
  publicUrl
  createdAt
}
    `;
export const CostCenterFragmentFragmentDoc = gql`
    fragment CostCenterFragment on CostCenter {
  id
  endCustomerId
  name
  locationId
  suite
  email
  phone
}
    `;
export const CustomFieldFragmentFragmentDoc = gql`
    fragment CustomFieldFragment on CustomField {
  id
  name
  type
  customerVisibilityType
  customerSpecificityType
  requirementType
}
    `;
export const CourierFragmentFragmentDoc = gql`
    fragment CourierFragment on Courier {
  id
  name
  primaryPhoneNumber
  primaryEmail
  packageTypes {
    id
    courierId
    name
  }
  vehicleTypes {
    id
    courierId
    name
    shortCode
  }
  customFields {
    ...CustomFieldFragment
  }
  enabledCommunicationTypes
  logoUrl
  timeZoneId
  primaryLocation {
    ...LocationFragment
  }
  finixMerchantId
  defaultCurrency
  dispatcherOrderEntryAdditionalFields
}
    ${CustomFieldFragmentFragmentDoc}
${LocationFragmentFragmentDoc}`;
export const CustomFieldValueFragmentFragmentDoc = gql`
    fragment CustomFieldValueFragment on CustomFieldValue {
  fieldId
  entityId
  courierId
  valueDisplay
  valueText
}
    `;
export const DispatchPreviewFragmentFragmentDoc = gql`
    fragment DispatchPreviewFragment on DispatchPreview {
  shipmentId
  shipmentDate
  distanceInMeters
  durationInSeconds
  distanceAdditionalInMeters
  durationAdditionalInSeconds
  remainingWorkloadInSeconds
  numCurrentTasks
  tags
}
    `;
export const DriverDailyWorkFragmentFragmentDoc = gql`
    fragment DriverDailyWorkFragment on DriverDailyWork {
  date
  workDurationInMinutes
  isConsistentEvents
  milesByOdometer
  dailyRegularWorkDuration
  dailyOvertimeWorkDuration
}
    `;
export const DriverReportItemFragmentFragmentDoc = gql`
    fragment DriverReportItemFragment on DriverReportItem {
  driverId
  startDate
  endDate
  workDurations {
    ...DriverDailyWorkFragment
  }
  regularHourlyRate
  overtimeHourlyRate
  reimbursementPerMile
  totalMilesByGPS
  mileageReimbursementMethod
  numCompletedOrder
  deductions {
    name
    amountTotal
  }
  totalCommission
  totalMilesByOdometer
  totalWorkDurationInMinutes
  regularDailyCalculatedWorkDurationInMinutes
  overtimeDailyCalculatedWorkDurationInMinutes
  numDaysWorked
  wageRegular
  wageOvertime
  wageTotal
  mileageReimbursement
  wageTotalWithMileageReimbursement
  totalPay
  suggestedBonus
}
    ${DriverDailyWorkFragmentFragmentDoc}`;
export const VehicleTypeFragmentFragmentDoc = gql`
    fragment VehicleTypeFragment on VehicleType {
  id
  courierId
  name
  shortCode
}
    `;
export const DriverFragmentFragmentDoc = gql`
    fragment DriverFragment on Driver {
  id
  firstName
  lastName
  photoUrl
  phone
  email
  isActive
  commission
  workType
  selfRoutingType
  speed
  homeLocation {
    ...LocationFragment
  }
  employmentType
  hourlyRateRegular
  hourlyRateOvertime
  mileageRate
  vehicleType {
    ...VehicleTypeFragment
  }
}
    ${LocationFragmentFragmentDoc}
${VehicleTypeFragmentFragmentDoc}`;
export const VehicleFragmentFragmentDoc = gql`
    fragment VehicleFragment on Vehicle {
  id
  driverId
  transportationType
}
    `;
export const DriverLocationFragmentFragmentDoc = gql`
    fragment DriverLocationFragment on DriverLocation {
  lastReportedTime
  lngLat {
    ...LngLatFragment
  }
}
    ${LngLatFragmentFragmentDoc}`;
export const BreadcrumbCurveFragmentFragmentDoc = gql`
    fragment BreadcrumbCurveFragment on DriverBreadcrumbCurve {
  locations {
    ...DriverLocationFragment
  }
}
    ${DriverLocationFragmentFragmentDoc}`;
export const DriverScheduleForDateFragmentFragmentDoc = gql`
    fragment DriverScheduleForDateFragment on DriverScheduleForDate {
  driverId
  date
  labels
  emailSentAt
  confirmedAt
  hasWorkloadChanged
}
    `;
export const DriverScheduleTimeBlockFragmentFragmentDoc = gql`
    fragment DriverScheduleTimeBlockFragment on DriverScheduleTimeBlock {
  start
  end
}
    `;
export const DriverTimeEventFragmentFragmentDoc = gql`
    fragment DriverTimeEventFragment on DriverTimeEvent {
  id
  date
  driverId
  courierId
  eventType
  reason
  odometerInMiles
  updatedBy
  eventAt
}
    `;
export const EndUserFragmentFragmentDoc = gql`
    fragment EndUserFragment on EndUser {
  id
  courierId
  endCustomerId
  email
  phone
  firstName
  lastName
  firebaseUid
}
    `;
export const EndCustomerCommunicationFragmentFragmentDoc = gql`
    fragment EndCustomerCommunicationFragment on EndCustomerCommunication {
  id
  courierId
  endCustomerId
  orderId
  shipmentId
  stopId
  communicationTypeId
  emailId
  idempotencyToken
  createdAt
  dateCreated
}
    `;
export const PricingListFragmentFragmentDoc = gql`
    fragment PricingListFragment on PricingList {
  id
  displayId
  courierId
  name
}
    `;
export const EndCustomerFragmentFragmentDoc = gql`
    fragment EndCustomerFragment on EndCustomer {
  id
  courierId
  companyName
  contactPhoneNumber
  contactEmail
  firstName
  lastName
  displayId
  suite
  invoicingFrequency
  pricingListId
  pricingList {
    ...PricingListFragment
  }
  location {
    ...LocationFragment
  }
  visibleServiceTypeIds
  podEmails
  firebaseUid
  taxCode
  newCustomerConfirmationStatus
  endCustomerCreatedSource
  enabledCommunicationTypes
  totalPricingMultiplier
  billingEmails
  note
  scanRequirementType
}
    ${PricingListFragmentFragmentDoc}
${LocationFragmentFragmentDoc}`;
export const CourierHolidayFragmentFragmentDoc = gql`
    fragment CourierHolidayFragment on CourierHoliday {
  id
  name
  recurrenceRule
}
    `;
export const HolidayScheduleFragmentFragmentDoc = gql`
    fragment HolidayScheduleFragment on HolidaySchedule {
  id
  name
}
    `;
export const HolidayScheduleBehaviorFragmentFragmentDoc = gql`
    fragment HolidayScheduleBehaviorFragment on HolidayScheduleBehavior {
  holidayScheduleId
  courierHolidayId
  behavior
  name
  recurrenceRule
}
    `;
export const InvoiceFragmentFragmentDoc = gql`
    fragment InvoiceFragment on Invoice {
  id
  displayId
  courierId
  endCustomerId
  costCenterId
  startDate
  endDate
  status
  amountTotal
  isForceGenerated
  invoicePaymentStatus
  paymentSource
  separateGenerationType
  separateGenerationKey
  endCustomerPayLink
}
    `;
export const InvoiceDocumentFragmentFragmentDoc = gql`
    fragment InvoiceDocumentFragment on InvoiceDocument {
  id
  invoiceId
  invoicePdfTemplateId
  url
}
    `;
export const InvoicePdfTemplateFragmentFragmentDoc = gql`
    fragment InvoicePdfTemplateFragment on InvoicePdfTemplate {
  id
  courierId
  name
  isDefault
  separateGenerationType
  subtotalGroupedByType
  subtotalGroupedByCustomFieldId
  subtotalPageBreakType
  summaryDisplayType
  columnsWithWidth {
    column
    widthPercentage
  }
  detailColumnFields
  returnSlipType
  marginLeft
  tableContentFontSize
  largeTextFontSize
  smallTextFontSize
  showTableBorder
  brandColor
  labelColor
  borderSize
  finalMessage
}
    `;
export const LinkedAccountFragmentFragmentDoc = gql`
    fragment LinkedAccountFragment on LinkedAccount {
  id
  courierId
  remoteId
  name
  provider
  accountExpiresAt
  isValid
}
    `;
export const RoutingNodeFragmentFragmentDoc = gql`
    fragment RoutingNodeFragment on RoutingNode {
  id
  jobId
  isNewAssignment
  assignedRouteSequenceNumber
}
    `;
export const RoutingVehicleFragmentFragmentDoc = gql`
    fragment RoutingVehicleFragment on RoutingVehicle {
  id
  jobId
  startLocation {
    ...LocationFragment
  }
  endLocation {
    ...LocationFragment
  }
  startTime
  endTime
  useDriverCurrentLocationAtStart
}
    ${LocationFragmentFragmentDoc}`;
export const RoutingDayResultFragmentFragmentDoc = gql`
    fragment RoutingDayResultFragment on RoutingDayResult {
  date
  jobId
  vehicles {
    ...RoutingVehicleFragment
  }
}
    ${RoutingVehicleFragmentFragmentDoc}`;
export const RoutingJobFragmentFragmentDoc = gql`
    fragment RoutingJobFragment on RoutingJob {
  id
  courierId
  displayId
  status
  dateCreated
  shipmentIds
  driverIds
}
    `;
export const RoutingNodeEtaFragmentFragmentDoc = gql`
    fragment RoutingNodeEtaFragment on RoutingNodeEta {
  routingNodeId
  eta
  isLikelyLate
  isLikelyEarly
  likelyLateByInMinutes
  likelyEarlyByInMinutes
}
    `;
export const OrderAttachmentFragmentFragmentDoc = gql`
    fragment OrderAttachmentFragment on OrderAttachment {
  id
  fileName
  publicUrl
}
    `;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  acquisitionType
  caller
  costCenterId
  courierId
  displayId
  driverPayOverride
  endCustomerReferenceNumber
  id
  priceOverride
  priceOverrideBreakdown {
    description
    amount
  }
  recurrenceDetail {
    biweeklySchedule {
      startDateISO8601
    }
    endDateISO8601
    monthlySchedule {
      days
    }
    scheduleType
    startDateISO8601
    weeklySchedule {
      weekDays
    }
  }
  recurrenceType
  name
  pricingStopIds
  additionalEmailRecipients
}
    `;
export const PackageTypeFragmentFragmentDoc = gql`
    fragment PackageTypeFragment on PackageType {
  id
  courierId
  name
}
    `;
export const PageInfoFragmentFragmentDoc = gql`
    fragment PageInfoFragment on PageInfo {
  endCursor
  hasNextPage
  hasPreviousPage
  startCursor
}
    `;
export const PaymentTransferFragmentFragmentDoc = gql`
    fragment PaymentTransferFragment on PaymentTransfer {
  id
  displayId
  courierId
  endCustomerId
  amount
  currency
  status
  failureCode
  failureMessage
  refundType
}
    `;
export const CreditCardDetailFragmentFragmentDoc = gql`
    fragment CreditCardDetailFragment on CreditCardDetail {
  name
  lastFour
  expirationMonth
  expirationYear
  brand
}
    `;
export const BankAccountDetailFragmentFragmentDoc = gql`
    fragment BankAccountDetailFragment on BankAccountDetail {
  name
  maskedAccountNumber
  bankCode
}
    `;
export const PaymentInstrumentFragmentFragmentDoc = gql`
    fragment PaymentInstrumentFragment on PaymentInstrument {
  id
  courierId
  endCustomerId
  costCenterId
  paymentInstrumentType
  isDefault
  creditCardDetail {
    ...CreditCardDetailFragment
  }
  bankAccountDetail {
    ...BankAccountDetailFragment
  }
}
    ${CreditCardDetailFragmentFragmentDoc}
${BankAccountDetailFragmentFragmentDoc}`;
export const InvoicePaymentFragmentFragmentDoc = gql`
    fragment InvoicePaymentFragment on InvoicePayment {
  id
  courierId
  invoiceId
  paymentTransferId
  allocatedAmount
}
    `;
export const PaymentSettlementFragmentFragmentDoc = gql`
    fragment PaymentSettlementFragment on PaymentSettlement {
  id
  remoteId
  courierId
  merchantId
  status
  providerCreatedAt
  netAmount
  totalAmount
  totalFee
  totalFeeIncludingSubscriptionBilling
  type
}
    `;
export const InvoicePaymentFieldsFragmentDoc = gql`
    fragment InvoicePaymentFields on InvoicePayment {
  id
  courierId
  invoiceId
  paymentTransferId
  allocatedAmount
}
    `;
export const InvoiceBalanceFieldsFragmentDoc = gql`
    fragment InvoiceBalanceFields on InvoiceBalance {
  invoiceId
  remainingBalance
}
    `;
export const DriverPayEntryFragmentFragmentDoc = gql`
    fragment DriverPayEntryFragment on DriverPayEntry {
  id
  driverId
  startDate
  endDate
  amountTotal
  ordersCount
  status
}
    `;
export const PayPeriodFragmentFragmentDoc = gql`
    fragment PayPeriodFragment on PayPeriod {
  startDate
  endDate
}
    `;
export const PayrollReportFileFragmentFragmentDoc = gql`
    fragment PayrollReportFileFragment on PayrollReportFile {
  url
}
    `;
export const PayrollSettingFragmentFragmentDoc = gql`
    fragment PayrollSettingFragment on PayrollSetting {
  courierId
  defaultCommission
  payPeriodType
}
    `;
export const OrderPayBreakDownFragmentFragmentDoc = gql`
    fragment OrderPayBreakDownFragment on OrderPayBreakDown {
  total
}
    `;
export const OrderPayBreakDownItemFragmentFragmentDoc = gql`
    fragment OrderPayBreakDownItemFragment on OrderPayBreakDownItem {
  name
  description
  amount
}
    `;
export const PayrollDeductionRuleFragmentFragmentDoc = gql`
    fragment PayrollDeductionRuleFragment on PayrollDeductionRule {
  id
  name
  amount
  amountType
  ruleType
  drivers {
    id
    firstName
    lastName
  }
}
    `;
export const PricingRuleFragmentFragmentDoc = gql`
    fragment PricingRuleFragment on PricingRule {
  id
  courierId
  pricingListId
  origin
  originDisplay
  originType
  destination
  destinationDisplay
  destinationType
  minMiles
  maxMiles
  minWeight
  maxWeight
  serviceTypeId
  basePrice
  minimumPrice
  pricePerMile
  driverPayFixed
  driverCommission
  freeMiles
  minTrips
  maxTrips
  packageType {
    id
    courierId
    name
  }
}
    `;
export const PricingBreakDownFragmentFragmentDoc = gql`
    fragment PricingBreakDownFragment on PricingBreakDown {
  items {
    name
    amount
    description
    adjustmentId
    isAdjustmentOverride
  }
}
    `;
export const SurchargePricingRuleFragmentFragmentDoc = gql`
    fragment SurchargePricingRuleFragment on SurchargePricingRule {
  id
  courierId
  pricingListId
  name
  amount
  amountDisplay
  percent
  amountType
  applyType
  minMiles
  maxMiles
  minWeight
  maxWeight
  minPackageCount
  maxPackageCount
  packageSize
  driverCommission
  showInInvoice
  minReadyTimeInSecondsSinceMidnight
  maxReadyTimeInSecondsSinceMidnight
  timeZoneId
  daysOfTheWeek
  freeMiles
  freePackageCount
  freeWeight
  surchargePricingRuleIdsToExclude
  perimeterZone {
    id
    courierId
    displayId
    type
    name
  }
}
    `;
export const PricingAdjustmentFragmentFragmentDoc = gql`
    fragment PricingAdjustmentFragment on PricingAdjustment {
  id
  orderId
  surchargePricingRuleId
  type
  amount
  note
  surchargePricingRule {
    ...SurchargePricingRuleFragment
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}`;
export const OrderPriceFragmentFragmentDoc = gql`
    fragment OrderPriceFragment on OrderPrice {
  total
  isPriceOverride
  isBasePriceOverride
  priceOverride
  basePriceOverride
  pricingBreakDown {
    ...PricingBreakDownFragment
  }
  customSurchargeAdjustments {
    ...PricingAdjustmentFragment
  }
  isFinalized
  priceOverrideBreakdown {
    description
    amount
  }
}
    ${PricingBreakDownFragmentFragmentDoc}
${PricingAdjustmentFragmentFragmentDoc}`;
export const ZipGroupFragmentFragmentDoc = gql`
    fragment ZipGroupFragment on ZipGroup {
  id
  courierId
  name
  zipCodes
}
    `;
export const RemoteEntityFragmentFragmentDoc = gql`
    fragment RemoteEntityFragment on RemoteEntity {
  id
  courierId
  provider
  remoteId
  internalId
  type
  externalUrl
}
    `;
export const SalesReportFileFragmentFragmentDoc = gql`
    fragment SalesReportFileFragment on SalesReportFile {
  url
}
    `;
export const SalesOverviewFragmentFragmentDoc = gql`
    fragment SalesOverviewFragment on SalesOverview {
  courierId
  minDate
  maxDate
  amountTotal
  amountForCompletedShipments
  numShipmentsTotal
  numShipmentsCompleted
}
    `;
export const ServiceTypeFragmentFragmentDoc = gql`
    fragment ServiceTypeFragment on ServiceType {
  id
  courierId
  name
  displayId
  deliveryTimeInMinutes
  color
  visibilityType
  dueTimeType
  dueTimeSecondsSinceMidnight
  dueTimeInBusinessDaysAfter
  readyTimeSchedule {
    weekDailyList {
      days
      startTimeSecondsSinceMidnight
      endTimeSecondsSinceMidnight
    }
  }
  deliveryRoutedDaysAfter
  customMessage
}
    `;
export const ShipmentFragmentFragmentDoc = gql`
    fragment ShipmentFragment on Shipment {
  id
  courierId
  shipmentDate
  driverId
  status
  packageSize
  packageWeightInPounds
  numPackages
  trackingNumber
  isClosed
  isForceCompleted
  type
  internalNote
  assignedAt
  createdAt
  driverConfirmedAt
  signedByOverride
  deliveredAtOverride
  waitTimeInMinutes
  packageDescription
  routingJobId
  firstEffectiveStopDate
  driverReportedWaitTimeInMinutes
  waitTimeUnfreeMinutesOverride
  completedDate
  completedDateOverriddenBy
  hasCompletedDateOverride
  proposedNumPackages
  proposedPackageWeightInPounds
}
    `;
export const ShipmentTemplateFragmentFragmentDoc = gql`
    fragment ShipmentTemplateFragment on ShipmentTemplate {
  id
  courierId
  orderId
  packageSize
  packageWeightInPounds
  type
  numPackages
  packageTypeId
  vehicleTypeId
}
    `;
export const DriverPayAllocationFragmentFragmentDoc = gql`
    fragment DriverPayAllocationFragment on DriverPayAllocation {
  id
  driverId
  shipmentId
  allocationRate
}
    `;
export const StopFragmentFragmentDoc = gql`
    fragment StopFragment on Stop {
  id
  shipmentId
  type
  streetAddress
  googlePlaceId
  suite
  city
  state
  country
  dispatchZone
  driverNote
  zipCode
  contactName
  companyName
  phone
  instruction
  timeStatus
  completedAt
  stopDate
  lngLat {
    lng
    lat
  }
  timeWindow {
    open
    close
  }
  dispatchZoneLine2
  effectiveStopDate
  locationId
}
    `;
export const StopTemplateFragmentFragmentDoc = gql`
    fragment StopTemplateFragment on StopTemplate {
  id
  shipmentTemplateId
  type
  streetAddress
  suite
  city
  state
  country
  zipCode
  lngLat {
    lng
    lat
  }
  googlePlaceId
  contactName
  companyName
  phone
  instruction
  dispatchZone
  timeWindow {
    openSecondsSinceMidnightUtc
    closeSecondsSinceMidnightUtc
  }
  timeZoneId
}
    `;
export const TaskFragmentFragmentDoc = gql`
    fragment TaskFragment on Task {
  id
  driverId
  sequenceNumber
  status
  arrivedAt
  etaEpochSeconds
  date
}
    `;
export const StopEtaFragmentFragmentDoc = gql`
    fragment StopEtaFragment on StopEta {
  stopId
  eta
  isLikelyLate
  likelyLateByInMinutes
}
    `;
export const VisibleColumnsConfigFragmentFragmentDoc = gql`
    fragment VisibleColumnsConfigFragment on VisibleColumnsConfig {
  id
  salesReportColumnIds
  driverReportColumnIds
  userOrEmployeeId
}
    `;
export const CourieUserFragmentFragmentDoc = gql`
    fragment CourieUserFragment on CourieUser {
  id
  email
  courierId
  firebaseUid
  profilePhotoUrl
}
    `;
export const ZoneFragmentFragmentDoc = gql`
    fragment ZoneFragment on Zone {
  id
  courierId
  displayId
  type
  name
  polygon {
    points {
      lng
      lat
    }
  }
}
    `;
export const ActivitiesDocument = gql`
    query Activities($courierId: ID!, $entityId: ID!) {
  activities(courierId: $courierId, entityId: $entityId) {
    activities {
      ...ActivityFragment
      change {
        old {
          ...ActivitySnapshotFragment
        }
        new {
          ...ActivitySnapshotFragment
        }
      }
      updatedByUser {
        ...CourieUserFragment
      }
      updatedByEndCustomer {
        ...EndCustomerFragment
      }
      updatedByEndUser {
        ...EndUserFragment
      }
      updatedByDriver {
        ...DriverFragment
      }
    }
  }
}
    ${ActivityFragmentFragmentDoc}
${ActivitySnapshotFragmentFragmentDoc}
${CourieUserFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${EndUserFragmentFragmentDoc}
${DriverFragmentFragmentDoc}`;

/**
 * __useActivitiesQuery__
 *
 * To run a query within a React component, call `useActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useActivitiesQuery(baseOptions: Apollo.QueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, options);
      }
export function useActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, options);
        }
export type ActivitiesQueryHookResult = ReturnType<typeof useActivitiesQuery>;
export type ActivitiesLazyQueryHookResult = ReturnType<typeof useActivitiesLazyQuery>;
export type ActivitiesQueryResult = Apollo.QueryResult<ActivitiesQuery, ActivitiesQueryVariables>;
export const CreateAddressBookDocument = gql`
    mutation CreateAddressBook($courierId: ID!, $endCustomerId: ID, $contactName: String, $companyName: String, $phone: String, $suite: String, $instruction: String, $locationId: ID!) {
  createAddressBook(
    courierId: $courierId
    endCustomerId: $endCustomerId
    contactName: $contactName
    companyName: $companyName
    phone: $phone
    suite: $suite
    instruction: $instruction
    locationId: $locationId
  ) {
    ...AddressBookFragment
  }
}
    ${AddressBookFragmentFragmentDoc}`;
export type CreateAddressBookMutationFn = Apollo.MutationFunction<CreateAddressBookMutation, CreateAddressBookMutationVariables>;

/**
 * __useCreateAddressBookMutation__
 *
 * To run a mutation, you first call `useCreateAddressBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressBookMutation, { data, loading, error }] = useCreateAddressBookMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      contactName: // value for 'contactName'
 *      companyName: // value for 'companyName'
 *      phone: // value for 'phone'
 *      suite: // value for 'suite'
 *      instruction: // value for 'instruction'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useCreateAddressBookMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddressBookMutation, CreateAddressBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddressBookMutation, CreateAddressBookMutationVariables>(CreateAddressBookDocument, options);
      }
export type CreateAddressBookMutationHookResult = ReturnType<typeof useCreateAddressBookMutation>;
export type CreateAddressBookMutationResult = Apollo.MutationResult<CreateAddressBookMutation>;
export type CreateAddressBookMutationOptions = Apollo.BaseMutationOptions<CreateAddressBookMutation, CreateAddressBookMutationVariables>;
export const FullUpdateAddressBookDocument = gql`
    mutation FullUpdateAddressBook($id: ID!, $courierId: ID!, $endCustomerId: ID, $contactName: String, $companyName: String, $phone: String, $suite: String, $instruction: String, $locationId: ID!) {
  fullUpdateAddressBook(
    id: $id
    courierId: $courierId
    endCustomerId: $endCustomerId
    contactName: $contactName
    companyName: $companyName
    phone: $phone
    suite: $suite
    instruction: $instruction
    locationId: $locationId
  ) {
    ...AddressBookFragment
  }
}
    ${AddressBookFragmentFragmentDoc}`;
export type FullUpdateAddressBookMutationFn = Apollo.MutationFunction<FullUpdateAddressBookMutation, FullUpdateAddressBookMutationVariables>;

/**
 * __useFullUpdateAddressBookMutation__
 *
 * To run a mutation, you first call `useFullUpdateAddressBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateAddressBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateAddressBookMutation, { data, loading, error }] = useFullUpdateAddressBookMutation({
 *   variables: {
 *      id: // value for 'id'
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      contactName: // value for 'contactName'
 *      companyName: // value for 'companyName'
 *      phone: // value for 'phone'
 *      suite: // value for 'suite'
 *      instruction: // value for 'instruction'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useFullUpdateAddressBookMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateAddressBookMutation, FullUpdateAddressBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateAddressBookMutation, FullUpdateAddressBookMutationVariables>(FullUpdateAddressBookDocument, options);
      }
export type FullUpdateAddressBookMutationHookResult = ReturnType<typeof useFullUpdateAddressBookMutation>;
export type FullUpdateAddressBookMutationResult = Apollo.MutationResult<FullUpdateAddressBookMutation>;
export type FullUpdateAddressBookMutationOptions = Apollo.BaseMutationOptions<FullUpdateAddressBookMutation, FullUpdateAddressBookMutationVariables>;
export const DeleteAddressBookDocument = gql`
    mutation DeleteAddressBook($id: ID!, $courierId: ID!) {
  deleteAddressBook(id: $id, courierId: $courierId)
}
    `;
export type DeleteAddressBookMutationFn = Apollo.MutationFunction<DeleteAddressBookMutation, DeleteAddressBookMutationVariables>;

/**
 * __useDeleteAddressBookMutation__
 *
 * To run a mutation, you first call `useDeleteAddressBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddressBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressBookMutation, { data, loading, error }] = useDeleteAddressBookMutation({
 *   variables: {
 *      id: // value for 'id'
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useDeleteAddressBookMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAddressBookMutation, DeleteAddressBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAddressBookMutation, DeleteAddressBookMutationVariables>(DeleteAddressBookDocument, options);
      }
export type DeleteAddressBookMutationHookResult = ReturnType<typeof useDeleteAddressBookMutation>;
export type DeleteAddressBookMutationResult = Apollo.MutationResult<DeleteAddressBookMutation>;
export type DeleteAddressBookMutationOptions = Apollo.BaseMutationOptions<DeleteAddressBookMutation, DeleteAddressBookMutationVariables>;
export const SearchFromAddressBookDocument = gql`
    query SearchFromAddressBook($courierId: ID!, $endCustomerId: ID, $endCustomerIdBias: ID, $contactNameSearch: String, $companyNameSearch: String, $phoneSearch: String, $streetAddressSearch: String) {
  searchFromAddressBook(
    courierId: $courierId
    endCustomerId: $endCustomerId
    endCustomerIdBias: $endCustomerIdBias
    contactNameSearch: $contactNameSearch
    companyNameSearch: $companyNameSearch
    phoneSearch: $phoneSearch
    streetAddressSearch: $streetAddressSearch
  ) {
    ...AddressBookFragment
  }
}
    ${AddressBookFragmentFragmentDoc}`;

/**
 * __useSearchFromAddressBookQuery__
 *
 * To run a query within a React component, call `useSearchFromAddressBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFromAddressBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFromAddressBookQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      endCustomerIdBias: // value for 'endCustomerIdBias'
 *      contactNameSearch: // value for 'contactNameSearch'
 *      companyNameSearch: // value for 'companyNameSearch'
 *      phoneSearch: // value for 'phoneSearch'
 *      streetAddressSearch: // value for 'streetAddressSearch'
 *   },
 * });
 */
export function useSearchFromAddressBookQuery(baseOptions: Apollo.QueryHookOptions<SearchFromAddressBookQuery, SearchFromAddressBookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFromAddressBookQuery, SearchFromAddressBookQueryVariables>(SearchFromAddressBookDocument, options);
      }
export function useSearchFromAddressBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFromAddressBookQuery, SearchFromAddressBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFromAddressBookQuery, SearchFromAddressBookQueryVariables>(SearchFromAddressBookDocument, options);
        }
export type SearchFromAddressBookQueryHookResult = ReturnType<typeof useSearchFromAddressBookQuery>;
export type SearchFromAddressBookLazyQueryHookResult = ReturnType<typeof useSearchFromAddressBookLazyQuery>;
export type SearchFromAddressBookQueryResult = Apollo.QueryResult<SearchFromAddressBookQuery, SearchFromAddressBookQueryVariables>;
export const AddressBookEntriesDocument = gql`
    query AddressBookEntries($courierId: ID!, $endCustomerIds: [ID!], $limit: Int, $after: Int, $sortFields: [AddressBookSorting!]) {
  addressBookEntries(
    courierId: $courierId
    endCustomerIds: $endCustomerIds
    limit: $limit
    after: $after
    sortFields: $sortFields
  ) {
    edges {
      node {
        ...AddressBookFragment
        endCustomer {
          ...EndCustomerFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${AddressBookFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useAddressBookEntriesQuery__
 *
 * To run a query within a React component, call `useAddressBookEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressBookEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressBookEntriesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useAddressBookEntriesQuery(baseOptions: Apollo.QueryHookOptions<AddressBookEntriesQuery, AddressBookEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressBookEntriesQuery, AddressBookEntriesQueryVariables>(AddressBookEntriesDocument, options);
      }
export function useAddressBookEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressBookEntriesQuery, AddressBookEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressBookEntriesQuery, AddressBookEntriesQueryVariables>(AddressBookEntriesDocument, options);
        }
export type AddressBookEntriesQueryHookResult = ReturnType<typeof useAddressBookEntriesQuery>;
export type AddressBookEntriesLazyQueryHookResult = ReturnType<typeof useAddressBookEntriesLazyQuery>;
export type AddressBookEntriesQueryResult = Apollo.QueryResult<AddressBookEntriesQuery, AddressBookEntriesQueryVariables>;
export const GenerateResetPasswordLinkDocument = gql`
    mutation GenerateResetPasswordLink($email: String!) {
  generateResetPasswordLink(email: $email) {
    link
  }
}
    `;
export type GenerateResetPasswordLinkMutationFn = Apollo.MutationFunction<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>;

/**
 * __useGenerateResetPasswordLinkMutation__
 *
 * To run a mutation, you first call `useGenerateResetPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateResetPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateResetPasswordLinkMutation, { data, loading, error }] = useGenerateResetPasswordLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGenerateResetPasswordLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>(GenerateResetPasswordLinkDocument, options);
      }
export type GenerateResetPasswordLinkMutationHookResult = ReturnType<typeof useGenerateResetPasswordLinkMutation>;
export type GenerateResetPasswordLinkMutationResult = Apollo.MutationResult<GenerateResetPasswordLinkMutation>;
export type GenerateResetPasswordLinkMutationOptions = Apollo.BaseMutationOptions<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation SendPasswordResetEmail($courierId: ID!, $endCustomerIds: [ID!], $driverIds: [ID!], $endUserIds: [ID!], $userIds: [ID!], $emails: [String!]) {
  sendPasswordResetEmail(
    courierId: $courierId
    endCustomerIds: $endCustomerIds
    driverIds: $driverIds
    endUserIds: $endUserIds
    userIds: $userIds
    emails: $emails
  )
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *      driverIds: // value for 'driverIds'
 *      endUserIds: // value for 'endUserIds'
 *      userIds: // value for 'userIds'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, options);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const BulkUploadOrdersDocument = gql`
    mutation BulkUploadOrders($courierId: ID!, $file: Upload!) {
  bulkUploadOrders(courierId: $courierId, file: $file) {
    numSuccess
    error {
      errorMessages
      lineErrors {
        lineNumber
        cellErrors {
          columnName
          errorMessage
        }
      }
    }
  }
}
    `;
export type BulkUploadOrdersMutationFn = Apollo.MutationFunction<BulkUploadOrdersMutation, BulkUploadOrdersMutationVariables>;

/**
 * __useBulkUploadOrdersMutation__
 *
 * To run a mutation, you first call `useBulkUploadOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadOrdersMutation, { data, loading, error }] = useBulkUploadOrdersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useBulkUploadOrdersMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadOrdersMutation, BulkUploadOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadOrdersMutation, BulkUploadOrdersMutationVariables>(BulkUploadOrdersDocument, options);
      }
export type BulkUploadOrdersMutationHookResult = ReturnType<typeof useBulkUploadOrdersMutation>;
export type BulkUploadOrdersMutationResult = Apollo.MutationResult<BulkUploadOrdersMutation>;
export type BulkUploadOrdersMutationOptions = Apollo.BaseMutationOptions<BulkUploadOrdersMutation, BulkUploadOrdersMutationVariables>;
export const BulkUploadEndCustomersDocument = gql`
    mutation BulkUploadEndCustomers($courierId: ID!, $file: Upload!, $ignoreInvalidAddresses: Boolean, $ignoreInvalidPricingLists: Boolean, $ignoreInvalidInvoiceFrequencies: Boolean) {
  bulkUploadEndCustomers(
    courierId: $courierId
    file: $file
    ignoreInvalidAddresses: $ignoreInvalidAddresses
    ignoreInvalidPricingLists: $ignoreInvalidPricingLists
    ignoreInvalidInvoiceFrequencies: $ignoreInvalidInvoiceFrequencies
  ) {
    numSuccess
    errors {
      rowNumber
      messages
    }
  }
}
    `;
export type BulkUploadEndCustomersMutationFn = Apollo.MutationFunction<BulkUploadEndCustomersMutation, BulkUploadEndCustomersMutationVariables>;

/**
 * __useBulkUploadEndCustomersMutation__
 *
 * To run a mutation, you first call `useBulkUploadEndCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadEndCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadEndCustomersMutation, { data, loading, error }] = useBulkUploadEndCustomersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *      ignoreInvalidAddresses: // value for 'ignoreInvalidAddresses'
 *      ignoreInvalidPricingLists: // value for 'ignoreInvalidPricingLists'
 *      ignoreInvalidInvoiceFrequencies: // value for 'ignoreInvalidInvoiceFrequencies'
 *   },
 * });
 */
export function useBulkUploadEndCustomersMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadEndCustomersMutation, BulkUploadEndCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadEndCustomersMutation, BulkUploadEndCustomersMutationVariables>(BulkUploadEndCustomersDocument, options);
      }
export type BulkUploadEndCustomersMutationHookResult = ReturnType<typeof useBulkUploadEndCustomersMutation>;
export type BulkUploadEndCustomersMutationResult = Apollo.MutationResult<BulkUploadEndCustomersMutation>;
export type BulkUploadEndCustomersMutationOptions = Apollo.BaseMutationOptions<BulkUploadEndCustomersMutation, BulkUploadEndCustomersMutationVariables>;
export const CreateCostCenterDocument = gql`
    mutation CreateCostCenter($endCustomerId: ID!, $name: String!, $googlePlaceId: String, $suite: String, $email: String, $phone: String) {
  createCostCenter(
    costCenterCreate: {endCustomerId: $endCustomerId, name: $name, googlePlaceId: $googlePlaceId, suite: $suite, email: $email, phone: $phone}
  ) {
    ...CostCenterFragment
    location {
      ...LocationFragment
    }
  }
}
    ${CostCenterFragmentFragmentDoc}
${LocationFragmentFragmentDoc}`;
export type CreateCostCenterMutationFn = Apollo.MutationFunction<CreateCostCenterMutation, CreateCostCenterMutationVariables>;

/**
 * __useCreateCostCenterMutation__
 *
 * To run a mutation, you first call `useCreateCostCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCostCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCostCenterMutation, { data, loading, error }] = useCreateCostCenterMutation({
 *   variables: {
 *      endCustomerId: // value for 'endCustomerId'
 *      name: // value for 'name'
 *      googlePlaceId: // value for 'googlePlaceId'
 *      suite: // value for 'suite'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCreateCostCenterMutation(baseOptions?: Apollo.MutationHookOptions<CreateCostCenterMutation, CreateCostCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCostCenterMutation, CreateCostCenterMutationVariables>(CreateCostCenterDocument, options);
      }
export type CreateCostCenterMutationHookResult = ReturnType<typeof useCreateCostCenterMutation>;
export type CreateCostCenterMutationResult = Apollo.MutationResult<CreateCostCenterMutation>;
export type CreateCostCenterMutationOptions = Apollo.BaseMutationOptions<CreateCostCenterMutation, CreateCostCenterMutationVariables>;
export const MarkCostCenterDeletedDocument = gql`
    mutation MarkCostCenterDeleted($courierId: ID!, $costCenterId: ID!) {
  markCostCenterDeleted(courierId: $courierId, costCenterId: $costCenterId)
}
    `;
export type MarkCostCenterDeletedMutationFn = Apollo.MutationFunction<MarkCostCenterDeletedMutation, MarkCostCenterDeletedMutationVariables>;

/**
 * __useMarkCostCenterDeletedMutation__
 *
 * To run a mutation, you first call `useMarkCostCenterDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCostCenterDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCostCenterDeletedMutation, { data, loading, error }] = useMarkCostCenterDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      costCenterId: // value for 'costCenterId'
 *   },
 * });
 */
export function useMarkCostCenterDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkCostCenterDeletedMutation, MarkCostCenterDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCostCenterDeletedMutation, MarkCostCenterDeletedMutationVariables>(MarkCostCenterDeletedDocument, options);
      }
export type MarkCostCenterDeletedMutationHookResult = ReturnType<typeof useMarkCostCenterDeletedMutation>;
export type MarkCostCenterDeletedMutationResult = Apollo.MutationResult<MarkCostCenterDeletedMutation>;
export type MarkCostCenterDeletedMutationOptions = Apollo.BaseMutationOptions<MarkCostCenterDeletedMutation, MarkCostCenterDeletedMutationVariables>;
export const GetCostCentersDocument = gql`
    query GetCostCenters($endCustomerIds: [ID!]!) {
  costCenters(endCustomerIds: $endCustomerIds) {
    ...CostCenterFragment
    location {
      ...LocationFragment
    }
  }
}
    ${CostCenterFragmentFragmentDoc}
${LocationFragmentFragmentDoc}`;

/**
 * __useGetCostCentersQuery__
 *
 * To run a query within a React component, call `useGetCostCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCostCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCostCentersQuery({
 *   variables: {
 *      endCustomerIds: // value for 'endCustomerIds'
 *   },
 * });
 */
export function useGetCostCentersQuery(baseOptions: Apollo.QueryHookOptions<GetCostCentersQuery, GetCostCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCostCentersQuery, GetCostCentersQueryVariables>(GetCostCentersDocument, options);
      }
export function useGetCostCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCostCentersQuery, GetCostCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCostCentersQuery, GetCostCentersQueryVariables>(GetCostCentersDocument, options);
        }
export type GetCostCentersQueryHookResult = ReturnType<typeof useGetCostCentersQuery>;
export type GetCostCentersLazyQueryHookResult = ReturnType<typeof useGetCostCentersLazyQuery>;
export type GetCostCentersQueryResult = Apollo.QueryResult<GetCostCentersQuery, GetCostCentersQueryVariables>;
export const GetCourierDocument = gql`
    query GetCourier($courierId: ID!) {
  courier(courierId: $courierId) {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;

/**
 * __useGetCourierQuery__
 *
 * To run a query within a React component, call `useGetCourierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourierQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetCourierQuery(baseOptions: Apollo.QueryHookOptions<GetCourierQuery, GetCourierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourierQuery, GetCourierQueryVariables>(GetCourierDocument, options);
      }
export function useGetCourierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourierQuery, GetCourierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourierQuery, GetCourierQueryVariables>(GetCourierDocument, options);
        }
export type GetCourierQueryHookResult = ReturnType<typeof useGetCourierQuery>;
export type GetCourierLazyQueryHookResult = ReturnType<typeof useGetCourierLazyQuery>;
export type GetCourierQueryResult = Apollo.QueryResult<GetCourierQuery, GetCourierQueryVariables>;
export const GetCouriersDocument = gql`
    query GetCouriers {
  couriers {
    ...CourierFragment
  }
}
    ${CourierFragmentFragmentDoc}`;

/**
 * __useGetCouriersQuery__
 *
 * To run a query within a React component, call `useGetCouriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCouriersQuery(baseOptions?: Apollo.QueryHookOptions<GetCouriersQuery, GetCouriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouriersQuery, GetCouriersQueryVariables>(GetCouriersDocument, options);
      }
export function useGetCouriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouriersQuery, GetCouriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouriersQuery, GetCouriersQueryVariables>(GetCouriersDocument, options);
        }
export type GetCouriersQueryHookResult = ReturnType<typeof useGetCouriersQuery>;
export type GetCouriersLazyQueryHookResult = ReturnType<typeof useGetCouriersLazyQuery>;
export type GetCouriersQueryResult = Apollo.QueryResult<GetCouriersQuery, GetCouriersQueryVariables>;
export const CreateCustomFieldDocument = gql`
    mutation createCustomField($courierId: ID!, $name: String!, $type: CustomFieldType!, $visibilityType: CustomFieldCustomerVisibilityType, $customerSpecificityType: CustomFieldCustomerSpecificity, $requirementType: CustomFieldCustomerRequirementType) {
  createCustomField(
    courierId: $courierId
    name: $name
    type: $type
    visibilityType: $visibilityType
    customerSpecificityType: $customerSpecificityType
    requirementType: $requirementType
  ) {
    ...CustomFieldFragment
  }
}
    ${CustomFieldFragmentFragmentDoc}`;
export type CreateCustomFieldMutationFn = Apollo.MutationFunction<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>;

/**
 * __useCreateCustomFieldMutation__
 *
 * To run a mutation, you first call `useCreateCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomFieldMutation, { data, loading, error }] = useCreateCustomFieldMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      visibilityType: // value for 'visibilityType'
 *      customerSpecificityType: // value for 'customerSpecificityType'
 *      requirementType: // value for 'requirementType'
 *   },
 * });
 */
export function useCreateCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>(CreateCustomFieldDocument, options);
      }
export type CreateCustomFieldMutationHookResult = ReturnType<typeof useCreateCustomFieldMutation>;
export type CreateCustomFieldMutationResult = Apollo.MutationResult<CreateCustomFieldMutation>;
export type CreateCustomFieldMutationOptions = Apollo.BaseMutationOptions<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>;
export const FullUpdateCustomFieldDocument = gql`
    mutation fullUpdateCustomField($courierId: ID!, $id: ID!, $name: String!, $type: CustomFieldType!, $visibilityType: CustomFieldCustomerVisibilityType!, $customerSpecificityType: CustomFieldCustomerSpecificity!, $requirementType: CustomFieldCustomerRequirementType!) {
  fullUpdateCustomField(
    courierId: $courierId
    id: $id
    name: $name
    type: $type
    visibilityType: $visibilityType
    customerSpecificityType: $customerSpecificityType
    requirementType: $requirementType
  ) {
    ...CustomFieldFragment
  }
}
    ${CustomFieldFragmentFragmentDoc}`;
export type FullUpdateCustomFieldMutationFn = Apollo.MutationFunction<FullUpdateCustomFieldMutation, FullUpdateCustomFieldMutationVariables>;

/**
 * __useFullUpdateCustomFieldMutation__
 *
 * To run a mutation, you first call `useFullUpdateCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateCustomFieldMutation, { data, loading, error }] = useFullUpdateCustomFieldMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      visibilityType: // value for 'visibilityType'
 *      customerSpecificityType: // value for 'customerSpecificityType'
 *      requirementType: // value for 'requirementType'
 *   },
 * });
 */
export function useFullUpdateCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateCustomFieldMutation, FullUpdateCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateCustomFieldMutation, FullUpdateCustomFieldMutationVariables>(FullUpdateCustomFieldDocument, options);
      }
export type FullUpdateCustomFieldMutationHookResult = ReturnType<typeof useFullUpdateCustomFieldMutation>;
export type FullUpdateCustomFieldMutationResult = Apollo.MutationResult<FullUpdateCustomFieldMutation>;
export type FullUpdateCustomFieldMutationOptions = Apollo.BaseMutationOptions<FullUpdateCustomFieldMutation, FullUpdateCustomFieldMutationVariables>;
export const MarkCustomFieldAsDeletedDocument = gql`
    mutation markCustomFieldAsDeleted($courierId: ID!, $id: ID!) {
  markCustomFieldAsDeleted(courierId: $courierId, id: $id)
}
    `;
export type MarkCustomFieldAsDeletedMutationFn = Apollo.MutationFunction<MarkCustomFieldAsDeletedMutation, MarkCustomFieldAsDeletedMutationVariables>;

/**
 * __useMarkCustomFieldAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkCustomFieldAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCustomFieldAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCustomFieldAsDeletedMutation, { data, loading, error }] = useMarkCustomFieldAsDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkCustomFieldAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkCustomFieldAsDeletedMutation, MarkCustomFieldAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCustomFieldAsDeletedMutation, MarkCustomFieldAsDeletedMutationVariables>(MarkCustomFieldAsDeletedDocument, options);
      }
export type MarkCustomFieldAsDeletedMutationHookResult = ReturnType<typeof useMarkCustomFieldAsDeletedMutation>;
export type MarkCustomFieldAsDeletedMutationResult = Apollo.MutationResult<MarkCustomFieldAsDeletedMutation>;
export type MarkCustomFieldAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkCustomFieldAsDeletedMutation, MarkCustomFieldAsDeletedMutationVariables>;
export const GetCustomFieldsDocument = gql`
    query getCustomFields($courierId: ID!, $endCustomerId: ID, $visibleToSelectedEndCustomerOnly: Boolean) {
  customFields(
    courierId: $courierId
    endCustomerId: $endCustomerId
    visibleToSelectedEndCustomerOnly: $visibleToSelectedEndCustomerOnly
  ) {
    ...CustomFieldFragment
  }
}
    ${CustomFieldFragmentFragmentDoc}`;

/**
 * __useGetCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFieldsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      visibleToSelectedEndCustomerOnly: // value for 'visibleToSelectedEndCustomerOnly'
 *   },
 * });
 */
export function useGetCustomFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>(GetCustomFieldsDocument, options);
      }
export function useGetCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>(GetCustomFieldsDocument, options);
        }
export type GetCustomFieldsQueryHookResult = ReturnType<typeof useGetCustomFieldsQuery>;
export type GetCustomFieldsLazyQueryHookResult = ReturnType<typeof useGetCustomFieldsLazyQuery>;
export type GetCustomFieldsQueryResult = Apollo.QueryResult<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>;
export const DispatchDriverForShipmentDocument = gql`
    mutation DispatchDriverForShipment($shipmentId: ID!, $driverId: ID!, $orderingAlgorithmType: OrderingAlgorithmType, $stopIds: [ID!], $dispatchedBy: ID, $autoRoutedStopIds: [ID!]) {
  dispatchDriverForShipment(
    shipmentId: $shipmentId
    driverId: $driverId
    orderingAlgorithmType: $orderingAlgorithmType
    stopIds: $stopIds
    dispatchedBy: $dispatchedBy
    autoRoutedStopIds: $autoRoutedStopIds
  )
}
    `;
export type DispatchDriverForShipmentMutationFn = Apollo.MutationFunction<DispatchDriverForShipmentMutation, DispatchDriverForShipmentMutationVariables>;

/**
 * __useDispatchDriverForShipmentMutation__
 *
 * To run a mutation, you first call `useDispatchDriverForShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispatchDriverForShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispatchDriverForShipmentMutation, { data, loading, error }] = useDispatchDriverForShipmentMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      driverId: // value for 'driverId'
 *      orderingAlgorithmType: // value for 'orderingAlgorithmType'
 *      stopIds: // value for 'stopIds'
 *      dispatchedBy: // value for 'dispatchedBy'
 *      autoRoutedStopIds: // value for 'autoRoutedStopIds'
 *   },
 * });
 */
export function useDispatchDriverForShipmentMutation(baseOptions?: Apollo.MutationHookOptions<DispatchDriverForShipmentMutation, DispatchDriverForShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DispatchDriverForShipmentMutation, DispatchDriverForShipmentMutationVariables>(DispatchDriverForShipmentDocument, options);
      }
export type DispatchDriverForShipmentMutationHookResult = ReturnType<typeof useDispatchDriverForShipmentMutation>;
export type DispatchDriverForShipmentMutationResult = Apollo.MutationResult<DispatchDriverForShipmentMutation>;
export type DispatchDriverForShipmentMutationOptions = Apollo.BaseMutationOptions<DispatchDriverForShipmentMutation, DispatchDriverForShipmentMutationVariables>;
export const OptimizeRouteForDispatchDocument = gql`
    mutation OptimizeRouteForDispatch($newShipmentId: ID!, $driverId: ID!, $orderingAlgorithmType: OrderingAlgorithmType!, $stopDate: Date, $baseTime: Timestamp, $startLocationId: ID, $endLocationId: ID) {
  optimizeRouteForDispatch(
    newShipmentId: $newShipmentId
    driverId: $driverId
    orderingAlgorithmType: $orderingAlgorithmType
    stopDate: $stopDate
    baseTime: $baseTime
    startLocationId: $startLocationId
    endLocationId: $endLocationId
  ) {
    stops {
      ...StopFragment
      shipment {
        ...ShipmentFragment
        order {
          ...OrderFragment
          serviceType {
            ...ServiceTypeFragment
          }
          endCustomer {
            ...EndCustomerFragment
          }
        }
      }
    }
  }
}
    ${StopFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}`;
export type OptimizeRouteForDispatchMutationFn = Apollo.MutationFunction<OptimizeRouteForDispatchMutation, OptimizeRouteForDispatchMutationVariables>;

/**
 * __useOptimizeRouteForDispatchMutation__
 *
 * To run a mutation, you first call `useOptimizeRouteForDispatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptimizeRouteForDispatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optimizeRouteForDispatchMutation, { data, loading, error }] = useOptimizeRouteForDispatchMutation({
 *   variables: {
 *      newShipmentId: // value for 'newShipmentId'
 *      driverId: // value for 'driverId'
 *      orderingAlgorithmType: // value for 'orderingAlgorithmType'
 *      stopDate: // value for 'stopDate'
 *      baseTime: // value for 'baseTime'
 *      startLocationId: // value for 'startLocationId'
 *      endLocationId: // value for 'endLocationId'
 *   },
 * });
 */
export function useOptimizeRouteForDispatchMutation(baseOptions?: Apollo.MutationHookOptions<OptimizeRouteForDispatchMutation, OptimizeRouteForDispatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptimizeRouteForDispatchMutation, OptimizeRouteForDispatchMutationVariables>(OptimizeRouteForDispatchDocument, options);
      }
export type OptimizeRouteForDispatchMutationHookResult = ReturnType<typeof useOptimizeRouteForDispatchMutation>;
export type OptimizeRouteForDispatchMutationResult = Apollo.MutationResult<OptimizeRouteForDispatchMutation>;
export type OptimizeRouteForDispatchMutationOptions = Apollo.BaseMutationOptions<OptimizeRouteForDispatchMutation, OptimizeRouteForDispatchMutationVariables>;
export const DispatchDriverForShipmentMultiDayDocument = gql`
    mutation DispatchDriverForShipmentMultiDay($shipmentId: ID!, $driverId: ID!, $orderingAlgorithmType: OrderingAlgorithmType!, $dispatchedBy: ID, $days: [DispatchStopsOnDayInput!]!, $dispatchSource: DispatchSource, $dispatchPreviewSortingType: String, $dispatchPreviewSection: String, $driverRank: Int, $dispatchPreviews: [DispatchPreviewSaveInput!], $dispatchPageType: DispatchPageType) {
  dispatchDriverForShipmentMultiDay(
    shipmentId: $shipmentId
    driverId: $driverId
    orderingAlgorithmType: $orderingAlgorithmType
    dispatchedBy: $dispatchedBy
    days: $days
    dispatchSource: $dispatchSource
    dispatchPreviewSortingType: $dispatchPreviewSortingType
    dispatchPreviewSection: $dispatchPreviewSection
    driverRank: $driverRank
    dispatchPreviews: $dispatchPreviews
    dispatchPageType: $dispatchPageType
  )
}
    `;
export type DispatchDriverForShipmentMultiDayMutationFn = Apollo.MutationFunction<DispatchDriverForShipmentMultiDayMutation, DispatchDriverForShipmentMultiDayMutationVariables>;

/**
 * __useDispatchDriverForShipmentMultiDayMutation__
 *
 * To run a mutation, you first call `useDispatchDriverForShipmentMultiDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispatchDriverForShipmentMultiDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispatchDriverForShipmentMultiDayMutation, { data, loading, error }] = useDispatchDriverForShipmentMultiDayMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      driverId: // value for 'driverId'
 *      orderingAlgorithmType: // value for 'orderingAlgorithmType'
 *      dispatchedBy: // value for 'dispatchedBy'
 *      days: // value for 'days'
 *      dispatchSource: // value for 'dispatchSource'
 *      dispatchPreviewSortingType: // value for 'dispatchPreviewSortingType'
 *      dispatchPreviewSection: // value for 'dispatchPreviewSection'
 *      driverRank: // value for 'driverRank'
 *      dispatchPreviews: // value for 'dispatchPreviews'
 *      dispatchPageType: // value for 'dispatchPageType'
 *   },
 * });
 */
export function useDispatchDriverForShipmentMultiDayMutation(baseOptions?: Apollo.MutationHookOptions<DispatchDriverForShipmentMultiDayMutation, DispatchDriverForShipmentMultiDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DispatchDriverForShipmentMultiDayMutation, DispatchDriverForShipmentMultiDayMutationVariables>(DispatchDriverForShipmentMultiDayDocument, options);
      }
export type DispatchDriverForShipmentMultiDayMutationHookResult = ReturnType<typeof useDispatchDriverForShipmentMultiDayMutation>;
export type DispatchDriverForShipmentMultiDayMutationResult = Apollo.MutationResult<DispatchDriverForShipmentMultiDayMutation>;
export type DispatchDriverForShipmentMultiDayMutationOptions = Apollo.BaseMutationOptions<DispatchDriverForShipmentMultiDayMutation, DispatchDriverForShipmentMultiDayMutationVariables>;
export const GetDispatchPreviewsDocument = gql`
    query GetDispatchPreviews($shipmentId: ID!, $taskStatusFilter: [TaskStatus!], $shipmentDate: Date!, $isActive: Boolean, $workType: DriverWorkType) {
  dispatchPreviews(
    shipmentId: $shipmentId
    isActive: $isActive
    workType: $workType
  ) {
    driver {
      ...DriverFragment
      lastReportedLocation {
        ...DriverLocationFragment
      }
      workType
      tasks(statusFilter: $taskStatusFilter, date: $shipmentDate) {
        ...TaskFragment
        stop {
          ...StopFragment
          shipment {
            ...ShipmentFragment
            order {
              ...OrderFragment
              serviceType {
                ...ServiceTypeFragment
              }
              endCustomer {
                ...EndCustomerFragment
              }
            }
            shipmentTemplate {
              ...ShipmentTemplateFragment
              order {
                id
                serviceType {
                  ...ServiceTypeFragment
                }
              }
            }
          }
        }
      }
      vehicle {
        ...VehicleFragment
      }
    }
    ...DispatchPreviewFragment
  }
}
    ${DriverFragmentFragmentDoc}
${DriverLocationFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}
${VehicleFragmentFragmentDoc}
${DispatchPreviewFragmentFragmentDoc}`;

/**
 * __useGetDispatchPreviewsQuery__
 *
 * To run a query within a React component, call `useGetDispatchPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispatchPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispatchPreviewsQuery({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      taskStatusFilter: // value for 'taskStatusFilter'
 *      shipmentDate: // value for 'shipmentDate'
 *      isActive: // value for 'isActive'
 *      workType: // value for 'workType'
 *   },
 * });
 */
export function useGetDispatchPreviewsQuery(baseOptions: Apollo.QueryHookOptions<GetDispatchPreviewsQuery, GetDispatchPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDispatchPreviewsQuery, GetDispatchPreviewsQueryVariables>(GetDispatchPreviewsDocument, options);
      }
export function useGetDispatchPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDispatchPreviewsQuery, GetDispatchPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDispatchPreviewsQuery, GetDispatchPreviewsQueryVariables>(GetDispatchPreviewsDocument, options);
        }
export type GetDispatchPreviewsQueryHookResult = ReturnType<typeof useGetDispatchPreviewsQuery>;
export type GetDispatchPreviewsLazyQueryHookResult = ReturnType<typeof useGetDispatchPreviewsLazyQuery>;
export type GetDispatchPreviewsQueryResult = Apollo.QueryResult<GetDispatchPreviewsQuery, GetDispatchPreviewsQueryVariables>;
export const DispatchPreviewsByDriverIdDocument = gql`
    query DispatchPreviewsByDriverId($courierId: ID!, $driverId: ID!, $targetDate: Date!, $readyStatus: DispatchPreviewReadyStatus!) {
  dispatchPreviewsByDriverId(
    courierId: $courierId
    driverId: $driverId
    targetDate: $targetDate
    readyStatus: $readyStatus
  ) {
    ...DispatchPreviewFragment
    shipment {
      ...ShipmentFragment
      stops {
        ...StopFragment
      }
      order {
        ...OrderFragment
        createdByUser {
          ...CourieUserFragment
        }
        createdByEndCustomer {
          ...EndCustomerFragment
        }
        createdByEndUser {
          ...EndUserFragment
        }
        costCenter {
          ...CostCenterFragment
        }
        endCustomer {
          ...EndCustomerFragment
        }
        serviceType {
          ...ServiceTypeFragment
        }
      }
    }
  }
}
    ${DispatchPreviewFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${CourieUserFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${EndUserFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}`;

/**
 * __useDispatchPreviewsByDriverIdQuery__
 *
 * To run a query within a React component, call `useDispatchPreviewsByDriverIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispatchPreviewsByDriverIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispatchPreviewsByDriverIdQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      targetDate: // value for 'targetDate'
 *      readyStatus: // value for 'readyStatus'
 *   },
 * });
 */
export function useDispatchPreviewsByDriverIdQuery(baseOptions: Apollo.QueryHookOptions<DispatchPreviewsByDriverIdQuery, DispatchPreviewsByDriverIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispatchPreviewsByDriverIdQuery, DispatchPreviewsByDriverIdQueryVariables>(DispatchPreviewsByDriverIdDocument, options);
      }
export function useDispatchPreviewsByDriverIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispatchPreviewsByDriverIdQuery, DispatchPreviewsByDriverIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispatchPreviewsByDriverIdQuery, DispatchPreviewsByDriverIdQueryVariables>(DispatchPreviewsByDriverIdDocument, options);
        }
export type DispatchPreviewsByDriverIdQueryHookResult = ReturnType<typeof useDispatchPreviewsByDriverIdQuery>;
export type DispatchPreviewsByDriverIdLazyQueryHookResult = ReturnType<typeof useDispatchPreviewsByDriverIdLazyQuery>;
export type DispatchPreviewsByDriverIdQueryResult = Apollo.QueryResult<DispatchPreviewsByDriverIdQuery, DispatchPreviewsByDriverIdQueryVariables>;
export const DriverReportItemsDocument = gql`
    query DriverReportItems($courierId: ID!, $driverIds: [ID!], $startDate: Date!, $endDate: Date!) {
  driverReportItems(
    courierId: $courierId
    driverIds: $driverIds
    startDate: $startDate
    endDate: $endDate
  ) {
    ...DriverReportItemFragment
    driver {
      ...DriverFragment
    }
  }
}
    ${DriverReportItemFragmentFragmentDoc}
${DriverFragmentFragmentDoc}`;

/**
 * __useDriverReportItemsQuery__
 *
 * To run a query within a React component, call `useDriverReportItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriverReportItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriverReportItemsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverIds: // value for 'driverIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useDriverReportItemsQuery(baseOptions: Apollo.QueryHookOptions<DriverReportItemsQuery, DriverReportItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriverReportItemsQuery, DriverReportItemsQueryVariables>(DriverReportItemsDocument, options);
      }
export function useDriverReportItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriverReportItemsQuery, DriverReportItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriverReportItemsQuery, DriverReportItemsQueryVariables>(DriverReportItemsDocument, options);
        }
export type DriverReportItemsQueryHookResult = ReturnType<typeof useDriverReportItemsQuery>;
export type DriverReportItemsLazyQueryHookResult = ReturnType<typeof useDriverReportItemsLazyQuery>;
export type DriverReportItemsQueryResult = Apollo.QueryResult<DriverReportItemsQuery, DriverReportItemsQueryVariables>;
export const AssignDriverVehicleTypeDocument = gql`
    mutation assignDriverVehicleType($courierId: ID!, $driverId: ID!, $vehicleTypeId: ID) {
  assignDriverVehicleType(
    courierId: $courierId
    driverId: $driverId
    vehicleTypeId: $vehicleTypeId
  ) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type AssignDriverVehicleTypeMutationFn = Apollo.MutationFunction<AssignDriverVehicleTypeMutation, AssignDriverVehicleTypeMutationVariables>;

/**
 * __useAssignDriverVehicleTypeMutation__
 *
 * To run a mutation, you first call `useAssignDriverVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDriverVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDriverVehicleTypeMutation, { data, loading, error }] = useAssignDriverVehicleTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *   },
 * });
 */
export function useAssignDriverVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<AssignDriverVehicleTypeMutation, AssignDriverVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignDriverVehicleTypeMutation, AssignDriverVehicleTypeMutationVariables>(AssignDriverVehicleTypeDocument, options);
      }
export type AssignDriverVehicleTypeMutationHookResult = ReturnType<typeof useAssignDriverVehicleTypeMutation>;
export type AssignDriverVehicleTypeMutationResult = Apollo.MutationResult<AssignDriverVehicleTypeMutation>;
export type AssignDriverVehicleTypeMutationOptions = Apollo.BaseMutationOptions<AssignDriverVehicleTypeMutation, AssignDriverVehicleTypeMutationVariables>;
export const CreateDriverDocument = gql`
    mutation createDriver($courierId: ID!, $firstName: String!, $lastName: String!, $middleName: String, $photoUrl: String, $phone: String!, $email: String, $speed: Float, $homeLocationId: ID) {
  createDriver(
    courierId: $courierId
    firstName: $firstName
    lastName: $lastName
    middleName: $middleName
    photoUrl: $photoUrl
    phone: $phone
    email: $email
    speed: $speed
    homeLocationId: $homeLocationId
  ) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type CreateDriverMutationFn = Apollo.MutationFunction<CreateDriverMutation, CreateDriverMutationVariables>;

/**
 * __useCreateDriverMutation__
 *
 * To run a mutation, you first call `useCreateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriverMutation, { data, loading, error }] = useCreateDriverMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      middleName: // value for 'middleName'
 *      photoUrl: // value for 'photoUrl'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      speed: // value for 'speed'
 *      homeLocationId: // value for 'homeLocationId'
 *   },
 * });
 */
export function useCreateDriverMutation(baseOptions?: Apollo.MutationHookOptions<CreateDriverMutation, CreateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDriverMutation, CreateDriverMutationVariables>(CreateDriverDocument, options);
      }
export type CreateDriverMutationHookResult = ReturnType<typeof useCreateDriverMutation>;
export type CreateDriverMutationResult = Apollo.MutationResult<CreateDriverMutation>;
export type CreateDriverMutationOptions = Apollo.BaseMutationOptions<CreateDriverMutation, CreateDriverMutationVariables>;
export const FullUpdateDriverDocument = gql`
    mutation fullUpdateDriver($fullUpdate: DriverFullUpdate!) {
  fullUpdateDriver(fullUpdate: $fullUpdate) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type FullUpdateDriverMutationFn = Apollo.MutationFunction<FullUpdateDriverMutation, FullUpdateDriverMutationVariables>;

/**
 * __useFullUpdateDriverMutation__
 *
 * To run a mutation, you first call `useFullUpdateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateDriverMutation, { data, loading, error }] = useFullUpdateDriverMutation({
 *   variables: {
 *      fullUpdate: // value for 'fullUpdate'
 *   },
 * });
 */
export function useFullUpdateDriverMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateDriverMutation, FullUpdateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateDriverMutation, FullUpdateDriverMutationVariables>(FullUpdateDriverDocument, options);
      }
export type FullUpdateDriverMutationHookResult = ReturnType<typeof useFullUpdateDriverMutation>;
export type FullUpdateDriverMutationResult = Apollo.MutationResult<FullUpdateDriverMutation>;
export type FullUpdateDriverMutationOptions = Apollo.BaseMutationOptions<FullUpdateDriverMutation, FullUpdateDriverMutationVariables>;
export const DeleteDriverDocument = gql`
    mutation deleteDriver($driverId: ID!) {
  deleteDriver(driverId: $driverId) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type DeleteDriverMutationFn = Apollo.MutationFunction<DeleteDriverMutation, DeleteDriverMutationVariables>;

/**
 * __useDeleteDriverMutation__
 *
 * To run a mutation, you first call `useDeleteDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDriverMutation, { data, loading, error }] = useDeleteDriverMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useDeleteDriverMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDriverMutation, DeleteDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDriverMutation, DeleteDriverMutationVariables>(DeleteDriverDocument, options);
      }
export type DeleteDriverMutationHookResult = ReturnType<typeof useDeleteDriverMutation>;
export type DeleteDriverMutationResult = Apollo.MutationResult<DeleteDriverMutation>;
export type DeleteDriverMutationOptions = Apollo.BaseMutationOptions<DeleteDriverMutation, DeleteDriverMutationVariables>;
export const UpdateDriverAvailabilityV1Document = gql`
    mutation UpdateDriverAvailabilityV1($driverId: ID!, $isAvailable: Boolean!) {
  updateDriverAvailabilityV1(driverId: $driverId, isAvailable: $isAvailable) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type UpdateDriverAvailabilityV1MutationFn = Apollo.MutationFunction<UpdateDriverAvailabilityV1Mutation, UpdateDriverAvailabilityV1MutationVariables>;

/**
 * __useUpdateDriverAvailabilityV1Mutation__
 *
 * To run a mutation, you first call `useUpdateDriverAvailabilityV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverAvailabilityV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverAvailabilityV1Mutation, { data, loading, error }] = useUpdateDriverAvailabilityV1Mutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      isAvailable: // value for 'isAvailable'
 *   },
 * });
 */
export function useUpdateDriverAvailabilityV1Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverAvailabilityV1Mutation, UpdateDriverAvailabilityV1MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverAvailabilityV1Mutation, UpdateDriverAvailabilityV1MutationVariables>(UpdateDriverAvailabilityV1Document, options);
      }
export type UpdateDriverAvailabilityV1MutationHookResult = ReturnType<typeof useUpdateDriverAvailabilityV1Mutation>;
export type UpdateDriverAvailabilityV1MutationResult = Apollo.MutationResult<UpdateDriverAvailabilityV1Mutation>;
export type UpdateDriverAvailabilityV1MutationOptions = Apollo.BaseMutationOptions<UpdateDriverAvailabilityV1Mutation, UpdateDriverAvailabilityV1MutationVariables>;
export const UpdateDriverBaseWorkScheduleDocument = gql`
    mutation UpdateDriverBaseWorkSchedule($driverId: ID!, $workSchedule: DriverWorkScheduleInput!) {
  updateDriverBaseWorkSchedule(driverId: $driverId, workSchedule: $workSchedule) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type UpdateDriverBaseWorkScheduleMutationFn = Apollo.MutationFunction<UpdateDriverBaseWorkScheduleMutation, UpdateDriverBaseWorkScheduleMutationVariables>;

/**
 * __useUpdateDriverBaseWorkScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateDriverBaseWorkScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverBaseWorkScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverBaseWorkScheduleMutation, { data, loading, error }] = useUpdateDriverBaseWorkScheduleMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      workSchedule: // value for 'workSchedule'
 *   },
 * });
 */
export function useUpdateDriverBaseWorkScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverBaseWorkScheduleMutation, UpdateDriverBaseWorkScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverBaseWorkScheduleMutation, UpdateDriverBaseWorkScheduleMutationVariables>(UpdateDriverBaseWorkScheduleDocument, options);
      }
export type UpdateDriverBaseWorkScheduleMutationHookResult = ReturnType<typeof useUpdateDriverBaseWorkScheduleMutation>;
export type UpdateDriverBaseWorkScheduleMutationResult = Apollo.MutationResult<UpdateDriverBaseWorkScheduleMutation>;
export type UpdateDriverBaseWorkScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateDriverBaseWorkScheduleMutation, UpdateDriverBaseWorkScheduleMutationVariables>;
export const SetDriverScheduleOverrideDocument = gql`
    mutation setDriverScheduleOverride($courierId: ID!, $driverId: ID!, $date: Date!, $isDayOff: Boolean!, $timeBlocks: [DriverScheduleTimeBlockInput!]!, $labels: [String!]!) {
  setDriverScheduleOverride(
    courierId: $courierId
    driverId: $driverId
    date: $date
    isDayOff: $isDayOff
    timeBlocks: $timeBlocks
    labels: $labels
  ) {
    ...DriverScheduleForDateFragment
    timeBlocks {
      ...DriverScheduleTimeBlockFragment
    }
  }
}
    ${DriverScheduleForDateFragmentFragmentDoc}
${DriverScheduleTimeBlockFragmentFragmentDoc}`;
export type SetDriverScheduleOverrideMutationFn = Apollo.MutationFunction<SetDriverScheduleOverrideMutation, SetDriverScheduleOverrideMutationVariables>;

/**
 * __useSetDriverScheduleOverrideMutation__
 *
 * To run a mutation, you first call `useSetDriverScheduleOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDriverScheduleOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDriverScheduleOverrideMutation, { data, loading, error }] = useSetDriverScheduleOverrideMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      date: // value for 'date'
 *      isDayOff: // value for 'isDayOff'
 *      timeBlocks: // value for 'timeBlocks'
 *      labels: // value for 'labels'
 *   },
 * });
 */
export function useSetDriverScheduleOverrideMutation(baseOptions?: Apollo.MutationHookOptions<SetDriverScheduleOverrideMutation, SetDriverScheduleOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDriverScheduleOverrideMutation, SetDriverScheduleOverrideMutationVariables>(SetDriverScheduleOverrideDocument, options);
      }
export type SetDriverScheduleOverrideMutationHookResult = ReturnType<typeof useSetDriverScheduleOverrideMutation>;
export type SetDriverScheduleOverrideMutationResult = Apollo.MutationResult<SetDriverScheduleOverrideMutation>;
export type SetDriverScheduleOverrideMutationOptions = Apollo.BaseMutationOptions<SetDriverScheduleOverrideMutation, SetDriverScheduleOverrideMutationVariables>;
export const ModifyDriverTimeEventsDocument = gql`
    mutation modifyDriverTimeEvents($courierId: ID!, $updates: [DriverTimeEventUpdateInput!]!, $newEvent: DriverTimeEventCreateInput, $eventIdsToDelete: [ID!]!, $updatedBy: ID!) {
  modifyDriverTimeEvents(
    courierId: $courierId
    updates: $updates
    newEvent: $newEvent
    eventIdsToDelete: $eventIdsToDelete
    updatedBy: $updatedBy
  ) {
    ...DriverTimeEventFragment
  }
}
    ${DriverTimeEventFragmentFragmentDoc}`;
export type ModifyDriverTimeEventsMutationFn = Apollo.MutationFunction<ModifyDriverTimeEventsMutation, ModifyDriverTimeEventsMutationVariables>;

/**
 * __useModifyDriverTimeEventsMutation__
 *
 * To run a mutation, you first call `useModifyDriverTimeEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyDriverTimeEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyDriverTimeEventsMutation, { data, loading, error }] = useModifyDriverTimeEventsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      updates: // value for 'updates'
 *      newEvent: // value for 'newEvent'
 *      eventIdsToDelete: // value for 'eventIdsToDelete'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useModifyDriverTimeEventsMutation(baseOptions?: Apollo.MutationHookOptions<ModifyDriverTimeEventsMutation, ModifyDriverTimeEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyDriverTimeEventsMutation, ModifyDriverTimeEventsMutationVariables>(ModifyDriverTimeEventsDocument, options);
      }
export type ModifyDriverTimeEventsMutationHookResult = ReturnType<typeof useModifyDriverTimeEventsMutation>;
export type ModifyDriverTimeEventsMutationResult = Apollo.MutationResult<ModifyDriverTimeEventsMutation>;
export type ModifyDriverTimeEventsMutationOptions = Apollo.BaseMutationOptions<ModifyDriverTimeEventsMutation, ModifyDriverTimeEventsMutationVariables>;
export const SendDriverScheduleConfirmationEmailsDocument = gql`
    mutation SendDriverScheduleConfirmationEmails($courierId: ID!, $startDate: Date!, $endDate: Date!, $forceSend: Boolean, $driverIds: [ID!]) {
  sendDriverScheduleConfirmationEmails(
    courierId: $courierId
    startDate: $startDate
    endDate: $endDate
    forceSend: $forceSend
    driverIds: $driverIds
  )
}
    `;
export type SendDriverScheduleConfirmationEmailsMutationFn = Apollo.MutationFunction<SendDriverScheduleConfirmationEmailsMutation, SendDriverScheduleConfirmationEmailsMutationVariables>;

/**
 * __useSendDriverScheduleConfirmationEmailsMutation__
 *
 * To run a mutation, you first call `useSendDriverScheduleConfirmationEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDriverScheduleConfirmationEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDriverScheduleConfirmationEmailsMutation, { data, loading, error }] = useSendDriverScheduleConfirmationEmailsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      forceSend: // value for 'forceSend'
 *      driverIds: // value for 'driverIds'
 *   },
 * });
 */
export function useSendDriverScheduleConfirmationEmailsMutation(baseOptions?: Apollo.MutationHookOptions<SendDriverScheduleConfirmationEmailsMutation, SendDriverScheduleConfirmationEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDriverScheduleConfirmationEmailsMutation, SendDriverScheduleConfirmationEmailsMutationVariables>(SendDriverScheduleConfirmationEmailsDocument, options);
      }
export type SendDriverScheduleConfirmationEmailsMutationHookResult = ReturnType<typeof useSendDriverScheduleConfirmationEmailsMutation>;
export type SendDriverScheduleConfirmationEmailsMutationResult = Apollo.MutationResult<SendDriverScheduleConfirmationEmailsMutation>;
export type SendDriverScheduleConfirmationEmailsMutationOptions = Apollo.BaseMutationOptions<SendDriverScheduleConfirmationEmailsMutation, SendDriverScheduleConfirmationEmailsMutationVariables>;
export const UpdateDriverCompensationDocument = gql`
    mutation UpdateDriverCompensation($courierId: ID!, $driverId: ID!, $employmentType: DriverEmploymentType!, $compensation: DriverCompensation!) {
  updateDriverCompensation(
    courierId: $courierId
    driverId: $driverId
    employmentType: $employmentType
    compensation: $compensation
  ) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type UpdateDriverCompensationMutationFn = Apollo.MutationFunction<UpdateDriverCompensationMutation, UpdateDriverCompensationMutationVariables>;

/**
 * __useUpdateDriverCompensationMutation__
 *
 * To run a mutation, you first call `useUpdateDriverCompensationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverCompensationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverCompensationMutation, { data, loading, error }] = useUpdateDriverCompensationMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverId: // value for 'driverId'
 *      employmentType: // value for 'employmentType'
 *      compensation: // value for 'compensation'
 *   },
 * });
 */
export function useUpdateDriverCompensationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverCompensationMutation, UpdateDriverCompensationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverCompensationMutation, UpdateDriverCompensationMutationVariables>(UpdateDriverCompensationDocument, options);
      }
export type UpdateDriverCompensationMutationHookResult = ReturnType<typeof useUpdateDriverCompensationMutation>;
export type UpdateDriverCompensationMutationResult = Apollo.MutationResult<UpdateDriverCompensationMutation>;
export type UpdateDriverCompensationMutationOptions = Apollo.BaseMutationOptions<UpdateDriverCompensationMutation, UpdateDriverCompensationMutationVariables>;
export const GetBreadcrumbByDriverIdDocument = gql`
    query GetBreadcrumbByDriverId($driverId: ID!, $minTime: Timestamp, $maxTime: Timestamp, $date: Date) {
  breadcrumb(
    driverId: $driverId
    minTime: $minTime
    maxTime: $maxTime
    date: $date
  ) {
    driverId
    curves {
      ...BreadcrumbCurveFragment
    }
  }
}
    ${BreadcrumbCurveFragmentFragmentDoc}`;

/**
 * __useGetBreadcrumbByDriverIdQuery__
 *
 * To run a query within a React component, call `useGetBreadcrumbByDriverIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreadcrumbByDriverIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreadcrumbByDriverIdQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      minTime: // value for 'minTime'
 *      maxTime: // value for 'maxTime'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetBreadcrumbByDriverIdQuery(baseOptions: Apollo.QueryHookOptions<GetBreadcrumbByDriverIdQuery, GetBreadcrumbByDriverIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBreadcrumbByDriverIdQuery, GetBreadcrumbByDriverIdQueryVariables>(GetBreadcrumbByDriverIdDocument, options);
      }
export function useGetBreadcrumbByDriverIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBreadcrumbByDriverIdQuery, GetBreadcrumbByDriverIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBreadcrumbByDriverIdQuery, GetBreadcrumbByDriverIdQueryVariables>(GetBreadcrumbByDriverIdDocument, options);
        }
export type GetBreadcrumbByDriverIdQueryHookResult = ReturnType<typeof useGetBreadcrumbByDriverIdQuery>;
export type GetBreadcrumbByDriverIdLazyQueryHookResult = ReturnType<typeof useGetBreadcrumbByDriverIdLazyQuery>;
export type GetBreadcrumbByDriverIdQueryResult = Apollo.QueryResult<GetBreadcrumbByDriverIdQuery, GetBreadcrumbByDriverIdQueryVariables>;
export const GetDriverTasksByDriverIdDocument = gql`
    query GetDriverTasksByDriverId($driverId: ID!, $date: Date!, $statusFilter: [TaskStatus!]) {
  driverById(driverId: $driverId) {
    ...DriverFragment
    tasks(date: $date, statusFilter: $statusFilter) {
      ...TaskFragment
      stop {
        ...StopFragment
        shipment {
          id
          status
          order {
            id
            serviceType {
              ...ServiceTypeFragment
            }
            endCustomer {
              ...EndCustomerFragment
              invoicePdfTemplate {
                ...InvoicePdfTemplateFragment
              }
            }
          }
          shipmentTemplate {
            ...ShipmentTemplateFragment
          }
        }
      }
    }
  }
}
    ${DriverFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${InvoicePdfTemplateFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}`;

/**
 * __useGetDriverTasksByDriverIdQuery__
 *
 * To run a query within a React component, call `useGetDriverTasksByDriverIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverTasksByDriverIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverTasksByDriverIdQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      date: // value for 'date'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetDriverTasksByDriverIdQuery(baseOptions: Apollo.QueryHookOptions<GetDriverTasksByDriverIdQuery, GetDriverTasksByDriverIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverTasksByDriverIdQuery, GetDriverTasksByDriverIdQueryVariables>(GetDriverTasksByDriverIdDocument, options);
      }
export function useGetDriverTasksByDriverIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverTasksByDriverIdQuery, GetDriverTasksByDriverIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverTasksByDriverIdQuery, GetDriverTasksByDriverIdQueryVariables>(GetDriverTasksByDriverIdDocument, options);
        }
export type GetDriverTasksByDriverIdQueryHookResult = ReturnType<typeof useGetDriverTasksByDriverIdQuery>;
export type GetDriverTasksByDriverIdLazyQueryHookResult = ReturnType<typeof useGetDriverTasksByDriverIdLazyQuery>;
export type GetDriverTasksByDriverIdQueryResult = Apollo.QueryResult<GetDriverTasksByDriverIdQuery, GetDriverTasksByDriverIdQueryVariables>;
export const GetDriversDocument = gql`
    query GetDrivers($courierId: ID!, $limit: Int, $after: Int, $sortFields: [DriverSorting!], $simpleSearch: String) {
  drivers(
    courierId: $courierId
    limit: $limit
    after: $after
    sortFields: $sortFields
    simpleSearch: $simpleSearch
  ) {
    edges {
      node {
        ...DriverFragment
        homeLocationId
        homeLocation {
          ...LocationFragment
        }
        baseWorkSchedule {
          weekDailyList {
            days
            startTimeSecondsSinceMidnight
            endTimeSecondsSinceMidnight
          }
        }
        remoteEntities {
          ...RemoteEntityFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${DriverFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetDriversQuery__
 *
 * To run a query within a React component, call `useGetDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriversQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *      simpleSearch: // value for 'simpleSearch'
 *   },
 * });
 */
export function useGetDriversQuery(baseOptions: Apollo.QueryHookOptions<GetDriversQuery, GetDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriversQuery, GetDriversQueryVariables>(GetDriversDocument, options);
      }
export function useGetDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriversQuery, GetDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriversQuery, GetDriversQueryVariables>(GetDriversDocument, options);
        }
export type GetDriversQueryHookResult = ReturnType<typeof useGetDriversQuery>;
export type GetDriversLazyQueryHookResult = ReturnType<typeof useGetDriversLazyQuery>;
export type GetDriversQueryResult = Apollo.QueryResult<GetDriversQuery, GetDriversQueryVariables>;
export const GetFleetQueryDocument = gql`
    query GetFleetQuery($courierId: ID!, $limit: Int, $after: Int, $date: Date!, $statusFilter: [TaskStatus!]) {
  drivers(courierId: $courierId, limit: $limit, after: $after) {
    edges {
      node {
        ...DriverFragment
        lastReportedLocation {
          ...DriverLocationFragment
        }
        tasks(date: $date, statusFilter: $statusFilter) {
          ...TaskFragment
          stop {
            ...StopFragment
          }
        }
      }
    }
  }
}
    ${DriverFragmentFragmentDoc}
${DriverLocationFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${StopFragmentFragmentDoc}`;

/**
 * __useGetFleetQueryQuery__
 *
 * To run a query within a React component, call `useGetFleetQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFleetQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFleetQueryQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      date: // value for 'date'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetFleetQueryQuery(baseOptions: Apollo.QueryHookOptions<GetFleetQueryQuery, GetFleetQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFleetQueryQuery, GetFleetQueryQueryVariables>(GetFleetQueryDocument, options);
      }
export function useGetFleetQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFleetQueryQuery, GetFleetQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFleetQueryQuery, GetFleetQueryQueryVariables>(GetFleetQueryDocument, options);
        }
export type GetFleetQueryQueryHookResult = ReturnType<typeof useGetFleetQueryQuery>;
export type GetFleetQueryLazyQueryHookResult = ReturnType<typeof useGetFleetQueryLazyQuery>;
export type GetFleetQueryQueryResult = Apollo.QueryResult<GetFleetQueryQuery, GetFleetQueryQueryVariables>;
export const GetDriverByIdDocument = gql`
    query getDriverById($driverId: ID!, $date: Date!, $statusFilter: [TaskStatus!]) {
  driverById(driverId: $driverId) {
    ...DriverFragment
    lastReportedLocation {
      ...DriverLocationFragment
    }
    tasks(date: $date, statusFilter: $statusFilter) {
      ...TaskFragment
      stop {
        ...StopFragment
        completedAt
        shipment {
          id
          status
          order {
            ...OrderFragment
            serviceType {
              ...ServiceTypeFragment
            }
            endCustomer {
              ...EndCustomerFragment
              invoicePdfTemplate {
                ...InvoicePdfTemplateFragment
              }
            }
          }
          shipmentTemplate {
            ...ShipmentTemplateFragment
            order {
              id
              serviceType {
                ...ServiceTypeFragment
              }
            }
          }
        }
      }
    }
  }
}
    ${DriverFragmentFragmentDoc}
${DriverLocationFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${InvoicePdfTemplateFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}`;

/**
 * __useGetDriverByIdQuery__
 *
 * To run a query within a React component, call `useGetDriverByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverByIdQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      date: // value for 'date'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetDriverByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDriverByIdQuery, GetDriverByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverByIdQuery, GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
      }
export function useGetDriverByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverByIdQuery, GetDriverByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverByIdQuery, GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
        }
export type GetDriverByIdQueryHookResult = ReturnType<typeof useGetDriverByIdQuery>;
export type GetDriverByIdLazyQueryHookResult = ReturnType<typeof useGetDriverByIdLazyQuery>;
export type GetDriverByIdQueryResult = Apollo.QueryResult<GetDriverByIdQuery, GetDriverByIdQueryVariables>;
export const FetchDriverTasksByDateAndStatusDocument = gql`
    query FetchDriverTasksByDateAndStatus($courierId: ID!, $date: Date!, $statusFilter: [TaskStatus!], $limit: Int) {
  drivers(courierId: $courierId, limit: $limit) {
    edges {
      node {
        ...DriverFragment
        homeLocationId
        homeLocation {
          ...LocationFragment
        }
        tasks(date: $date, statusFilter: $statusFilter) {
          ...TaskFragment
          stop {
            ...StopFragment
            completedAt
            shipment {
              id
              status
            }
          }
        }
        numRecurringStops(date: $date)
      }
    }
  }
}
    ${DriverFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${StopFragmentFragmentDoc}`;

/**
 * __useFetchDriverTasksByDateAndStatusQuery__
 *
 * To run a query within a React component, call `useFetchDriverTasksByDateAndStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDriverTasksByDateAndStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDriverTasksByDateAndStatusQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      date: // value for 'date'
 *      statusFilter: // value for 'statusFilter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFetchDriverTasksByDateAndStatusQuery(baseOptions: Apollo.QueryHookOptions<FetchDriverTasksByDateAndStatusQuery, FetchDriverTasksByDateAndStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDriverTasksByDateAndStatusQuery, FetchDriverTasksByDateAndStatusQueryVariables>(FetchDriverTasksByDateAndStatusDocument, options);
      }
export function useFetchDriverTasksByDateAndStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDriverTasksByDateAndStatusQuery, FetchDriverTasksByDateAndStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDriverTasksByDateAndStatusQuery, FetchDriverTasksByDateAndStatusQueryVariables>(FetchDriverTasksByDateAndStatusDocument, options);
        }
export type FetchDriverTasksByDateAndStatusQueryHookResult = ReturnType<typeof useFetchDriverTasksByDateAndStatusQuery>;
export type FetchDriverTasksByDateAndStatusLazyQueryHookResult = ReturnType<typeof useFetchDriverTasksByDateAndStatusLazyQuery>;
export type FetchDriverTasksByDateAndStatusQueryResult = Apollo.QueryResult<FetchDriverTasksByDateAndStatusQuery, FetchDriverTasksByDateAndStatusQueryVariables>;
export const GetDriverCurrentLocationDocument = gql`
    query GetDriverCurrentLocation($driverId: ID!) {
  driverById(driverId: $driverId) {
    ...DriverFragment
    lastReportedLocation {
      ...DriverLocationFragment
    }
  }
}
    ${DriverFragmentFragmentDoc}
${DriverLocationFragmentFragmentDoc}`;

/**
 * __useGetDriverCurrentLocationQuery__
 *
 * To run a query within a React component, call `useGetDriverCurrentLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverCurrentLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverCurrentLocationQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useGetDriverCurrentLocationQuery(baseOptions: Apollo.QueryHookOptions<GetDriverCurrentLocationQuery, GetDriverCurrentLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverCurrentLocationQuery, GetDriverCurrentLocationQueryVariables>(GetDriverCurrentLocationDocument, options);
      }
export function useGetDriverCurrentLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverCurrentLocationQuery, GetDriverCurrentLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverCurrentLocationQuery, GetDriverCurrentLocationQueryVariables>(GetDriverCurrentLocationDocument, options);
        }
export type GetDriverCurrentLocationQueryHookResult = ReturnType<typeof useGetDriverCurrentLocationQuery>;
export type GetDriverCurrentLocationLazyQueryHookResult = ReturnType<typeof useGetDriverCurrentLocationLazyQuery>;
export type GetDriverCurrentLocationQueryResult = Apollo.QueryResult<GetDriverCurrentLocationQuery, GetDriverCurrentLocationQueryVariables>;
export const GetDriverTasksOnlyByDriverIdDocument = gql`
    query GetDriverTasksOnlyByDriverId($driverId: ID!, $statusFilter: [TaskStatus!], $minDate: Date, $maxDate: Date) {
  driverById(driverId: $driverId) {
    ...DriverFragment
    tasks(statusFilter: $statusFilter, minDate: $minDate, maxDate: $maxDate) {
      ...TaskFragment
    }
  }
}
    ${DriverFragmentFragmentDoc}
${TaskFragmentFragmentDoc}`;

/**
 * __useGetDriverTasksOnlyByDriverIdQuery__
 *
 * To run a query within a React component, call `useGetDriverTasksOnlyByDriverIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverTasksOnlyByDriverIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverTasksOnlyByDriverIdQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      statusFilter: // value for 'statusFilter'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useGetDriverTasksOnlyByDriverIdQuery(baseOptions: Apollo.QueryHookOptions<GetDriverTasksOnlyByDriverIdQuery, GetDriverTasksOnlyByDriverIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverTasksOnlyByDriverIdQuery, GetDriverTasksOnlyByDriverIdQueryVariables>(GetDriverTasksOnlyByDriverIdDocument, options);
      }
export function useGetDriverTasksOnlyByDriverIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverTasksOnlyByDriverIdQuery, GetDriverTasksOnlyByDriverIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverTasksOnlyByDriverIdQuery, GetDriverTasksOnlyByDriverIdQueryVariables>(GetDriverTasksOnlyByDriverIdDocument, options);
        }
export type GetDriverTasksOnlyByDriverIdQueryHookResult = ReturnType<typeof useGetDriverTasksOnlyByDriverIdQuery>;
export type GetDriverTasksOnlyByDriverIdLazyQueryHookResult = ReturnType<typeof useGetDriverTasksOnlyByDriverIdLazyQuery>;
export type GetDriverTasksOnlyByDriverIdQueryResult = Apollo.QueryResult<GetDriverTasksOnlyByDriverIdQuery, GetDriverTasksOnlyByDriverIdQueryVariables>;
export const GetDriverDefaultRoutingConfigurationsDocument = gql`
    query GetDriverDefaultRoutingConfigurations($driverIds: [ID!]!, $dates: [Date!]!) {
  driverDefaultRoutingConfigurations(driverIds: $driverIds, dates: $dates) {
    driverId
    date
    startLocationId
    endLocationId
    useCurrentLocationAtStart
    startTime
    endTime
    isWorkDay
    startLocation {
      ...LocationFragment
    }
    endLocation {
      ...LocationFragment
    }
  }
}
    ${LocationFragmentFragmentDoc}`;

/**
 * __useGetDriverDefaultRoutingConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetDriverDefaultRoutingConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverDefaultRoutingConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverDefaultRoutingConfigurationsQuery({
 *   variables: {
 *      driverIds: // value for 'driverIds'
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useGetDriverDefaultRoutingConfigurationsQuery(baseOptions: Apollo.QueryHookOptions<GetDriverDefaultRoutingConfigurationsQuery, GetDriverDefaultRoutingConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverDefaultRoutingConfigurationsQuery, GetDriverDefaultRoutingConfigurationsQueryVariables>(GetDriverDefaultRoutingConfigurationsDocument, options);
      }
export function useGetDriverDefaultRoutingConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverDefaultRoutingConfigurationsQuery, GetDriverDefaultRoutingConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverDefaultRoutingConfigurationsQuery, GetDriverDefaultRoutingConfigurationsQueryVariables>(GetDriverDefaultRoutingConfigurationsDocument, options);
        }
export type GetDriverDefaultRoutingConfigurationsQueryHookResult = ReturnType<typeof useGetDriverDefaultRoutingConfigurationsQuery>;
export type GetDriverDefaultRoutingConfigurationsLazyQueryHookResult = ReturnType<typeof useGetDriverDefaultRoutingConfigurationsLazyQuery>;
export type GetDriverDefaultRoutingConfigurationsQueryResult = Apollo.QueryResult<GetDriverDefaultRoutingConfigurationsQuery, GetDriverDefaultRoutingConfigurationsQueryVariables>;
export const GetDriverScheduleForDateRangeDocument = gql`
    query GetDriverScheduleForDateRange($courierId: ID!, $startDate: Date!, $endDate: Date!, $endCustomerId: ID) {
  driverScheduleForDateRange(
    courierId: $courierId
    startDate: $startDate
    endDate: $endDate
    endCustomerId: $endCustomerId
  ) {
    driverSchedules {
      driver {
        ...DriverFragment
      }
      schedule {
        ...DriverScheduleForDateFragment
        timeBlocks {
          ...DriverScheduleTimeBlockFragment
        }
        shipments {
          ...ShipmentFragment
          shipmentTemplate {
            order {
              displayId
              name
            }
          }
          order {
            ...OrderFragment
            endCustomer {
              ...EndCustomerFragment
            }
            serviceType {
              ...ServiceTypeFragment
            }
          }
          stops {
            ...StopFragment
          }
        }
        completedShipments {
          ...ShipmentFragment
          shipmentTemplate {
            order {
              displayId
              name
            }
          }
          order {
            ...OrderFragment
            endCustomer {
              ...EndCustomerFragment
            }
            serviceType {
              ...ServiceTypeFragment
            }
          }
          stops {
            ...StopFragment
          }
        }
        shipmentTemplates {
          ...ShipmentTemplateFragment
          order {
            ...OrderFragment
            endCustomer {
              ...EndCustomerFragment
            }
            serviceType {
              ...ServiceTypeFragment
            }
          }
          stopTemplates {
            ...StopTemplateFragment
          }
          driver {
            ...DriverFragment
          }
        }
      }
    }
    unassignedShipments {
      date
      shipments {
        ...ShipmentFragment
        stops {
          ...StopFragment
        }
        order {
          ...OrderFragment
          endCustomer {
            ...EndCustomerFragment
          }
          serviceType {
            ...ServiceTypeFragment
          }
        }
      }
      shipmentTemplates {
        ...ShipmentTemplateFragment
        order {
          ...OrderFragment
          costCenter {
            ...CostCenterFragment
          }
          endCustomer {
            ...EndCustomerFragment
          }
          serviceType {
            ...ServiceTypeFragment
          }
          customFieldValues {
            ...CustomFieldValueFragment
            field {
              ...CustomFieldFragment
            }
          }
        }
        driver {
          ...DriverFragment
        }
        stopTemplates {
          ...StopTemplateFragment
        }
      }
    }
  }
}
    ${DriverFragmentFragmentDoc}
${DriverScheduleForDateFragmentFragmentDoc}
${DriverScheduleTimeBlockFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}
${StopTemplateFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}`;

/**
 * __useGetDriverScheduleForDateRangeQuery__
 *
 * To run a query within a React component, call `useGetDriverScheduleForDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverScheduleForDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverScheduleForDateRangeQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      endCustomerId: // value for 'endCustomerId'
 *   },
 * });
 */
export function useGetDriverScheduleForDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetDriverScheduleForDateRangeQuery, GetDriverScheduleForDateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverScheduleForDateRangeQuery, GetDriverScheduleForDateRangeQueryVariables>(GetDriverScheduleForDateRangeDocument, options);
      }
export function useGetDriverScheduleForDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverScheduleForDateRangeQuery, GetDriverScheduleForDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverScheduleForDateRangeQuery, GetDriverScheduleForDateRangeQueryVariables>(GetDriverScheduleForDateRangeDocument, options);
        }
export type GetDriverScheduleForDateRangeQueryHookResult = ReturnType<typeof useGetDriverScheduleForDateRangeQuery>;
export type GetDriverScheduleForDateRangeLazyQueryHookResult = ReturnType<typeof useGetDriverScheduleForDateRangeLazyQuery>;
export type GetDriverScheduleForDateRangeQueryResult = Apollo.QueryResult<GetDriverScheduleForDateRangeQuery, GetDriverScheduleForDateRangeQueryVariables>;
export const GetDriverWorkingTimesForDateDocument = gql`
    query GetDriverWorkingTimesForDate($courierId: ID!, $date: Date!) {
  driverScheduleForDateRange(
    courierId: $courierId
    startDate: $date
    endDate: $date
  ) {
    driverSchedules {
      driver {
        id
      }
      schedule {
        date
        timeBlocks {
          start
          end
        }
      }
    }
  }
}
    `;

/**
 * __useGetDriverWorkingTimesForDateQuery__
 *
 * To run a query within a React component, call `useGetDriverWorkingTimesForDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverWorkingTimesForDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverWorkingTimesForDateQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetDriverWorkingTimesForDateQuery(baseOptions: Apollo.QueryHookOptions<GetDriverWorkingTimesForDateQuery, GetDriverWorkingTimesForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverWorkingTimesForDateQuery, GetDriverWorkingTimesForDateQueryVariables>(GetDriverWorkingTimesForDateDocument, options);
      }
export function useGetDriverWorkingTimesForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverWorkingTimesForDateQuery, GetDriverWorkingTimesForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverWorkingTimesForDateQuery, GetDriverWorkingTimesForDateQueryVariables>(GetDriverWorkingTimesForDateDocument, options);
        }
export type GetDriverWorkingTimesForDateQueryHookResult = ReturnType<typeof useGetDriverWorkingTimesForDateQuery>;
export type GetDriverWorkingTimesForDateLazyQueryHookResult = ReturnType<typeof useGetDriverWorkingTimesForDateLazyQuery>;
export type GetDriverWorkingTimesForDateQueryResult = Apollo.QueryResult<GetDriverWorkingTimesForDateQuery, GetDriverWorkingTimesForDateQueryVariables>;
export const GetDriverTimeEventsDocument = gql`
    query GetDriverTimeEvents($courierId: ID!, $driverIds: [ID!], $startDate: Date!, $endDate: Date!) {
  driverTimeEvents(
    courierId: $courierId
    driverIds: $driverIds
    startDate: $startDate
    endDate: $endDate
  ) {
    ...DriverTimeEventFragment
  }
}
    ${DriverTimeEventFragmentFragmentDoc}`;

/**
 * __useGetDriverTimeEventsQuery__
 *
 * To run a query within a React component, call `useGetDriverTimeEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverTimeEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverTimeEventsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverIds: // value for 'driverIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDriverTimeEventsQuery(baseOptions: Apollo.QueryHookOptions<GetDriverTimeEventsQuery, GetDriverTimeEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverTimeEventsQuery, GetDriverTimeEventsQueryVariables>(GetDriverTimeEventsDocument, options);
      }
export function useGetDriverTimeEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverTimeEventsQuery, GetDriverTimeEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverTimeEventsQuery, GetDriverTimeEventsQueryVariables>(GetDriverTimeEventsDocument, options);
        }
export type GetDriverTimeEventsQueryHookResult = ReturnType<typeof useGetDriverTimeEventsQuery>;
export type GetDriverTimeEventsLazyQueryHookResult = ReturnType<typeof useGetDriverTimeEventsLazyQuery>;
export type GetDriverTimeEventsQueryResult = Apollo.QueryResult<GetDriverTimeEventsQuery, GetDriverTimeEventsQueryVariables>;
export const CreateEndUserDocument = gql`
    mutation CreateEndUser($courierId: String!, $endCustomerId: String!, $email: String!, $phone: String, $firstName: String, $lastName: String) {
  createEndUser(
    courierId: $courierId
    endCustomerId: $endCustomerId
    email: $email
    phone: $phone
    firstName: $firstName
    lastName: $lastName
  ) {
    ...EndUserFragment
  }
}
    ${EndUserFragmentFragmentDoc}`;
export type CreateEndUserMutationFn = Apollo.MutationFunction<CreateEndUserMutation, CreateEndUserMutationVariables>;

/**
 * __useCreateEndUserMutation__
 *
 * To run a mutation, you first call `useCreateEndUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEndUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEndUserMutation, { data, loading, error }] = useCreateEndUserMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useCreateEndUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateEndUserMutation, CreateEndUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEndUserMutation, CreateEndUserMutationVariables>(CreateEndUserDocument, options);
      }
export type CreateEndUserMutationHookResult = ReturnType<typeof useCreateEndUserMutation>;
export type CreateEndUserMutationResult = Apollo.MutationResult<CreateEndUserMutation>;
export type CreateEndUserMutationOptions = Apollo.BaseMutationOptions<CreateEndUserMutation, CreateEndUserMutationVariables>;
export const MarkEndUserAsDeletedDocument = gql`
    mutation MarkEndUserAsDeleted($endUserId: ID!) {
  markEndUserAsDeleted(endUserId: $endUserId)
}
    `;
export type MarkEndUserAsDeletedMutationFn = Apollo.MutationFunction<MarkEndUserAsDeletedMutation, MarkEndUserAsDeletedMutationVariables>;

/**
 * __useMarkEndUserAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkEndUserAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEndUserAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEndUserAsDeletedMutation, { data, loading, error }] = useMarkEndUserAsDeletedMutation({
 *   variables: {
 *      endUserId: // value for 'endUserId'
 *   },
 * });
 */
export function useMarkEndUserAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkEndUserAsDeletedMutation, MarkEndUserAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEndUserAsDeletedMutation, MarkEndUserAsDeletedMutationVariables>(MarkEndUserAsDeletedDocument, options);
      }
export type MarkEndUserAsDeletedMutationHookResult = ReturnType<typeof useMarkEndUserAsDeletedMutation>;
export type MarkEndUserAsDeletedMutationResult = Apollo.MutationResult<MarkEndUserAsDeletedMutation>;
export type MarkEndUserAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkEndUserAsDeletedMutation, MarkEndUserAsDeletedMutationVariables>;
export const GetEndUsersDocument = gql`
    query GetEndUsers($courierId: String!, $endCustomerIds: [String!]) {
  endUsers(courierId: $courierId, endCustomerIds: $endCustomerIds) {
    ...EndUserFragment
  }
}
    ${EndUserFragmentFragmentDoc}`;

/**
 * __useGetEndUsersQuery__
 *
 * To run a query within a React component, call `useGetEndUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndUsersQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *   },
 * });
 */
export function useGetEndUsersQuery(baseOptions: Apollo.QueryHookOptions<GetEndUsersQuery, GetEndUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndUsersQuery, GetEndUsersQueryVariables>(GetEndUsersDocument, options);
      }
export function useGetEndUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndUsersQuery, GetEndUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndUsersQuery, GetEndUsersQueryVariables>(GetEndUsersDocument, options);
        }
export type GetEndUsersQueryHookResult = ReturnType<typeof useGetEndUsersQuery>;
export type GetEndUsersLazyQueryHookResult = ReturnType<typeof useGetEndUsersLazyQuery>;
export type GetEndUsersQueryResult = Apollo.QueryResult<GetEndUsersQuery, GetEndUsersQueryVariables>;
export const SendCommunicationToEndCustomerDocument = gql`
    mutation sendCommunicationToEndCustomer($courierId: ID!, $shipmentId: ID, $stopId: ID, $communicationTypeId: CommunicationTypeId, $emailRecipientsCommaSeparated: String) {
  sendCommunicationToEndCustomer(
    courierId: $courierId
    shipmentId: $shipmentId
    stopId: $stopId
    communicationTypeId: $communicationTypeId
    emailRecipientsCommaSeparated: $emailRecipientsCommaSeparated
  ) {
    ...EndCustomerCommunicationFragment
  }
}
    ${EndCustomerCommunicationFragmentFragmentDoc}`;
export type SendCommunicationToEndCustomerMutationFn = Apollo.MutationFunction<SendCommunicationToEndCustomerMutation, SendCommunicationToEndCustomerMutationVariables>;

/**
 * __useSendCommunicationToEndCustomerMutation__
 *
 * To run a mutation, you first call `useSendCommunicationToEndCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCommunicationToEndCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCommunicationToEndCustomerMutation, { data, loading, error }] = useSendCommunicationToEndCustomerMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      stopId: // value for 'stopId'
 *      communicationTypeId: // value for 'communicationTypeId'
 *      emailRecipientsCommaSeparated: // value for 'emailRecipientsCommaSeparated'
 *   },
 * });
 */
export function useSendCommunicationToEndCustomerMutation(baseOptions?: Apollo.MutationHookOptions<SendCommunicationToEndCustomerMutation, SendCommunicationToEndCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCommunicationToEndCustomerMutation, SendCommunicationToEndCustomerMutationVariables>(SendCommunicationToEndCustomerDocument, options);
      }
export type SendCommunicationToEndCustomerMutationHookResult = ReturnType<typeof useSendCommunicationToEndCustomerMutation>;
export type SendCommunicationToEndCustomerMutationResult = Apollo.MutationResult<SendCommunicationToEndCustomerMutation>;
export type SendCommunicationToEndCustomerMutationOptions = Apollo.BaseMutationOptions<SendCommunicationToEndCustomerMutation, SendCommunicationToEndCustomerMutationVariables>;
export const SendInvoiceEmailDocument = gql`
    mutation SendInvoiceEmail($courierId: ID!, $invoiceEmailSendInput: InvoiceEmailSendInput!) {
  sendInvoiceEmail(
    courierId: $courierId
    invoiceEmailSendInput: $invoiceEmailSendInput
  ) {
    ...EndCustomerCommunicationFragment
  }
}
    ${EndCustomerCommunicationFragmentFragmentDoc}`;
export type SendInvoiceEmailMutationFn = Apollo.MutationFunction<SendInvoiceEmailMutation, SendInvoiceEmailMutationVariables>;

/**
 * __useSendInvoiceEmailMutation__
 *
 * To run a mutation, you first call `useSendInvoiceEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoiceEmailMutation, { data, loading, error }] = useSendInvoiceEmailMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceEmailSendInput: // value for 'invoiceEmailSendInput'
 *   },
 * });
 */
export function useSendInvoiceEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendInvoiceEmailMutation, SendInvoiceEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvoiceEmailMutation, SendInvoiceEmailMutationVariables>(SendInvoiceEmailDocument, options);
      }
export type SendInvoiceEmailMutationHookResult = ReturnType<typeof useSendInvoiceEmailMutation>;
export type SendInvoiceEmailMutationResult = Apollo.MutationResult<SendInvoiceEmailMutation>;
export type SendInvoiceEmailMutationOptions = Apollo.BaseMutationOptions<SendInvoiceEmailMutation, SendInvoiceEmailMutationVariables>;
export const CreateEndCustomerDocument = gql`
    mutation CreateEndCustomer($courierId: ID!, $companyName: String, $contactPhoneNumber: String!, $contactEmail: String!, $firstName: String, $lastName: String!, $pricingListId: ID, $googlePlaceId: String, $suite: String, $endCustomerCreatedSource: EndCustomerCreatedSource) {
  createEndCustomer(
    courierId: $courierId
    companyName: $companyName
    contactPhoneNumber: $contactPhoneNumber
    contactEmail: $contactEmail
    firstName: $firstName
    lastName: $lastName
    pricingListId: $pricingListId
    googlePlaceId: $googlePlaceId
    suite: $suite
    endCustomerCreatedSource: $endCustomerCreatedSource
  ) {
    ...EndCustomerFragment
    location {
      ...LocationFragment
    }
  }
}
    ${EndCustomerFragmentFragmentDoc}
${LocationFragmentFragmentDoc}`;
export type CreateEndCustomerMutationFn = Apollo.MutationFunction<CreateEndCustomerMutation, CreateEndCustomerMutationVariables>;

/**
 * __useCreateEndCustomerMutation__
 *
 * To run a mutation, you first call `useCreateEndCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEndCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEndCustomerMutation, { data, loading, error }] = useCreateEndCustomerMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      companyName: // value for 'companyName'
 *      contactPhoneNumber: // value for 'contactPhoneNumber'
 *      contactEmail: // value for 'contactEmail'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      pricingListId: // value for 'pricingListId'
 *      googlePlaceId: // value for 'googlePlaceId'
 *      suite: // value for 'suite'
 *      endCustomerCreatedSource: // value for 'endCustomerCreatedSource'
 *   },
 * });
 */
export function useCreateEndCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateEndCustomerMutation, CreateEndCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEndCustomerMutation, CreateEndCustomerMutationVariables>(CreateEndCustomerDocument, options);
      }
export type CreateEndCustomerMutationHookResult = ReturnType<typeof useCreateEndCustomerMutation>;
export type CreateEndCustomerMutationResult = Apollo.MutationResult<CreateEndCustomerMutation>;
export type CreateEndCustomerMutationOptions = Apollo.BaseMutationOptions<CreateEndCustomerMutation, CreateEndCustomerMutationVariables>;
export const FullUpdateEndCustomerDocument = gql`
    mutation FullUpdateEndCustomer($id: ID!, $companyName: String, $contactPhoneNumber: String!, $contactEmail: String!, $billingEmails: [String!], $firstName: String, $lastName: String, $pricingListId: ID, $suite: String, $googlePlaceId: String, $invoicingFrequency: InvoicingFrequency!, $taxCode: String, $totalPricingMultiplier: Money, $invoicePdfTemplateId: ID, $scanRequirementType: ScanRequirement) {
  fullUpdateEndCustomer(
    fullUpdate: {id: $id, companyName: $companyName, contactPhoneNumber: $contactPhoneNumber, contactEmail: $contactEmail, billingEmails: $billingEmails, firstName: $firstName, lastName: $lastName, pricingListId: $pricingListId, suite: $suite, googlePlaceId: $googlePlaceId, invoicingFrequency: $invoicingFrequency, taxCode: $taxCode, totalPricingMultiplier: $totalPricingMultiplier, invoicePdfTemplateId: $invoicePdfTemplateId, scanRequirementType: $scanRequirementType}
  ) {
    ...EndCustomerFragment
    invoicePdfTemplate {
      ...InvoicePdfTemplateFragment
    }
  }
}
    ${EndCustomerFragmentFragmentDoc}
${InvoicePdfTemplateFragmentFragmentDoc}`;
export type FullUpdateEndCustomerMutationFn = Apollo.MutationFunction<FullUpdateEndCustomerMutation, FullUpdateEndCustomerMutationVariables>;

/**
 * __useFullUpdateEndCustomerMutation__
 *
 * To run a mutation, you first call `useFullUpdateEndCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateEndCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateEndCustomerMutation, { data, loading, error }] = useFullUpdateEndCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyName: // value for 'companyName'
 *      contactPhoneNumber: // value for 'contactPhoneNumber'
 *      contactEmail: // value for 'contactEmail'
 *      billingEmails: // value for 'billingEmails'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      pricingListId: // value for 'pricingListId'
 *      suite: // value for 'suite'
 *      googlePlaceId: // value for 'googlePlaceId'
 *      invoicingFrequency: // value for 'invoicingFrequency'
 *      taxCode: // value for 'taxCode'
 *      totalPricingMultiplier: // value for 'totalPricingMultiplier'
 *      invoicePdfTemplateId: // value for 'invoicePdfTemplateId'
 *      scanRequirementType: // value for 'scanRequirementType'
 *   },
 * });
 */
export function useFullUpdateEndCustomerMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateEndCustomerMutation, FullUpdateEndCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateEndCustomerMutation, FullUpdateEndCustomerMutationVariables>(FullUpdateEndCustomerDocument, options);
      }
export type FullUpdateEndCustomerMutationHookResult = ReturnType<typeof useFullUpdateEndCustomerMutation>;
export type FullUpdateEndCustomerMutationResult = Apollo.MutationResult<FullUpdateEndCustomerMutation>;
export type FullUpdateEndCustomerMutationOptions = Apollo.BaseMutationOptions<FullUpdateEndCustomerMutation, FullUpdateEndCustomerMutationVariables>;
export const UpdateEndCustomerVisibleServiceTypeIdsDocument = gql`
    mutation UpdateEndCustomerVisibleServiceTypeIds($endCustomerId: ID!, $visibleServiceTypeIds: [ID!]) {
  updateEndCustomerVisibleServiceTypeIds(
    endCustomerId: $endCustomerId
    visibleServiceTypeIds: $visibleServiceTypeIds
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdateEndCustomerVisibleServiceTypeIdsMutationFn = Apollo.MutationFunction<UpdateEndCustomerVisibleServiceTypeIdsMutation, UpdateEndCustomerVisibleServiceTypeIdsMutationVariables>;

/**
 * __useUpdateEndCustomerVisibleServiceTypeIdsMutation__
 *
 * To run a mutation, you first call `useUpdateEndCustomerVisibleServiceTypeIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndCustomerVisibleServiceTypeIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndCustomerVisibleServiceTypeIdsMutation, { data, loading, error }] = useUpdateEndCustomerVisibleServiceTypeIdsMutation({
 *   variables: {
 *      endCustomerId: // value for 'endCustomerId'
 *      visibleServiceTypeIds: // value for 'visibleServiceTypeIds'
 *   },
 * });
 */
export function useUpdateEndCustomerVisibleServiceTypeIdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndCustomerVisibleServiceTypeIdsMutation, UpdateEndCustomerVisibleServiceTypeIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndCustomerVisibleServiceTypeIdsMutation, UpdateEndCustomerVisibleServiceTypeIdsMutationVariables>(UpdateEndCustomerVisibleServiceTypeIdsDocument, options);
      }
export type UpdateEndCustomerVisibleServiceTypeIdsMutationHookResult = ReturnType<typeof useUpdateEndCustomerVisibleServiceTypeIdsMutation>;
export type UpdateEndCustomerVisibleServiceTypeIdsMutationResult = Apollo.MutationResult<UpdateEndCustomerVisibleServiceTypeIdsMutation>;
export type UpdateEndCustomerVisibleServiceTypeIdsMutationOptions = Apollo.BaseMutationOptions<UpdateEndCustomerVisibleServiceTypeIdsMutation, UpdateEndCustomerVisibleServiceTypeIdsMutationVariables>;
export const UpdatePodEmailsDocument = gql`
    mutation UpdatePodEmails($endCustomerId: ID!, $podEmails: [ID!]) {
  updatePodEmails(endCustomerId: $endCustomerId, podEmails: $podEmails) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdatePodEmailsMutationFn = Apollo.MutationFunction<UpdatePodEmailsMutation, UpdatePodEmailsMutationVariables>;

/**
 * __useUpdatePodEmailsMutation__
 *
 * To run a mutation, you first call `useUpdatePodEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePodEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePodEmailsMutation, { data, loading, error }] = useUpdatePodEmailsMutation({
 *   variables: {
 *      endCustomerId: // value for 'endCustomerId'
 *      podEmails: // value for 'podEmails'
 *   },
 * });
 */
export function useUpdatePodEmailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePodEmailsMutation, UpdatePodEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePodEmailsMutation, UpdatePodEmailsMutationVariables>(UpdatePodEmailsDocument, options);
      }
export type UpdatePodEmailsMutationHookResult = ReturnType<typeof useUpdatePodEmailsMutation>;
export type UpdatePodEmailsMutationResult = Apollo.MutationResult<UpdatePodEmailsMutation>;
export type UpdatePodEmailsMutationOptions = Apollo.BaseMutationOptions<UpdatePodEmailsMutation, UpdatePodEmailsMutationVariables>;
export const MergeEndCustomersDocument = gql`
    mutation MergeEndCustomers($courierId: ID!, $sourceEndCustomerId: ID!, $targetEndCustomerId: ID!) {
  mergeEndCustomers(
    courierId: $courierId
    sourceEndCustomerId: $sourceEndCustomerId
    targetEndCustomerId: $targetEndCustomerId
  ) {
    id
  }
}
    `;
export type MergeEndCustomersMutationFn = Apollo.MutationFunction<MergeEndCustomersMutation, MergeEndCustomersMutationVariables>;

/**
 * __useMergeEndCustomersMutation__
 *
 * To run a mutation, you first call `useMergeEndCustomersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeEndCustomersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeEndCustomersMutation, { data, loading, error }] = useMergeEndCustomersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      sourceEndCustomerId: // value for 'sourceEndCustomerId'
 *      targetEndCustomerId: // value for 'targetEndCustomerId'
 *   },
 * });
 */
export function useMergeEndCustomersMutation(baseOptions?: Apollo.MutationHookOptions<MergeEndCustomersMutation, MergeEndCustomersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeEndCustomersMutation, MergeEndCustomersMutationVariables>(MergeEndCustomersDocument, options);
      }
export type MergeEndCustomersMutationHookResult = ReturnType<typeof useMergeEndCustomersMutation>;
export type MergeEndCustomersMutationResult = Apollo.MutationResult<MergeEndCustomersMutation>;
export type MergeEndCustomersMutationOptions = Apollo.BaseMutationOptions<MergeEndCustomersMutation, MergeEndCustomersMutationVariables>;
export const DeleteFirebaseUserForEndCustomerDocument = gql`
    mutation DeleteFirebaseUserForEndCustomer($endCustomerId: ID!) {
  deleteFirebaseUserForEndCustomer(endCustomerId: $endCustomerId) {
    id
  }
}
    `;
export type DeleteFirebaseUserForEndCustomerMutationFn = Apollo.MutationFunction<DeleteFirebaseUserForEndCustomerMutation, DeleteFirebaseUserForEndCustomerMutationVariables>;

/**
 * __useDeleteFirebaseUserForEndCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteFirebaseUserForEndCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFirebaseUserForEndCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFirebaseUserForEndCustomerMutation, { data, loading, error }] = useDeleteFirebaseUserForEndCustomerMutation({
 *   variables: {
 *      endCustomerId: // value for 'endCustomerId'
 *   },
 * });
 */
export function useDeleteFirebaseUserForEndCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFirebaseUserForEndCustomerMutation, DeleteFirebaseUserForEndCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFirebaseUserForEndCustomerMutation, DeleteFirebaseUserForEndCustomerMutationVariables>(DeleteFirebaseUserForEndCustomerDocument, options);
      }
export type DeleteFirebaseUserForEndCustomerMutationHookResult = ReturnType<typeof useDeleteFirebaseUserForEndCustomerMutation>;
export type DeleteFirebaseUserForEndCustomerMutationResult = Apollo.MutationResult<DeleteFirebaseUserForEndCustomerMutation>;
export type DeleteFirebaseUserForEndCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteFirebaseUserForEndCustomerMutation, DeleteFirebaseUserForEndCustomerMutationVariables>;
export const ChangePasswordEndCustomerDocument = gql`
    mutation ChangePasswordEndCustomer($endCustomerId: ID!, $password: String!) {
  changePasswordEndCustomer(endCustomerId: $endCustomerId, password: $password) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type ChangePasswordEndCustomerMutationFn = Apollo.MutationFunction<ChangePasswordEndCustomerMutation, ChangePasswordEndCustomerMutationVariables>;

/**
 * __useChangePasswordEndCustomerMutation__
 *
 * To run a mutation, you first call `useChangePasswordEndCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordEndCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordEndCustomerMutation, { data, loading, error }] = useChangePasswordEndCustomerMutation({
 *   variables: {
 *      endCustomerId: // value for 'endCustomerId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordEndCustomerMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordEndCustomerMutation, ChangePasswordEndCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordEndCustomerMutation, ChangePasswordEndCustomerMutationVariables>(ChangePasswordEndCustomerDocument, options);
      }
export type ChangePasswordEndCustomerMutationHookResult = ReturnType<typeof useChangePasswordEndCustomerMutation>;
export type ChangePasswordEndCustomerMutationResult = Apollo.MutationResult<ChangePasswordEndCustomerMutation>;
export type ChangePasswordEndCustomerMutationOptions = Apollo.BaseMutationOptions<ChangePasswordEndCustomerMutation, ChangePasswordEndCustomerMutationVariables>;
export const MarkEndCustomerConfirmedAsNewDocument = gql`
    mutation MarkEndCustomerConfirmedAsNew($endCustomerId: ID!) {
  markEndCustomerConfirmedAsNew(endCustomerId: $endCustomerId) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type MarkEndCustomerConfirmedAsNewMutationFn = Apollo.MutationFunction<MarkEndCustomerConfirmedAsNewMutation, MarkEndCustomerConfirmedAsNewMutationVariables>;

/**
 * __useMarkEndCustomerConfirmedAsNewMutation__
 *
 * To run a mutation, you first call `useMarkEndCustomerConfirmedAsNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEndCustomerConfirmedAsNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEndCustomerConfirmedAsNewMutation, { data, loading, error }] = useMarkEndCustomerConfirmedAsNewMutation({
 *   variables: {
 *      endCustomerId: // value for 'endCustomerId'
 *   },
 * });
 */
export function useMarkEndCustomerConfirmedAsNewMutation(baseOptions?: Apollo.MutationHookOptions<MarkEndCustomerConfirmedAsNewMutation, MarkEndCustomerConfirmedAsNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEndCustomerConfirmedAsNewMutation, MarkEndCustomerConfirmedAsNewMutationVariables>(MarkEndCustomerConfirmedAsNewDocument, options);
      }
export type MarkEndCustomerConfirmedAsNewMutationHookResult = ReturnType<typeof useMarkEndCustomerConfirmedAsNewMutation>;
export type MarkEndCustomerConfirmedAsNewMutationResult = Apollo.MutationResult<MarkEndCustomerConfirmedAsNewMutation>;
export type MarkEndCustomerConfirmedAsNewMutationOptions = Apollo.BaseMutationOptions<MarkEndCustomerConfirmedAsNewMutation, MarkEndCustomerConfirmedAsNewMutationVariables>;
export const UpdateEnabledEndCustomerCommunicationsTypesDocument = gql`
    mutation UpdateEnabledEndCustomerCommunicationsTypes($endCustomerId: ID!, $enabledCommunicationTypeIds: [CommunicationTypeId!]!) {
  updateEnabledEndCustomerCommunicationsTypes(
    endCustomerId: $endCustomerId
    enabledCommunicationTypeIds: $enabledCommunicationTypeIds
  )
}
    `;
export type UpdateEnabledEndCustomerCommunicationsTypesMutationFn = Apollo.MutationFunction<UpdateEnabledEndCustomerCommunicationsTypesMutation, UpdateEnabledEndCustomerCommunicationsTypesMutationVariables>;

/**
 * __useUpdateEnabledEndCustomerCommunicationsTypesMutation__
 *
 * To run a mutation, you first call `useUpdateEnabledEndCustomerCommunicationsTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnabledEndCustomerCommunicationsTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnabledEndCustomerCommunicationsTypesMutation, { data, loading, error }] = useUpdateEnabledEndCustomerCommunicationsTypesMutation({
 *   variables: {
 *      endCustomerId: // value for 'endCustomerId'
 *      enabledCommunicationTypeIds: // value for 'enabledCommunicationTypeIds'
 *   },
 * });
 */
export function useUpdateEnabledEndCustomerCommunicationsTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnabledEndCustomerCommunicationsTypesMutation, UpdateEnabledEndCustomerCommunicationsTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnabledEndCustomerCommunicationsTypesMutation, UpdateEnabledEndCustomerCommunicationsTypesMutationVariables>(UpdateEnabledEndCustomerCommunicationsTypesDocument, options);
      }
export type UpdateEnabledEndCustomerCommunicationsTypesMutationHookResult = ReturnType<typeof useUpdateEnabledEndCustomerCommunicationsTypesMutation>;
export type UpdateEnabledEndCustomerCommunicationsTypesMutationResult = Apollo.MutationResult<UpdateEnabledEndCustomerCommunicationsTypesMutation>;
export type UpdateEnabledEndCustomerCommunicationsTypesMutationOptions = Apollo.BaseMutationOptions<UpdateEnabledEndCustomerCommunicationsTypesMutation, UpdateEnabledEndCustomerCommunicationsTypesMutationVariables>;
export const MarkEndCustomerDeletedDocument = gql`
    mutation MarkEndCustomerDeleted($courierId: ID!, $endCustomerId: ID!) {
  markEndCustomerDeleted(courierId: $courierId, endCustomerId: $endCustomerId)
}
    `;
export type MarkEndCustomerDeletedMutationFn = Apollo.MutationFunction<MarkEndCustomerDeletedMutation, MarkEndCustomerDeletedMutationVariables>;

/**
 * __useMarkEndCustomerDeletedMutation__
 *
 * To run a mutation, you first call `useMarkEndCustomerDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEndCustomerDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEndCustomerDeletedMutation, { data, loading, error }] = useMarkEndCustomerDeletedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *   },
 * });
 */
export function useMarkEndCustomerDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkEndCustomerDeletedMutation, MarkEndCustomerDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEndCustomerDeletedMutation, MarkEndCustomerDeletedMutationVariables>(MarkEndCustomerDeletedDocument, options);
      }
export type MarkEndCustomerDeletedMutationHookResult = ReturnType<typeof useMarkEndCustomerDeletedMutation>;
export type MarkEndCustomerDeletedMutationResult = Apollo.MutationResult<MarkEndCustomerDeletedMutation>;
export type MarkEndCustomerDeletedMutationOptions = Apollo.BaseMutationOptions<MarkEndCustomerDeletedMutation, MarkEndCustomerDeletedMutationVariables>;
export const UpdateEndCustomerCustomFieldsDocument = gql`
    mutation UpdateEndCustomerCustomFields($courierId: ID!, $endCustomerId: ID!, $customFieldIds: [ID!]!) {
  updateEndCustomerCustomFields(
    courierId: $courierId
    endCustomerId: $endCustomerId
    customFieldIds: $customFieldIds
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdateEndCustomerCustomFieldsMutationFn = Apollo.MutationFunction<UpdateEndCustomerCustomFieldsMutation, UpdateEndCustomerCustomFieldsMutationVariables>;

/**
 * __useUpdateEndCustomerCustomFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateEndCustomerCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndCustomerCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndCustomerCustomFieldsMutation, { data, loading, error }] = useUpdateEndCustomerCustomFieldsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      customFieldIds: // value for 'customFieldIds'
 *   },
 * });
 */
export function useUpdateEndCustomerCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndCustomerCustomFieldsMutation, UpdateEndCustomerCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndCustomerCustomFieldsMutation, UpdateEndCustomerCustomFieldsMutationVariables>(UpdateEndCustomerCustomFieldsDocument, options);
      }
export type UpdateEndCustomerCustomFieldsMutationHookResult = ReturnType<typeof useUpdateEndCustomerCustomFieldsMutation>;
export type UpdateEndCustomerCustomFieldsMutationResult = Apollo.MutationResult<UpdateEndCustomerCustomFieldsMutation>;
export type UpdateEndCustomerCustomFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateEndCustomerCustomFieldsMutation, UpdateEndCustomerCustomFieldsMutationVariables>;
export const UpdateEndCustomerNoteDocument = gql`
    mutation UpdateEndCustomerNote($courierId: ID!, $endCustomerId: ID!, $note: String) {
  updateEndCustomerNote(
    courierId: $courierId
    endCustomerId: $endCustomerId
    note: $note
  ) {
    ...EndCustomerFragment
  }
}
    ${EndCustomerFragmentFragmentDoc}`;
export type UpdateEndCustomerNoteMutationFn = Apollo.MutationFunction<UpdateEndCustomerNoteMutation, UpdateEndCustomerNoteMutationVariables>;

/**
 * __useUpdateEndCustomerNoteMutation__
 *
 * To run a mutation, you first call `useUpdateEndCustomerNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEndCustomerNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEndCustomerNoteMutation, { data, loading, error }] = useUpdateEndCustomerNoteMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateEndCustomerNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEndCustomerNoteMutation, UpdateEndCustomerNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEndCustomerNoteMutation, UpdateEndCustomerNoteMutationVariables>(UpdateEndCustomerNoteDocument, options);
      }
export type UpdateEndCustomerNoteMutationHookResult = ReturnType<typeof useUpdateEndCustomerNoteMutation>;
export type UpdateEndCustomerNoteMutationResult = Apollo.MutationResult<UpdateEndCustomerNoteMutation>;
export type UpdateEndCustomerNoteMutationOptions = Apollo.BaseMutationOptions<UpdateEndCustomerNoteMutation, UpdateEndCustomerNoteMutationVariables>;
export const SearchEndCustomerDocument = gql`
    query SearchEndCustomer($courierId: ID!, $searchTerm: String!) {
  searchEndCustomer(courierId: $courierId, searchTerm: $searchTerm) {
    ...EndCustomerFragment
    remoteEntities {
      ...RemoteEntityFragment
    }
    costCenters {
      ...CostCenterFragment
      location {
        ...LocationFragment
      }
    }
    location {
      ...LocationFragment
    }
    pricingList {
      ...PricingListFragment
    }
  }
}
    ${EndCustomerFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}`;

/**
 * __useSearchEndCustomerQuery__
 *
 * To run a query within a React component, call `useSearchEndCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEndCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEndCustomerQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchEndCustomerQuery(baseOptions: Apollo.QueryHookOptions<SearchEndCustomerQuery, SearchEndCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEndCustomerQuery, SearchEndCustomerQueryVariables>(SearchEndCustomerDocument, options);
      }
export function useSearchEndCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEndCustomerQuery, SearchEndCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEndCustomerQuery, SearchEndCustomerQueryVariables>(SearchEndCustomerDocument, options);
        }
export type SearchEndCustomerQueryHookResult = ReturnType<typeof useSearchEndCustomerQuery>;
export type SearchEndCustomerLazyQueryHookResult = ReturnType<typeof useSearchEndCustomerLazyQuery>;
export type SearchEndCustomerQueryResult = Apollo.QueryResult<SearchEndCustomerQuery, SearchEndCustomerQueryVariables>;
export const GetEndCustomersDocument = gql`
    query GetEndCustomers($courierId: ID!, $ids: [ID!], $limit: Int, $after: Int, $sortFields: [EndCustomerSorting!]) {
  endCustomers(
    courierId: $courierId
    ids: $ids
    limit: $limit
    after: $after
    sortFields: $sortFields
  ) {
    edges {
      node {
        ...EndCustomerFragment
        pricingList {
          ...PricingListFragment
        }
        location {
          ...LocationFragment
        }
        remoteEntities {
          ...RemoteEntityFragment
        }
        costCenters {
          ...CostCenterFragment
          location {
            ...LocationFragment
          }
        }
        invoicePdfTemplate {
          ...InvoicePdfTemplateFragment
        }
        customFields {
          ...CustomFieldFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${EndCustomerFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}
${LocationFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${InvoicePdfTemplateFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetEndCustomersQuery__
 *
 * To run a query within a React component, call `useGetEndCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndCustomersQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useGetEndCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetEndCustomersQuery, GetEndCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndCustomersQuery, GetEndCustomersQueryVariables>(GetEndCustomersDocument, options);
      }
export function useGetEndCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndCustomersQuery, GetEndCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndCustomersQuery, GetEndCustomersQueryVariables>(GetEndCustomersDocument, options);
        }
export type GetEndCustomersQueryHookResult = ReturnType<typeof useGetEndCustomersQuery>;
export type GetEndCustomersLazyQueryHookResult = ReturnType<typeof useGetEndCustomersLazyQuery>;
export type GetEndCustomersQueryResult = Apollo.QueryResult<GetEndCustomersQuery, GetEndCustomersQueryVariables>;
export const GetEndCustomersLengthDocument = gql`
    query GetEndCustomersLength($courierId: ID!) {
  endCustomers(courierId: $courierId) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useGetEndCustomersLengthQuery__
 *
 * To run a query within a React component, call `useGetEndCustomersLengthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndCustomersLengthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndCustomersLengthQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetEndCustomersLengthQuery(baseOptions: Apollo.QueryHookOptions<GetEndCustomersLengthQuery, GetEndCustomersLengthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndCustomersLengthQuery, GetEndCustomersLengthQueryVariables>(GetEndCustomersLengthDocument, options);
      }
export function useGetEndCustomersLengthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndCustomersLengthQuery, GetEndCustomersLengthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndCustomersLengthQuery, GetEndCustomersLengthQueryVariables>(GetEndCustomersLengthDocument, options);
        }
export type GetEndCustomersLengthQueryHookResult = ReturnType<typeof useGetEndCustomersLengthQuery>;
export type GetEndCustomersLengthLazyQueryHookResult = ReturnType<typeof useGetEndCustomersLengthLazyQuery>;
export type GetEndCustomersLengthQueryResult = Apollo.QueryResult<GetEndCustomersLengthQuery, GetEndCustomersLengthQueryVariables>;
export const GetEndCustomersOverviewDocument = gql`
    query getEndCustomersOverview($courierId: ID!) {
  endCustomersOverview(courierId: $courierId) {
    numUnconfirmedCustomerPortalEndCustomers
  }
}
    `;

/**
 * __useGetEndCustomersOverviewQuery__
 *
 * To run a query within a React component, call `useGetEndCustomersOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndCustomersOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndCustomersOverviewQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetEndCustomersOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetEndCustomersOverviewQuery, GetEndCustomersOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndCustomersOverviewQuery, GetEndCustomersOverviewQueryVariables>(GetEndCustomersOverviewDocument, options);
      }
export function useGetEndCustomersOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndCustomersOverviewQuery, GetEndCustomersOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndCustomersOverviewQuery, GetEndCustomersOverviewQueryVariables>(GetEndCustomersOverviewDocument, options);
        }
export type GetEndCustomersOverviewQueryHookResult = ReturnType<typeof useGetEndCustomersOverviewQuery>;
export type GetEndCustomersOverviewLazyQueryHookResult = ReturnType<typeof useGetEndCustomersOverviewLazyQuery>;
export type GetEndCustomersOverviewQueryResult = Apollo.QueryResult<GetEndCustomersOverviewQuery, GetEndCustomersOverviewQueryVariables>;
export const CreateHolidayScheduleDocument = gql`
    mutation createHolidaySchedule($courierId: ID!, $name: String!) {
  createHolidaySchedule(courierId: $courierId, name: $name) {
    ...HolidayScheduleFragment
  }
}
    ${HolidayScheduleFragmentFragmentDoc}`;
export type CreateHolidayScheduleMutationFn = Apollo.MutationFunction<CreateHolidayScheduleMutation, CreateHolidayScheduleMutationVariables>;

/**
 * __useCreateHolidayScheduleMutation__
 *
 * To run a mutation, you first call `useCreateHolidayScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHolidayScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHolidayScheduleMutation, { data, loading, error }] = useCreateHolidayScheduleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateHolidayScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateHolidayScheduleMutation, CreateHolidayScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHolidayScheduleMutation, CreateHolidayScheduleMutationVariables>(CreateHolidayScheduleDocument, options);
      }
export type CreateHolidayScheduleMutationHookResult = ReturnType<typeof useCreateHolidayScheduleMutation>;
export type CreateHolidayScheduleMutationResult = Apollo.MutationResult<CreateHolidayScheduleMutation>;
export type CreateHolidayScheduleMutationOptions = Apollo.BaseMutationOptions<CreateHolidayScheduleMutation, CreateHolidayScheduleMutationVariables>;
export const DeleteHolidayScheduleDocument = gql`
    mutation deleteHolidaySchedule($courierId: ID!, $holidayScheduleId: ID!) {
  deleteHolidaySchedule(
    courierId: $courierId
    holidayScheduleId: $holidayScheduleId
  )
}
    `;
export type DeleteHolidayScheduleMutationFn = Apollo.MutationFunction<DeleteHolidayScheduleMutation, DeleteHolidayScheduleMutationVariables>;

/**
 * __useDeleteHolidayScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteHolidayScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHolidayScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHolidayScheduleMutation, { data, loading, error }] = useDeleteHolidayScheduleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *   },
 * });
 */
export function useDeleteHolidayScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHolidayScheduleMutation, DeleteHolidayScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHolidayScheduleMutation, DeleteHolidayScheduleMutationVariables>(DeleteHolidayScheduleDocument, options);
      }
export type DeleteHolidayScheduleMutationHookResult = ReturnType<typeof useDeleteHolidayScheduleMutation>;
export type DeleteHolidayScheduleMutationResult = Apollo.MutationResult<DeleteHolidayScheduleMutation>;
export type DeleteHolidayScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteHolidayScheduleMutation, DeleteHolidayScheduleMutationVariables>;
export const DeleteHolidayScheduleBehaviorDocument = gql`
    mutation deleteHolidayScheduleBehavior($courierId: ID!, $courierHolidayId: ID!, $holidayScheduleId: ID!) {
  deleteHolidayScheduleBehavior(
    courierId: $courierId
    courierHolidayId: $courierHolidayId
    holidayScheduleId: $holidayScheduleId
  )
}
    `;
export type DeleteHolidayScheduleBehaviorMutationFn = Apollo.MutationFunction<DeleteHolidayScheduleBehaviorMutation, DeleteHolidayScheduleBehaviorMutationVariables>;

/**
 * __useDeleteHolidayScheduleBehaviorMutation__
 *
 * To run a mutation, you first call `useDeleteHolidayScheduleBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHolidayScheduleBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHolidayScheduleBehaviorMutation, { data, loading, error }] = useDeleteHolidayScheduleBehaviorMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      courierHolidayId: // value for 'courierHolidayId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *   },
 * });
 */
export function useDeleteHolidayScheduleBehaviorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHolidayScheduleBehaviorMutation, DeleteHolidayScheduleBehaviorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHolidayScheduleBehaviorMutation, DeleteHolidayScheduleBehaviorMutationVariables>(DeleteHolidayScheduleBehaviorDocument, options);
      }
export type DeleteHolidayScheduleBehaviorMutationHookResult = ReturnType<typeof useDeleteHolidayScheduleBehaviorMutation>;
export type DeleteHolidayScheduleBehaviorMutationResult = Apollo.MutationResult<DeleteHolidayScheduleBehaviorMutation>;
export type DeleteHolidayScheduleBehaviorMutationOptions = Apollo.BaseMutationOptions<DeleteHolidayScheduleBehaviorMutation, DeleteHolidayScheduleBehaviorMutationVariables>;
export const UpdateHolidayScheduleDocument = gql`
    mutation updateHolidaySchedule($courierId: ID!, $holidayScheduleId: ID!, $name: String!) {
  updateHolidaySchedule(
    courierId: $courierId
    holidayScheduleId: $holidayScheduleId
    name: $name
  )
}
    `;
export type UpdateHolidayScheduleMutationFn = Apollo.MutationFunction<UpdateHolidayScheduleMutation, UpdateHolidayScheduleMutationVariables>;

/**
 * __useUpdateHolidayScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateHolidayScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHolidayScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHolidayScheduleMutation, { data, loading, error }] = useUpdateHolidayScheduleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateHolidayScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHolidayScheduleMutation, UpdateHolidayScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHolidayScheduleMutation, UpdateHolidayScheduleMutationVariables>(UpdateHolidayScheduleDocument, options);
      }
export type UpdateHolidayScheduleMutationHookResult = ReturnType<typeof useUpdateHolidayScheduleMutation>;
export type UpdateHolidayScheduleMutationResult = Apollo.MutationResult<UpdateHolidayScheduleMutation>;
export type UpdateHolidayScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateHolidayScheduleMutation, UpdateHolidayScheduleMutationVariables>;
export const UpsertHolidayScheduleBehaviorDocument = gql`
    mutation upsertHolidayScheduleBehavior($courierId: ID!, $courierHolidayId: ID!, $holidayScheduleId: ID!, $holidayBehavior: HolidayBehavior!) {
  upsertHolidayScheduleBehavior(
    courierId: $courierId
    courierHolidayId: $courierHolidayId
    holidayScheduleId: $holidayScheduleId
    holidayBehavior: $holidayBehavior
  )
}
    `;
export type UpsertHolidayScheduleBehaviorMutationFn = Apollo.MutationFunction<UpsertHolidayScheduleBehaviorMutation, UpsertHolidayScheduleBehaviorMutationVariables>;

/**
 * __useUpsertHolidayScheduleBehaviorMutation__
 *
 * To run a mutation, you first call `useUpsertHolidayScheduleBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHolidayScheduleBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHolidayScheduleBehaviorMutation, { data, loading, error }] = useUpsertHolidayScheduleBehaviorMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      courierHolidayId: // value for 'courierHolidayId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *      holidayBehavior: // value for 'holidayBehavior'
 *   },
 * });
 */
export function useUpsertHolidayScheduleBehaviorMutation(baseOptions?: Apollo.MutationHookOptions<UpsertHolidayScheduleBehaviorMutation, UpsertHolidayScheduleBehaviorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertHolidayScheduleBehaviorMutation, UpsertHolidayScheduleBehaviorMutationVariables>(UpsertHolidayScheduleBehaviorDocument, options);
      }
export type UpsertHolidayScheduleBehaviorMutationHookResult = ReturnType<typeof useUpsertHolidayScheduleBehaviorMutation>;
export type UpsertHolidayScheduleBehaviorMutationResult = Apollo.MutationResult<UpsertHolidayScheduleBehaviorMutation>;
export type UpsertHolidayScheduleBehaviorMutationOptions = Apollo.BaseMutationOptions<UpsertHolidayScheduleBehaviorMutation, UpsertHolidayScheduleBehaviorMutationVariables>;
export const GetCourierHolidaysDocument = gql`
    query GetCourierHolidays($courierId: ID!) {
  courierHolidays(courierId: $courierId) {
    ...CourierHolidayFragment
  }
}
    ${CourierHolidayFragmentFragmentDoc}`;

/**
 * __useGetCourierHolidaysQuery__
 *
 * To run a query within a React component, call `useGetCourierHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourierHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourierHolidaysQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetCourierHolidaysQuery(baseOptions: Apollo.QueryHookOptions<GetCourierHolidaysQuery, GetCourierHolidaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourierHolidaysQuery, GetCourierHolidaysQueryVariables>(GetCourierHolidaysDocument, options);
      }
export function useGetCourierHolidaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourierHolidaysQuery, GetCourierHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourierHolidaysQuery, GetCourierHolidaysQueryVariables>(GetCourierHolidaysDocument, options);
        }
export type GetCourierHolidaysQueryHookResult = ReturnType<typeof useGetCourierHolidaysQuery>;
export type GetCourierHolidaysLazyQueryHookResult = ReturnType<typeof useGetCourierHolidaysLazyQuery>;
export type GetCourierHolidaysQueryResult = Apollo.QueryResult<GetCourierHolidaysQuery, GetCourierHolidaysQueryVariables>;
export const GetHolidaySchedulesDocument = gql`
    query GetHolidaySchedules($courierId: ID!) {
  holidaySchedules(courierId: $courierId) {
    ...HolidayScheduleFragment
  }
}
    ${HolidayScheduleFragmentFragmentDoc}`;

/**
 * __useGetHolidaySchedulesQuery__
 *
 * To run a query within a React component, call `useGetHolidaySchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidaySchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidaySchedulesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetHolidaySchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetHolidaySchedulesQuery, GetHolidaySchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHolidaySchedulesQuery, GetHolidaySchedulesQueryVariables>(GetHolidaySchedulesDocument, options);
      }
export function useGetHolidaySchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHolidaySchedulesQuery, GetHolidaySchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHolidaySchedulesQuery, GetHolidaySchedulesQueryVariables>(GetHolidaySchedulesDocument, options);
        }
export type GetHolidaySchedulesQueryHookResult = ReturnType<typeof useGetHolidaySchedulesQuery>;
export type GetHolidaySchedulesLazyQueryHookResult = ReturnType<typeof useGetHolidaySchedulesLazyQuery>;
export type GetHolidaySchedulesQueryResult = Apollo.QueryResult<GetHolidaySchedulesQuery, GetHolidaySchedulesQueryVariables>;
export const GetHolidayScheduleBehaviorsDocument = gql`
    query GetHolidayScheduleBehaviors($courierId: ID!, $holidayScheduleId: ID!) {
  holidayScheduleBehaviors(
    courierId: $courierId
    holidayScheduleId: $holidayScheduleId
  ) {
    ...HolidayScheduleBehaviorFragment
  }
}
    ${HolidayScheduleBehaviorFragmentFragmentDoc}`;

/**
 * __useGetHolidayScheduleBehaviorsQuery__
 *
 * To run a query within a React component, call `useGetHolidayScheduleBehaviorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHolidayScheduleBehaviorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHolidayScheduleBehaviorsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      holidayScheduleId: // value for 'holidayScheduleId'
 *   },
 * });
 */
export function useGetHolidayScheduleBehaviorsQuery(baseOptions: Apollo.QueryHookOptions<GetHolidayScheduleBehaviorsQuery, GetHolidayScheduleBehaviorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHolidayScheduleBehaviorsQuery, GetHolidayScheduleBehaviorsQueryVariables>(GetHolidayScheduleBehaviorsDocument, options);
      }
export function useGetHolidayScheduleBehaviorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHolidayScheduleBehaviorsQuery, GetHolidayScheduleBehaviorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHolidayScheduleBehaviorsQuery, GetHolidayScheduleBehaviorsQueryVariables>(GetHolidayScheduleBehaviorsDocument, options);
        }
export type GetHolidayScheduleBehaviorsQueryHookResult = ReturnType<typeof useGetHolidayScheduleBehaviorsQuery>;
export type GetHolidayScheduleBehaviorsLazyQueryHookResult = ReturnType<typeof useGetHolidayScheduleBehaviorsLazyQuery>;
export type GetHolidayScheduleBehaviorsQueryResult = Apollo.QueryResult<GetHolidayScheduleBehaviorsQuery, GetHolidayScheduleBehaviorsQueryVariables>;
export const ApproveInvoiceDocument = gql`
    mutation approveInvoice($invoiceId: ID!) {
  approveInvoice(invoiceId: $invoiceId) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type ApproveInvoiceMutationFn = Apollo.MutationFunction<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>;

/**
 * __useApproveInvoiceMutation__
 *
 * To run a mutation, you first call `useApproveInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveInvoiceMutation, { data, loading, error }] = useApproveInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useApproveInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>(ApproveInvoiceDocument, options);
      }
export type ApproveInvoiceMutationHookResult = ReturnType<typeof useApproveInvoiceMutation>;
export type ApproveInvoiceMutationResult = Apollo.MutationResult<ApproveInvoiceMutation>;
export type ApproveInvoiceMutationOptions = Apollo.BaseMutationOptions<ApproveInvoiceMutation, ApproveInvoiceMutationVariables>;
export const ApproveInvoicesDocument = gql`
    mutation approveInvoices($courierId: ID!, $invoiceIds: [ID!]!) {
  approveInvoices(courierId: $courierId, invoiceIds: $invoiceIds) {
    approved {
      ...InvoiceFragment
    }
    failures {
      invoiceId
      message
    }
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type ApproveInvoicesMutationFn = Apollo.MutationFunction<ApproveInvoicesMutation, ApproveInvoicesMutationVariables>;

/**
 * __useApproveInvoicesMutation__
 *
 * To run a mutation, you first call `useApproveInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveInvoicesMutation, { data, loading, error }] = useApproveInvoicesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useApproveInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<ApproveInvoicesMutation, ApproveInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveInvoicesMutation, ApproveInvoicesMutationVariables>(ApproveInvoicesDocument, options);
      }
export type ApproveInvoicesMutationHookResult = ReturnType<typeof useApproveInvoicesMutation>;
export type ApproveInvoicesMutationResult = Apollo.MutationResult<ApproveInvoicesMutation>;
export type ApproveInvoicesMutationOptions = Apollo.BaseMutationOptions<ApproveInvoicesMutation, ApproveInvoicesMutationVariables>;
export const ForceGenerateInvoicesDocument = gql`
    mutation ForceGenerateInvoices($courierId: String!, $startDate: Date!, $endDate: Date!, $endCustomerIdsFilter: [String]) {
  forceGenerateInvoices(
    courierId: $courierId
    startDate: $startDate
    endDate: $endDate
    endCustomerIdsFilter: $endCustomerIdsFilter
  ) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type ForceGenerateInvoicesMutationFn = Apollo.MutationFunction<ForceGenerateInvoicesMutation, ForceGenerateInvoicesMutationVariables>;

/**
 * __useForceGenerateInvoicesMutation__
 *
 * To run a mutation, you first call `useForceGenerateInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceGenerateInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceGenerateInvoicesMutation, { data, loading, error }] = useForceGenerateInvoicesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *   },
 * });
 */
export function useForceGenerateInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<ForceGenerateInvoicesMutation, ForceGenerateInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceGenerateInvoicesMutation, ForceGenerateInvoicesMutationVariables>(ForceGenerateInvoicesDocument, options);
      }
export type ForceGenerateInvoicesMutationHookResult = ReturnType<typeof useForceGenerateInvoicesMutation>;
export type ForceGenerateInvoicesMutationResult = Apollo.MutationResult<ForceGenerateInvoicesMutation>;
export type ForceGenerateInvoicesMutationOptions = Apollo.BaseMutationOptions<ForceGenerateInvoicesMutation, ForceGenerateInvoicesMutationVariables>;
export const VoidInvoicesDocument = gql`
    mutation voidInvoices($invoiceIds: [ID!]!) {
  voidInvoices(invoiceIds: $invoiceIds) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type VoidInvoicesMutationFn = Apollo.MutationFunction<VoidInvoicesMutation, VoidInvoicesMutationVariables>;

/**
 * __useVoidInvoicesMutation__
 *
 * To run a mutation, you first call `useVoidInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidInvoicesMutation, { data, loading, error }] = useVoidInvoicesMutation({
 *   variables: {
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useVoidInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<VoidInvoicesMutation, VoidInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidInvoicesMutation, VoidInvoicesMutationVariables>(VoidInvoicesDocument, options);
      }
export type VoidInvoicesMutationHookResult = ReturnType<typeof useVoidInvoicesMutation>;
export type VoidInvoicesMutationResult = Apollo.MutationResult<VoidInvoicesMutation>;
export type VoidInvoicesMutationOptions = Apollo.BaseMutationOptions<VoidInvoicesMutation, VoidInvoicesMutationVariables>;
export const GenerateCsvForInvoicesDocument = gql`
    mutation generateCsvForInvoices($courierId: String!, $invoiceIds: [ID!]!) {
  generateCsvForInvoices(courierId: $courierId, invoiceIds: $invoiceIds)
}
    `;
export type GenerateCsvForInvoicesMutationFn = Apollo.MutationFunction<GenerateCsvForInvoicesMutation, GenerateCsvForInvoicesMutationVariables>;

/**
 * __useGenerateCsvForInvoicesMutation__
 *
 * To run a mutation, you first call `useGenerateCsvForInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCsvForInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCsvForInvoicesMutation, { data, loading, error }] = useGenerateCsvForInvoicesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useGenerateCsvForInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCsvForInvoicesMutation, GenerateCsvForInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCsvForInvoicesMutation, GenerateCsvForInvoicesMutationVariables>(GenerateCsvForInvoicesDocument, options);
      }
export type GenerateCsvForInvoicesMutationHookResult = ReturnType<typeof useGenerateCsvForInvoicesMutation>;
export type GenerateCsvForInvoicesMutationResult = Apollo.MutationResult<GenerateCsvForInvoicesMutation>;
export type GenerateCsvForInvoicesMutationOptions = Apollo.BaseMutationOptions<GenerateCsvForInvoicesMutation, GenerateCsvForInvoicesMutationVariables>;
export const MarkInvoiceAsPaidManuallyDocument = gql`
    mutation markInvoiceAsPaidManually($courierId: ID!, $invoiceIds: [ID!]!, $markedBy: String!) {
  markInvoiceAsPaidManually(
    courierId: $courierId
    invoiceIds: $invoiceIds
    markedBy: $markedBy
  ) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type MarkInvoiceAsPaidManuallyMutationFn = Apollo.MutationFunction<MarkInvoiceAsPaidManuallyMutation, MarkInvoiceAsPaidManuallyMutationVariables>;

/**
 * __useMarkInvoiceAsPaidManuallyMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsPaidManuallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsPaidManuallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsPaidManuallyMutation, { data, loading, error }] = useMarkInvoiceAsPaidManuallyMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *      markedBy: // value for 'markedBy'
 *   },
 * });
 */
export function useMarkInvoiceAsPaidManuallyMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsPaidManuallyMutation, MarkInvoiceAsPaidManuallyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsPaidManuallyMutation, MarkInvoiceAsPaidManuallyMutationVariables>(MarkInvoiceAsPaidManuallyDocument, options);
      }
export type MarkInvoiceAsPaidManuallyMutationHookResult = ReturnType<typeof useMarkInvoiceAsPaidManuallyMutation>;
export type MarkInvoiceAsPaidManuallyMutationResult = Apollo.MutationResult<MarkInvoiceAsPaidManuallyMutation>;
export type MarkInvoiceAsPaidManuallyMutationOptions = Apollo.BaseMutationOptions<MarkInvoiceAsPaidManuallyMutation, MarkInvoiceAsPaidManuallyMutationVariables>;
export const GeneratePdfForInvoiceDocument = gql`
    mutation generatePdfForInvoice($courierId: String!, $invoiceId: ID!) {
  generatePdfForInvoice(courierId: $courierId, invoiceId: $invoiceId) {
    ...InvoiceDocumentFragment
  }
}
    ${InvoiceDocumentFragmentFragmentDoc}`;
export type GeneratePdfForInvoiceMutationFn = Apollo.MutationFunction<GeneratePdfForInvoiceMutation, GeneratePdfForInvoiceMutationVariables>;

/**
 * __useGeneratePdfForInvoiceMutation__
 *
 * To run a mutation, you first call `useGeneratePdfForInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePdfForInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePdfForInvoiceMutation, { data, loading, error }] = useGeneratePdfForInvoiceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGeneratePdfForInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePdfForInvoiceMutation, GeneratePdfForInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePdfForInvoiceMutation, GeneratePdfForInvoiceMutationVariables>(GeneratePdfForInvoiceDocument, options);
      }
export type GeneratePdfForInvoiceMutationHookResult = ReturnType<typeof useGeneratePdfForInvoiceMutation>;
export type GeneratePdfForInvoiceMutationResult = Apollo.MutationResult<GeneratePdfForInvoiceMutation>;
export type GeneratePdfForInvoiceMutationOptions = Apollo.BaseMutationOptions<GeneratePdfForInvoiceMutation, GeneratePdfForInvoiceMutationVariables>;
export const PreviewInvoicePdfFromCreateDocument = gql`
    mutation previewInvoicePdfFromCreate($courierId: ID!, $template: InvoicePdfTemplateCreateInput!) {
  previewInvoicePdfFromCreate(courierId: $courierId, template: $template) {
    ...InvoiceDocumentFragment
  }
}
    ${InvoiceDocumentFragmentFragmentDoc}`;
export type PreviewInvoicePdfFromCreateMutationFn = Apollo.MutationFunction<PreviewInvoicePdfFromCreateMutation, PreviewInvoicePdfFromCreateMutationVariables>;

/**
 * __usePreviewInvoicePdfFromCreateMutation__
 *
 * To run a mutation, you first call `usePreviewInvoicePdfFromCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewInvoicePdfFromCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewInvoicePdfFromCreateMutation, { data, loading, error }] = usePreviewInvoicePdfFromCreateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      template: // value for 'template'
 *   },
 * });
 */
export function usePreviewInvoicePdfFromCreateMutation(baseOptions?: Apollo.MutationHookOptions<PreviewInvoicePdfFromCreateMutation, PreviewInvoicePdfFromCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewInvoicePdfFromCreateMutation, PreviewInvoicePdfFromCreateMutationVariables>(PreviewInvoicePdfFromCreateDocument, options);
      }
export type PreviewInvoicePdfFromCreateMutationHookResult = ReturnType<typeof usePreviewInvoicePdfFromCreateMutation>;
export type PreviewInvoicePdfFromCreateMutationResult = Apollo.MutationResult<PreviewInvoicePdfFromCreateMutation>;
export type PreviewInvoicePdfFromCreateMutationOptions = Apollo.BaseMutationOptions<PreviewInvoicePdfFromCreateMutation, PreviewInvoicePdfFromCreateMutationVariables>;
export const PreviewInvoicePdfFromUpdateDocument = gql`
    mutation previewInvoicePdfFromUpdate($courierId: ID!, $template: InvoicePdfTemplateUpdateInput!) {
  previewInvoicePdfFromUpdate(courierId: $courierId, template: $template) {
    ...InvoiceDocumentFragment
  }
}
    ${InvoiceDocumentFragmentFragmentDoc}`;
export type PreviewInvoicePdfFromUpdateMutationFn = Apollo.MutationFunction<PreviewInvoicePdfFromUpdateMutation, PreviewInvoicePdfFromUpdateMutationVariables>;

/**
 * __usePreviewInvoicePdfFromUpdateMutation__
 *
 * To run a mutation, you first call `usePreviewInvoicePdfFromUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewInvoicePdfFromUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewInvoicePdfFromUpdateMutation, { data, loading, error }] = usePreviewInvoicePdfFromUpdateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      template: // value for 'template'
 *   },
 * });
 */
export function usePreviewInvoicePdfFromUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PreviewInvoicePdfFromUpdateMutation, PreviewInvoicePdfFromUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewInvoicePdfFromUpdateMutation, PreviewInvoicePdfFromUpdateMutationVariables>(PreviewInvoicePdfFromUpdateDocument, options);
      }
export type PreviewInvoicePdfFromUpdateMutationHookResult = ReturnType<typeof usePreviewInvoicePdfFromUpdateMutation>;
export type PreviewInvoicePdfFromUpdateMutationResult = Apollo.MutationResult<PreviewInvoicePdfFromUpdateMutation>;
export type PreviewInvoicePdfFromUpdateMutationOptions = Apollo.BaseMutationOptions<PreviewInvoicePdfFromUpdateMutation, PreviewInvoicePdfFromUpdateMutationVariables>;
export const CreateInvoicePdfTemplateDocument = gql`
    mutation createInvoicePdfTemplate($courierId: ID!, $input: InvoicePdfTemplateCreateInput!, $updatedBy: String!) {
  createInvoicePdfTemplate(
    courierId: $courierId
    input: $input
    updatedBy: $updatedBy
  ) {
    ...InvoicePdfTemplateFragment
  }
}
    ${InvoicePdfTemplateFragmentFragmentDoc}`;
export type CreateInvoicePdfTemplateMutationFn = Apollo.MutationFunction<CreateInvoicePdfTemplateMutation, CreateInvoicePdfTemplateMutationVariables>;

/**
 * __useCreateInvoicePdfTemplateMutation__
 *
 * To run a mutation, you first call `useCreateInvoicePdfTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoicePdfTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoicePdfTemplateMutation, { data, loading, error }] = useCreateInvoicePdfTemplateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      input: // value for 'input'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useCreateInvoicePdfTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoicePdfTemplateMutation, CreateInvoicePdfTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoicePdfTemplateMutation, CreateInvoicePdfTemplateMutationVariables>(CreateInvoicePdfTemplateDocument, options);
      }
export type CreateInvoicePdfTemplateMutationHookResult = ReturnType<typeof useCreateInvoicePdfTemplateMutation>;
export type CreateInvoicePdfTemplateMutationResult = Apollo.MutationResult<CreateInvoicePdfTemplateMutation>;
export type CreateInvoicePdfTemplateMutationOptions = Apollo.BaseMutationOptions<CreateInvoicePdfTemplateMutation, CreateInvoicePdfTemplateMutationVariables>;
export const FullUpdateInvoicePdfTemplateDocument = gql`
    mutation fullUpdateInvoicePdfTemplate($courierId: ID!, $input: InvoicePdfTemplateUpdateInput!, $updatedBy: String!) {
  fullUpdateInvoicePdfTemplate(
    courierId: $courierId
    input: $input
    updatedBy: $updatedBy
  ) {
    ...InvoicePdfTemplateFragment
  }
}
    ${InvoicePdfTemplateFragmentFragmentDoc}`;
export type FullUpdateInvoicePdfTemplateMutationFn = Apollo.MutationFunction<FullUpdateInvoicePdfTemplateMutation, FullUpdateInvoicePdfTemplateMutationVariables>;

/**
 * __useFullUpdateInvoicePdfTemplateMutation__
 *
 * To run a mutation, you first call `useFullUpdateInvoicePdfTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateInvoicePdfTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateInvoicePdfTemplateMutation, { data, loading, error }] = useFullUpdateInvoicePdfTemplateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      input: // value for 'input'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useFullUpdateInvoicePdfTemplateMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateInvoicePdfTemplateMutation, FullUpdateInvoicePdfTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateInvoicePdfTemplateMutation, FullUpdateInvoicePdfTemplateMutationVariables>(FullUpdateInvoicePdfTemplateDocument, options);
      }
export type FullUpdateInvoicePdfTemplateMutationHookResult = ReturnType<typeof useFullUpdateInvoicePdfTemplateMutation>;
export type FullUpdateInvoicePdfTemplateMutationResult = Apollo.MutationResult<FullUpdateInvoicePdfTemplateMutation>;
export type FullUpdateInvoicePdfTemplateMutationOptions = Apollo.BaseMutationOptions<FullUpdateInvoicePdfTemplateMutation, FullUpdateInvoicePdfTemplateMutationVariables>;
export const DeleteInvoicePdfTemplateDocument = gql`
    mutation deleteInvoicePdfTemplate($courierId: ID!, $invoicePdfTemplateId: ID!, $deletedBy: String!) {
  deleteInvoicePdfTemplate(
    courierId: $courierId
    invoicePdfTemplateId: $invoicePdfTemplateId
    deletedBy: $deletedBy
  )
}
    `;
export type DeleteInvoicePdfTemplateMutationFn = Apollo.MutationFunction<DeleteInvoicePdfTemplateMutation, DeleteInvoicePdfTemplateMutationVariables>;

/**
 * __useDeleteInvoicePdfTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteInvoicePdfTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoicePdfTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoicePdfTemplateMutation, { data, loading, error }] = useDeleteInvoicePdfTemplateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoicePdfTemplateId: // value for 'invoicePdfTemplateId'
 *      deletedBy: // value for 'deletedBy'
 *   },
 * });
 */
export function useDeleteInvoicePdfTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvoicePdfTemplateMutation, DeleteInvoicePdfTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvoicePdfTemplateMutation, DeleteInvoicePdfTemplateMutationVariables>(DeleteInvoicePdfTemplateDocument, options);
      }
export type DeleteInvoicePdfTemplateMutationHookResult = ReturnType<typeof useDeleteInvoicePdfTemplateMutation>;
export type DeleteInvoicePdfTemplateMutationResult = Apollo.MutationResult<DeleteInvoicePdfTemplateMutation>;
export type DeleteInvoicePdfTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteInvoicePdfTemplateMutation, DeleteInvoicePdfTemplateMutationVariables>;
export const MarkInvoicePdfTemplateAsDefaultDocument = gql`
    mutation markInvoicePdfTemplateAsDefault($courierId: ID!, $invoicePdfTemplateId: ID!, $updatedBy: String!) {
  markInvoicePdfTemplateAsDefault(
    courierId: $courierId
    invoicePdfTemplateId: $invoicePdfTemplateId
    updatedBy: $updatedBy
  ) {
    ...InvoicePdfTemplateFragment
  }
}
    ${InvoicePdfTemplateFragmentFragmentDoc}`;
export type MarkInvoicePdfTemplateAsDefaultMutationFn = Apollo.MutationFunction<MarkInvoicePdfTemplateAsDefaultMutation, MarkInvoicePdfTemplateAsDefaultMutationVariables>;

/**
 * __useMarkInvoicePdfTemplateAsDefaultMutation__
 *
 * To run a mutation, you first call `useMarkInvoicePdfTemplateAsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoicePdfTemplateAsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoicePdfTemplateAsDefaultMutation, { data, loading, error }] = useMarkInvoicePdfTemplateAsDefaultMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoicePdfTemplateId: // value for 'invoicePdfTemplateId'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useMarkInvoicePdfTemplateAsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoicePdfTemplateAsDefaultMutation, MarkInvoicePdfTemplateAsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoicePdfTemplateAsDefaultMutation, MarkInvoicePdfTemplateAsDefaultMutationVariables>(MarkInvoicePdfTemplateAsDefaultDocument, options);
      }
export type MarkInvoicePdfTemplateAsDefaultMutationHookResult = ReturnType<typeof useMarkInvoicePdfTemplateAsDefaultMutation>;
export type MarkInvoicePdfTemplateAsDefaultMutationResult = Apollo.MutationResult<MarkInvoicePdfTemplateAsDefaultMutation>;
export type MarkInvoicePdfTemplateAsDefaultMutationOptions = Apollo.BaseMutationOptions<MarkInvoicePdfTemplateAsDefaultMutation, MarkInvoicePdfTemplateAsDefaultMutationVariables>;
export const GetInvoicesPaginatedDocument = gql`
    query GetInvoicesPaginated($courierId: String!, $endCustomerIds: [String], $costCenterIds: [String], $minEndDate: Date, $maxEndDate: Date, $invoicingFrequency: [InvoicingFrequency], $statuses: [InvoiceStatus], $limit: Int, $after: Int, $sortFields: [InvoiceSorting!], $paymentStatuses: [InvoicePaymentStatus]) {
  invoicesPaginated(
    courierId: $courierId
    endCustomerIds: $endCustomerIds
    costCenterIds: $costCenterIds
    minEndDate: $minEndDate
    maxEndDate: $maxEndDate
    invoicingFrequency: $invoicingFrequency
    statuses: $statuses
    paymentStatuses: $paymentStatuses
    limit: $limit
    after: $after
    sortFields: $sortFields
  ) {
    edges {
      node {
        ...InvoiceFragment
        remoteEntities {
          ...RemoteEntityFragment
        }
        endCustomer {
          ...EndCustomerFragment
        }
        costCenter {
          ...CostCenterFragment
        }
        communications {
          ...EndCustomerCommunicationFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${InvoiceFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${EndCustomerCommunicationFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetInvoicesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetInvoicesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *      costCenterIds: // value for 'costCenterIds'
 *      minEndDate: // value for 'minEndDate'
 *      maxEndDate: // value for 'maxEndDate'
 *      invoicingFrequency: // value for 'invoicingFrequency'
 *      statuses: // value for 'statuses'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *      paymentStatuses: // value for 'paymentStatuses'
 *   },
 * });
 */
export function useGetInvoicesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesPaginatedQuery, GetInvoicesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesPaginatedQuery, GetInvoicesPaginatedQueryVariables>(GetInvoicesPaginatedDocument, options);
      }
export function useGetInvoicesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesPaginatedQuery, GetInvoicesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesPaginatedQuery, GetInvoicesPaginatedQueryVariables>(GetInvoicesPaginatedDocument, options);
        }
export type GetInvoicesPaginatedQueryHookResult = ReturnType<typeof useGetInvoicesPaginatedQuery>;
export type GetInvoicesPaginatedLazyQueryHookResult = ReturnType<typeof useGetInvoicesPaginatedLazyQuery>;
export type GetInvoicesPaginatedQueryResult = Apollo.QueryResult<GetInvoicesPaginatedQuery, GetInvoicesPaginatedQueryVariables>;
export const GetInvoiceExtendedDetailDocument = gql`
    query GetInvoiceExtendedDetail($invoiceId: ID!) {
  invoiceExtendedDetail(invoiceId: $invoiceId) {
    amountTotal
    invoice {
      ...InvoiceFragment
      remoteEntities {
        ...RemoteEntityFragment
      }
      endCustomer {
        ...EndCustomerFragment
      }
      costCenter {
        ...CostCenterFragment
      }
    }
    shipments {
      ...ShipmentFragment
      artifacts {
        ...ArtifactFragment
      }
      order {
        ...OrderFragment
        endCustomer {
          ...EndCustomerFragment
        }
        price {
          ...OrderPriceFragment
        }
      }
    }
  }
}
    ${InvoiceFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${ArtifactFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${OrderPriceFragmentFragmentDoc}`;

/**
 * __useGetInvoiceExtendedDetailQuery__
 *
 * To run a query within a React component, call `useGetInvoiceExtendedDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceExtendedDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceExtendedDetailQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoiceExtendedDetailQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceExtendedDetailQuery, GetInvoiceExtendedDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceExtendedDetailQuery, GetInvoiceExtendedDetailQueryVariables>(GetInvoiceExtendedDetailDocument, options);
      }
export function useGetInvoiceExtendedDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceExtendedDetailQuery, GetInvoiceExtendedDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceExtendedDetailQuery, GetInvoiceExtendedDetailQueryVariables>(GetInvoiceExtendedDetailDocument, options);
        }
export type GetInvoiceExtendedDetailQueryHookResult = ReturnType<typeof useGetInvoiceExtendedDetailQuery>;
export type GetInvoiceExtendedDetailLazyQueryHookResult = ReturnType<typeof useGetInvoiceExtendedDetailLazyQuery>;
export type GetInvoiceExtendedDetailQueryResult = Apollo.QueryResult<GetInvoiceExtendedDetailQuery, GetInvoiceExtendedDetailQueryVariables>;
export const InvoicesOverviewDocument = gql`
    query InvoicesOverview($courierId: String!) {
  invoicesOverview(courierId: $courierId) {
    numToReview
    numUnpaid
    numPaymentProcessing
    numPartialPaid
  }
}
    `;

/**
 * __useInvoicesOverviewQuery__
 *
 * To run a query within a React component, call `useInvoicesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesOverviewQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useInvoicesOverviewQuery(baseOptions: Apollo.QueryHookOptions<InvoicesOverviewQuery, InvoicesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesOverviewQuery, InvoicesOverviewQueryVariables>(InvoicesOverviewDocument, options);
      }
export function useInvoicesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesOverviewQuery, InvoicesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesOverviewQuery, InvoicesOverviewQueryVariables>(InvoicesOverviewDocument, options);
        }
export type InvoicesOverviewQueryHookResult = ReturnType<typeof useInvoicesOverviewQuery>;
export type InvoicesOverviewLazyQueryHookResult = ReturnType<typeof useInvoicesOverviewLazyQuery>;
export type InvoicesOverviewQueryResult = Apollo.QueryResult<InvoicesOverviewQuery, InvoicesOverviewQueryVariables>;
export const GetInvoicePdfTemplatesPaginatedDocument = gql`
    query GetInvoicePdfTemplatesPaginated($courierId: String!, $limit: Int, $after: Int) {
  invoicePdfTemplatesPaginated(
    courierId: $courierId
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...InvoicePdfTemplateFragment
        subtotalGroupedByCustomField {
          ...CustomFieldFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${InvoicePdfTemplateFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetInvoicePdfTemplatesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetInvoicePdfTemplatesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePdfTemplatesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePdfTemplatesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetInvoicePdfTemplatesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePdfTemplatesPaginatedQuery, GetInvoicePdfTemplatesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePdfTemplatesPaginatedQuery, GetInvoicePdfTemplatesPaginatedQueryVariables>(GetInvoicePdfTemplatesPaginatedDocument, options);
      }
export function useGetInvoicePdfTemplatesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePdfTemplatesPaginatedQuery, GetInvoicePdfTemplatesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePdfTemplatesPaginatedQuery, GetInvoicePdfTemplatesPaginatedQueryVariables>(GetInvoicePdfTemplatesPaginatedDocument, options);
        }
export type GetInvoicePdfTemplatesPaginatedQueryHookResult = ReturnType<typeof useGetInvoicePdfTemplatesPaginatedQuery>;
export type GetInvoicePdfTemplatesPaginatedLazyQueryHookResult = ReturnType<typeof useGetInvoicePdfTemplatesPaginatedLazyQuery>;
export type GetInvoicePdfTemplatesPaginatedQueryResult = Apollo.QueryResult<GetInvoicePdfTemplatesPaginatedQuery, GetInvoicePdfTemplatesPaginatedQueryVariables>;
export const GetInvoicePdfTemplateSkeletonDocument = gql`
    query GetInvoicePdfTemplateSkeleton($courierId: String!) {
  getInvoicePdfTemplateSkeleton(courierId: $courierId) {
    ...InvoicePdfTemplateFragment
    subtotalGroupedByCustomField {
      ...CustomFieldFragment
    }
  }
}
    ${InvoicePdfTemplateFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}`;

/**
 * __useGetInvoicePdfTemplateSkeletonQuery__
 *
 * To run a query within a React component, call `useGetInvoicePdfTemplateSkeletonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePdfTemplateSkeletonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePdfTemplateSkeletonQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetInvoicePdfTemplateSkeletonQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePdfTemplateSkeletonQuery, GetInvoicePdfTemplateSkeletonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePdfTemplateSkeletonQuery, GetInvoicePdfTemplateSkeletonQueryVariables>(GetInvoicePdfTemplateSkeletonDocument, options);
      }
export function useGetInvoicePdfTemplateSkeletonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePdfTemplateSkeletonQuery, GetInvoicePdfTemplateSkeletonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePdfTemplateSkeletonQuery, GetInvoicePdfTemplateSkeletonQueryVariables>(GetInvoicePdfTemplateSkeletonDocument, options);
        }
export type GetInvoicePdfTemplateSkeletonQueryHookResult = ReturnType<typeof useGetInvoicePdfTemplateSkeletonQuery>;
export type GetInvoicePdfTemplateSkeletonLazyQueryHookResult = ReturnType<typeof useGetInvoicePdfTemplateSkeletonLazyQuery>;
export type GetInvoicePdfTemplateSkeletonQueryResult = Apollo.QueryResult<GetInvoicePdfTemplateSkeletonQuery, GetInvoicePdfTemplateSkeletonQueryVariables>;
export const InitiateInvoicePaymentDocument = gql`
    mutation InitiateInvoicePayment($courierId: ID!, $invoiceId: ID!, $paymentInstrumentId: ID!, $amount: Money!, $idempotencyToken: String!, $fraudSessionId: String, $createdBy: String!, $emailRecipients: [String!]!) {
  initiateInvoicePayment(
    courierId: $courierId
    invoiceId: $invoiceId
    paymentInstrumentId: $paymentInstrumentId
    amount: $amount
    idempotencyToken: $idempotencyToken
    fraudSessionId: $fraudSessionId
    createdBy: $createdBy
    emailRecipients: $emailRecipients
  ) {
    id
    courierId
    invoiceId
    paymentTransferId
    allocatedAmount
    invoice {
      ...InvoiceFragment
    }
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InitiateInvoicePaymentMutationFn = Apollo.MutationFunction<InitiateInvoicePaymentMutation, InitiateInvoicePaymentMutationVariables>;

/**
 * __useInitiateInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useInitiateInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateInvoicePaymentMutation, { data, loading, error }] = useInitiateInvoicePaymentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceId: // value for 'invoiceId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      amount: // value for 'amount'
 *      idempotencyToken: // value for 'idempotencyToken'
 *      fraudSessionId: // value for 'fraudSessionId'
 *      createdBy: // value for 'createdBy'
 *      emailRecipients: // value for 'emailRecipients'
 *   },
 * });
 */
export function useInitiateInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitiateInvoicePaymentMutation, InitiateInvoicePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateInvoicePaymentMutation, InitiateInvoicePaymentMutationVariables>(InitiateInvoicePaymentDocument, options);
      }
export type InitiateInvoicePaymentMutationHookResult = ReturnType<typeof useInitiateInvoicePaymentMutation>;
export type InitiateInvoicePaymentMutationResult = Apollo.MutationResult<InitiateInvoicePaymentMutation>;
export type InitiateInvoicePaymentMutationOptions = Apollo.BaseMutationOptions<InitiateInvoicePaymentMutation, InitiateInvoicePaymentMutationVariables>;
export const InvoiceBalancesDocument = gql`
    query InvoiceBalances($courierId: ID!, $invoiceIds: [ID!]!) {
  invoiceBalances(courierId: $courierId, invoiceIds: $invoiceIds) {
    invoiceId
    remainingBalance
  }
}
    `;

/**
 * __useInvoiceBalancesQuery__
 *
 * To run a query within a React component, call `useInvoiceBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceBalancesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useInvoiceBalancesQuery(baseOptions: Apollo.QueryHookOptions<InvoiceBalancesQuery, InvoiceBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceBalancesQuery, InvoiceBalancesQueryVariables>(InvoiceBalancesDocument, options);
      }
export function useInvoiceBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceBalancesQuery, InvoiceBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceBalancesQuery, InvoiceBalancesQueryVariables>(InvoiceBalancesDocument, options);
        }
export type InvoiceBalancesQueryHookResult = ReturnType<typeof useInvoiceBalancesQuery>;
export type InvoiceBalancesLazyQueryHookResult = ReturnType<typeof useInvoiceBalancesLazyQuery>;
export type InvoiceBalancesQueryResult = Apollo.QueryResult<InvoiceBalancesQuery, InvoiceBalancesQueryVariables>;
export const UpsertLinkedAccountDocument = gql`
    mutation UpsertLinkedAccount($courierId: ID!, $remoteId: String!, $provider: ApiProvider!, $refreshToken: String, $accessToken: String!, $accessTokenExpiresInSeconds: Int, $refreshTokenExpiresInSeconds: Int) {
  upsertLinkedAccount(
    linkedAccountCreate: {courierId: $courierId, remoteId: $remoteId, provider: $provider, refreshToken: $refreshToken, accessToken: $accessToken, accessTokenExpiresInSeconds: $accessTokenExpiresInSeconds, refreshTokenExpiresInSeconds: $refreshTokenExpiresInSeconds}
  ) {
    ...LinkedAccountFragment
  }
}
    ${LinkedAccountFragmentFragmentDoc}`;
export type UpsertLinkedAccountMutationFn = Apollo.MutationFunction<UpsertLinkedAccountMutation, UpsertLinkedAccountMutationVariables>;

/**
 * __useUpsertLinkedAccountMutation__
 *
 * To run a mutation, you first call `useUpsertLinkedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLinkedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLinkedAccountMutation, { data, loading, error }] = useUpsertLinkedAccountMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      remoteId: // value for 'remoteId'
 *      provider: // value for 'provider'
 *      refreshToken: // value for 'refreshToken'
 *      accessToken: // value for 'accessToken'
 *      accessTokenExpiresInSeconds: // value for 'accessTokenExpiresInSeconds'
 *      refreshTokenExpiresInSeconds: // value for 'refreshTokenExpiresInSeconds'
 *   },
 * });
 */
export function useUpsertLinkedAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLinkedAccountMutation, UpsertLinkedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLinkedAccountMutation, UpsertLinkedAccountMutationVariables>(UpsertLinkedAccountDocument, options);
      }
export type UpsertLinkedAccountMutationHookResult = ReturnType<typeof useUpsertLinkedAccountMutation>;
export type UpsertLinkedAccountMutationResult = Apollo.MutationResult<UpsertLinkedAccountMutation>;
export type UpsertLinkedAccountMutationOptions = Apollo.BaseMutationOptions<UpsertLinkedAccountMutation, UpsertLinkedAccountMutationVariables>;
export const DeleteLinkedAccountDocument = gql`
    mutation DeleteLinkedAccount($id: ID!) {
  deleteLinkedAccount(id: $id)
}
    `;
export type DeleteLinkedAccountMutationFn = Apollo.MutationFunction<DeleteLinkedAccountMutation, DeleteLinkedAccountMutationVariables>;

/**
 * __useDeleteLinkedAccountMutation__
 *
 * To run a mutation, you first call `useDeleteLinkedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLinkedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLinkedAccountMutation, { data, loading, error }] = useDeleteLinkedAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLinkedAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLinkedAccountMutation, DeleteLinkedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLinkedAccountMutation, DeleteLinkedAccountMutationVariables>(DeleteLinkedAccountDocument, options);
      }
export type DeleteLinkedAccountMutationHookResult = ReturnType<typeof useDeleteLinkedAccountMutation>;
export type DeleteLinkedAccountMutationResult = Apollo.MutationResult<DeleteLinkedAccountMutation>;
export type DeleteLinkedAccountMutationOptions = Apollo.BaseMutationOptions<DeleteLinkedAccountMutation, DeleteLinkedAccountMutationVariables>;
export const GetLinkedAccountsDocument = gql`
    query GetLinkedAccounts($courierId: ID!) {
  linkedAccounts(courierId: $courierId) {
    ...LinkedAccountFragment
    isValidAndFresh
  }
}
    ${LinkedAccountFragmentFragmentDoc}`;

/**
 * __useGetLinkedAccountsQuery__
 *
 * To run a query within a React component, call `useGetLinkedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedAccountsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetLinkedAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>(GetLinkedAccountsDocument, options);
      }
export function useGetLinkedAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>(GetLinkedAccountsDocument, options);
        }
export type GetLinkedAccountsQueryHookResult = ReturnType<typeof useGetLinkedAccountsQuery>;
export type GetLinkedAccountsLazyQueryHookResult = ReturnType<typeof useGetLinkedAccountsLazyQuery>;
export type GetLinkedAccountsQueryResult = Apollo.QueryResult<GetLinkedAccountsQuery, GetLinkedAccountsQueryVariables>;
export const LinkedAccountsDocument = gql`
    query LinkedAccounts($courierId: ID!) {
  linkedAccounts(courierId: $courierId) {
    ...LinkedAccountFragment
    isValidAndFresh
  }
}
    ${LinkedAccountFragmentFragmentDoc}`;

/**
 * __useLinkedAccountsQuery__
 *
 * To run a query within a React component, call `useLinkedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedAccountsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useLinkedAccountsQuery(baseOptions: Apollo.QueryHookOptions<LinkedAccountsQuery, LinkedAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkedAccountsQuery, LinkedAccountsQueryVariables>(LinkedAccountsDocument, options);
      }
export function useLinkedAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkedAccountsQuery, LinkedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkedAccountsQuery, LinkedAccountsQueryVariables>(LinkedAccountsDocument, options);
        }
export type LinkedAccountsQueryHookResult = ReturnType<typeof useLinkedAccountsQuery>;
export type LinkedAccountsLazyQueryHookResult = ReturnType<typeof useLinkedAccountsLazyQuery>;
export type LinkedAccountsQueryResult = Apollo.QueryResult<LinkedAccountsQuery, LinkedAccountsQueryVariables>;
export const GetOrCreateLocationsDocument = gql`
    mutation GetOrCreateLocations($googlePlaceIds: [String!]!, $courierId: ID, $targetShipmentDate: Date) {
  getOrCreateLocations(
    googlePlaceIds: $googlePlaceIds
    courierId: $courierId
    targetShipmentDate: $targetShipmentDate
  ) {
    location {
      ...LocationFragment
    }
  }
}
    ${LocationFragmentFragmentDoc}`;
export type GetOrCreateLocationsMutationFn = Apollo.MutationFunction<GetOrCreateLocationsMutation, GetOrCreateLocationsMutationVariables>;

/**
 * __useGetOrCreateLocationsMutation__
 *
 * To run a mutation, you first call `useGetOrCreateLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateLocationsMutation, { data, loading, error }] = useGetOrCreateLocationsMutation({
 *   variables: {
 *      googlePlaceIds: // value for 'googlePlaceIds'
 *      courierId: // value for 'courierId'
 *      targetShipmentDate: // value for 'targetShipmentDate'
 *   },
 * });
 */
export function useGetOrCreateLocationsMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateLocationsMutation, GetOrCreateLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateLocationsMutation, GetOrCreateLocationsMutationVariables>(GetOrCreateLocationsDocument, options);
      }
export type GetOrCreateLocationsMutationHookResult = ReturnType<typeof useGetOrCreateLocationsMutation>;
export type GetOrCreateLocationsMutationResult = Apollo.MutationResult<GetOrCreateLocationsMutation>;
export type GetOrCreateLocationsMutationOptions = Apollo.BaseMutationOptions<GetOrCreateLocationsMutation, GetOrCreateLocationsMutationVariables>;
export const GetOrCreateLocationsWithOverviewDocument = gql`
    mutation GetOrCreateLocationsWithOverview($googlePlaceIds: [String!]!) {
  getOrCreateLocationsWithOverview(googlePlaceIds: $googlePlaceIds) {
    locations {
      ...LocationFragment
    }
    totalDistanceInMiles
  }
}
    ${LocationFragmentFragmentDoc}`;
export type GetOrCreateLocationsWithOverviewMutationFn = Apollo.MutationFunction<GetOrCreateLocationsWithOverviewMutation, GetOrCreateLocationsWithOverviewMutationVariables>;

/**
 * __useGetOrCreateLocationsWithOverviewMutation__
 *
 * To run a mutation, you first call `useGetOrCreateLocationsWithOverviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateLocationsWithOverviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateLocationsWithOverviewMutation, { data, loading, error }] = useGetOrCreateLocationsWithOverviewMutation({
 *   variables: {
 *      googlePlaceIds: // value for 'googlePlaceIds'
 *   },
 * });
 */
export function useGetOrCreateLocationsWithOverviewMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateLocationsWithOverviewMutation, GetOrCreateLocationsWithOverviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateLocationsWithOverviewMutation, GetOrCreateLocationsWithOverviewMutationVariables>(GetOrCreateLocationsWithOverviewDocument, options);
      }
export type GetOrCreateLocationsWithOverviewMutationHookResult = ReturnType<typeof useGetOrCreateLocationsWithOverviewMutation>;
export type GetOrCreateLocationsWithOverviewMutationResult = Apollo.MutationResult<GetOrCreateLocationsWithOverviewMutation>;
export type GetOrCreateLocationsWithOverviewMutationOptions = Apollo.BaseMutationOptions<GetOrCreateLocationsWithOverviewMutation, GetOrCreateLocationsWithOverviewMutationVariables>;
export const GetOrCreateLocationFromCoordinateDocument = gql`
    mutation GetOrCreateLocationFromCoordinate($courierId: ID!, $lngLat: LngLatInput!, $createdBy: String!) {
  getOrCreateLocationFromCoordinate(
    courierId: $courierId
    lngLat: $lngLat
    createdBy: $createdBy
  ) {
    location {
      ...LocationFragment
    }
  }
}
    ${LocationFragmentFragmentDoc}`;
export type GetOrCreateLocationFromCoordinateMutationFn = Apollo.MutationFunction<GetOrCreateLocationFromCoordinateMutation, GetOrCreateLocationFromCoordinateMutationVariables>;

/**
 * __useGetOrCreateLocationFromCoordinateMutation__
 *
 * To run a mutation, you first call `useGetOrCreateLocationFromCoordinateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateLocationFromCoordinateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateLocationFromCoordinateMutation, { data, loading, error }] = useGetOrCreateLocationFromCoordinateMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      lngLat: // value for 'lngLat'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useGetOrCreateLocationFromCoordinateMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateLocationFromCoordinateMutation, GetOrCreateLocationFromCoordinateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateLocationFromCoordinateMutation, GetOrCreateLocationFromCoordinateMutationVariables>(GetOrCreateLocationFromCoordinateDocument, options);
      }
export type GetOrCreateLocationFromCoordinateMutationHookResult = ReturnType<typeof useGetOrCreateLocationFromCoordinateMutation>;
export type GetOrCreateLocationFromCoordinateMutationResult = Apollo.MutationResult<GetOrCreateLocationFromCoordinateMutation>;
export type GetOrCreateLocationFromCoordinateMutationOptions = Apollo.BaseMutationOptions<GetOrCreateLocationFromCoordinateMutation, GetOrCreateLocationFromCoordinateMutationVariables>;
export const FullUpdateLocationDocument = gql`
    mutation FullUpdateLocation($courierId: ID!, $id: ID!, $streetAddress: String!, $city: String!) {
  fullUpdateLocation(
    courierId: $courierId
    id: $id
    streetAddress: $streetAddress
    city: $city
  ) {
    location {
      ...LocationFragment
    }
  }
}
    ${LocationFragmentFragmentDoc}`;
export type FullUpdateLocationMutationFn = Apollo.MutationFunction<FullUpdateLocationMutation, FullUpdateLocationMutationVariables>;

/**
 * __useFullUpdateLocationMutation__
 *
 * To run a mutation, you first call `useFullUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateLocationMutation, { data, loading, error }] = useFullUpdateLocationMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      streetAddress: // value for 'streetAddress'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useFullUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateLocationMutation, FullUpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateLocationMutation, FullUpdateLocationMutationVariables>(FullUpdateLocationDocument, options);
      }
export type FullUpdateLocationMutationHookResult = ReturnType<typeof useFullUpdateLocationMutation>;
export type FullUpdateLocationMutationResult = Apollo.MutationResult<FullUpdateLocationMutation>;
export type FullUpdateLocationMutationOptions = Apollo.BaseMutationOptions<FullUpdateLocationMutation, FullUpdateLocationMutationVariables>;
export const CreateRoutingJobDocument = gql`
    mutation CreateRoutingJob($jobCreate: RoutingJobCreate!, $vehicleCreates: [RoutingVehicleCreate!]!) {
  createRoutingJob(jobCreate: $jobCreate, vehicleCreates: $vehicleCreates) {
    ...RoutingJobFragment
  }
}
    ${RoutingJobFragmentFragmentDoc}`;
export type CreateRoutingJobMutationFn = Apollo.MutationFunction<CreateRoutingJobMutation, CreateRoutingJobMutationVariables>;

/**
 * __useCreateRoutingJobMutation__
 *
 * To run a mutation, you first call `useCreateRoutingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoutingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoutingJobMutation, { data, loading, error }] = useCreateRoutingJobMutation({
 *   variables: {
 *      jobCreate: // value for 'jobCreate'
 *      vehicleCreates: // value for 'vehicleCreates'
 *   },
 * });
 */
export function useCreateRoutingJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoutingJobMutation, CreateRoutingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoutingJobMutation, CreateRoutingJobMutationVariables>(CreateRoutingJobDocument, options);
      }
export type CreateRoutingJobMutationHookResult = ReturnType<typeof useCreateRoutingJobMutation>;
export type CreateRoutingJobMutationResult = Apollo.MutationResult<CreateRoutingJobMutation>;
export type CreateRoutingJobMutationOptions = Apollo.BaseMutationOptions<CreateRoutingJobMutation, CreateRoutingJobMutationVariables>;
export const ApproveRoutingJobDocument = gql`
    mutation ApproveRoutingJob($jobId: ID!, $approvedBy: String!) {
  approveRoutingJob(jobId: $jobId, approvedBy: $approvedBy) {
    ...RoutingJobFragment
  }
}
    ${RoutingJobFragmentFragmentDoc}`;
export type ApproveRoutingJobMutationFn = Apollo.MutationFunction<ApproveRoutingJobMutation, ApproveRoutingJobMutationVariables>;

/**
 * __useApproveRoutingJobMutation__
 *
 * To run a mutation, you first call `useApproveRoutingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRoutingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRoutingJobMutation, { data, loading, error }] = useApproveRoutingJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      approvedBy: // value for 'approvedBy'
 *   },
 * });
 */
export function useApproveRoutingJobMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRoutingJobMutation, ApproveRoutingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRoutingJobMutation, ApproveRoutingJobMutationVariables>(ApproveRoutingJobDocument, options);
      }
export type ApproveRoutingJobMutationHookResult = ReturnType<typeof useApproveRoutingJobMutation>;
export type ApproveRoutingJobMutationResult = Apollo.MutationResult<ApproveRoutingJobMutation>;
export type ApproveRoutingJobMutationOptions = Apollo.BaseMutationOptions<ApproveRoutingJobMutation, ApproveRoutingJobMutationVariables>;
export const CancelRoutingJobDocument = gql`
    mutation CancelRoutingJob($jobId: ID!, $canceledBy: String!) {
  cancelRoutingJob(jobId: $jobId, canceledBy: $canceledBy) {
    ...RoutingJobFragment
  }
}
    ${RoutingJobFragmentFragmentDoc}`;
export type CancelRoutingJobMutationFn = Apollo.MutationFunction<CancelRoutingJobMutation, CancelRoutingJobMutationVariables>;

/**
 * __useCancelRoutingJobMutation__
 *
 * To run a mutation, you first call `useCancelRoutingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRoutingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRoutingJobMutation, { data, loading, error }] = useCancelRoutingJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      canceledBy: // value for 'canceledBy'
 *   },
 * });
 */
export function useCancelRoutingJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelRoutingJobMutation, CancelRoutingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRoutingJobMutation, CancelRoutingJobMutationVariables>(CancelRoutingJobDocument, options);
      }
export type CancelRoutingJobMutationHookResult = ReturnType<typeof useCancelRoutingJobMutation>;
export type CancelRoutingJobMutationResult = Apollo.MutationResult<CancelRoutingJobMutation>;
export type CancelRoutingJobMutationOptions = Apollo.BaseMutationOptions<CancelRoutingJobMutation, CancelRoutingJobMutationVariables>;
export const ReplaceRoutingVehicleSequenceDocument = gql`
    mutation ReplaceRoutingVehicleSequence($routingVehicleId: ID!, $routingNodeIds: [ID!]!) {
  replaceRoutingVehicleSequence(
    routingVehicleId: $routingVehicleId
    routingNodeIds: $routingNodeIds
  ) {
    ...RoutingNodeFragment
  }
}
    ${RoutingNodeFragmentFragmentDoc}`;
export type ReplaceRoutingVehicleSequenceMutationFn = Apollo.MutationFunction<ReplaceRoutingVehicleSequenceMutation, ReplaceRoutingVehicleSequenceMutationVariables>;

/**
 * __useReplaceRoutingVehicleSequenceMutation__
 *
 * To run a mutation, you first call `useReplaceRoutingVehicleSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceRoutingVehicleSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceRoutingVehicleSequenceMutation, { data, loading, error }] = useReplaceRoutingVehicleSequenceMutation({
 *   variables: {
 *      routingVehicleId: // value for 'routingVehicleId'
 *      routingNodeIds: // value for 'routingNodeIds'
 *   },
 * });
 */
export function useReplaceRoutingVehicleSequenceMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceRoutingVehicleSequenceMutation, ReplaceRoutingVehicleSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceRoutingVehicleSequenceMutation, ReplaceRoutingVehicleSequenceMutationVariables>(ReplaceRoutingVehicleSequenceDocument, options);
      }
export type ReplaceRoutingVehicleSequenceMutationHookResult = ReturnType<typeof useReplaceRoutingVehicleSequenceMutation>;
export type ReplaceRoutingVehicleSequenceMutationResult = Apollo.MutationResult<ReplaceRoutingVehicleSequenceMutation>;
export type ReplaceRoutingVehicleSequenceMutationOptions = Apollo.BaseMutationOptions<ReplaceRoutingVehicleSequenceMutation, ReplaceRoutingVehicleSequenceMutationVariables>;
export const TransferShipmentDocument = gql`
    mutation TransferShipment($shipmentId: ID!, $targetDriverId: ID!, $routingJobId: ID!) {
  transferShipment(
    shipmentId: $shipmentId
    targetDriverId: $targetDriverId
    routingJobId: $routingJobId
  ) {
    ...RoutingNodeFragment
  }
}
    ${RoutingNodeFragmentFragmentDoc}`;
export type TransferShipmentMutationFn = Apollo.MutationFunction<TransferShipmentMutation, TransferShipmentMutationVariables>;

/**
 * __useTransferShipmentMutation__
 *
 * To run a mutation, you first call `useTransferShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferShipmentMutation, { data, loading, error }] = useTransferShipmentMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      targetDriverId: // value for 'targetDriverId'
 *      routingJobId: // value for 'routingJobId'
 *   },
 * });
 */
export function useTransferShipmentMutation(baseOptions?: Apollo.MutationHookOptions<TransferShipmentMutation, TransferShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferShipmentMutation, TransferShipmentMutationVariables>(TransferShipmentDocument, options);
      }
export type TransferShipmentMutationHookResult = ReturnType<typeof useTransferShipmentMutation>;
export type TransferShipmentMutationResult = Apollo.MutationResult<TransferShipmentMutation>;
export type TransferShipmentMutationOptions = Apollo.BaseMutationOptions<TransferShipmentMutation, TransferShipmentMutationVariables>;
export const RoutingJobsDocument = gql`
    query RoutingJobs($courierId: ID!, $start: Int, $limit: Int) {
  routingJobs(courierId: $courierId, start: $start, limit: $limit) {
    edges {
      node {
        ...RoutingJobFragment
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${RoutingJobFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useRoutingJobsQuery__
 *
 * To run a query within a React component, call `useRoutingJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoutingJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutingJobsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRoutingJobsQuery(baseOptions: Apollo.QueryHookOptions<RoutingJobsQuery, RoutingJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoutingJobsQuery, RoutingJobsQueryVariables>(RoutingJobsDocument, options);
      }
export function useRoutingJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoutingJobsQuery, RoutingJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoutingJobsQuery, RoutingJobsQueryVariables>(RoutingJobsDocument, options);
        }
export type RoutingJobsQueryHookResult = ReturnType<typeof useRoutingJobsQuery>;
export type RoutingJobsLazyQueryHookResult = ReturnType<typeof useRoutingJobsLazyQuery>;
export type RoutingJobsQueryResult = Apollo.QueryResult<RoutingJobsQuery, RoutingJobsQueryVariables>;
export const RoutingJobByIdDocument = gql`
    query RoutingJobById($id: ID!) {
  routingJobById(id: $id) {
    ...RoutingJobFragment
    results {
      ...RoutingDayResultFragment
      vehicles {
        ...RoutingVehicleFragment
        driver {
          ...DriverFragment
          lastReportedLocation {
            ...DriverLocationFragment
          }
        }
        nodes {
          ...RoutingNodeFragment
          stop {
            ...StopFragment
            shipment {
              ...ShipmentFragment
            }
          }
        }
      }
    }
  }
}
    ${RoutingJobFragmentFragmentDoc}
${RoutingDayResultFragmentFragmentDoc}
${RoutingVehicleFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${DriverLocationFragmentFragmentDoc}
${RoutingNodeFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}`;

/**
 * __useRoutingJobByIdQuery__
 *
 * To run a query within a React component, call `useRoutingJobByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoutingJobByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoutingJobByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoutingJobByIdQuery(baseOptions: Apollo.QueryHookOptions<RoutingJobByIdQuery, RoutingJobByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoutingJobByIdQuery, RoutingJobByIdQueryVariables>(RoutingJobByIdDocument, options);
      }
export function useRoutingJobByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoutingJobByIdQuery, RoutingJobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoutingJobByIdQuery, RoutingJobByIdQueryVariables>(RoutingJobByIdDocument, options);
        }
export type RoutingJobByIdQueryHookResult = ReturnType<typeof useRoutingJobByIdQuery>;
export type RoutingJobByIdLazyQueryHookResult = ReturnType<typeof useRoutingJobByIdLazyQuery>;
export type RoutingJobByIdQueryResult = Apollo.QueryResult<RoutingJobByIdQuery, RoutingJobByIdQueryVariables>;
export const PreviewEtaForRoutingVehicleDocument = gql`
    query PreviewEtaForRoutingVehicle($routingVehicleId: ID!) {
  previewEtaForRoutingVehicle(routingVehicleId: $routingVehicleId) {
    ...RoutingNodeEtaFragment
  }
}
    ${RoutingNodeEtaFragmentFragmentDoc}`;

/**
 * __usePreviewEtaForRoutingVehicleQuery__
 *
 * To run a query within a React component, call `usePreviewEtaForRoutingVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewEtaForRoutingVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewEtaForRoutingVehicleQuery({
 *   variables: {
 *      routingVehicleId: // value for 'routingVehicleId'
 *   },
 * });
 */
export function usePreviewEtaForRoutingVehicleQuery(baseOptions: Apollo.QueryHookOptions<PreviewEtaForRoutingVehicleQuery, PreviewEtaForRoutingVehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewEtaForRoutingVehicleQuery, PreviewEtaForRoutingVehicleQueryVariables>(PreviewEtaForRoutingVehicleDocument, options);
      }
export function usePreviewEtaForRoutingVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewEtaForRoutingVehicleQuery, PreviewEtaForRoutingVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewEtaForRoutingVehicleQuery, PreviewEtaForRoutingVehicleQueryVariables>(PreviewEtaForRoutingVehicleDocument, options);
        }
export type PreviewEtaForRoutingVehicleQueryHookResult = ReturnType<typeof usePreviewEtaForRoutingVehicleQuery>;
export type PreviewEtaForRoutingVehicleLazyQueryHookResult = ReturnType<typeof usePreviewEtaForRoutingVehicleLazyQuery>;
export type PreviewEtaForRoutingVehicleQueryResult = Apollo.QueryResult<PreviewEtaForRoutingVehicleQuery, PreviewEtaForRoutingVehicleQueryVariables>;
export const CreateOrderAttachmentsDocument = gql`
    mutation CreateOrderAttachments($courierId: ID!, $orderAttachmentUploads: [OrderAttachmentCreate!]!) {
  createOrderAttachments(
    courierId: $courierId
    orderAttachmentUploads: $orderAttachmentUploads
  ) {
    ...OrderAttachmentFragment
  }
}
    ${OrderAttachmentFragmentFragmentDoc}`;
export type CreateOrderAttachmentsMutationFn = Apollo.MutationFunction<CreateOrderAttachmentsMutation, CreateOrderAttachmentsMutationVariables>;

/**
 * __useCreateOrderAttachmentsMutation__
 *
 * To run a mutation, you first call `useCreateOrderAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderAttachmentsMutation, { data, loading, error }] = useCreateOrderAttachmentsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderAttachmentUploads: // value for 'orderAttachmentUploads'
 *   },
 * });
 */
export function useCreateOrderAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderAttachmentsMutation, CreateOrderAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderAttachmentsMutation, CreateOrderAttachmentsMutationVariables>(CreateOrderAttachmentsDocument, options);
      }
export type CreateOrderAttachmentsMutationHookResult = ReturnType<typeof useCreateOrderAttachmentsMutation>;
export type CreateOrderAttachmentsMutationResult = Apollo.MutationResult<CreateOrderAttachmentsMutation>;
export type CreateOrderAttachmentsMutationOptions = Apollo.BaseMutationOptions<CreateOrderAttachmentsMutation, CreateOrderAttachmentsMutationVariables>;
export const CreateOneOffOrderDocument = gql`
    mutation createOneOffOrder($courierId: ID!, $orderTypeId: ID, $endCustomerId: ID!, $acquisitionType: OrderAcquisitionType!, $shipments: [ShipmentCreateInput!]!, $endCustomerReferenceNumber: String, $serviceTypeId: ID, $notes: String, $caller: String, $costCenterId: ID, $pricingAdjustments: [PricingAdjustmentCreate!], $createdBy: String, $customFieldValues: [CustomFieldValueInput!], $originalOrderId: ID, $additionalEmailRecipients: [String!]) {
  createOneOffOrder(
    courierId: $courierId
    orderTypeId: $orderTypeId
    endCustomerId: $endCustomerId
    acquisitionType: $acquisitionType
    shipments: $shipments
    endCustomerReferenceNumber: $endCustomerReferenceNumber
    serviceTypeId: $serviceTypeId
    notes: $notes
    caller: $caller
    costCenterId: $costCenterId
    pricingAdjustments: $pricingAdjustments
    createdBy: $createdBy
    customFieldValues: $customFieldValues
    originalOrderId: $originalOrderId
    additionalEmailRecipients: $additionalEmailRecipients
  )
}
    `;
export type CreateOneOffOrderMutationFn = Apollo.MutationFunction<CreateOneOffOrderMutation, CreateOneOffOrderMutationVariables>;

/**
 * __useCreateOneOffOrderMutation__
 *
 * To run a mutation, you first call `useCreateOneOffOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneOffOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneOffOrderMutation, { data, loading, error }] = useCreateOneOffOrderMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderTypeId: // value for 'orderTypeId'
 *      endCustomerId: // value for 'endCustomerId'
 *      acquisitionType: // value for 'acquisitionType'
 *      shipments: // value for 'shipments'
 *      endCustomerReferenceNumber: // value for 'endCustomerReferenceNumber'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      notes: // value for 'notes'
 *      caller: // value for 'caller'
 *      costCenterId: // value for 'costCenterId'
 *      pricingAdjustments: // value for 'pricingAdjustments'
 *      createdBy: // value for 'createdBy'
 *      customFieldValues: // value for 'customFieldValues'
 *      originalOrderId: // value for 'originalOrderId'
 *      additionalEmailRecipients: // value for 'additionalEmailRecipients'
 *   },
 * });
 */
export function useCreateOneOffOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneOffOrderMutation, CreateOneOffOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneOffOrderMutation, CreateOneOffOrderMutationVariables>(CreateOneOffOrderDocument, options);
      }
export type CreateOneOffOrderMutationHookResult = ReturnType<typeof useCreateOneOffOrderMutation>;
export type CreateOneOffOrderMutationResult = Apollo.MutationResult<CreateOneOffOrderMutation>;
export type CreateOneOffOrderMutationOptions = Apollo.BaseMutationOptions<CreateOneOffOrderMutation, CreateOneOffOrderMutationVariables>;
export const FullUpdateOrderDocument = gql`
    mutation fullUpdateOrder($id: ID!, $courierId: ID!, $endCustomerId: ID!, $shipmentUpdates: [ShipmentFullUpdate!]!, $endCustomerReferenceNumber: String, $notes: String, $caller: String, $serviceTypeId: ID, $costCenterId: ID, $customFieldValuesToReplace: [CustomFieldValueInput!], $updatedBy: String, $additionalEmailRecipients: [String!]) {
  fullUpdateOrder(
    id: $id
    courierId: $courierId
    endCustomerId: $endCustomerId
    shipmentUpdates: $shipmentUpdates
    endCustomerReferenceNumber: $endCustomerReferenceNumber
    notes: $notes
    caller: $caller
    serviceTypeId: $serviceTypeId
    costCenterId: $costCenterId
    customFieldValuesToReplace: $customFieldValuesToReplace
    updatedBy: $updatedBy
    additionalEmailRecipients: $additionalEmailRecipients
  ) {
    id
    courierId
    displayId
    recurrenceType
    endCustomerReferenceNumber
    caller
    costCenterId
    endCustomer {
      ...EndCustomerFragment
    }
    costCenter {
      ...CostCenterFragment
    }
    serviceType {
      ...ServiceTypeFragment
    }
  }
}
    ${EndCustomerFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}`;
export type FullUpdateOrderMutationFn = Apollo.MutationFunction<FullUpdateOrderMutation, FullUpdateOrderMutationVariables>;

/**
 * __useFullUpdateOrderMutation__
 *
 * To run a mutation, you first call `useFullUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateOrderMutation, { data, loading, error }] = useFullUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      shipmentUpdates: // value for 'shipmentUpdates'
 *      endCustomerReferenceNumber: // value for 'endCustomerReferenceNumber'
 *      notes: // value for 'notes'
 *      caller: // value for 'caller'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      costCenterId: // value for 'costCenterId'
 *      customFieldValuesToReplace: // value for 'customFieldValuesToReplace'
 *      updatedBy: // value for 'updatedBy'
 *      additionalEmailRecipients: // value for 'additionalEmailRecipients'
 *   },
 * });
 */
export function useFullUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateOrderMutation, FullUpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateOrderMutation, FullUpdateOrderMutationVariables>(FullUpdateOrderDocument, options);
      }
export type FullUpdateOrderMutationHookResult = ReturnType<typeof useFullUpdateOrderMutation>;
export type FullUpdateOrderMutationResult = Apollo.MutationResult<FullUpdateOrderMutation>;
export type FullUpdateOrderMutationOptions = Apollo.BaseMutationOptions<FullUpdateOrderMutation, FullUpdateOrderMutationVariables>;
export const CreateRecurringOrderDocument = gql`
    mutation CreateRecurringOrder($courierId: ID!, $orderTypeId: ID, $endCustomerId: ID, $endCustomerCreate: EndCustomerCreateInput, $acquisitionType: OrderAcquisitionType!, $recurrenceDetail: RecurrenceDetailInput!, $endCustomerReferenceNumber: String, $notes: String, $caller: String, $serviceTypeId: ID, $costCenterId: ID, $shipmentTemplates: [ShipmentTemplateCreateInput!]!, $customFieldValues: [CustomFieldValueInput!], $name: String, $additionalEmailRecipients: [String!]) {
  createRecurringOrder(
    courierId: $courierId
    orderTypeId: $orderTypeId
    endCustomerId: $endCustomerId
    endCustomerCreate: $endCustomerCreate
    acquisitionType: $acquisitionType
    recurrenceDetail: $recurrenceDetail
    endCustomerReferenceNumber: $endCustomerReferenceNumber
    notes: $notes
    caller: $caller
    serviceTypeId: $serviceTypeId
    costCenterId: $costCenterId
    shipmentTemplates: $shipmentTemplates
    customFieldValues: $customFieldValues
    name: $name
    additionalEmailRecipients: $additionalEmailRecipients
  )
}
    `;
export type CreateRecurringOrderMutationFn = Apollo.MutationFunction<CreateRecurringOrderMutation, CreateRecurringOrderMutationVariables>;

/**
 * __useCreateRecurringOrderMutation__
 *
 * To run a mutation, you first call `useCreateRecurringOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringOrderMutation, { data, loading, error }] = useCreateRecurringOrderMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderTypeId: // value for 'orderTypeId'
 *      endCustomerId: // value for 'endCustomerId'
 *      endCustomerCreate: // value for 'endCustomerCreate'
 *      acquisitionType: // value for 'acquisitionType'
 *      recurrenceDetail: // value for 'recurrenceDetail'
 *      endCustomerReferenceNumber: // value for 'endCustomerReferenceNumber'
 *      notes: // value for 'notes'
 *      caller: // value for 'caller'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      costCenterId: // value for 'costCenterId'
 *      shipmentTemplates: // value for 'shipmentTemplates'
 *      customFieldValues: // value for 'customFieldValues'
 *      name: // value for 'name'
 *      additionalEmailRecipients: // value for 'additionalEmailRecipients'
 *   },
 * });
 */
export function useCreateRecurringOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringOrderMutation, CreateRecurringOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringOrderMutation, CreateRecurringOrderMutationVariables>(CreateRecurringOrderDocument, options);
      }
export type CreateRecurringOrderMutationHookResult = ReturnType<typeof useCreateRecurringOrderMutation>;
export type CreateRecurringOrderMutationResult = Apollo.MutationResult<CreateRecurringOrderMutation>;
export type CreateRecurringOrderMutationOptions = Apollo.BaseMutationOptions<CreateRecurringOrderMutation, CreateRecurringOrderMutationVariables>;
export const FullUpdateRecurringOrderDocument = gql`
    mutation fullUpdateRecurringOrder($id: ID!, $endCustomerId: ID!, $recurrenceDetail: RecurrenceDetailInput!, $endCustomerReferenceNumber: String, $serviceTypeId: ID, $costCenterId: ID, $shipmentTemplateUpdates: [ShipmentTemplateFullUpdate!]!, $additionalEmailRecipients: [String!], $name: String, $updatedBy: String) {
  fullUpdateRecurringOrder(
    id: $id
    endCustomerId: $endCustomerId
    recurrenceDetail: $recurrenceDetail
    endCustomerReferenceNumber: $endCustomerReferenceNumber
    serviceTypeId: $serviceTypeId
    costCenterId: $costCenterId
    shipmentTemplateUpdates: $shipmentTemplateUpdates
    additionalEmailRecipients: $additionalEmailRecipients
    name: $name
    updatedBy: $updatedBy
  ) {
    id
  }
}
    `;
export type FullUpdateRecurringOrderMutationFn = Apollo.MutationFunction<FullUpdateRecurringOrderMutation, FullUpdateRecurringOrderMutationVariables>;

/**
 * __useFullUpdateRecurringOrderMutation__
 *
 * To run a mutation, you first call `useFullUpdateRecurringOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateRecurringOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateRecurringOrderMutation, { data, loading, error }] = useFullUpdateRecurringOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      endCustomerId: // value for 'endCustomerId'
 *      recurrenceDetail: // value for 'recurrenceDetail'
 *      endCustomerReferenceNumber: // value for 'endCustomerReferenceNumber'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      costCenterId: // value for 'costCenterId'
 *      shipmentTemplateUpdates: // value for 'shipmentTemplateUpdates'
 *      additionalEmailRecipients: // value for 'additionalEmailRecipients'
 *      name: // value for 'name'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useFullUpdateRecurringOrderMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateRecurringOrderMutation, FullUpdateRecurringOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateRecurringOrderMutation, FullUpdateRecurringOrderMutationVariables>(FullUpdateRecurringOrderDocument, options);
      }
export type FullUpdateRecurringOrderMutationHookResult = ReturnType<typeof useFullUpdateRecurringOrderMutation>;
export type FullUpdateRecurringOrderMutationResult = Apollo.MutationResult<FullUpdateRecurringOrderMutation>;
export type FullUpdateRecurringOrderMutationOptions = Apollo.BaseMutationOptions<FullUpdateRecurringOrderMutation, FullUpdateRecurringOrderMutationVariables>;
export const ForceInstantiateRecurringOrdersDocument = gql`
    mutation forceInstantiateRecurringOrders($courierId: ID!, $shipmentTemplateIds: [ID!]!, $targetDate: Date!) {
  forceInstantiateRecurringOrders(
    courierId: $courierId
    shipmentTemplateIds: $shipmentTemplateIds
    targetDate: $targetDate
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type ForceInstantiateRecurringOrdersMutationFn = Apollo.MutationFunction<ForceInstantiateRecurringOrdersMutation, ForceInstantiateRecurringOrdersMutationVariables>;

/**
 * __useForceInstantiateRecurringOrdersMutation__
 *
 * To run a mutation, you first call `useForceInstantiateRecurringOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceInstantiateRecurringOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceInstantiateRecurringOrdersMutation, { data, loading, error }] = useForceInstantiateRecurringOrdersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentTemplateIds: // value for 'shipmentTemplateIds'
 *      targetDate: // value for 'targetDate'
 *   },
 * });
 */
export function useForceInstantiateRecurringOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ForceInstantiateRecurringOrdersMutation, ForceInstantiateRecurringOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceInstantiateRecurringOrdersMutation, ForceInstantiateRecurringOrdersMutationVariables>(ForceInstantiateRecurringOrdersDocument, options);
      }
export type ForceInstantiateRecurringOrdersMutationHookResult = ReturnType<typeof useForceInstantiateRecurringOrdersMutation>;
export type ForceInstantiateRecurringOrdersMutationResult = Apollo.MutationResult<ForceInstantiateRecurringOrdersMutation>;
export type ForceInstantiateRecurringOrdersMutationOptions = Apollo.BaseMutationOptions<ForceInstantiateRecurringOrdersMutation, ForceInstantiateRecurringOrdersMutationVariables>;
export const GetOrForceInstantiateRecurringOrdersDocument = gql`
    mutation getOrForceInstantiateRecurringOrders($courierId: ID!, $shipmentTemplateIds: [ID!]!, $targetDate: Date!, $shouldUseTemplateDriver: Boolean!) {
  getOrForceInstantiateRecurringOrders(
    courierId: $courierId
    shipmentTemplateIds: $shipmentTemplateIds
    targetDate: $targetDate
    shouldUseTemplateDriver: $shouldUseTemplateDriver
  ) {
    ...OrderFragment
    shipment {
      ...ShipmentFragment
      stops {
        ...StopFragment
      }
      order {
        ...OrderFragment
        endCustomer {
          ...EndCustomerFragment
        }
        serviceType {
          ...ServiceTypeFragment
        }
      }
    }
  }
}
    ${OrderFragmentFragmentDoc}
${ShipmentFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}`;
export type GetOrForceInstantiateRecurringOrdersMutationFn = Apollo.MutationFunction<GetOrForceInstantiateRecurringOrdersMutation, GetOrForceInstantiateRecurringOrdersMutationVariables>;

/**
 * __useGetOrForceInstantiateRecurringOrdersMutation__
 *
 * To run a mutation, you first call `useGetOrForceInstantiateRecurringOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrForceInstantiateRecurringOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrForceInstantiateRecurringOrdersMutation, { data, loading, error }] = useGetOrForceInstantiateRecurringOrdersMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentTemplateIds: // value for 'shipmentTemplateIds'
 *      targetDate: // value for 'targetDate'
 *      shouldUseTemplateDriver: // value for 'shouldUseTemplateDriver'
 *   },
 * });
 */
export function useGetOrForceInstantiateRecurringOrdersMutation(baseOptions?: Apollo.MutationHookOptions<GetOrForceInstantiateRecurringOrdersMutation, GetOrForceInstantiateRecurringOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrForceInstantiateRecurringOrdersMutation, GetOrForceInstantiateRecurringOrdersMutationVariables>(GetOrForceInstantiateRecurringOrdersDocument, options);
      }
export type GetOrForceInstantiateRecurringOrdersMutationHookResult = ReturnType<typeof useGetOrForceInstantiateRecurringOrdersMutation>;
export type GetOrForceInstantiateRecurringOrdersMutationResult = Apollo.MutationResult<GetOrForceInstantiateRecurringOrdersMutation>;
export type GetOrForceInstantiateRecurringOrdersMutationOptions = Apollo.BaseMutationOptions<GetOrForceInstantiateRecurringOrdersMutation, GetOrForceInstantiateRecurringOrdersMutationVariables>;
export const GenerateOrdersPdfDocument = gql`
    mutation GenerateOrdersPdf($orderIds: [ID!]!) {
  generateOrdersPdf(orderIds: $orderIds) {
    url
  }
}
    `;
export type GenerateOrdersPdfMutationFn = Apollo.MutationFunction<GenerateOrdersPdfMutation, GenerateOrdersPdfMutationVariables>;

/**
 * __useGenerateOrdersPdfMutation__
 *
 * To run a mutation, you first call `useGenerateOrdersPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrdersPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrdersPdfMutation, { data, loading, error }] = useGenerateOrdersPdfMutation({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useGenerateOrdersPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOrdersPdfMutation, GenerateOrdersPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOrdersPdfMutation, GenerateOrdersPdfMutationVariables>(GenerateOrdersPdfDocument, options);
      }
export type GenerateOrdersPdfMutationHookResult = ReturnType<typeof useGenerateOrdersPdfMutation>;
export type GenerateOrdersPdfMutationResult = Apollo.MutationResult<GenerateOrdersPdfMutation>;
export type GenerateOrdersPdfMutationOptions = Apollo.BaseMutationOptions<GenerateOrdersPdfMutation, GenerateOrdersPdfMutationVariables>;
export const RecordOrderClickDocument = gql`
    mutation recordOrderClick($input: RecordOrderClickInput!) {
  recordOrderClick(input: $input)
}
    `;
export type RecordOrderClickMutationFn = Apollo.MutationFunction<RecordOrderClickMutation, RecordOrderClickMutationVariables>;

/**
 * __useRecordOrderClickMutation__
 *
 * To run a mutation, you first call `useRecordOrderClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordOrderClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordOrderClickMutation, { data, loading, error }] = useRecordOrderClickMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordOrderClickMutation(baseOptions?: Apollo.MutationHookOptions<RecordOrderClickMutation, RecordOrderClickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordOrderClickMutation, RecordOrderClickMutationVariables>(RecordOrderClickDocument, options);
      }
export type RecordOrderClickMutationHookResult = ReturnType<typeof useRecordOrderClickMutation>;
export type RecordOrderClickMutationResult = Apollo.MutationResult<RecordOrderClickMutation>;
export type RecordOrderClickMutationOptions = Apollo.BaseMutationOptions<RecordOrderClickMutation, RecordOrderClickMutationVariables>;
export const CreateLiveOrderDocument = gql`
    mutation createLiveOrder($courierId: ID!, $branchId: ID, $orderTypeId: ID, $endCustomerId: ID, $endCustomerCreate: EndCustomerCreateInput, $acquisitionType: OrderAcquisitionType!, $shipments: [ShipmentCreateInput!]!, $endCustomerReferenceNumber: String, $notes: String, $caller: String, $serviceTypeId: ID, $costCenterId: ID, $pricingAdjustments: [PricingAdjustmentCreate!], $additionalEmailRecipients: [String!], $createdBy: String, $customFieldValues: [CustomFieldValueInput!], $endUserId: ID, $originalOrderId: ID) {
  createLiveOrder(
    courierId: $courierId
    branchId: $branchId
    orderTypeId: $orderTypeId
    endCustomerId: $endCustomerId
    endCustomerCreate: $endCustomerCreate
    acquisitionType: $acquisitionType
    shipments: $shipments
    endCustomerReferenceNumber: $endCustomerReferenceNumber
    notes: $notes
    caller: $caller
    serviceTypeId: $serviceTypeId
    costCenterId: $costCenterId
    pricingAdjustments: $pricingAdjustments
    additionalEmailRecipients: $additionalEmailRecipients
    createdBy: $createdBy
    customFieldValues: $customFieldValues
    endUserId: $endUserId
    originalOrderId: $originalOrderId
  ) {
    endCustomer {
      companyName
    }
    shipment {
      id
      trackingNumber
    }
  }
}
    `;
export type CreateLiveOrderMutationFn = Apollo.MutationFunction<CreateLiveOrderMutation, CreateLiveOrderMutationVariables>;

/**
 * __useCreateLiveOrderMutation__
 *
 * To run a mutation, you first call `useCreateLiveOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLiveOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLiveOrderMutation, { data, loading, error }] = useCreateLiveOrderMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      branchId: // value for 'branchId'
 *      orderTypeId: // value for 'orderTypeId'
 *      endCustomerId: // value for 'endCustomerId'
 *      endCustomerCreate: // value for 'endCustomerCreate'
 *      acquisitionType: // value for 'acquisitionType'
 *      shipments: // value for 'shipments'
 *      endCustomerReferenceNumber: // value for 'endCustomerReferenceNumber'
 *      notes: // value for 'notes'
 *      caller: // value for 'caller'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      costCenterId: // value for 'costCenterId'
 *      pricingAdjustments: // value for 'pricingAdjustments'
 *      additionalEmailRecipients: // value for 'additionalEmailRecipients'
 *      createdBy: // value for 'createdBy'
 *      customFieldValues: // value for 'customFieldValues'
 *      endUserId: // value for 'endUserId'
 *      originalOrderId: // value for 'originalOrderId'
 *   },
 * });
 */
export function useCreateLiveOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateLiveOrderMutation, CreateLiveOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLiveOrderMutation, CreateLiveOrderMutationVariables>(CreateLiveOrderDocument, options);
      }
export type CreateLiveOrderMutationHookResult = ReturnType<typeof useCreateLiveOrderMutation>;
export type CreateLiveOrderMutationResult = Apollo.MutationResult<CreateLiveOrderMutation>;
export type CreateLiveOrderMutationOptions = Apollo.BaseMutationOptions<CreateLiveOrderMutation, CreateLiveOrderMutationVariables>;
export const FullUpdatePackageTypeDocument = gql`
    mutation fullUpdatePackageType($id: ID!, $name: String!) {
  fullUpdatePackageType(id: $id, name: $name) {
    ...PackageTypeFragment
  }
}
    ${PackageTypeFragmentFragmentDoc}`;
export type FullUpdatePackageTypeMutationFn = Apollo.MutationFunction<FullUpdatePackageTypeMutation, FullUpdatePackageTypeMutationVariables>;

/**
 * __useFullUpdatePackageTypeMutation__
 *
 * To run a mutation, you first call `useFullUpdatePackageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdatePackageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdatePackageTypeMutation, { data, loading, error }] = useFullUpdatePackageTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFullUpdatePackageTypeMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdatePackageTypeMutation, FullUpdatePackageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdatePackageTypeMutation, FullUpdatePackageTypeMutationVariables>(FullUpdatePackageTypeDocument, options);
      }
export type FullUpdatePackageTypeMutationHookResult = ReturnType<typeof useFullUpdatePackageTypeMutation>;
export type FullUpdatePackageTypeMutationResult = Apollo.MutationResult<FullUpdatePackageTypeMutation>;
export type FullUpdatePackageTypeMutationOptions = Apollo.BaseMutationOptions<FullUpdatePackageTypeMutation, FullUpdatePackageTypeMutationVariables>;
export const CreatePackageTypeDocument = gql`
    mutation createPackageType($courierId: ID!, $name: String!) {
  createPackageType(courierId: $courierId, name: $name) {
    ...PackageTypeFragment
  }
}
    ${PackageTypeFragmentFragmentDoc}`;
export type CreatePackageTypeMutationFn = Apollo.MutationFunction<CreatePackageTypeMutation, CreatePackageTypeMutationVariables>;

/**
 * __useCreatePackageTypeMutation__
 *
 * To run a mutation, you first call `useCreatePackageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageTypeMutation, { data, loading, error }] = useCreatePackageTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreatePackageTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackageTypeMutation, CreatePackageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackageTypeMutation, CreatePackageTypeMutationVariables>(CreatePackageTypeDocument, options);
      }
export type CreatePackageTypeMutationHookResult = ReturnType<typeof useCreatePackageTypeMutation>;
export type CreatePackageTypeMutationResult = Apollo.MutationResult<CreatePackageTypeMutation>;
export type CreatePackageTypeMutationOptions = Apollo.BaseMutationOptions<CreatePackageTypeMutation, CreatePackageTypeMutationVariables>;
export const DeletePackageTypeDocument = gql`
    mutation deletePackageType($id: ID!) {
  deletePackageType(id: $id) {
    ...PackageTypeFragment
  }
}
    ${PackageTypeFragmentFragmentDoc}`;
export type DeletePackageTypeMutationFn = Apollo.MutationFunction<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>;

/**
 * __useDeletePackageTypeMutation__
 *
 * To run a mutation, you first call `useDeletePackageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackageTypeMutation, { data, loading, error }] = useDeletePackageTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePackageTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>(DeletePackageTypeDocument, options);
      }
export type DeletePackageTypeMutationHookResult = ReturnType<typeof useDeletePackageTypeMutation>;
export type DeletePackageTypeMutationResult = Apollo.MutationResult<DeletePackageTypeMutation>;
export type DeletePackageTypeMutationOptions = Apollo.BaseMutationOptions<DeletePackageTypeMutation, DeletePackageTypeMutationVariables>;
export const CreatePaymentInstrumentDocument = gql`
    mutation CreatePaymentInstrument($courierId: ID!, $endCustomerId: ID, $costCenterId: ID, $token: String!, $source: PaymentInstrumentAcquisitionSource!, $createdBy: String!) {
  createPaymentInstrument(
    courierId: $courierId
    endCustomerId: $endCustomerId
    costCenterId: $costCenterId
    token: $token
    source: $source
    createdBy: $createdBy
  ) {
    ...PaymentInstrumentFragment
  }
}
    ${PaymentInstrumentFragmentFragmentDoc}`;
export type CreatePaymentInstrumentMutationFn = Apollo.MutationFunction<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>;

/**
 * __useCreatePaymentInstrumentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentInstrumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentInstrumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentInstrumentMutation, { data, loading, error }] = useCreatePaymentInstrumentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *      costCenterId: // value for 'costCenterId'
 *      token: // value for 'token'
 *      source: // value for 'source'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useCreatePaymentInstrumentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>(CreatePaymentInstrumentDocument, options);
      }
export type CreatePaymentInstrumentMutationHookResult = ReturnType<typeof useCreatePaymentInstrumentMutation>;
export type CreatePaymentInstrumentMutationResult = Apollo.MutationResult<CreatePaymentInstrumentMutation>;
export type CreatePaymentInstrumentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentInstrumentMutation, CreatePaymentInstrumentMutationVariables>;
export const PaymentTransfersPaginatedDocument = gql`
    query PaymentTransfersPaginated($courierId: ID!, $endCustomerIdsFilter: [ID!], $statusFilter: [PaymentTransferStatus!], $refundTypes: [PaymentTransferRefundType!], $invoiceIds: [ID!], $limit: Int!, $after: Int!) {
  paymentTransfersPaginated(
    courierId: $courierId
    endCustomerIdsFilter: $endCustomerIdsFilter
    statusFilter: $statusFilter
    refundTypes: $refundTypes
    invoiceIds: $invoiceIds
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...PaymentTransferFragment
        sourcePaymentInstrument {
          ...PaymentInstrumentFragment
        }
        invoicePayments {
          ...InvoicePaymentFragment
          invoice {
            ...InvoiceFragment
          }
        }
        parentPaymentTransfer {
          ...PaymentTransferFragment
        }
        endCustomer {
          ...EndCustomerFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${PaymentTransferFragmentFragmentDoc}
${PaymentInstrumentFragmentFragmentDoc}
${InvoicePaymentFragmentFragmentDoc}
${InvoiceFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __usePaymentTransfersPaginatedQuery__
 *
 * To run a query within a React component, call `usePaymentTransfersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTransfersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTransfersPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      statusFilter: // value for 'statusFilter'
 *      refundTypes: // value for 'refundTypes'
 *      invoiceIds: // value for 'invoiceIds'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaymentTransfersPaginatedQuery(baseOptions: Apollo.QueryHookOptions<PaymentTransfersPaginatedQuery, PaymentTransfersPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentTransfersPaginatedQuery, PaymentTransfersPaginatedQueryVariables>(PaymentTransfersPaginatedDocument, options);
      }
export function usePaymentTransfersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentTransfersPaginatedQuery, PaymentTransfersPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentTransfersPaginatedQuery, PaymentTransfersPaginatedQueryVariables>(PaymentTransfersPaginatedDocument, options);
        }
export type PaymentTransfersPaginatedQueryHookResult = ReturnType<typeof usePaymentTransfersPaginatedQuery>;
export type PaymentTransfersPaginatedLazyQueryHookResult = ReturnType<typeof usePaymentTransfersPaginatedLazyQuery>;
export type PaymentTransfersPaginatedQueryResult = Apollo.QueryResult<PaymentTransfersPaginatedQuery, PaymentTransfersPaginatedQueryVariables>;
export const PaymentInstrumentsDocument = gql`
    query PaymentInstruments($courierId: ID!, $endCustomerIds: [ID!]!) {
  paymentInstruments(courierId: $courierId, endCustomerIds: $endCustomerIds) {
    ...PaymentInstrumentFragment
  }
}
    ${PaymentInstrumentFragmentFragmentDoc}`;

/**
 * __usePaymentInstrumentsQuery__
 *
 * To run a query within a React component, call `usePaymentInstrumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentInstrumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentInstrumentsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIds: // value for 'endCustomerIds'
 *   },
 * });
 */
export function usePaymentInstrumentsQuery(baseOptions: Apollo.QueryHookOptions<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>(PaymentInstrumentsDocument, options);
      }
export function usePaymentInstrumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>(PaymentInstrumentsDocument, options);
        }
export type PaymentInstrumentsQueryHookResult = ReturnType<typeof usePaymentInstrumentsQuery>;
export type PaymentInstrumentsLazyQueryHookResult = ReturnType<typeof usePaymentInstrumentsLazyQuery>;
export type PaymentInstrumentsQueryResult = Apollo.QueryResult<PaymentInstrumentsQuery, PaymentInstrumentsQueryVariables>;
export const PaymentSettlementsPaginatedDocument = gql`
    query PaymentSettlementsPaginated($courierId: ID!, $limit: Int!, $after: Int!) {
  paymentSettlementsPaginated(courierId: $courierId, limit: $limit, after: $after) {
    edges {
      node {
        ...PaymentSettlementFragment
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${PaymentSettlementFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __usePaymentSettlementsPaginatedQuery__
 *
 * To run a query within a React component, call `usePaymentSettlementsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentSettlementsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentSettlementsPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaymentSettlementsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<PaymentSettlementsPaginatedQuery, PaymentSettlementsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentSettlementsPaginatedQuery, PaymentSettlementsPaginatedQueryVariables>(PaymentSettlementsPaginatedDocument, options);
      }
export function usePaymentSettlementsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentSettlementsPaginatedQuery, PaymentSettlementsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentSettlementsPaginatedQuery, PaymentSettlementsPaginatedQueryVariables>(PaymentSettlementsPaginatedDocument, options);
        }
export type PaymentSettlementsPaginatedQueryHookResult = ReturnType<typeof usePaymentSettlementsPaginatedQuery>;
export type PaymentSettlementsPaginatedLazyQueryHookResult = ReturnType<typeof usePaymentSettlementsPaginatedLazyQuery>;
export type PaymentSettlementsPaginatedQueryResult = Apollo.QueryResult<PaymentSettlementsPaginatedQuery, PaymentSettlementsPaginatedQueryVariables>;
export const InitiateInvoiceRefundDocument = gql`
    mutation InitiateInvoiceRefund($courierId: ID!, $parentPaymentTransferId: ID!, $amount: Money!, $idempotencyToken: String!, $createdBy: String!) {
  initiateInvoiceRefund(
    courierId: $courierId
    parentPaymentTransferId: $parentPaymentTransferId
    amount: $amount
    idempotencyToken: $idempotencyToken
    createdBy: $createdBy
  ) {
    ...InvoicePaymentFields
  }
}
    ${InvoicePaymentFieldsFragmentDoc}`;
export type InitiateInvoiceRefundMutationFn = Apollo.MutationFunction<InitiateInvoiceRefundMutation, InitiateInvoiceRefundMutationVariables>;

/**
 * __useInitiateInvoiceRefundMutation__
 *
 * To run a mutation, you first call `useInitiateInvoiceRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateInvoiceRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateInvoiceRefundMutation, { data, loading, error }] = useInitiateInvoiceRefundMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      parentPaymentTransferId: // value for 'parentPaymentTransferId'
 *      amount: // value for 'amount'
 *      idempotencyToken: // value for 'idempotencyToken'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useInitiateInvoiceRefundMutation(baseOptions?: Apollo.MutationHookOptions<InitiateInvoiceRefundMutation, InitiateInvoiceRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateInvoiceRefundMutation, InitiateInvoiceRefundMutationVariables>(InitiateInvoiceRefundDocument, options);
      }
export type InitiateInvoiceRefundMutationHookResult = ReturnType<typeof useInitiateInvoiceRefundMutation>;
export type InitiateInvoiceRefundMutationResult = Apollo.MutationResult<InitiateInvoiceRefundMutation>;
export type InitiateInvoiceRefundMutationOptions = Apollo.BaseMutationOptions<InitiateInvoiceRefundMutation, InitiateInvoiceRefundMutationVariables>;
export const GetInvoiceBalancesDocument = gql`
    query GetInvoiceBalances($courierId: ID!, $invoiceIds: [ID!]!) {
  invoiceBalances(courierId: $courierId, invoiceIds: $invoiceIds) {
    ...InvoiceBalanceFields
  }
}
    ${InvoiceBalanceFieldsFragmentDoc}`;

/**
 * __useGetInvoiceBalancesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceBalancesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useGetInvoiceBalancesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceBalancesQuery, GetInvoiceBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceBalancesQuery, GetInvoiceBalancesQueryVariables>(GetInvoiceBalancesDocument, options);
      }
export function useGetInvoiceBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceBalancesQuery, GetInvoiceBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceBalancesQuery, GetInvoiceBalancesQueryVariables>(GetInvoiceBalancesDocument, options);
        }
export type GetInvoiceBalancesQueryHookResult = ReturnType<typeof useGetInvoiceBalancesQuery>;
export type GetInvoiceBalancesLazyQueryHookResult = ReturnType<typeof useGetInvoiceBalancesLazyQuery>;
export type GetInvoiceBalancesQueryResult = Apollo.QueryResult<GetInvoiceBalancesQuery, GetInvoiceBalancesQueryVariables>;
export const UpsertPayrollSettingsDocument = gql`
    mutation UpsertPayrollSettings($courierId: ID!, $defaultCommission: Float!, $payPeriodType: PayPeriodType!) {
  upsertPayrollSettings(
    courierId: $courierId
    defaultCommission: $defaultCommission
    payPeriodType: $payPeriodType
  ) {
    courierId
    defaultCommission
    payPeriodType
  }
}
    `;
export type UpsertPayrollSettingsMutationFn = Apollo.MutationFunction<UpsertPayrollSettingsMutation, UpsertPayrollSettingsMutationVariables>;

/**
 * __useUpsertPayrollSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertPayrollSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPayrollSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPayrollSettingsMutation, { data, loading, error }] = useUpsertPayrollSettingsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      defaultCommission: // value for 'defaultCommission'
 *      payPeriodType: // value for 'payPeriodType'
 *   },
 * });
 */
export function useUpsertPayrollSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPayrollSettingsMutation, UpsertPayrollSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPayrollSettingsMutation, UpsertPayrollSettingsMutationVariables>(UpsertPayrollSettingsDocument, options);
      }
export type UpsertPayrollSettingsMutationHookResult = ReturnType<typeof useUpsertPayrollSettingsMutation>;
export type UpsertPayrollSettingsMutationResult = Apollo.MutationResult<UpsertPayrollSettingsMutation>;
export type UpsertPayrollSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertPayrollSettingsMutation, UpsertPayrollSettingsMutationVariables>;
export const GetOrGenerateDriverPayEntriesDocument = gql`
    mutation GetOrGenerateDriverPayEntries($courierId: ID!, $startDate: Date!, $endDate: Date!, $driverSearch: String, $sortFields: [DriverPayrollSorting!]) {
  getOrGenerateDriverPayEntries(
    courierId: $courierId
    startDate: $startDate
    endDate: $endDate
    driverSearch: $driverSearch
    sortFields: $sortFields
  ) {
    ...DriverPayEntryFragment
    driver {
      ...DriverFragment
    }
    remoteEntities {
      ...RemoteEntityFragment
    }
  }
}
    ${DriverPayEntryFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${RemoteEntityFragmentFragmentDoc}`;
export type GetOrGenerateDriverPayEntriesMutationFn = Apollo.MutationFunction<GetOrGenerateDriverPayEntriesMutation, GetOrGenerateDriverPayEntriesMutationVariables>;

/**
 * __useGetOrGenerateDriverPayEntriesMutation__
 *
 * To run a mutation, you first call `useGetOrGenerateDriverPayEntriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrGenerateDriverPayEntriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrGenerateDriverPayEntriesMutation, { data, loading, error }] = useGetOrGenerateDriverPayEntriesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      driverSearch: // value for 'driverSearch'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useGetOrGenerateDriverPayEntriesMutation(baseOptions?: Apollo.MutationHookOptions<GetOrGenerateDriverPayEntriesMutation, GetOrGenerateDriverPayEntriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrGenerateDriverPayEntriesMutation, GetOrGenerateDriverPayEntriesMutationVariables>(GetOrGenerateDriverPayEntriesDocument, options);
      }
export type GetOrGenerateDriverPayEntriesMutationHookResult = ReturnType<typeof useGetOrGenerateDriverPayEntriesMutation>;
export type GetOrGenerateDriverPayEntriesMutationResult = Apollo.MutationResult<GetOrGenerateDriverPayEntriesMutation>;
export type GetOrGenerateDriverPayEntriesMutationOptions = Apollo.BaseMutationOptions<GetOrGenerateDriverPayEntriesMutation, GetOrGenerateDriverPayEntriesMutationVariables>;
export const GeneratePayrollReportDocument = gql`
    mutation GeneratePayrollReport($courierId: ID!, $driverIds: [ID!], $startDate: Date!, $endDate: Date!) {
  generatePayrollReport(
    courierId: $courierId
    driverIds: $driverIds
    startDate: $startDate
    endDate: $endDate
  ) {
    ...PayrollReportFileFragment
  }
}
    ${PayrollReportFileFragmentFragmentDoc}`;
export type GeneratePayrollReportMutationFn = Apollo.MutationFunction<GeneratePayrollReportMutation, GeneratePayrollReportMutationVariables>;

/**
 * __useGeneratePayrollReportMutation__
 *
 * To run a mutation, you first call `useGeneratePayrollReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePayrollReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePayrollReportMutation, { data, loading, error }] = useGeneratePayrollReportMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverIds: // value for 'driverIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGeneratePayrollReportMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePayrollReportMutation, GeneratePayrollReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePayrollReportMutation, GeneratePayrollReportMutationVariables>(GeneratePayrollReportDocument, options);
      }
export type GeneratePayrollReportMutationHookResult = ReturnType<typeof useGeneratePayrollReportMutation>;
export type GeneratePayrollReportMutationResult = Apollo.MutationResult<GeneratePayrollReportMutation>;
export type GeneratePayrollReportMutationOptions = Apollo.BaseMutationOptions<GeneratePayrollReportMutation, GeneratePayrollReportMutationVariables>;
export const SendEmailToDriversDocument = gql`
    mutation SendEmailToDrivers($driverPayEntryId: ID!, $recipients: [String!]!) {
  sendEmailToDrivers(driverPayEntryId: $driverPayEntryId, recipients: $recipients) {
    id
    driverPayEntryId
    driverId
    fileId
    recipients
    emailId
  }
}
    `;
export type SendEmailToDriversMutationFn = Apollo.MutationFunction<SendEmailToDriversMutation, SendEmailToDriversMutationVariables>;

/**
 * __useSendEmailToDriversMutation__
 *
 * To run a mutation, you first call `useSendEmailToDriversMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToDriversMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToDriversMutation, { data, loading, error }] = useSendEmailToDriversMutation({
 *   variables: {
 *      driverPayEntryId: // value for 'driverPayEntryId'
 *      recipients: // value for 'recipients'
 *   },
 * });
 */
export function useSendEmailToDriversMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailToDriversMutation, SendEmailToDriversMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailToDriversMutation, SendEmailToDriversMutationVariables>(SendEmailToDriversDocument, options);
      }
export type SendEmailToDriversMutationHookResult = ReturnType<typeof useSendEmailToDriversMutation>;
export type SendEmailToDriversMutationResult = Apollo.MutationResult<SendEmailToDriversMutation>;
export type SendEmailToDriversMutationOptions = Apollo.BaseMutationOptions<SendEmailToDriversMutation, SendEmailToDriversMutationVariables>;
export const ApproveDriverPayDocument = gql`
    mutation ApproveDriverPay($driverPayEntryId: ID!) {
  approveDriverPay(driverPayEntryId: $driverPayEntryId) {
    ...DriverPayEntryFragment
  }
}
    ${DriverPayEntryFragmentFragmentDoc}`;
export type ApproveDriverPayMutationFn = Apollo.MutationFunction<ApproveDriverPayMutation, ApproveDriverPayMutationVariables>;

/**
 * __useApproveDriverPayMutation__
 *
 * To run a mutation, you first call `useApproveDriverPayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveDriverPayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveDriverPayMutation, { data, loading, error }] = useApproveDriverPayMutation({
 *   variables: {
 *      driverPayEntryId: // value for 'driverPayEntryId'
 *   },
 * });
 */
export function useApproveDriverPayMutation(baseOptions?: Apollo.MutationHookOptions<ApproveDriverPayMutation, ApproveDriverPayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveDriverPayMutation, ApproveDriverPayMutationVariables>(ApproveDriverPayDocument, options);
      }
export type ApproveDriverPayMutationHookResult = ReturnType<typeof useApproveDriverPayMutation>;
export type ApproveDriverPayMutationResult = Apollo.MutationResult<ApproveDriverPayMutation>;
export type ApproveDriverPayMutationOptions = Apollo.BaseMutationOptions<ApproveDriverPayMutation, ApproveDriverPayMutationVariables>;
export const ModifyDriverPayDeductionsDocument = gql`
    mutation ModifyDriverPayDeductions($driverPayEntryId: ID!, $deductionsToAdd: [DriverPayDeductionValueInput!]!, $deductionIdsToRemove: [ID!]!) {
  modifyDriverPayDeductions(
    driverPayEntryId: $driverPayEntryId
    deductionsToAdd: $deductionsToAdd
    deductionIdsToRemove: $deductionIdsToRemove
  ) {
    ...DriverPayEntryFragment
  }
}
    ${DriverPayEntryFragmentFragmentDoc}`;
export type ModifyDriverPayDeductionsMutationFn = Apollo.MutationFunction<ModifyDriverPayDeductionsMutation, ModifyDriverPayDeductionsMutationVariables>;

/**
 * __useModifyDriverPayDeductionsMutation__
 *
 * To run a mutation, you first call `useModifyDriverPayDeductionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyDriverPayDeductionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyDriverPayDeductionsMutation, { data, loading, error }] = useModifyDriverPayDeductionsMutation({
 *   variables: {
 *      driverPayEntryId: // value for 'driverPayEntryId'
 *      deductionsToAdd: // value for 'deductionsToAdd'
 *      deductionIdsToRemove: // value for 'deductionIdsToRemove'
 *   },
 * });
 */
export function useModifyDriverPayDeductionsMutation(baseOptions?: Apollo.MutationHookOptions<ModifyDriverPayDeductionsMutation, ModifyDriverPayDeductionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyDriverPayDeductionsMutation, ModifyDriverPayDeductionsMutationVariables>(ModifyDriverPayDeductionsDocument, options);
      }
export type ModifyDriverPayDeductionsMutationHookResult = ReturnType<typeof useModifyDriverPayDeductionsMutation>;
export type ModifyDriverPayDeductionsMutationResult = Apollo.MutationResult<ModifyDriverPayDeductionsMutation>;
export type ModifyDriverPayDeductionsMutationOptions = Apollo.BaseMutationOptions<ModifyDriverPayDeductionsMutation, ModifyDriverPayDeductionsMutationVariables>;
export const ForceExportDriverPayDocument = gql`
    mutation ForceExportDriverPay($driverPayEntryId: ID!, $provider: ApiProvider!) {
  forceExportDriverPay(driverPayEntryId: $driverPayEntryId, provider: $provider) {
    ...DriverPayEntryFragment
  }
}
    ${DriverPayEntryFragmentFragmentDoc}`;
export type ForceExportDriverPayMutationFn = Apollo.MutationFunction<ForceExportDriverPayMutation, ForceExportDriverPayMutationVariables>;

/**
 * __useForceExportDriverPayMutation__
 *
 * To run a mutation, you first call `useForceExportDriverPayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceExportDriverPayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceExportDriverPayMutation, { data, loading, error }] = useForceExportDriverPayMutation({
 *   variables: {
 *      driverPayEntryId: // value for 'driverPayEntryId'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useForceExportDriverPayMutation(baseOptions?: Apollo.MutationHookOptions<ForceExportDriverPayMutation, ForceExportDriverPayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceExportDriverPayMutation, ForceExportDriverPayMutationVariables>(ForceExportDriverPayDocument, options);
      }
export type ForceExportDriverPayMutationHookResult = ReturnType<typeof useForceExportDriverPayMutation>;
export type ForceExportDriverPayMutationResult = Apollo.MutationResult<ForceExportDriverPayMutation>;
export type ForceExportDriverPayMutationOptions = Apollo.BaseMutationOptions<ForceExportDriverPayMutation, ForceExportDriverPayMutationVariables>;
export const CreatePayrollDeductionRuleDocument = gql`
    mutation CreatePayrollDeductionRule($courierId: ID!, $name: String!, $amount: Money!, $amountType: PayrollDeductionAmountType!, $ruleType: PayrollDeductionRuleType!, $driverIds: [ID!]) {
  createPayrollDeductionRule(
    courierId: $courierId
    name: $name
    amount: $amount
    amountType: $amountType
    ruleType: $ruleType
    driverIds: $driverIds
  ) {
    ...PayrollDeductionRuleFragment
  }
}
    ${PayrollDeductionRuleFragmentFragmentDoc}`;
export type CreatePayrollDeductionRuleMutationFn = Apollo.MutationFunction<CreatePayrollDeductionRuleMutation, CreatePayrollDeductionRuleMutationVariables>;

/**
 * __useCreatePayrollDeductionRuleMutation__
 *
 * To run a mutation, you first call `useCreatePayrollDeductionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayrollDeductionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayrollDeductionRuleMutation, { data, loading, error }] = useCreatePayrollDeductionRuleMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      amount: // value for 'amount'
 *      amountType: // value for 'amountType'
 *      ruleType: // value for 'ruleType'
 *      driverIds: // value for 'driverIds'
 *   },
 * });
 */
export function useCreatePayrollDeductionRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayrollDeductionRuleMutation, CreatePayrollDeductionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayrollDeductionRuleMutation, CreatePayrollDeductionRuleMutationVariables>(CreatePayrollDeductionRuleDocument, options);
      }
export type CreatePayrollDeductionRuleMutationHookResult = ReturnType<typeof useCreatePayrollDeductionRuleMutation>;
export type CreatePayrollDeductionRuleMutationResult = Apollo.MutationResult<CreatePayrollDeductionRuleMutation>;
export type CreatePayrollDeductionRuleMutationOptions = Apollo.BaseMutationOptions<CreatePayrollDeductionRuleMutation, CreatePayrollDeductionRuleMutationVariables>;
export const FullUpdatePayrollDeductionRuleDocument = gql`
    mutation FullUpdatePayrollDeductionRule($id: ID!, $courierId: ID!, $name: String!, $amount: Money!, $amountType: PayrollDeductionAmountType!, $ruleType: PayrollDeductionRuleType!, $driverIds: [ID!]) {
  fullUpdatePayrollDeductionRule(
    id: $id
    courierId: $courierId
    name: $name
    amount: $amount
    amountType: $amountType
    ruleType: $ruleType
    driverIds: $driverIds
  ) {
    ...PayrollDeductionRuleFragment
  }
}
    ${PayrollDeductionRuleFragmentFragmentDoc}`;
export type FullUpdatePayrollDeductionRuleMutationFn = Apollo.MutationFunction<FullUpdatePayrollDeductionRuleMutation, FullUpdatePayrollDeductionRuleMutationVariables>;

/**
 * __useFullUpdatePayrollDeductionRuleMutation__
 *
 * To run a mutation, you first call `useFullUpdatePayrollDeductionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdatePayrollDeductionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdatePayrollDeductionRuleMutation, { data, loading, error }] = useFullUpdatePayrollDeductionRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      amount: // value for 'amount'
 *      amountType: // value for 'amountType'
 *      ruleType: // value for 'ruleType'
 *      driverIds: // value for 'driverIds'
 *   },
 * });
 */
export function useFullUpdatePayrollDeductionRuleMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdatePayrollDeductionRuleMutation, FullUpdatePayrollDeductionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdatePayrollDeductionRuleMutation, FullUpdatePayrollDeductionRuleMutationVariables>(FullUpdatePayrollDeductionRuleDocument, options);
      }
export type FullUpdatePayrollDeductionRuleMutationHookResult = ReturnType<typeof useFullUpdatePayrollDeductionRuleMutation>;
export type FullUpdatePayrollDeductionRuleMutationResult = Apollo.MutationResult<FullUpdatePayrollDeductionRuleMutation>;
export type FullUpdatePayrollDeductionRuleMutationOptions = Apollo.BaseMutationOptions<FullUpdatePayrollDeductionRuleMutation, FullUpdatePayrollDeductionRuleMutationVariables>;
export const DeletePayrollDeductionRuleDocument = gql`
    mutation DeletePayrollDeductionRule($id: ID!, $courierId: ID!) {
  deletePayrollDeductionRule(id: $id, courierId: $courierId) {
    ...PayrollDeductionRuleFragment
  }
}
    ${PayrollDeductionRuleFragmentFragmentDoc}`;
export type DeletePayrollDeductionRuleMutationFn = Apollo.MutationFunction<DeletePayrollDeductionRuleMutation, DeletePayrollDeductionRuleMutationVariables>;

/**
 * __useDeletePayrollDeductionRuleMutation__
 *
 * To run a mutation, you first call `useDeletePayrollDeductionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePayrollDeductionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePayrollDeductionRuleMutation, { data, loading, error }] = useDeletePayrollDeductionRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useDeletePayrollDeductionRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeletePayrollDeductionRuleMutation, DeletePayrollDeductionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePayrollDeductionRuleMutation, DeletePayrollDeductionRuleMutationVariables>(DeletePayrollDeductionRuleDocument, options);
      }
export type DeletePayrollDeductionRuleMutationHookResult = ReturnType<typeof useDeletePayrollDeductionRuleMutation>;
export type DeletePayrollDeductionRuleMutationResult = Apollo.MutationResult<DeletePayrollDeductionRuleMutation>;
export type DeletePayrollDeductionRuleMutationOptions = Apollo.BaseMutationOptions<DeletePayrollDeductionRuleMutation, DeletePayrollDeductionRuleMutationVariables>;
export const GetPayPeriodsDocument = gql`
    query GetPayPeriods($courierId: ID!, $minDate: Date!, $maxDate: Date!) {
  payPeriods(courierId: $courierId, minDate: $minDate, maxDate: $maxDate) {
    ...PayPeriodFragment
  }
}
    ${PayPeriodFragmentFragmentDoc}`;

/**
 * __useGetPayPeriodsQuery__
 *
 * To run a query within a React component, call `useGetPayPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayPeriodsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useGetPayPeriodsQuery(baseOptions: Apollo.QueryHookOptions<GetPayPeriodsQuery, GetPayPeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayPeriodsQuery, GetPayPeriodsQueryVariables>(GetPayPeriodsDocument, options);
      }
export function useGetPayPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayPeriodsQuery, GetPayPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayPeriodsQuery, GetPayPeriodsQueryVariables>(GetPayPeriodsDocument, options);
        }
export type GetPayPeriodsQueryHookResult = ReturnType<typeof useGetPayPeriodsQuery>;
export type GetPayPeriodsLazyQueryHookResult = ReturnType<typeof useGetPayPeriodsLazyQuery>;
export type GetPayPeriodsQueryResult = Apollo.QueryResult<GetPayPeriodsQuery, GetPayPeriodsQueryVariables>;
export const GetPayrollSettingsDocument = gql`
    query GetPayrollSettings($courierId: ID!) {
  payrollSettings(courierId: $courierId) {
    ...PayrollSettingFragment
  }
}
    ${PayrollSettingFragmentFragmentDoc}`;

/**
 * __useGetPayrollSettingsQuery__
 *
 * To run a query within a React component, call `useGetPayrollSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayrollSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayrollSettingsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetPayrollSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetPayrollSettingsQuery, GetPayrollSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayrollSettingsQuery, GetPayrollSettingsQueryVariables>(GetPayrollSettingsDocument, options);
      }
export function useGetPayrollSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayrollSettingsQuery, GetPayrollSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayrollSettingsQuery, GetPayrollSettingsQueryVariables>(GetPayrollSettingsDocument, options);
        }
export type GetPayrollSettingsQueryHookResult = ReturnType<typeof useGetPayrollSettingsQuery>;
export type GetPayrollSettingsLazyQueryHookResult = ReturnType<typeof useGetPayrollSettingsLazyQuery>;
export type GetPayrollSettingsQueryResult = Apollo.QueryResult<GetPayrollSettingsQuery, GetPayrollSettingsQueryVariables>;
export const CustomDeductionsDocument = gql`
    query CustomDeductions($driverPayEntryId: ID!) {
  customDeductions(driverPayEntryId: $driverPayEntryId) {
    id
    name
    amount
  }
}
    `;

/**
 * __useCustomDeductionsQuery__
 *
 * To run a query within a React component, call `useCustomDeductionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomDeductionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDeductionsQuery({
 *   variables: {
 *      driverPayEntryId: // value for 'driverPayEntryId'
 *   },
 * });
 */
export function useCustomDeductionsQuery(baseOptions: Apollo.QueryHookOptions<CustomDeductionsQuery, CustomDeductionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomDeductionsQuery, CustomDeductionsQueryVariables>(CustomDeductionsDocument, options);
      }
export function useCustomDeductionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomDeductionsQuery, CustomDeductionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomDeductionsQuery, CustomDeductionsQueryVariables>(CustomDeductionsDocument, options);
        }
export type CustomDeductionsQueryHookResult = ReturnType<typeof useCustomDeductionsQuery>;
export type CustomDeductionsLazyQueryHookResult = ReturnType<typeof useCustomDeductionsLazyQuery>;
export type CustomDeductionsQueryResult = Apollo.QueryResult<CustomDeductionsQuery, CustomDeductionsQueryVariables>;
export const PayrollDeductionRulesPaginatedDocument = gql`
    query PayrollDeductionRulesPaginated($courierId: ID!, $limit: Int!, $after: Int!, $sortFields: [PayrollDeductionRuleSorting!]) {
  payrollDeductionRulesPaginated(
    courierId: $courierId
    limit: $limit
    after: $after
    sortFields: $sortFields
  ) {
    edges {
      node {
        ...PayrollDeductionRuleFragment
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${PayrollDeductionRuleFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __usePayrollDeductionRulesPaginatedQuery__
 *
 * To run a query within a React component, call `usePayrollDeductionRulesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollDeductionRulesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollDeductionRulesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function usePayrollDeductionRulesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<PayrollDeductionRulesPaginatedQuery, PayrollDeductionRulesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollDeductionRulesPaginatedQuery, PayrollDeductionRulesPaginatedQueryVariables>(PayrollDeductionRulesPaginatedDocument, options);
      }
export function usePayrollDeductionRulesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollDeductionRulesPaginatedQuery, PayrollDeductionRulesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollDeductionRulesPaginatedQuery, PayrollDeductionRulesPaginatedQueryVariables>(PayrollDeductionRulesPaginatedDocument, options);
        }
export type PayrollDeductionRulesPaginatedQueryHookResult = ReturnType<typeof usePayrollDeductionRulesPaginatedQuery>;
export type PayrollDeductionRulesPaginatedLazyQueryHookResult = ReturnType<typeof usePayrollDeductionRulesPaginatedLazyQuery>;
export type PayrollDeductionRulesPaginatedQueryResult = Apollo.QueryResult<PayrollDeductionRulesPaginatedQuery, PayrollDeductionRulesPaginatedQueryVariables>;
export const OrderPayBreakDownWithAllocationsDocument = gql`
    query OrderPayBreakDownWithAllocations($courierId: ID!, $orderId: ID!) {
  orderPayBreakDownWithAllocations(courierId: $courierId, orderId: $orderId) {
    allocations {
      driverId
      allocationRate
      breakdown {
        items {
          name
          description
          amount
        }
        total
      }
      driver {
        id
        firstName
        lastName
      }
    }
    isOverride
    total
  }
}
    `;

/**
 * __useOrderPayBreakDownWithAllocationsQuery__
 *
 * To run a query within a React component, call `useOrderPayBreakDownWithAllocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPayBreakDownWithAllocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPayBreakDownWithAllocationsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderPayBreakDownWithAllocationsQuery(baseOptions: Apollo.QueryHookOptions<OrderPayBreakDownWithAllocationsQuery, OrderPayBreakDownWithAllocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPayBreakDownWithAllocationsQuery, OrderPayBreakDownWithAllocationsQueryVariables>(OrderPayBreakDownWithAllocationsDocument, options);
      }
export function useOrderPayBreakDownWithAllocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPayBreakDownWithAllocationsQuery, OrderPayBreakDownWithAllocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPayBreakDownWithAllocationsQuery, OrderPayBreakDownWithAllocationsQueryVariables>(OrderPayBreakDownWithAllocationsDocument, options);
        }
export type OrderPayBreakDownWithAllocationsQueryHookResult = ReturnType<typeof useOrderPayBreakDownWithAllocationsQuery>;
export type OrderPayBreakDownWithAllocationsLazyQueryHookResult = ReturnType<typeof useOrderPayBreakDownWithAllocationsLazyQuery>;
export type OrderPayBreakDownWithAllocationsQueryResult = Apollo.QueryResult<OrderPayBreakDownWithAllocationsQuery, OrderPayBreakDownWithAllocationsQueryVariables>;
export const PreviewPriceDocument = gql`
    mutation PreviewPrice($courierId: ID!, $googlePlaceIds: [String!]!, $serviceTypeId: String, $requestedPricingAdjustments: [PricingAdjustmentCreate!], $endCustomerId: ID, $shipmentType: ShipmentType, $packageSize: PackageSize, $packageWeight: Float, $packageCount: Int, $packageTypeId: ID) {
  previewPrice(
    courierId: $courierId
    googlePlaceIds: $googlePlaceIds
    serviceTypeId: $serviceTypeId
    requestedPricingAdjustments: $requestedPricingAdjustments
    endCustomerId: $endCustomerId
    shipmentType: $shipmentType
    packageSize: $packageSize
    packageWeight: $packageWeight
    packageCount: $packageCount
    packageTypeId: $packageTypeId
  ) {
    total
    breakdown {
      ...PricingBreakDownFragment
    }
    pricingListId
    pricingList {
      ...PricingListFragment
    }
  }
}
    ${PricingBreakDownFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}`;
export type PreviewPriceMutationFn = Apollo.MutationFunction<PreviewPriceMutation, PreviewPriceMutationVariables>;

/**
 * __usePreviewPriceMutation__
 *
 * To run a mutation, you first call `usePreviewPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewPriceMutation, { data, loading, error }] = usePreviewPriceMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      googlePlaceIds: // value for 'googlePlaceIds'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      requestedPricingAdjustments: // value for 'requestedPricingAdjustments'
 *      endCustomerId: // value for 'endCustomerId'
 *      shipmentType: // value for 'shipmentType'
 *      packageSize: // value for 'packageSize'
 *      packageWeight: // value for 'packageWeight'
 *      packageCount: // value for 'packageCount'
 *      packageTypeId: // value for 'packageTypeId'
 *   },
 * });
 */
export function usePreviewPriceMutation(baseOptions?: Apollo.MutationHookOptions<PreviewPriceMutation, PreviewPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewPriceMutation, PreviewPriceMutationVariables>(PreviewPriceDocument, options);
      }
export type PreviewPriceMutationHookResult = ReturnType<typeof usePreviewPriceMutation>;
export type PreviewPriceMutationResult = Apollo.MutationResult<PreviewPriceMutation>;
export type PreviewPriceMutationOptions = Apollo.BaseMutationOptions<PreviewPriceMutation, PreviewPriceMutationVariables>;
export const CreatePricingRuleDocument = gql`
    mutation CreatePricingRule($pricingRuleCreate: PricingRuleCreate!) {
  createPricingRule(pricingRuleCreate: $pricingRuleCreate) {
    ...PricingRuleFragment
  }
}
    ${PricingRuleFragmentFragmentDoc}`;
export type CreatePricingRuleMutationFn = Apollo.MutationFunction<CreatePricingRuleMutation, CreatePricingRuleMutationVariables>;

/**
 * __useCreatePricingRuleMutation__
 *
 * To run a mutation, you first call `useCreatePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPricingRuleMutation, { data, loading, error }] = useCreatePricingRuleMutation({
 *   variables: {
 *      pricingRuleCreate: // value for 'pricingRuleCreate'
 *   },
 * });
 */
export function useCreatePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreatePricingRuleMutation, CreatePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePricingRuleMutation, CreatePricingRuleMutationVariables>(CreatePricingRuleDocument, options);
      }
export type CreatePricingRuleMutationHookResult = ReturnType<typeof useCreatePricingRuleMutation>;
export type CreatePricingRuleMutationResult = Apollo.MutationResult<CreatePricingRuleMutation>;
export type CreatePricingRuleMutationOptions = Apollo.BaseMutationOptions<CreatePricingRuleMutation, CreatePricingRuleMutationVariables>;
export const CreateSurchargePricingRuleDocument = gql`
    mutation CreateSurchargePricingRule($surchargePricingRuleCreate: SurchargePricingRuleCreate!) {
  createSurchargePricingRule(
    surchargePricingRuleCreate: $surchargePricingRuleCreate
  ) {
    ...SurchargePricingRuleFragment
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}`;
export type CreateSurchargePricingRuleMutationFn = Apollo.MutationFunction<CreateSurchargePricingRuleMutation, CreateSurchargePricingRuleMutationVariables>;

/**
 * __useCreateSurchargePricingRuleMutation__
 *
 * To run a mutation, you first call `useCreateSurchargePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurchargePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurchargePricingRuleMutation, { data, loading, error }] = useCreateSurchargePricingRuleMutation({
 *   variables: {
 *      surchargePricingRuleCreate: // value for 'surchargePricingRuleCreate'
 *   },
 * });
 */
export function useCreateSurchargePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurchargePricingRuleMutation, CreateSurchargePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurchargePricingRuleMutation, CreateSurchargePricingRuleMutationVariables>(CreateSurchargePricingRuleDocument, options);
      }
export type CreateSurchargePricingRuleMutationHookResult = ReturnType<typeof useCreateSurchargePricingRuleMutation>;
export type CreateSurchargePricingRuleMutationResult = Apollo.MutationResult<CreateSurchargePricingRuleMutation>;
export type CreateSurchargePricingRuleMutationOptions = Apollo.BaseMutationOptions<CreateSurchargePricingRuleMutation, CreateSurchargePricingRuleMutationVariables>;
export const DeletePricingRuleDocument = gql`
    mutation DeletePricingRule($pricingRuleId: ID!, $courierId: ID!) {
  deletePricingRule(pricingRuleId: $pricingRuleId, courierId: $courierId)
}
    `;
export type DeletePricingRuleMutationFn = Apollo.MutationFunction<DeletePricingRuleMutation, DeletePricingRuleMutationVariables>;

/**
 * __useDeletePricingRuleMutation__
 *
 * To run a mutation, you first call `useDeletePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePricingRuleMutation, { data, loading, error }] = useDeletePricingRuleMutation({
 *   variables: {
 *      pricingRuleId: // value for 'pricingRuleId'
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useDeletePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeletePricingRuleMutation, DeletePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePricingRuleMutation, DeletePricingRuleMutationVariables>(DeletePricingRuleDocument, options);
      }
export type DeletePricingRuleMutationHookResult = ReturnType<typeof useDeletePricingRuleMutation>;
export type DeletePricingRuleMutationResult = Apollo.MutationResult<DeletePricingRuleMutation>;
export type DeletePricingRuleMutationOptions = Apollo.BaseMutationOptions<DeletePricingRuleMutation, DeletePricingRuleMutationVariables>;
export const DeleteSurchargePricingRuleDocument = gql`
    mutation DeleteSurchargePricingRule($surchargePricingRuleId: ID!, $courierId: ID!) {
  deleteSurchargePricingRule(
    surchargePricingRuleId: $surchargePricingRuleId
    courierId: $courierId
  )
}
    `;
export type DeleteSurchargePricingRuleMutationFn = Apollo.MutationFunction<DeleteSurchargePricingRuleMutation, DeleteSurchargePricingRuleMutationVariables>;

/**
 * __useDeleteSurchargePricingRuleMutation__
 *
 * To run a mutation, you first call `useDeleteSurchargePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurchargePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurchargePricingRuleMutation, { data, loading, error }] = useDeleteSurchargePricingRuleMutation({
 *   variables: {
 *      surchargePricingRuleId: // value for 'surchargePricingRuleId'
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useDeleteSurchargePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurchargePricingRuleMutation, DeleteSurchargePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurchargePricingRuleMutation, DeleteSurchargePricingRuleMutationVariables>(DeleteSurchargePricingRuleDocument, options);
      }
export type DeleteSurchargePricingRuleMutationHookResult = ReturnType<typeof useDeleteSurchargePricingRuleMutation>;
export type DeleteSurchargePricingRuleMutationResult = Apollo.MutationResult<DeleteSurchargePricingRuleMutation>;
export type DeleteSurchargePricingRuleMutationOptions = Apollo.BaseMutationOptions<DeleteSurchargePricingRuleMutation, DeleteSurchargePricingRuleMutationVariables>;
export const CreatePricingListDocument = gql`
    mutation CreatePricingList($courierId: ID!, $name: String!, $copyBasePricingRules: Boolean, $pricingListIdToCopyFrom: ID, $pricingRulesValueMultiplier: Float) {
  createPricingList(
    courierId: $courierId
    name: $name
    copyBasePricingRules: $copyBasePricingRules
    pricingListIdToCopyFrom: $pricingListIdToCopyFrom
    pricingRulesValueMultiplier: $pricingRulesValueMultiplier
  ) {
    id
    displayId
    courierId
    name
  }
}
    `;
export type CreatePricingListMutationFn = Apollo.MutationFunction<CreatePricingListMutation, CreatePricingListMutationVariables>;

/**
 * __useCreatePricingListMutation__
 *
 * To run a mutation, you first call `useCreatePricingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePricingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPricingListMutation, { data, loading, error }] = useCreatePricingListMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      copyBasePricingRules: // value for 'copyBasePricingRules'
 *      pricingListIdToCopyFrom: // value for 'pricingListIdToCopyFrom'
 *      pricingRulesValueMultiplier: // value for 'pricingRulesValueMultiplier'
 *   },
 * });
 */
export function useCreatePricingListMutation(baseOptions?: Apollo.MutationHookOptions<CreatePricingListMutation, CreatePricingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePricingListMutation, CreatePricingListMutationVariables>(CreatePricingListDocument, options);
      }
export type CreatePricingListMutationHookResult = ReturnType<typeof useCreatePricingListMutation>;
export type CreatePricingListMutationResult = Apollo.MutationResult<CreatePricingListMutation>;
export type CreatePricingListMutationOptions = Apollo.BaseMutationOptions<CreatePricingListMutation, CreatePricingListMutationVariables>;
export const DeletePricingListDocument = gql`
    mutation DeletePricingList($pricingListId: ID!) {
  deletePricingList(pricingListId: $pricingListId)
}
    `;
export type DeletePricingListMutationFn = Apollo.MutationFunction<DeletePricingListMutation, DeletePricingListMutationVariables>;

/**
 * __useDeletePricingListMutation__
 *
 * To run a mutation, you first call `useDeletePricingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePricingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePricingListMutation, { data, loading, error }] = useDeletePricingListMutation({
 *   variables: {
 *      pricingListId: // value for 'pricingListId'
 *   },
 * });
 */
export function useDeletePricingListMutation(baseOptions?: Apollo.MutationHookOptions<DeletePricingListMutation, DeletePricingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePricingListMutation, DeletePricingListMutationVariables>(DeletePricingListDocument, options);
      }
export type DeletePricingListMutationHookResult = ReturnType<typeof useDeletePricingListMutation>;
export type DeletePricingListMutationResult = Apollo.MutationResult<DeletePricingListMutation>;
export type DeletePricingListMutationOptions = Apollo.BaseMutationOptions<DeletePricingListMutation, DeletePricingListMutationVariables>;
export const FullUpdatePricingRuleDocument = gql`
    mutation FullUpdatePricingRule($pricingRuleFullUpdate: PricingRuleFullUpdate!) {
  fullUpdatePricingRule(pricingRuleFullUpdate: $pricingRuleFullUpdate) {
    ...PricingRuleFragment
  }
}
    ${PricingRuleFragmentFragmentDoc}`;
export type FullUpdatePricingRuleMutationFn = Apollo.MutationFunction<FullUpdatePricingRuleMutation, FullUpdatePricingRuleMutationVariables>;

/**
 * __useFullUpdatePricingRuleMutation__
 *
 * To run a mutation, you first call `useFullUpdatePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdatePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdatePricingRuleMutation, { data, loading, error }] = useFullUpdatePricingRuleMutation({
 *   variables: {
 *      pricingRuleFullUpdate: // value for 'pricingRuleFullUpdate'
 *   },
 * });
 */
export function useFullUpdatePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdatePricingRuleMutation, FullUpdatePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdatePricingRuleMutation, FullUpdatePricingRuleMutationVariables>(FullUpdatePricingRuleDocument, options);
      }
export type FullUpdatePricingRuleMutationHookResult = ReturnType<typeof useFullUpdatePricingRuleMutation>;
export type FullUpdatePricingRuleMutationResult = Apollo.MutationResult<FullUpdatePricingRuleMutation>;
export type FullUpdatePricingRuleMutationOptions = Apollo.BaseMutationOptions<FullUpdatePricingRuleMutation, FullUpdatePricingRuleMutationVariables>;
export const FullUpdateSurchargePricingRuleDocument = gql`
    mutation FullUpdateSurchargePricingRule($surchargePricingRuleFullUpdate: SurchargePricingRuleFullUpdate!) {
  fullUpdateSurchargePricingRule(
    surchargePricingRuleFullUpdate: $surchargePricingRuleFullUpdate
  ) {
    id
    courierId
    pricingListId
    name
    amount
    percent
    amountType
    applyType
    amountDisplay
    minMiles
    maxMiles
    pricingList {
      ...PricingListFragment
    }
  }
}
    ${PricingListFragmentFragmentDoc}`;
export type FullUpdateSurchargePricingRuleMutationFn = Apollo.MutationFunction<FullUpdateSurchargePricingRuleMutation, FullUpdateSurchargePricingRuleMutationVariables>;

/**
 * __useFullUpdateSurchargePricingRuleMutation__
 *
 * To run a mutation, you first call `useFullUpdateSurchargePricingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateSurchargePricingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateSurchargePricingRuleMutation, { data, loading, error }] = useFullUpdateSurchargePricingRuleMutation({
 *   variables: {
 *      surchargePricingRuleFullUpdate: // value for 'surchargePricingRuleFullUpdate'
 *   },
 * });
 */
export function useFullUpdateSurchargePricingRuleMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateSurchargePricingRuleMutation, FullUpdateSurchargePricingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateSurchargePricingRuleMutation, FullUpdateSurchargePricingRuleMutationVariables>(FullUpdateSurchargePricingRuleDocument, options);
      }
export type FullUpdateSurchargePricingRuleMutationHookResult = ReturnType<typeof useFullUpdateSurchargePricingRuleMutation>;
export type FullUpdateSurchargePricingRuleMutationResult = Apollo.MutationResult<FullUpdateSurchargePricingRuleMutation>;
export type FullUpdateSurchargePricingRuleMutationOptions = Apollo.BaseMutationOptions<FullUpdateSurchargePricingRuleMutation, FullUpdateSurchargePricingRuleMutationVariables>;
export const ModifyOrderPricingDocument = gql`
    mutation ModifyOrderPricing($orderId: ID!, $adjustmentsToAdd: [PricingAdjustmentCreate!], $adjustmentIdsToRemove: [ID!], $priceOverride: Money, $basePriceOverride: Money, $adjustmentOverrides: [AdjustmentOverrideInput!], $updatedBy: String, $priceOverrideBreakdown: [PriceOverrideBreakdownItemInput!]) {
  modifyOrderPricing(
    orderId: $orderId
    adjustmentsToAdd: $adjustmentsToAdd
    adjustmentIdsToRemove: $adjustmentIdsToRemove
    priceOverride: $priceOverride
    basePriceOverride: $basePriceOverride
    adjustmentOverrides: $adjustmentOverrides
    updatedBy: $updatedBy
    priceOverrideBreakdown: $priceOverrideBreakdown
  ) {
    ...OrderPriceFragment
  }
}
    ${OrderPriceFragmentFragmentDoc}`;
export type ModifyOrderPricingMutationFn = Apollo.MutationFunction<ModifyOrderPricingMutation, ModifyOrderPricingMutationVariables>;

/**
 * __useModifyOrderPricingMutation__
 *
 * To run a mutation, you first call `useModifyOrderPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyOrderPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyOrderPricingMutation, { data, loading, error }] = useModifyOrderPricingMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      adjustmentsToAdd: // value for 'adjustmentsToAdd'
 *      adjustmentIdsToRemove: // value for 'adjustmentIdsToRemove'
 *      priceOverride: // value for 'priceOverride'
 *      basePriceOverride: // value for 'basePriceOverride'
 *      adjustmentOverrides: // value for 'adjustmentOverrides'
 *      updatedBy: // value for 'updatedBy'
 *      priceOverrideBreakdown: // value for 'priceOverrideBreakdown'
 *   },
 * });
 */
export function useModifyOrderPricingMutation(baseOptions?: Apollo.MutationHookOptions<ModifyOrderPricingMutation, ModifyOrderPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyOrderPricingMutation, ModifyOrderPricingMutationVariables>(ModifyOrderPricingDocument, options);
      }
export type ModifyOrderPricingMutationHookResult = ReturnType<typeof useModifyOrderPricingMutation>;
export type ModifyOrderPricingMutationResult = Apollo.MutationResult<ModifyOrderPricingMutation>;
export type ModifyOrderPricingMutationOptions = Apollo.BaseMutationOptions<ModifyOrderPricingMutation, ModifyOrderPricingMutationVariables>;
export const PreviewOrderPricingModificationDocument = gql`
    mutation PreviewOrderPricingModification($orderId: ID!, $adjustmentsToAdd: [PricingAdjustmentCreate!]!, $adjustmentIdsToRemove: [ID!]!, $priceOverride: Money) {
  previewOrderPricingModification(
    orderId: $orderId
    adjustmentsToAdd: $adjustmentsToAdd
    adjustmentIdsToRemove: $adjustmentIdsToRemove
    priceOverride: $priceOverride
  ) {
    total
  }
}
    `;
export type PreviewOrderPricingModificationMutationFn = Apollo.MutationFunction<PreviewOrderPricingModificationMutation, PreviewOrderPricingModificationMutationVariables>;

/**
 * __usePreviewOrderPricingModificationMutation__
 *
 * To run a mutation, you first call `usePreviewOrderPricingModificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewOrderPricingModificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewOrderPricingModificationMutation, { data, loading, error }] = usePreviewOrderPricingModificationMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      adjustmentsToAdd: // value for 'adjustmentsToAdd'
 *      adjustmentIdsToRemove: // value for 'adjustmentIdsToRemove'
 *      priceOverride: // value for 'priceOverride'
 *   },
 * });
 */
export function usePreviewOrderPricingModificationMutation(baseOptions?: Apollo.MutationHookOptions<PreviewOrderPricingModificationMutation, PreviewOrderPricingModificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewOrderPricingModificationMutation, PreviewOrderPricingModificationMutationVariables>(PreviewOrderPricingModificationDocument, options);
      }
export type PreviewOrderPricingModificationMutationHookResult = ReturnType<typeof usePreviewOrderPricingModificationMutation>;
export type PreviewOrderPricingModificationMutationResult = Apollo.MutationResult<PreviewOrderPricingModificationMutation>;
export type PreviewOrderPricingModificationMutationOptions = Apollo.BaseMutationOptions<PreviewOrderPricingModificationMutation, PreviewOrderPricingModificationMutationVariables>;
export const UpdatePriceOverrideForRecurringOrderDocument = gql`
    mutation UpdatePriceOverrideForRecurringOrder($orderId: ID!, $priceOverride: Money, $updatedBy: String, $breakdown: [PriceOverrideBreakdownItemInput!]) {
  updatePriceOverrideForRecurringOrder(
    orderId: $orderId
    priceOverride: $priceOverride
    updatedBy: $updatedBy
    breakdown: $breakdown
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type UpdatePriceOverrideForRecurringOrderMutationFn = Apollo.MutationFunction<UpdatePriceOverrideForRecurringOrderMutation, UpdatePriceOverrideForRecurringOrderMutationVariables>;

/**
 * __useUpdatePriceOverrideForRecurringOrderMutation__
 *
 * To run a mutation, you first call `useUpdatePriceOverrideForRecurringOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriceOverrideForRecurringOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriceOverrideForRecurringOrderMutation, { data, loading, error }] = useUpdatePriceOverrideForRecurringOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      priceOverride: // value for 'priceOverride'
 *      updatedBy: // value for 'updatedBy'
 *      breakdown: // value for 'breakdown'
 *   },
 * });
 */
export function useUpdatePriceOverrideForRecurringOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriceOverrideForRecurringOrderMutation, UpdatePriceOverrideForRecurringOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriceOverrideForRecurringOrderMutation, UpdatePriceOverrideForRecurringOrderMutationVariables>(UpdatePriceOverrideForRecurringOrderDocument, options);
      }
export type UpdatePriceOverrideForRecurringOrderMutationHookResult = ReturnType<typeof useUpdatePriceOverrideForRecurringOrderMutation>;
export type UpdatePriceOverrideForRecurringOrderMutationResult = Apollo.MutationResult<UpdatePriceOverrideForRecurringOrderMutation>;
export type UpdatePriceOverrideForRecurringOrderMutationOptions = Apollo.BaseMutationOptions<UpdatePriceOverrideForRecurringOrderMutation, UpdatePriceOverrideForRecurringOrderMutationVariables>;
export const UpdateDriverPayOverrideDocument = gql`
    mutation UpdateDriverPayOverride($orderId: ID!, $driverPayOverride: Money, $updatedBy: String) {
  updateDriverPayOverride(
    orderId: $orderId
    driverPayOverride: $driverPayOverride
    updatedBy: $updatedBy
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type UpdateDriverPayOverrideMutationFn = Apollo.MutationFunction<UpdateDriverPayOverrideMutation, UpdateDriverPayOverrideMutationVariables>;

/**
 * __useUpdateDriverPayOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateDriverPayOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverPayOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverPayOverrideMutation, { data, loading, error }] = useUpdateDriverPayOverrideMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      driverPayOverride: // value for 'driverPayOverride'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useUpdateDriverPayOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverPayOverrideMutation, UpdateDriverPayOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverPayOverrideMutation, UpdateDriverPayOverrideMutationVariables>(UpdateDriverPayOverrideDocument, options);
      }
export type UpdateDriverPayOverrideMutationHookResult = ReturnType<typeof useUpdateDriverPayOverrideMutation>;
export type UpdateDriverPayOverrideMutationResult = Apollo.MutationResult<UpdateDriverPayOverrideMutation>;
export type UpdateDriverPayOverrideMutationOptions = Apollo.BaseMutationOptions<UpdateDriverPayOverrideMutation, UpdateDriverPayOverrideMutationVariables>;
export const CreateZipGroupDocument = gql`
    mutation CreateZipGroup($courierId: ID!, $name: String!, $zipCodes: [String!]!) {
  createZipGroup(courierId: $courierId, name: $name, zipCodes: $zipCodes) {
    id
    name
    zipCodes
  }
}
    `;
export type CreateZipGroupMutationFn = Apollo.MutationFunction<CreateZipGroupMutation, CreateZipGroupMutationVariables>;

/**
 * __useCreateZipGroupMutation__
 *
 * To run a mutation, you first call `useCreateZipGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZipGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZipGroupMutation, { data, loading, error }] = useCreateZipGroupMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      zipCodes: // value for 'zipCodes'
 *   },
 * });
 */
export function useCreateZipGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateZipGroupMutation, CreateZipGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZipGroupMutation, CreateZipGroupMutationVariables>(CreateZipGroupDocument, options);
      }
export type CreateZipGroupMutationHookResult = ReturnType<typeof useCreateZipGroupMutation>;
export type CreateZipGroupMutationResult = Apollo.MutationResult<CreateZipGroupMutation>;
export type CreateZipGroupMutationOptions = Apollo.BaseMutationOptions<CreateZipGroupMutation, CreateZipGroupMutationVariables>;
export const FullUpdateZipGroupDocument = gql`
    mutation FullUpdateZipGroup($zipGroupId: ID!, $name: String!, $zipCodes: [String!]!) {
  fullUpdateZipGroup(zipGroupId: $zipGroupId, name: $name, zipCodes: $zipCodes) {
    id
    name
    zipCodes
  }
}
    `;
export type FullUpdateZipGroupMutationFn = Apollo.MutationFunction<FullUpdateZipGroupMutation, FullUpdateZipGroupMutationVariables>;

/**
 * __useFullUpdateZipGroupMutation__
 *
 * To run a mutation, you first call `useFullUpdateZipGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateZipGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateZipGroupMutation, { data, loading, error }] = useFullUpdateZipGroupMutation({
 *   variables: {
 *      zipGroupId: // value for 'zipGroupId'
 *      name: // value for 'name'
 *      zipCodes: // value for 'zipCodes'
 *   },
 * });
 */
export function useFullUpdateZipGroupMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateZipGroupMutation, FullUpdateZipGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateZipGroupMutation, FullUpdateZipGroupMutationVariables>(FullUpdateZipGroupDocument, options);
      }
export type FullUpdateZipGroupMutationHookResult = ReturnType<typeof useFullUpdateZipGroupMutation>;
export type FullUpdateZipGroupMutationResult = Apollo.MutationResult<FullUpdateZipGroupMutation>;
export type FullUpdateZipGroupMutationOptions = Apollo.BaseMutationOptions<FullUpdateZipGroupMutation, FullUpdateZipGroupMutationVariables>;
export const OverrideAdjustmentAmountDocument = gql`
    mutation OverrideAdjustmentAmount($adjustmentId: ID!, $amountOverride: Money) {
  overrideAdjustmentAmount(
    adjustmentId: $adjustmentId
    amountOverride: $amountOverride
  ) {
    ...PricingAdjustmentFragment
  }
}
    ${PricingAdjustmentFragmentFragmentDoc}`;
export type OverrideAdjustmentAmountMutationFn = Apollo.MutationFunction<OverrideAdjustmentAmountMutation, OverrideAdjustmentAmountMutationVariables>;

/**
 * __useOverrideAdjustmentAmountMutation__
 *
 * To run a mutation, you first call `useOverrideAdjustmentAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideAdjustmentAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideAdjustmentAmountMutation, { data, loading, error }] = useOverrideAdjustmentAmountMutation({
 *   variables: {
 *      adjustmentId: // value for 'adjustmentId'
 *      amountOverride: // value for 'amountOverride'
 *   },
 * });
 */
export function useOverrideAdjustmentAmountMutation(baseOptions?: Apollo.MutationHookOptions<OverrideAdjustmentAmountMutation, OverrideAdjustmentAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideAdjustmentAmountMutation, OverrideAdjustmentAmountMutationVariables>(OverrideAdjustmentAmountDocument, options);
      }
export type OverrideAdjustmentAmountMutationHookResult = ReturnType<typeof useOverrideAdjustmentAmountMutation>;
export type OverrideAdjustmentAmountMutationResult = Apollo.MutationResult<OverrideAdjustmentAmountMutation>;
export type OverrideAdjustmentAmountMutationOptions = Apollo.BaseMutationOptions<OverrideAdjustmentAmountMutation, OverrideAdjustmentAmountMutationVariables>;
export const BulkUploadPricingRulesDocument = gql`
    mutation BulkUploadPricingRules($courierId: ID!, $file: Upload!) {
  bulkUploadPricingRules(courierId: $courierId, file: $file) {
    numSuccess
    errors {
      rowNumber
      messages
    }
  }
}
    `;
export type BulkUploadPricingRulesMutationFn = Apollo.MutationFunction<BulkUploadPricingRulesMutation, BulkUploadPricingRulesMutationVariables>;

/**
 * __useBulkUploadPricingRulesMutation__
 *
 * To run a mutation, you first call `useBulkUploadPricingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadPricingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadPricingRulesMutation, { data, loading, error }] = useBulkUploadPricingRulesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useBulkUploadPricingRulesMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadPricingRulesMutation, BulkUploadPricingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadPricingRulesMutation, BulkUploadPricingRulesMutationVariables>(BulkUploadPricingRulesDocument, options);
      }
export type BulkUploadPricingRulesMutationHookResult = ReturnType<typeof useBulkUploadPricingRulesMutation>;
export type BulkUploadPricingRulesMutationResult = Apollo.MutationResult<BulkUploadPricingRulesMutation>;
export type BulkUploadPricingRulesMutationOptions = Apollo.BaseMutationOptions<BulkUploadPricingRulesMutation, BulkUploadPricingRulesMutationVariables>;
export const BulkMultiplyPricingRulesDocument = gql`
    mutation BulkMultiplyPricingRules($courierId: ID!, $pricingListId: ID, $multiplier: Float!, $isBasePricingList: Boolean!) {
  bulkMultiplyPricingRules(
    courierId: $courierId
    pricingListId: $pricingListId
    multiplier: $multiplier
    isBasePricingList: $isBasePricingList
  ) {
    numSuccess
  }
}
    `;
export type BulkMultiplyPricingRulesMutationFn = Apollo.MutationFunction<BulkMultiplyPricingRulesMutation, BulkMultiplyPricingRulesMutationVariables>;

/**
 * __useBulkMultiplyPricingRulesMutation__
 *
 * To run a mutation, you first call `useBulkMultiplyPricingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMultiplyPricingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMultiplyPricingRulesMutation, { data, loading, error }] = useBulkMultiplyPricingRulesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingListId: // value for 'pricingListId'
 *      multiplier: // value for 'multiplier'
 *      isBasePricingList: // value for 'isBasePricingList'
 *   },
 * });
 */
export function useBulkMultiplyPricingRulesMutation(baseOptions?: Apollo.MutationHookOptions<BulkMultiplyPricingRulesMutation, BulkMultiplyPricingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkMultiplyPricingRulesMutation, BulkMultiplyPricingRulesMutationVariables>(BulkMultiplyPricingRulesDocument, options);
      }
export type BulkMultiplyPricingRulesMutationHookResult = ReturnType<typeof useBulkMultiplyPricingRulesMutation>;
export type BulkMultiplyPricingRulesMutationResult = Apollo.MutationResult<BulkMultiplyPricingRulesMutation>;
export type BulkMultiplyPricingRulesMutationOptions = Apollo.BaseMutationOptions<BulkMultiplyPricingRulesMutation, BulkMultiplyPricingRulesMutationVariables>;
export const GetOrderPriceDocument = gql`
    query GetOrderPrice($orderId: ID!) {
  orderPrice(orderId: $orderId) {
    ...OrderPriceFragment
  }
}
    ${OrderPriceFragmentFragmentDoc}`;

/**
 * __useGetOrderPriceQuery__
 *
 * To run a query within a React component, call `useGetOrderPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderPriceQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderPriceQuery(baseOptions: Apollo.QueryHookOptions<GetOrderPriceQuery, GetOrderPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderPriceQuery, GetOrderPriceQueryVariables>(GetOrderPriceDocument, options);
      }
export function useGetOrderPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderPriceQuery, GetOrderPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderPriceQuery, GetOrderPriceQueryVariables>(GetOrderPriceDocument, options);
        }
export type GetOrderPriceQueryHookResult = ReturnType<typeof useGetOrderPriceQuery>;
export type GetOrderPriceLazyQueryHookResult = ReturnType<typeof useGetOrderPriceLazyQuery>;
export type GetOrderPriceQueryResult = Apollo.QueryResult<GetOrderPriceQuery, GetOrderPriceQueryVariables>;
export const GetPricingRulesPaginatedDocument = gql`
    query GetPricingRulesPaginated($courierId: ID!, $defaultOnly: Boolean, $locationBasedOnly: Boolean, $pricingListIdsFilter: [ID!], $defaultPricingListOnly: Boolean, $distanceBasedOnly: Boolean, $tripBasedOnly: Boolean, $sortFields: [PricingRulesSorting!], $originZoneIdFilter: ID, $originCityFilter: CityStateCountryCreate, $originZipFilter: String, $originZipGroupIdFilter: ID, $destinationZoneIdFilter: ID, $destinationCityFilter: CityStateCountryCreate, $destinationZipFilter: String, $destinationZipGroupIdFilter: ID, $serviceTypeIdsFilter: [String!], $limit: Int, $after: Int) {
  pricingRulesPaginated(
    courierId: $courierId
    defaultOnly: $defaultOnly
    locationBasedOnly: $locationBasedOnly
    pricingListIdsFilter: $pricingListIdsFilter
    defaultPricingListOnly: $defaultPricingListOnly
    distanceBasedOnly: $distanceBasedOnly
    tripBasedOnly: $tripBasedOnly
    sortFields: $sortFields
    originZoneIdFilter: $originZoneIdFilter
    originCityFilter: $originCityFilter
    originZipFilter: $originZipFilter
    originZipGroupIdFilter: $originZipGroupIdFilter
    destinationZoneIdFilter: $destinationZoneIdFilter
    destinationCityFilter: $destinationCityFilter
    destinationZipFilter: $destinationZipFilter
    destinationZipGroupIdFilter: $destinationZipGroupIdFilter
    serviceTypeIdsFilter: $serviceTypeIdsFilter
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...PricingRuleFragment
        pricingList {
          ...PricingListFragment
        }
        serviceType {
          ...ServiceTypeFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${PricingRuleFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetPricingRulesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetPricingRulesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingRulesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingRulesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      defaultOnly: // value for 'defaultOnly'
 *      locationBasedOnly: // value for 'locationBasedOnly'
 *      pricingListIdsFilter: // value for 'pricingListIdsFilter'
 *      defaultPricingListOnly: // value for 'defaultPricingListOnly'
 *      distanceBasedOnly: // value for 'distanceBasedOnly'
 *      tripBasedOnly: // value for 'tripBasedOnly'
 *      sortFields: // value for 'sortFields'
 *      originZoneIdFilter: // value for 'originZoneIdFilter'
 *      originCityFilter: // value for 'originCityFilter'
 *      originZipFilter: // value for 'originZipFilter'
 *      originZipGroupIdFilter: // value for 'originZipGroupIdFilter'
 *      destinationZoneIdFilter: // value for 'destinationZoneIdFilter'
 *      destinationCityFilter: // value for 'destinationCityFilter'
 *      destinationZipFilter: // value for 'destinationZipFilter'
 *      destinationZipGroupIdFilter: // value for 'destinationZipGroupIdFilter'
 *      serviceTypeIdsFilter: // value for 'serviceTypeIdsFilter'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPricingRulesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetPricingRulesPaginatedQuery, GetPricingRulesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingRulesPaginatedQuery, GetPricingRulesPaginatedQueryVariables>(GetPricingRulesPaginatedDocument, options);
      }
export function useGetPricingRulesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingRulesPaginatedQuery, GetPricingRulesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingRulesPaginatedQuery, GetPricingRulesPaginatedQueryVariables>(GetPricingRulesPaginatedDocument, options);
        }
export type GetPricingRulesPaginatedQueryHookResult = ReturnType<typeof useGetPricingRulesPaginatedQuery>;
export type GetPricingRulesPaginatedLazyQueryHookResult = ReturnType<typeof useGetPricingRulesPaginatedLazyQuery>;
export type GetPricingRulesPaginatedQueryResult = Apollo.QueryResult<GetPricingRulesPaginatedQuery, GetPricingRulesPaginatedQueryVariables>;
export const GetSurchargePricingRuleDocument = gql`
    query GetSurchargePricingRule($courierId: ID!, $surchargeApplyType: SurchargeApplyType, $pricingListIdsFilter: [ID], $defaultPricingListOnly: Boolean, $amountTypes: [SurchargeAmountType!]) {
  surchargePricingRules(
    courierId: $courierId
    applyType: $surchargeApplyType
    pricingListIdsFilter: $pricingListIdsFilter
    defaultPricingListOnly: $defaultPricingListOnly
    amountTypes: $amountTypes
  ) {
    ...SurchargePricingRuleFragment
    surchargePricingRulesToExclude {
      ...SurchargePricingRuleFragment
    }
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}`;

/**
 * __useGetSurchargePricingRuleQuery__
 *
 * To run a query within a React component, call `useGetSurchargePricingRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurchargePricingRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurchargePricingRuleQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      surchargeApplyType: // value for 'surchargeApplyType'
 *      pricingListIdsFilter: // value for 'pricingListIdsFilter'
 *      defaultPricingListOnly: // value for 'defaultPricingListOnly'
 *      amountTypes: // value for 'amountTypes'
 *   },
 * });
 */
export function useGetSurchargePricingRuleQuery(baseOptions: Apollo.QueryHookOptions<GetSurchargePricingRuleQuery, GetSurchargePricingRuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurchargePricingRuleQuery, GetSurchargePricingRuleQueryVariables>(GetSurchargePricingRuleDocument, options);
      }
export function useGetSurchargePricingRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurchargePricingRuleQuery, GetSurchargePricingRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurchargePricingRuleQuery, GetSurchargePricingRuleQueryVariables>(GetSurchargePricingRuleDocument, options);
        }
export type GetSurchargePricingRuleQueryHookResult = ReturnType<typeof useGetSurchargePricingRuleQuery>;
export type GetSurchargePricingRuleLazyQueryHookResult = ReturnType<typeof useGetSurchargePricingRuleLazyQuery>;
export type GetSurchargePricingRuleQueryResult = Apollo.QueryResult<GetSurchargePricingRuleQuery, GetSurchargePricingRuleQueryVariables>;
export const GetSurchargePricingRulesPaginatedDocument = gql`
    query GetSurchargePricingRulesPaginated($courierId: ID!, $pricingListIdsFilter: [ID!], $defaultPricingListOnly: Boolean, $limit: Int!, $after: Int!) {
  surchargePricingRulesPaginated(
    courierId: $courierId
    pricingListIdsFilter: $pricingListIdsFilter
    defaultPricingListOnly: $defaultPricingListOnly
    limit: $limit
    after: $after
  ) {
    edges {
      node {
        ...SurchargePricingRuleFragment
        surchargePricingRulesToExclude {
          ...SurchargePricingRuleFragment
        }
        pricingList {
          ...PricingListFragment
        }
        packageType {
          id
          courierId
          name
        }
        serviceType {
          ...ServiceTypeFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${SurchargePricingRuleFragmentFragmentDoc}
${PricingListFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetSurchargePricingRulesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetSurchargePricingRulesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurchargePricingRulesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurchargePricingRulesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      pricingListIdsFilter: // value for 'pricingListIdsFilter'
 *      defaultPricingListOnly: // value for 'defaultPricingListOnly'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSurchargePricingRulesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetSurchargePricingRulesPaginatedQuery, GetSurchargePricingRulesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurchargePricingRulesPaginatedQuery, GetSurchargePricingRulesPaginatedQueryVariables>(GetSurchargePricingRulesPaginatedDocument, options);
      }
export function useGetSurchargePricingRulesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurchargePricingRulesPaginatedQuery, GetSurchargePricingRulesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurchargePricingRulesPaginatedQuery, GetSurchargePricingRulesPaginatedQueryVariables>(GetSurchargePricingRulesPaginatedDocument, options);
        }
export type GetSurchargePricingRulesPaginatedQueryHookResult = ReturnType<typeof useGetSurchargePricingRulesPaginatedQuery>;
export type GetSurchargePricingRulesPaginatedLazyQueryHookResult = ReturnType<typeof useGetSurchargePricingRulesPaginatedLazyQuery>;
export type GetSurchargePricingRulesPaginatedQueryResult = Apollo.QueryResult<GetSurchargePricingRulesPaginatedQuery, GetSurchargePricingRulesPaginatedQueryVariables>;
export const GetPricingListsDocument = gql`
    query GetPricingLists($courierId: ID!) {
  pricingLists(courierId: $courierId) {
    ...PricingListFragment
  }
}
    ${PricingListFragmentFragmentDoc}`;

/**
 * __useGetPricingListsQuery__
 *
 * To run a query within a React component, call `useGetPricingListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingListsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetPricingListsQuery(baseOptions: Apollo.QueryHookOptions<GetPricingListsQuery, GetPricingListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingListsQuery, GetPricingListsQueryVariables>(GetPricingListsDocument, options);
      }
export function useGetPricingListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingListsQuery, GetPricingListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingListsQuery, GetPricingListsQueryVariables>(GetPricingListsDocument, options);
        }
export type GetPricingListsQueryHookResult = ReturnType<typeof useGetPricingListsQuery>;
export type GetPricingListsLazyQueryHookResult = ReturnType<typeof useGetPricingListsLazyQuery>;
export type GetPricingListsQueryResult = Apollo.QueryResult<GetPricingListsQuery, GetPricingListsQueryVariables>;
export const GetZipGroupsDocument = gql`
    query GetZipGroups($courierId: ID!) {
  zipGroups(courierId: $courierId) {
    ...ZipGroupFragment
  }
}
    ${ZipGroupFragmentFragmentDoc}`;

/**
 * __useGetZipGroupsQuery__
 *
 * To run a query within a React component, call `useGetZipGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZipGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZipGroupsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useGetZipGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetZipGroupsQuery, GetZipGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZipGroupsQuery, GetZipGroupsQueryVariables>(GetZipGroupsDocument, options);
      }
export function useGetZipGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZipGroupsQuery, GetZipGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZipGroupsQuery, GetZipGroupsQueryVariables>(GetZipGroupsDocument, options);
        }
export type GetZipGroupsQueryHookResult = ReturnType<typeof useGetZipGroupsQuery>;
export type GetZipGroupsLazyQueryHookResult = ReturnType<typeof useGetZipGroupsLazyQuery>;
export type GetZipGroupsQueryResult = Apollo.QueryResult<GetZipGroupsQuery, GetZipGroupsQueryVariables>;
export const UpsertRemoteEntityLinkageDocument = gql`
    mutation UpsertRemoteEntityLinkage($upsert: RemoteEntityLinkageUpsert!) {
  upsertRemoteEntityLinkage(upsert: $upsert) {
    id
    externalUrl
  }
}
    `;
export type UpsertRemoteEntityLinkageMutationFn = Apollo.MutationFunction<UpsertRemoteEntityLinkageMutation, UpsertRemoteEntityLinkageMutationVariables>;

/**
 * __useUpsertRemoteEntityLinkageMutation__
 *
 * To run a mutation, you first call `useUpsertRemoteEntityLinkageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRemoteEntityLinkageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRemoteEntityLinkageMutation, { data, loading, error }] = useUpsertRemoteEntityLinkageMutation({
 *   variables: {
 *      upsert: // value for 'upsert'
 *   },
 * });
 */
export function useUpsertRemoteEntityLinkageMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRemoteEntityLinkageMutation, UpsertRemoteEntityLinkageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertRemoteEntityLinkageMutation, UpsertRemoteEntityLinkageMutationVariables>(UpsertRemoteEntityLinkageDocument, options);
      }
export type UpsertRemoteEntityLinkageMutationHookResult = ReturnType<typeof useUpsertRemoteEntityLinkageMutation>;
export type UpsertRemoteEntityLinkageMutationResult = Apollo.MutationResult<UpsertRemoteEntityLinkageMutation>;
export type UpsertRemoteEntityLinkageMutationOptions = Apollo.BaseMutationOptions<UpsertRemoteEntityLinkageMutation, UpsertRemoteEntityLinkageMutationVariables>;
export const QuickbookCustomerDocument = gql`
    query QuickbookCustomer($courierId: ID!, $remoteId: ID!) {
  quickbookCustomer(courierId: $courierId, remoteId: $remoteId) {
    id
    name
    email
    phone
  }
}
    `;

/**
 * __useQuickbookCustomerQuery__
 *
 * To run a query within a React component, call `useQuickbookCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickbookCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickbookCustomerQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      remoteId: // value for 'remoteId'
 *   },
 * });
 */
export function useQuickbookCustomerQuery(baseOptions: Apollo.QueryHookOptions<QuickbookCustomerQuery, QuickbookCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickbookCustomerQuery, QuickbookCustomerQueryVariables>(QuickbookCustomerDocument, options);
      }
export function useQuickbookCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickbookCustomerQuery, QuickbookCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickbookCustomerQuery, QuickbookCustomerQueryVariables>(QuickbookCustomerDocument, options);
        }
export type QuickbookCustomerQueryHookResult = ReturnType<typeof useQuickbookCustomerQuery>;
export type QuickbookCustomerLazyQueryHookResult = ReturnType<typeof useQuickbookCustomerLazyQuery>;
export type QuickbookCustomerQueryResult = Apollo.QueryResult<QuickbookCustomerQuery, QuickbookCustomerQueryVariables>;
export const QuickbookVendorDocument = gql`
    query QuickbookVendor($courierId: ID!, $remoteId: ID!) {
  quickbookVendor(courierId: $courierId, remoteId: $remoteId) {
    id
    name
    email
    phone
  }
}
    `;

/**
 * __useQuickbookVendorQuery__
 *
 * To run a query within a React component, call `useQuickbookVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickbookVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickbookVendorQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      remoteId: // value for 'remoteId'
 *   },
 * });
 */
export function useQuickbookVendorQuery(baseOptions: Apollo.QueryHookOptions<QuickbookVendorQuery, QuickbookVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickbookVendorQuery, QuickbookVendorQueryVariables>(QuickbookVendorDocument, options);
      }
export function useQuickbookVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickbookVendorQuery, QuickbookVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickbookVendorQuery, QuickbookVendorQueryVariables>(QuickbookVendorDocument, options);
        }
export type QuickbookVendorQueryHookResult = ReturnType<typeof useQuickbookVendorQuery>;
export type QuickbookVendorLazyQueryHookResult = ReturnType<typeof useQuickbookVendorLazyQuery>;
export type QuickbookVendorQueryResult = Apollo.QueryResult<QuickbookVendorQuery, QuickbookVendorQueryVariables>;
export const GenerateSalesReportCsvDocument = gql`
    mutation GenerateSalesReportCsv($courierId: ID!, $minDate: Date!, $maxDate: Date!, $includeAllSurcharge: Boolean) {
  generateSalesReportCsv(
    courierId: $courierId
    minDate: $minDate
    maxDate: $maxDate
    includeAllSurcharge: $includeAllSurcharge
  ) {
    ...SalesReportFileFragment
  }
}
    ${SalesReportFileFragmentFragmentDoc}`;
export type GenerateSalesReportCsvMutationFn = Apollo.MutationFunction<GenerateSalesReportCsvMutation, GenerateSalesReportCsvMutationVariables>;

/**
 * __useGenerateSalesReportCsvMutation__
 *
 * To run a mutation, you first call `useGenerateSalesReportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSalesReportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSalesReportCsvMutation, { data, loading, error }] = useGenerateSalesReportCsvMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      includeAllSurcharge: // value for 'includeAllSurcharge'
 *   },
 * });
 */
export function useGenerateSalesReportCsvMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSalesReportCsvMutation, GenerateSalesReportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSalesReportCsvMutation, GenerateSalesReportCsvMutationVariables>(GenerateSalesReportCsvDocument, options);
      }
export type GenerateSalesReportCsvMutationHookResult = ReturnType<typeof useGenerateSalesReportCsvMutation>;
export type GenerateSalesReportCsvMutationResult = Apollo.MutationResult<GenerateSalesReportCsvMutation>;
export type GenerateSalesReportCsvMutationOptions = Apollo.BaseMutationOptions<GenerateSalesReportCsvMutation, GenerateSalesReportCsvMutationVariables>;
export const SalesOverviewDocument = gql`
    query SalesOverview($courierId: ID!, $minDate: Date!, $maxDate: Date!) {
  salesOverview(courierId: $courierId, minDate: $minDate, maxDate: $maxDate) {
    ...SalesOverviewFragment
  }
}
    ${SalesOverviewFragmentFragmentDoc}`;

/**
 * __useSalesOverviewQuery__
 *
 * To run a query within a React component, call `useSalesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOverviewQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *   },
 * });
 */
export function useSalesOverviewQuery(baseOptions: Apollo.QueryHookOptions<SalesOverviewQuery, SalesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesOverviewQuery, SalesOverviewQueryVariables>(SalesOverviewDocument, options);
      }
export function useSalesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesOverviewQuery, SalesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesOverviewQuery, SalesOverviewQueryVariables>(SalesOverviewDocument, options);
        }
export type SalesOverviewQueryHookResult = ReturnType<typeof useSalesOverviewQuery>;
export type SalesOverviewLazyQueryHookResult = ReturnType<typeof useSalesOverviewLazyQuery>;
export type SalesOverviewQueryResult = Apollo.QueryResult<SalesOverviewQuery, SalesOverviewQueryVariables>;
export const CreateServiceTypeDocument = gql`
    mutation createServiceType($courierId: ID!, $name: String!, $deliveryTimeInMinutes: Int, $dueTimeType: ServiceTypeDueTimeType, $dueTimeSecondsSinceMidnight: Int, $dueTimeInBusinessDaysAfter: Int, $deliveryRoutedDaysAfter: Int) {
  createServiceType(
    courierId: $courierId
    name: $name
    deliveryTimeInMinutes: $deliveryTimeInMinutes
    dueTimeType: $dueTimeType
    dueTimeSecondsSinceMidnight: $dueTimeSecondsSinceMidnight
    dueTimeInBusinessDaysAfter: $dueTimeInBusinessDaysAfter
    deliveryRoutedDaysAfter: $deliveryRoutedDaysAfter
  ) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type CreateServiceTypeMutationFn = Apollo.MutationFunction<CreateServiceTypeMutation, CreateServiceTypeMutationVariables>;

/**
 * __useCreateServiceTypeMutation__
 *
 * To run a mutation, you first call `useCreateServiceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceTypeMutation, { data, loading, error }] = useCreateServiceTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      deliveryTimeInMinutes: // value for 'deliveryTimeInMinutes'
 *      dueTimeType: // value for 'dueTimeType'
 *      dueTimeSecondsSinceMidnight: // value for 'dueTimeSecondsSinceMidnight'
 *      dueTimeInBusinessDaysAfter: // value for 'dueTimeInBusinessDaysAfter'
 *      deliveryRoutedDaysAfter: // value for 'deliveryRoutedDaysAfter'
 *   },
 * });
 */
export function useCreateServiceTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceTypeMutation, CreateServiceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceTypeMutation, CreateServiceTypeMutationVariables>(CreateServiceTypeDocument, options);
      }
export type CreateServiceTypeMutationHookResult = ReturnType<typeof useCreateServiceTypeMutation>;
export type CreateServiceTypeMutationResult = Apollo.MutationResult<CreateServiceTypeMutation>;
export type CreateServiceTypeMutationOptions = Apollo.BaseMutationOptions<CreateServiceTypeMutation, CreateServiceTypeMutationVariables>;
export const FullUpdateServiceTypeDocument = gql`
    mutation fullUpdateServiceType($id: ID!, $name: String!, $deliveryTimeInMinutes: Int, $color: String, $visibilityType: ServiceTypeVisibilityType, $dueTimeType: ServiceTypeDueTimeType, $dueTimeSecondsSinceMidnight: Int, $dueTimeInBusinessDaysAfter: Int, $deliveryRoutedDaysAfter: Int, $customMessage: String) {
  fullUpdateServiceType(
    fullUpdate: {id: $id, name: $name, deliveryTimeInMinutes: $deliveryTimeInMinutes, color: $color, visibilityType: $visibilityType, dueTimeType: $dueTimeType, dueTimeSecondsSinceMidnight: $dueTimeSecondsSinceMidnight, dueTimeInBusinessDaysAfter: $dueTimeInBusinessDaysAfter, deliveryRoutedDaysAfter: $deliveryRoutedDaysAfter, customMessage: $customMessage}
  ) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type FullUpdateServiceTypeMutationFn = Apollo.MutationFunction<FullUpdateServiceTypeMutation, FullUpdateServiceTypeMutationVariables>;

/**
 * __useFullUpdateServiceTypeMutation__
 *
 * To run a mutation, you first call `useFullUpdateServiceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateServiceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateServiceTypeMutation, { data, loading, error }] = useFullUpdateServiceTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      deliveryTimeInMinutes: // value for 'deliveryTimeInMinutes'
 *      color: // value for 'color'
 *      visibilityType: // value for 'visibilityType'
 *      dueTimeType: // value for 'dueTimeType'
 *      dueTimeSecondsSinceMidnight: // value for 'dueTimeSecondsSinceMidnight'
 *      dueTimeInBusinessDaysAfter: // value for 'dueTimeInBusinessDaysAfter'
 *      deliveryRoutedDaysAfter: // value for 'deliveryRoutedDaysAfter'
 *      customMessage: // value for 'customMessage'
 *   },
 * });
 */
export function useFullUpdateServiceTypeMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateServiceTypeMutation, FullUpdateServiceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateServiceTypeMutation, FullUpdateServiceTypeMutationVariables>(FullUpdateServiceTypeDocument, options);
      }
export type FullUpdateServiceTypeMutationHookResult = ReturnType<typeof useFullUpdateServiceTypeMutation>;
export type FullUpdateServiceTypeMutationResult = Apollo.MutationResult<FullUpdateServiceTypeMutation>;
export type FullUpdateServiceTypeMutationOptions = Apollo.BaseMutationOptions<FullUpdateServiceTypeMutation, FullUpdateServiceTypeMutationVariables>;
export const UpdateReadyTimeScheduleDocument = gql`
    mutation UpdateReadyTimeSchedule($serviceTypeId: ID!, $readyTimeSchedule: TimeScheduleInput!) {
  updateReadyTimeSchedule(
    serviceTypeId: $serviceTypeId
    readyTimeSchedule: $readyTimeSchedule
  ) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type UpdateReadyTimeScheduleMutationFn = Apollo.MutationFunction<UpdateReadyTimeScheduleMutation, UpdateReadyTimeScheduleMutationVariables>;

/**
 * __useUpdateReadyTimeScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateReadyTimeScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReadyTimeScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReadyTimeScheduleMutation, { data, loading, error }] = useUpdateReadyTimeScheduleMutation({
 *   variables: {
 *      serviceTypeId: // value for 'serviceTypeId'
 *      readyTimeSchedule: // value for 'readyTimeSchedule'
 *   },
 * });
 */
export function useUpdateReadyTimeScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReadyTimeScheduleMutation, UpdateReadyTimeScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReadyTimeScheduleMutation, UpdateReadyTimeScheduleMutationVariables>(UpdateReadyTimeScheduleDocument, options);
      }
export type UpdateReadyTimeScheduleMutationHookResult = ReturnType<typeof useUpdateReadyTimeScheduleMutation>;
export type UpdateReadyTimeScheduleMutationResult = Apollo.MutationResult<UpdateReadyTimeScheduleMutation>;
export type UpdateReadyTimeScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateReadyTimeScheduleMutation, UpdateReadyTimeScheduleMutationVariables>;
export const DeleteServiceTypeDocument = gql`
    mutation DeleteServiceType($serviceTypeId: ID!) {
  deleteServiceType(serviceTypeId: $serviceTypeId) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;
export type DeleteServiceTypeMutationFn = Apollo.MutationFunction<DeleteServiceTypeMutation, DeleteServiceTypeMutationVariables>;

/**
 * __useDeleteServiceTypeMutation__
 *
 * To run a mutation, you first call `useDeleteServiceTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceTypeMutation, { data, loading, error }] = useDeleteServiceTypeMutation({
 *   variables: {
 *      serviceTypeId: // value for 'serviceTypeId'
 *   },
 * });
 */
export function useDeleteServiceTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceTypeMutation, DeleteServiceTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceTypeMutation, DeleteServiceTypeMutationVariables>(DeleteServiceTypeDocument, options);
      }
export type DeleteServiceTypeMutationHookResult = ReturnType<typeof useDeleteServiceTypeMutation>;
export type DeleteServiceTypeMutationResult = Apollo.MutationResult<DeleteServiceTypeMutation>;
export type DeleteServiceTypeMutationOptions = Apollo.BaseMutationOptions<DeleteServiceTypeMutation, DeleteServiceTypeMutationVariables>;
export const GetServiceTypesDocument = gql`
    query GetServiceTypes($courierId: ID!, $endCustomerId: ID) {
  serviceTypes(courierId: $courierId, endCustomerId: $endCustomerId) {
    ...ServiceTypeFragment
  }
}
    ${ServiceTypeFragmentFragmentDoc}`;

/**
 * __useGetServiceTypesQuery__
 *
 * To run a query within a React component, call `useGetServiceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceTypesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerId: // value for 'endCustomerId'
 *   },
 * });
 */
export function useGetServiceTypesQuery(baseOptions: Apollo.QueryHookOptions<GetServiceTypesQuery, GetServiceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceTypesQuery, GetServiceTypesQueryVariables>(GetServiceTypesDocument, options);
      }
export function useGetServiceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceTypesQuery, GetServiceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceTypesQuery, GetServiceTypesQueryVariables>(GetServiceTypesDocument, options);
        }
export type GetServiceTypesQueryHookResult = ReturnType<typeof useGetServiceTypesQuery>;
export type GetServiceTypesLazyQueryHookResult = ReturnType<typeof useGetServiceTypesLazyQuery>;
export type GetServiceTypesQueryResult = Apollo.QueryResult<GetServiceTypesQuery, GetServiceTypesQueryVariables>;
export const UnassignDriverFromShipmentDocument = gql`
    mutation UnassignDriverFromShipment($shipmentId: ID!) {
  unassignDriverFromShipment(shipmentId: $shipmentId) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type UnassignDriverFromShipmentMutationFn = Apollo.MutationFunction<UnassignDriverFromShipmentMutation, UnassignDriverFromShipmentMutationVariables>;

/**
 * __useUnassignDriverFromShipmentMutation__
 *
 * To run a mutation, you first call `useUnassignDriverFromShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignDriverFromShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignDriverFromShipmentMutation, { data, loading, error }] = useUnassignDriverFromShipmentMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useUnassignDriverFromShipmentMutation(baseOptions?: Apollo.MutationHookOptions<UnassignDriverFromShipmentMutation, UnassignDriverFromShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignDriverFromShipmentMutation, UnassignDriverFromShipmentMutationVariables>(UnassignDriverFromShipmentDocument, options);
      }
export type UnassignDriverFromShipmentMutationHookResult = ReturnType<typeof useUnassignDriverFromShipmentMutation>;
export type UnassignDriverFromShipmentMutationResult = Apollo.MutationResult<UnassignDriverFromShipmentMutation>;
export type UnassignDriverFromShipmentMutationOptions = Apollo.BaseMutationOptions<UnassignDriverFromShipmentMutation, UnassignDriverFromShipmentMutationVariables>;
export const MarkShipmentAsFailedDocument = gql`
    mutation MarkShipmentAsFailed($shipmentId: ID!) {
  markShipmentAsFailed(shipmentId: $shipmentId) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type MarkShipmentAsFailedMutationFn = Apollo.MutationFunction<MarkShipmentAsFailedMutation, MarkShipmentAsFailedMutationVariables>;

/**
 * __useMarkShipmentAsFailedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentAsFailedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentAsFailedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentAsFailedMutation, { data, loading, error }] = useMarkShipmentAsFailedMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useMarkShipmentAsFailedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentAsFailedMutation, MarkShipmentAsFailedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentAsFailedMutation, MarkShipmentAsFailedMutationVariables>(MarkShipmentAsFailedDocument, options);
      }
export type MarkShipmentAsFailedMutationHookResult = ReturnType<typeof useMarkShipmentAsFailedMutation>;
export type MarkShipmentAsFailedMutationResult = Apollo.MutationResult<MarkShipmentAsFailedMutation>;
export type MarkShipmentAsFailedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentAsFailedMutation, MarkShipmentAsFailedMutationVariables>;
export const MarkShipmentAsDeletedDocument = gql`
    mutation MarkShipmentAsDeleted($shipmentId: ID!) {
  markShipmentAsDeleted(shipmentId: $shipmentId) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type MarkShipmentAsDeletedMutationFn = Apollo.MutationFunction<MarkShipmentAsDeletedMutation, MarkShipmentAsDeletedMutationVariables>;

/**
 * __useMarkShipmentAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentAsDeletedMutation, { data, loading, error }] = useMarkShipmentAsDeletedMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useMarkShipmentAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentAsDeletedMutation, MarkShipmentAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentAsDeletedMutation, MarkShipmentAsDeletedMutationVariables>(MarkShipmentAsDeletedDocument, options);
      }
export type MarkShipmentAsDeletedMutationHookResult = ReturnType<typeof useMarkShipmentAsDeletedMutation>;
export type MarkShipmentAsDeletedMutationResult = Apollo.MutationResult<MarkShipmentAsDeletedMutation>;
export type MarkShipmentAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentAsDeletedMutation, MarkShipmentAsDeletedMutationVariables>;
export const MarkShipmentAsClosedDocument = gql`
    mutation MarkShipmentAsClosed($shipmentId: ID!) {
  markShipmentAsClosed(shipmentId: $shipmentId) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type MarkShipmentAsClosedMutationFn = Apollo.MutationFunction<MarkShipmentAsClosedMutation, MarkShipmentAsClosedMutationVariables>;

/**
 * __useMarkShipmentAsClosedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentAsClosedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentAsClosedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentAsClosedMutation, { data, loading, error }] = useMarkShipmentAsClosedMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useMarkShipmentAsClosedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentAsClosedMutation, MarkShipmentAsClosedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentAsClosedMutation, MarkShipmentAsClosedMutationVariables>(MarkShipmentAsClosedDocument, options);
      }
export type MarkShipmentAsClosedMutationHookResult = ReturnType<typeof useMarkShipmentAsClosedMutation>;
export type MarkShipmentAsClosedMutationResult = Apollo.MutationResult<MarkShipmentAsClosedMutation>;
export type MarkShipmentAsClosedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentAsClosedMutation, MarkShipmentAsClosedMutationVariables>;
export const ResetShipmentDocument = gql`
    mutation ResetShipment($shipmentId: ID!, $resetBy: String!) {
  resetShipment(shipmentId: $shipmentId, resetBy: $resetBy) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type ResetShipmentMutationFn = Apollo.MutationFunction<ResetShipmentMutation, ResetShipmentMutationVariables>;

/**
 * __useResetShipmentMutation__
 *
 * To run a mutation, you first call `useResetShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetShipmentMutation, { data, loading, error }] = useResetShipmentMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      resetBy: // value for 'resetBy'
 *   },
 * });
 */
export function useResetShipmentMutation(baseOptions?: Apollo.MutationHookOptions<ResetShipmentMutation, ResetShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetShipmentMutation, ResetShipmentMutationVariables>(ResetShipmentDocument, options);
      }
export type ResetShipmentMutationHookResult = ReturnType<typeof useResetShipmentMutation>;
export type ResetShipmentMutationResult = Apollo.MutationResult<ResetShipmentMutation>;
export type ResetShipmentMutationOptions = Apollo.BaseMutationOptions<ResetShipmentMutation, ResetShipmentMutationVariables>;
export const UncloseShipmentDocument = gql`
    mutation UncloseShipment($shipmentId: ID!) {
  uncloseShipment(shipmentId: $shipmentId) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type UncloseShipmentMutationFn = Apollo.MutationFunction<UncloseShipmentMutation, UncloseShipmentMutationVariables>;

/**
 * __useUncloseShipmentMutation__
 *
 * To run a mutation, you first call `useUncloseShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncloseShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncloseShipmentMutation, { data, loading, error }] = useUncloseShipmentMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useUncloseShipmentMutation(baseOptions?: Apollo.MutationHookOptions<UncloseShipmentMutation, UncloseShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncloseShipmentMutation, UncloseShipmentMutationVariables>(UncloseShipmentDocument, options);
      }
export type UncloseShipmentMutationHookResult = ReturnType<typeof useUncloseShipmentMutation>;
export type UncloseShipmentMutationResult = Apollo.MutationResult<UncloseShipmentMutation>;
export type UncloseShipmentMutationOptions = Apollo.BaseMutationOptions<UncloseShipmentMutation, UncloseShipmentMutationVariables>;
export const ForceCompleteShipmentDocument = gql`
    mutation ForceCompleteShipment($shipmentId: ID!, $completedBy: String!, $dateCompletedOverride: Date) {
  forceCompleteShipment(
    shipmentId: $shipmentId
    completedBy: $completedBy
    dateCompletedOverride: $dateCompletedOverride
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type ForceCompleteShipmentMutationFn = Apollo.MutationFunction<ForceCompleteShipmentMutation, ForceCompleteShipmentMutationVariables>;

/**
 * __useForceCompleteShipmentMutation__
 *
 * To run a mutation, you first call `useForceCompleteShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceCompleteShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceCompleteShipmentMutation, { data, loading, error }] = useForceCompleteShipmentMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      completedBy: // value for 'completedBy'
 *      dateCompletedOverride: // value for 'dateCompletedOverride'
 *   },
 * });
 */
export function useForceCompleteShipmentMutation(baseOptions?: Apollo.MutationHookOptions<ForceCompleteShipmentMutation, ForceCompleteShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceCompleteShipmentMutation, ForceCompleteShipmentMutationVariables>(ForceCompleteShipmentDocument, options);
      }
export type ForceCompleteShipmentMutationHookResult = ReturnType<typeof useForceCompleteShipmentMutation>;
export type ForceCompleteShipmentMutationResult = Apollo.MutationResult<ForceCompleteShipmentMutation>;
export type ForceCompleteShipmentMutationOptions = Apollo.BaseMutationOptions<ForceCompleteShipmentMutation, ForceCompleteShipmentMutationVariables>;
export const UpdateInternalNoteDocument = gql`
    mutation UpdateInternalNote($shipmentId: ID!, $internalNote: String!, $updatedBy: String!) {
  updateInternalNote(
    shipmentId: $shipmentId
    internalNote: $internalNote
    updatedBy: $updatedBy
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type UpdateInternalNoteMutationFn = Apollo.MutationFunction<UpdateInternalNoteMutation, UpdateInternalNoteMutationVariables>;

/**
 * __useUpdateInternalNoteMutation__
 *
 * To run a mutation, you first call `useUpdateInternalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalNoteMutation, { data, loading, error }] = useUpdateInternalNoteMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      internalNote: // value for 'internalNote'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useUpdateInternalNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternalNoteMutation, UpdateInternalNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternalNoteMutation, UpdateInternalNoteMutationVariables>(UpdateInternalNoteDocument, options);
      }
export type UpdateInternalNoteMutationHookResult = ReturnType<typeof useUpdateInternalNoteMutation>;
export type UpdateInternalNoteMutationResult = Apollo.MutationResult<UpdateInternalNoteMutation>;
export type UpdateInternalNoteMutationOptions = Apollo.BaseMutationOptions<UpdateInternalNoteMutation, UpdateInternalNoteMutationVariables>;
export const AssignDriverForShipmentTemplatesDocument = gql`
    mutation assignDriverForShipmentTemplates($shipmentTemplateIds: [ID!]!, $driverId: ID) {
  assignDriverForShipmentTemplates(
    shipmentTemplateIds: $shipmentTemplateIds
    driverId: $driverId
  ) {
    ...ShipmentTemplateFragment
  }
}
    ${ShipmentTemplateFragmentFragmentDoc}`;
export type AssignDriverForShipmentTemplatesMutationFn = Apollo.MutationFunction<AssignDriverForShipmentTemplatesMutation, AssignDriverForShipmentTemplatesMutationVariables>;

/**
 * __useAssignDriverForShipmentTemplatesMutation__
 *
 * To run a mutation, you first call `useAssignDriverForShipmentTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDriverForShipmentTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDriverForShipmentTemplatesMutation, { data, loading, error }] = useAssignDriverForShipmentTemplatesMutation({
 *   variables: {
 *      shipmentTemplateIds: // value for 'shipmentTemplateIds'
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useAssignDriverForShipmentTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<AssignDriverForShipmentTemplatesMutation, AssignDriverForShipmentTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignDriverForShipmentTemplatesMutation, AssignDriverForShipmentTemplatesMutationVariables>(AssignDriverForShipmentTemplatesDocument, options);
      }
export type AssignDriverForShipmentTemplatesMutationHookResult = ReturnType<typeof useAssignDriverForShipmentTemplatesMutation>;
export type AssignDriverForShipmentTemplatesMutationResult = Apollo.MutationResult<AssignDriverForShipmentTemplatesMutation>;
export type AssignDriverForShipmentTemplatesMutationOptions = Apollo.BaseMutationOptions<AssignDriverForShipmentTemplatesMutation, AssignDriverForShipmentTemplatesMutationVariables>;
export const OverridePodMetadataDocument = gql`
    mutation OverridePodMetadata($shipmentId: ID!, $updatedBy: String!, $signedBy: String, $deliveredAt: Timestamp) {
  overridePodMetadata(
    shipmentId: $shipmentId
    updatedBy: $updatedBy
    signedBy: $signedBy
    deliveredAt: $deliveredAt
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type OverridePodMetadataMutationFn = Apollo.MutationFunction<OverridePodMetadataMutation, OverridePodMetadataMutationVariables>;

/**
 * __useOverridePodMetadataMutation__
 *
 * To run a mutation, you first call `useOverridePodMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverridePodMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overridePodMetadataMutation, { data, loading, error }] = useOverridePodMetadataMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      updatedBy: // value for 'updatedBy'
 *      signedBy: // value for 'signedBy'
 *      deliveredAt: // value for 'deliveredAt'
 *   },
 * });
 */
export function useOverridePodMetadataMutation(baseOptions?: Apollo.MutationHookOptions<OverridePodMetadataMutation, OverridePodMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverridePodMetadataMutation, OverridePodMetadataMutationVariables>(OverridePodMetadataDocument, options);
      }
export type OverridePodMetadataMutationHookResult = ReturnType<typeof useOverridePodMetadataMutation>;
export type OverridePodMetadataMutationResult = Apollo.MutationResult<OverridePodMetadataMutation>;
export type OverridePodMetadataMutationOptions = Apollo.BaseMutationOptions<OverridePodMetadataMutation, OverridePodMetadataMutationVariables>;
export const OverridePricingDetailDocument = gql`
    mutation overridePricingDetail($shipmentId: ID!, $unfreeWaitTimeInMinutes: Float, $adjustmentUpdates: [PricingAdjustmentUpdate!], $adjustmentsToAdd: [PricingAdjustmentCreate!], $updatedBy: String) {
  overridePricingDetail(
    shipmentId: $shipmentId
    unfreeWaitTimeInMinutes: $unfreeWaitTimeInMinutes
    adjustmentUpdates: $adjustmentUpdates
    adjustmentsToAdd: $adjustmentsToAdd
    updatedBy: $updatedBy
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type OverridePricingDetailMutationFn = Apollo.MutationFunction<OverridePricingDetailMutation, OverridePricingDetailMutationVariables>;

/**
 * __useOverridePricingDetailMutation__
 *
 * To run a mutation, you first call `useOverridePricingDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverridePricingDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overridePricingDetailMutation, { data, loading, error }] = useOverridePricingDetailMutation({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *      unfreeWaitTimeInMinutes: // value for 'unfreeWaitTimeInMinutes'
 *      adjustmentUpdates: // value for 'adjustmentUpdates'
 *      adjustmentsToAdd: // value for 'adjustmentsToAdd'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useOverridePricingDetailMutation(baseOptions?: Apollo.MutationHookOptions<OverridePricingDetailMutation, OverridePricingDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverridePricingDetailMutation, OverridePricingDetailMutationVariables>(OverridePricingDetailDocument, options);
      }
export type OverridePricingDetailMutationHookResult = ReturnType<typeof useOverridePricingDetailMutation>;
export type OverridePricingDetailMutationResult = Apollo.MutationResult<OverridePricingDetailMutation>;
export type OverridePricingDetailMutationOptions = Apollo.BaseMutationOptions<OverridePricingDetailMutation, OverridePricingDetailMutationVariables>;
export const MarkShipmentTemplatesAsDeletedDocument = gql`
    mutation MarkShipmentTemplatesAsDeleted($shipmentTemplateIds: [ID!]!) {
  markShipmentTemplatesAsDeleted(shipmentTemplateIds: $shipmentTemplateIds) {
    ...ShipmentTemplateFragment
  }
}
    ${ShipmentTemplateFragmentFragmentDoc}`;
export type MarkShipmentTemplatesAsDeletedMutationFn = Apollo.MutationFunction<MarkShipmentTemplatesAsDeletedMutation, MarkShipmentTemplatesAsDeletedMutationVariables>;

/**
 * __useMarkShipmentTemplatesAsDeletedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentTemplatesAsDeletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentTemplatesAsDeletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentTemplatesAsDeletedMutation, { data, loading, error }] = useMarkShipmentTemplatesAsDeletedMutation({
 *   variables: {
 *      shipmentTemplateIds: // value for 'shipmentTemplateIds'
 *   },
 * });
 */
export function useMarkShipmentTemplatesAsDeletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentTemplatesAsDeletedMutation, MarkShipmentTemplatesAsDeletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentTemplatesAsDeletedMutation, MarkShipmentTemplatesAsDeletedMutationVariables>(MarkShipmentTemplatesAsDeletedDocument, options);
      }
export type MarkShipmentTemplatesAsDeletedMutationHookResult = ReturnType<typeof useMarkShipmentTemplatesAsDeletedMutation>;
export type MarkShipmentTemplatesAsDeletedMutationResult = Apollo.MutationResult<MarkShipmentTemplatesAsDeletedMutation>;
export type MarkShipmentTemplatesAsDeletedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentTemplatesAsDeletedMutation, MarkShipmentTemplatesAsDeletedMutationVariables>;
export const ReplaceAllocationDocument = gql`
    mutation ReplaceAllocation($replacement: DriverPayAllocationReplacement!) {
  replaceAllocation(replacement: $replacement) {
    ...DriverPayAllocationFragment
  }
}
    ${DriverPayAllocationFragmentFragmentDoc}`;
export type ReplaceAllocationMutationFn = Apollo.MutationFunction<ReplaceAllocationMutation, ReplaceAllocationMutationVariables>;

/**
 * __useReplaceAllocationMutation__
 *
 * To run a mutation, you first call `useReplaceAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceAllocationMutation, { data, loading, error }] = useReplaceAllocationMutation({
 *   variables: {
 *      replacement: // value for 'replacement'
 *   },
 * });
 */
export function useReplaceAllocationMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceAllocationMutation, ReplaceAllocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceAllocationMutation, ReplaceAllocationMutationVariables>(ReplaceAllocationDocument, options);
      }
export type ReplaceAllocationMutationHookResult = ReturnType<typeof useReplaceAllocationMutation>;
export type ReplaceAllocationMutationResult = Apollo.MutationResult<ReplaceAllocationMutation>;
export type ReplaceAllocationMutationOptions = Apollo.BaseMutationOptions<ReplaceAllocationMutation, ReplaceAllocationMutationVariables>;
export const BulkUnassignDriversFromShipmentDocument = gql`
    mutation BulkUnassignDriversFromShipment($courierId: ID!, $shipmentIds: [ID!]!) {
  bulkUnassignDriversFromShipment(
    courierId: $courierId
    shipmentIds: $shipmentIds
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type BulkUnassignDriversFromShipmentMutationFn = Apollo.MutationFunction<BulkUnassignDriversFromShipmentMutation, BulkUnassignDriversFromShipmentMutationVariables>;

/**
 * __useBulkUnassignDriversFromShipmentMutation__
 *
 * To run a mutation, you first call `useBulkUnassignDriversFromShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnassignDriversFromShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnassignDriversFromShipmentMutation, { data, loading, error }] = useBulkUnassignDriversFromShipmentMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *   },
 * });
 */
export function useBulkUnassignDriversFromShipmentMutation(baseOptions?: Apollo.MutationHookOptions<BulkUnassignDriversFromShipmentMutation, BulkUnassignDriversFromShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUnassignDriversFromShipmentMutation, BulkUnassignDriversFromShipmentMutationVariables>(BulkUnassignDriversFromShipmentDocument, options);
      }
export type BulkUnassignDriversFromShipmentMutationHookResult = ReturnType<typeof useBulkUnassignDriversFromShipmentMutation>;
export type BulkUnassignDriversFromShipmentMutationResult = Apollo.MutationResult<BulkUnassignDriversFromShipmentMutation>;
export type BulkUnassignDriversFromShipmentMutationOptions = Apollo.BaseMutationOptions<BulkUnassignDriversFromShipmentMutation, BulkUnassignDriversFromShipmentMutationVariables>;
export const MarkShipmentsAsClosedDocument = gql`
    mutation MarkShipmentsAsClosed($courierId: ID!, $shipmentIds: [ID!]!, $closedBy: String) {
  markShipmentsAsClosed(
    courierId: $courierId
    shipmentIds: $shipmentIds
    closedBy: $closedBy
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type MarkShipmentsAsClosedMutationFn = Apollo.MutationFunction<MarkShipmentsAsClosedMutation, MarkShipmentsAsClosedMutationVariables>;

/**
 * __useMarkShipmentsAsClosedMutation__
 *
 * To run a mutation, you first call `useMarkShipmentsAsClosedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkShipmentsAsClosedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markShipmentsAsClosedMutation, { data, loading, error }] = useMarkShipmentsAsClosedMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *      closedBy: // value for 'closedBy'
 *   },
 * });
 */
export function useMarkShipmentsAsClosedMutation(baseOptions?: Apollo.MutationHookOptions<MarkShipmentsAsClosedMutation, MarkShipmentsAsClosedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkShipmentsAsClosedMutation, MarkShipmentsAsClosedMutationVariables>(MarkShipmentsAsClosedDocument, options);
      }
export type MarkShipmentsAsClosedMutationHookResult = ReturnType<typeof useMarkShipmentsAsClosedMutation>;
export type MarkShipmentsAsClosedMutationResult = Apollo.MutationResult<MarkShipmentsAsClosedMutation>;
export type MarkShipmentsAsClosedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentsAsClosedMutation, MarkShipmentsAsClosedMutationVariables>;
export const UncloseShipmentsDocument = gql`
    mutation UncloseShipments($courierId: ID!, $shipmentIds: [ID!]!) {
  uncloseShipments(courierId: $courierId, shipmentIds: $shipmentIds) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type UncloseShipmentsMutationFn = Apollo.MutationFunction<UncloseShipmentsMutation, UncloseShipmentsMutationVariables>;

/**
 * __useUncloseShipmentsMutation__
 *
 * To run a mutation, you first call `useUncloseShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncloseShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncloseShipmentsMutation, { data, loading, error }] = useUncloseShipmentsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentIds: // value for 'shipmentIds'
 *   },
 * });
 */
export function useUncloseShipmentsMutation(baseOptions?: Apollo.MutationHookOptions<UncloseShipmentsMutation, UncloseShipmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncloseShipmentsMutation, UncloseShipmentsMutationVariables>(UncloseShipmentsDocument, options);
      }
export type UncloseShipmentsMutationHookResult = ReturnType<typeof useUncloseShipmentsMutation>;
export type UncloseShipmentsMutationResult = Apollo.MutationResult<UncloseShipmentsMutation>;
export type UncloseShipmentsMutationOptions = Apollo.BaseMutationOptions<UncloseShipmentsMutation, UncloseShipmentsMutationVariables>;
export const ApproveShipmentDetailsDocument = gql`
    mutation ApproveShipmentDetails($courierId: ID!, $shipmentId: ID!, $updatedBy: String!) {
  approveShipmentDetails(
    courierId: $courierId
    shipmentId: $shipmentId
    updatedBy: $updatedBy
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type ApproveShipmentDetailsMutationFn = Apollo.MutationFunction<ApproveShipmentDetailsMutation, ApproveShipmentDetailsMutationVariables>;

/**
 * __useApproveShipmentDetailsMutation__
 *
 * To run a mutation, you first call `useApproveShipmentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveShipmentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveShipmentDetailsMutation, { data, loading, error }] = useApproveShipmentDetailsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useApproveShipmentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveShipmentDetailsMutation, ApproveShipmentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveShipmentDetailsMutation, ApproveShipmentDetailsMutationVariables>(ApproveShipmentDetailsDocument, options);
      }
export type ApproveShipmentDetailsMutationHookResult = ReturnType<typeof useApproveShipmentDetailsMutation>;
export type ApproveShipmentDetailsMutationResult = Apollo.MutationResult<ApproveShipmentDetailsMutation>;
export type ApproveShipmentDetailsMutationOptions = Apollo.BaseMutationOptions<ApproveShipmentDetailsMutation, ApproveShipmentDetailsMutationVariables>;
export const GetShipmentsDocument = gql`
    query GetShipments($courierId: ID!, $limit: Int, $after: Int, $isAssignedFilter: Boolean, $statusFilter: ShipmentStatus, $statusListFilter: [ShipmentStatus!], $lateByFilter: Timestamp, $minClosingTimeFilter: Timestamp, $likelyLateOnlyFilter: Boolean, $isClosedFilter: Boolean, $driverIdsFilter: [ID!], $endCustomerIdsFilter: [ID!], $trackingNumbersFilter: [String!], $displayIdsFilter: [Int!], $minExpectedCompletionDate: Date, $maxShipmentDate: Date, $sortFields: [ShipmentsSorting!], $simpleSearch: String, $userId: ID!) {
  shipments(
    courierId: $courierId
    limit: $limit
    after: $after
    isAssignedFilter: $isAssignedFilter
    statusFilter: $statusFilter
    statusListFilter: $statusListFilter
    lateByFilter: $lateByFilter
    minClosingTimeFilter: $minClosingTimeFilter
    likelyLateOnlyFilter: $likelyLateOnlyFilter
    isClosedFilter: $isClosedFilter
    driverIdsFilter: $driverIdsFilter
    endCustomerIdsFilter: $endCustomerIdsFilter
    trackingNumbersFilter: $trackingNumbersFilter
    displayIdsFilter: $displayIdsFilter
    minExpectedCompletionDate: $minExpectedCompletionDate
    maxShipmentDate: $maxShipmentDate
    sortFields: $sortFields
    simpleSearch: $simpleSearch
  ) {
    edges {
      node {
        ...ShipmentFragment
        dispatchedByUser {
          ...CourieUserFragment
        }
        packageType {
          id
          courierId
          name
        }
        vehicleType {
          id
          courierId
          name
          shortCode
        }
        packageItems {
          width
          height
          length
          weight
        }
        routingJob {
          ...RoutingJobFragment
        }
        stops {
          ...StopFragment
          tasks {
            ...TaskFragment
          }
          shipment {
            status
            order {
              id
              serviceType {
                ...ServiceTypeFragment
              }
            }
            shipmentTemplate {
              ...ShipmentTemplateFragment
              order {
                id
                serviceType {
                  ...ServiceTypeFragment
                }
              }
            }
          }
          artifacts {
            ...ArtifactFragment
          }
        }
        order {
          ...OrderFragment
          userHasClicked(userId: $userId)
          createdByUser {
            ...CourieUserFragment
          }
          createdByEndCustomer {
            ...EndCustomerFragment
          }
          createdByEndUser {
            ...EndUserFragment
          }
          costCenter {
            ...CostCenterFragment
          }
          endCustomer {
            ...EndCustomerFragment
            invoicePdfTemplate {
              ...InvoicePdfTemplateFragment
            }
            customFields {
              ...CustomFieldFragment
            }
          }
          serviceType {
            ...ServiceTypeFragment
          }
          customFieldValues {
            ...CustomFieldValueFragment
            field {
              ...CustomFieldFragment
            }
          }
          orderAttachments {
            ...OrderAttachmentFragment
          }
        }
        driver {
          ...DriverFragment
        }
        driverPayAllocations {
          ...DriverPayAllocationFragment
        }
        shipmentTemplate {
          order {
            name
          }
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${ShipmentFragmentFragmentDoc}
${CourieUserFragmentFragmentDoc}
${RoutingJobFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}
${ArtifactFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${EndUserFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${InvoicePdfTemplateFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}
${OrderAttachmentFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${DriverPayAllocationFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetShipmentsQuery__
 *
 * To run a query within a React component, call `useGetShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      isAssignedFilter: // value for 'isAssignedFilter'
 *      statusFilter: // value for 'statusFilter'
 *      statusListFilter: // value for 'statusListFilter'
 *      lateByFilter: // value for 'lateByFilter'
 *      minClosingTimeFilter: // value for 'minClosingTimeFilter'
 *      likelyLateOnlyFilter: // value for 'likelyLateOnlyFilter'
 *      isClosedFilter: // value for 'isClosedFilter'
 *      driverIdsFilter: // value for 'driverIdsFilter'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      trackingNumbersFilter: // value for 'trackingNumbersFilter'
 *      displayIdsFilter: // value for 'displayIdsFilter'
 *      minExpectedCompletionDate: // value for 'minExpectedCompletionDate'
 *      maxShipmentDate: // value for 'maxShipmentDate'
 *      sortFields: // value for 'sortFields'
 *      simpleSearch: // value for 'simpleSearch'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetShipmentsQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
      }
export function useGetShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
        }
export type GetShipmentsQueryHookResult = ReturnType<typeof useGetShipmentsQuery>;
export type GetShipmentsLazyQueryHookResult = ReturnType<typeof useGetShipmentsLazyQuery>;
export type GetShipmentsQueryResult = Apollo.QueryResult<GetShipmentsQuery, GetShipmentsQueryVariables>;
export const GetShipmentCountsForFiltersDocument = gql`
    query GetShipmentCountsForFilters($courierId: ID!, $minExpectedCompletionDate: Date, $maxShipmentDate: Date, $now: Timestamp!, $in15Minutes: Timestamp!, $in30Minutes: Timestamp!, $in60Minutes: Timestamp!) {
  shipmentsOverview(
    courierId: $courierId
    minExpectedCompletionDate: $minExpectedCompletionDate
    maxShipmentDate: $maxShipmentDate
  ) {
    numLate: numLateBy(lateBy: $now)
    numLateIn15Minutes: numLateBy(lateBy: $in15Minutes, minClosingTime: $now)
    numLateIn30Minutes: numLateBy(lateBy: $in30Minutes, minClosingTime: $now)
    numLateIn60Minutes: numLateBy(lateBy: $in60Minutes, minClosingTime: $now)
    numLikelyLate: numLikelyLate(minClosingTime: $now)
    numActive
    numUnassigned
    numAssigned
    numDelivered
    numClosed
  }
}
    `;

/**
 * __useGetShipmentCountsForFiltersQuery__
 *
 * To run a query within a React component, call `useGetShipmentCountsForFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentCountsForFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentCountsForFiltersQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      minExpectedCompletionDate: // value for 'minExpectedCompletionDate'
 *      maxShipmentDate: // value for 'maxShipmentDate'
 *      now: // value for 'now'
 *      in15Minutes: // value for 'in15Minutes'
 *      in30Minutes: // value for 'in30Minutes'
 *      in60Minutes: // value for 'in60Minutes'
 *   },
 * });
 */
export function useGetShipmentCountsForFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentCountsForFiltersQuery, GetShipmentCountsForFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentCountsForFiltersQuery, GetShipmentCountsForFiltersQueryVariables>(GetShipmentCountsForFiltersDocument, options);
      }
export function useGetShipmentCountsForFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentCountsForFiltersQuery, GetShipmentCountsForFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentCountsForFiltersQuery, GetShipmentCountsForFiltersQueryVariables>(GetShipmentCountsForFiltersDocument, options);
        }
export type GetShipmentCountsForFiltersQueryHookResult = ReturnType<typeof useGetShipmentCountsForFiltersQuery>;
export type GetShipmentCountsForFiltersLazyQueryHookResult = ReturnType<typeof useGetShipmentCountsForFiltersLazyQuery>;
export type GetShipmentCountsForFiltersQueryResult = Apollo.QueryResult<GetShipmentCountsForFiltersQuery, GetShipmentCountsForFiltersQueryVariables>;
export const ShipmentTemplatesPaginatedDocument = gql`
    query ShipmentTemplatesPaginated($courierId: ID!, $endCustomerIdsFilter: [ID!], $limit: Int, $after: Int, $sortFields: [ShipmentTemplatesSorting!]) {
  shipmentTemplatesPaginated(
    courierId: $courierId
    endCustomerIdsFilter: $endCustomerIdsFilter
    limit: $limit
    after: $after
    sortFields: $sortFields
  ) {
    edges {
      node {
        ...ShipmentTemplateFragment
        stopTemplates {
          ...StopTemplateFragment
        }
        packageType {
          id
          courierId
          name
        }
        vehicleType {
          id
          courierId
          name
          shortCode
        }
        order {
          ...OrderFragment
          costCenter {
            ...CostCenterFragment
          }
          endCustomer {
            ...EndCustomerFragment
            customFields {
              ...CustomFieldFragment
            }
          }
          serviceType {
            ...ServiceTypeFragment
          }
          customFieldValues {
            ...CustomFieldValueFragment
            field {
              ...CustomFieldFragment
            }
          }
        }
        driver {
          ...DriverFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${ShipmentTemplateFragmentFragmentDoc}
${StopTemplateFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useShipmentTemplatesPaginatedQuery__
 *
 * To run a query within a React component, call `useShipmentTemplatesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentTemplatesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentTemplatesPaginatedQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useShipmentTemplatesPaginatedQuery(baseOptions: Apollo.QueryHookOptions<ShipmentTemplatesPaginatedQuery, ShipmentTemplatesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipmentTemplatesPaginatedQuery, ShipmentTemplatesPaginatedQueryVariables>(ShipmentTemplatesPaginatedDocument, options);
      }
export function useShipmentTemplatesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipmentTemplatesPaginatedQuery, ShipmentTemplatesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipmentTemplatesPaginatedQuery, ShipmentTemplatesPaginatedQueryVariables>(ShipmentTemplatesPaginatedDocument, options);
        }
export type ShipmentTemplatesPaginatedQueryHookResult = ReturnType<typeof useShipmentTemplatesPaginatedQuery>;
export type ShipmentTemplatesPaginatedLazyQueryHookResult = ReturnType<typeof useShipmentTemplatesPaginatedLazyQuery>;
export type ShipmentTemplatesPaginatedQueryResult = Apollo.QueryResult<ShipmentTemplatesPaginatedQuery, ShipmentTemplatesPaginatedQueryVariables>;
export const ShipmentByIdDocument = gql`
    query ShipmentById($courierId: ID!, $shipmentId: ID!) {
  shipmentById(courierId: $courierId, shipmentId: $shipmentId) {
    ...ShipmentFragment
    packageType {
      id
      courierId
      name
    }
    driver {
      ...DriverFragment
    }
    stops {
      ...StopFragment
      artifacts {
        ...ArtifactFragment
      }
    }
    order {
      ...OrderFragment
      costCenter {
        ...CostCenterFragment
      }
      serviceType {
        ...ServiceTypeFragment
      }
      endCustomer {
        ...EndCustomerFragment
      }
      customFieldValues {
        ...CustomFieldValueFragment
        field {
          ...CustomFieldFragment
        }
      }
    }
    dispatchedByUser {
      ...CourieUserFragment
    }
  }
}
    ${ShipmentFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${ArtifactFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${CourieUserFragmentFragmentDoc}`;

/**
 * __useShipmentByIdQuery__
 *
 * To run a query within a React component, call `useShipmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentByIdQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useShipmentByIdQuery(baseOptions: Apollo.QueryHookOptions<ShipmentByIdQuery, ShipmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipmentByIdQuery, ShipmentByIdQueryVariables>(ShipmentByIdDocument, options);
      }
export function useShipmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipmentByIdQuery, ShipmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipmentByIdQuery, ShipmentByIdQueryVariables>(ShipmentByIdDocument, options);
        }
export type ShipmentByIdQueryHookResult = ReturnType<typeof useShipmentByIdQuery>;
export type ShipmentByIdLazyQueryHookResult = ReturnType<typeof useShipmentByIdLazyQuery>;
export type ShipmentByIdQueryResult = Apollo.QueryResult<ShipmentByIdQuery, ShipmentByIdQueryVariables>;
export const GetShipmentsForSalesReportDocument = gql`
    query GetShipmentsForSalesReport($courierId: ID!, $limit: Int, $after: Int, $isAssignedFilter: Boolean, $statusFilter: ShipmentStatus, $statusListFilter: [ShipmentStatus!], $lateByFilter: Timestamp, $minClosingTimeFilter: Timestamp, $likelyLateOnlyFilter: Boolean, $isClosedFilter: Boolean, $driverIdsFilter: [ID!], $endCustomerIdsFilter: [ID!], $trackingNumbersFilter: [String!], $displayIdsFilter: [Int!], $minExpectedCompletionDate: Date, $maxShipmentDate: Date, $sortFields: [ShipmentsSorting!], $simpleSearch: String, $userId: ID!, $hasOrderInternalNote: Boolean, $hasDriverNoteOnly: Boolean, $hasWaitTimeOrOverride: Boolean, $hasMultipleDriverPayOnly: Boolean, $hasUnapprovedDriverPackageReportOnly: Boolean, $isDeliveredOnTime: Boolean) {
  shipments(
    courierId: $courierId
    limit: $limit
    after: $after
    isAssignedFilter: $isAssignedFilter
    statusFilter: $statusFilter
    statusListFilter: $statusListFilter
    lateByFilter: $lateByFilter
    minClosingTimeFilter: $minClosingTimeFilter
    likelyLateOnlyFilter: $likelyLateOnlyFilter
    isClosedFilter: $isClosedFilter
    driverIdsFilter: $driverIdsFilter
    endCustomerIdsFilter: $endCustomerIdsFilter
    trackingNumbersFilter: $trackingNumbersFilter
    displayIdsFilter: $displayIdsFilter
    minExpectedCompletionDate: $minExpectedCompletionDate
    maxShipmentDate: $maxShipmentDate
    sortFields: $sortFields
    simpleSearch: $simpleSearch
    hasOrderInternalNote: $hasOrderInternalNote
    hasDriverNoteOnly: $hasDriverNoteOnly
    hasWaitTimeOrOverride: $hasWaitTimeOrOverride
    hasMultipleDriverPayOnly: $hasMultipleDriverPayOnly
    hasUnapprovedDriverPackageReportOnly: $hasUnapprovedDriverPackageReportOnly
    isDeliveredOnTime: $isDeliveredOnTime
  ) {
    edges {
      node {
        ...ShipmentFragment
        distancesInMeters
        packageType {
          id
          courierId
          name
        }
        vehicleType {
          id
          courierId
          name
          shortCode
        }
        packageItems {
          width
          height
          length
          weight
        }
        stops {
          ...StopFragment
          wasLateByInMinutes
          tasks {
            ...TaskFragment
          }
          shipment {
            status
            order {
              id
              serviceType {
                ...ServiceTypeFragment
              }
            }
          }
          artifacts {
            ...ArtifactFragment
          }
        }
        order {
          ...OrderFragment
          orderPayBreakDownWithAllocation {
            allocations {
              driverId
              allocationRate
              breakdown {
                items {
                  name
                  description
                  amount
                }
                total
              }
              driver {
                ...DriverFragment
              }
            }
            isOverride
            total
          }
          userHasClicked(userId: $userId)
          createdByEndCustomer {
            ...EndCustomerFragment
          }
          createdByEndUser {
            ...EndUserFragment
          }
          costCenter {
            ...CostCenterFragment
          }
          endCustomer {
            ...EndCustomerFragment
          }
          serviceType {
            ...ServiceTypeFragment
          }
          orderAttachments {
            ...OrderAttachmentFragment
          }
          price {
            ...OrderPriceFragment
          }
          customFieldValues {
            ...CustomFieldValueFragment
            field {
              ...CustomFieldFragment
            }
          }
        }
        driver {
          ...DriverFragment
        }
        driverPayAllocations {
          ...DriverPayAllocationFragment
        }
        dispatchedByUser {
          ...CourieUserFragment
        }
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${ShipmentFragmentFragmentDoc}
${StopFragmentFragmentDoc}
${TaskFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${ArtifactFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${DriverFragmentFragmentDoc}
${EndCustomerFragmentFragmentDoc}
${EndUserFragmentFragmentDoc}
${CostCenterFragmentFragmentDoc}
${OrderAttachmentFragmentFragmentDoc}
${OrderPriceFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}
${CustomFieldFragmentFragmentDoc}
${DriverPayAllocationFragmentFragmentDoc}
${CourieUserFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetShipmentsForSalesReportQuery__
 *
 * To run a query within a React component, call `useGetShipmentsForSalesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentsForSalesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentsForSalesReportQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      isAssignedFilter: // value for 'isAssignedFilter'
 *      statusFilter: // value for 'statusFilter'
 *      statusListFilter: // value for 'statusListFilter'
 *      lateByFilter: // value for 'lateByFilter'
 *      minClosingTimeFilter: // value for 'minClosingTimeFilter'
 *      likelyLateOnlyFilter: // value for 'likelyLateOnlyFilter'
 *      isClosedFilter: // value for 'isClosedFilter'
 *      driverIdsFilter: // value for 'driverIdsFilter'
 *      endCustomerIdsFilter: // value for 'endCustomerIdsFilter'
 *      trackingNumbersFilter: // value for 'trackingNumbersFilter'
 *      displayIdsFilter: // value for 'displayIdsFilter'
 *      minExpectedCompletionDate: // value for 'minExpectedCompletionDate'
 *      maxShipmentDate: // value for 'maxShipmentDate'
 *      sortFields: // value for 'sortFields'
 *      simpleSearch: // value for 'simpleSearch'
 *      userId: // value for 'userId'
 *      hasOrderInternalNote: // value for 'hasOrderInternalNote'
 *      hasDriverNoteOnly: // value for 'hasDriverNoteOnly'
 *      hasWaitTimeOrOverride: // value for 'hasWaitTimeOrOverride'
 *      hasMultipleDriverPayOnly: // value for 'hasMultipleDriverPayOnly'
 *      hasUnapprovedDriverPackageReportOnly: // value for 'hasUnapprovedDriverPackageReportOnly'
 *      isDeliveredOnTime: // value for 'isDeliveredOnTime'
 *   },
 * });
 */
export function useGetShipmentsForSalesReportQuery(baseOptions: Apollo.QueryHookOptions<GetShipmentsForSalesReportQuery, GetShipmentsForSalesReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentsForSalesReportQuery, GetShipmentsForSalesReportQueryVariables>(GetShipmentsForSalesReportDocument, options);
      }
export function useGetShipmentsForSalesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentsForSalesReportQuery, GetShipmentsForSalesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentsForSalesReportQuery, GetShipmentsForSalesReportQueryVariables>(GetShipmentsForSalesReportDocument, options);
        }
export type GetShipmentsForSalesReportQueryHookResult = ReturnType<typeof useGetShipmentsForSalesReportQuery>;
export type GetShipmentsForSalesReportLazyQueryHookResult = ReturnType<typeof useGetShipmentsForSalesReportLazyQuery>;
export type GetShipmentsForSalesReportQueryResult = Apollo.QueryResult<GetShipmentsForSalesReportQuery, GetShipmentsForSalesReportQueryVariables>;
export const UpsertStopTemplateSequenceNumbersDocument = gql`
    mutation UpsertStopTemplateSequenceNumbers($upserts: [ScheduledStopTemplateSequenceNumberUpsert!]!) {
  upsertStopTemplateSequenceNumbers(upserts: $upserts) {
    id
    courierId
    stopTemplateId
    dayOfWeek
    sequenceNumber
    stopTemplate {
      ...StopTemplateFragment
    }
  }
}
    ${StopTemplateFragmentFragmentDoc}`;
export type UpsertStopTemplateSequenceNumbersMutationFn = Apollo.MutationFunction<UpsertStopTemplateSequenceNumbersMutation, UpsertStopTemplateSequenceNumbersMutationVariables>;

/**
 * __useUpsertStopTemplateSequenceNumbersMutation__
 *
 * To run a mutation, you first call `useUpsertStopTemplateSequenceNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStopTemplateSequenceNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStopTemplateSequenceNumbersMutation, { data, loading, error }] = useUpsertStopTemplateSequenceNumbersMutation({
 *   variables: {
 *      upserts: // value for 'upserts'
 *   },
 * });
 */
export function useUpsertStopTemplateSequenceNumbersMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStopTemplateSequenceNumbersMutation, UpsertStopTemplateSequenceNumbersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStopTemplateSequenceNumbersMutation, UpsertStopTemplateSequenceNumbersMutationVariables>(UpsertStopTemplateSequenceNumbersDocument, options);
      }
export type UpsertStopTemplateSequenceNumbersMutationHookResult = ReturnType<typeof useUpsertStopTemplateSequenceNumbersMutation>;
export type UpsertStopTemplateSequenceNumbersMutationResult = Apollo.MutationResult<UpsertStopTemplateSequenceNumbersMutation>;
export type UpsertStopTemplateSequenceNumbersMutationOptions = Apollo.BaseMutationOptions<UpsertStopTemplateSequenceNumbersMutation, UpsertStopTemplateSequenceNumbersMutationVariables>;
export const ForceCompleteStopsDocument = gql`
    mutation ForceCompleteStops($courierId: ID!, $shipmentId: ID!, $stopIds: [ID!]!, $completedBy: String!) {
  forceCompleteStops(
    courierId: $courierId
    shipmentId: $shipmentId
    stopIds: $stopIds
    completedBy: $completedBy
  ) {
    ...ShipmentFragment
  }
}
    ${ShipmentFragmentFragmentDoc}`;
export type ForceCompleteStopsMutationFn = Apollo.MutationFunction<ForceCompleteStopsMutation, ForceCompleteStopsMutationVariables>;

/**
 * __useForceCompleteStopsMutation__
 *
 * To run a mutation, you first call `useForceCompleteStopsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceCompleteStopsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceCompleteStopsMutation, { data, loading, error }] = useForceCompleteStopsMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentId: // value for 'shipmentId'
 *      stopIds: // value for 'stopIds'
 *      completedBy: // value for 'completedBy'
 *   },
 * });
 */
export function useForceCompleteStopsMutation(baseOptions?: Apollo.MutationHookOptions<ForceCompleteStopsMutation, ForceCompleteStopsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceCompleteStopsMutation, ForceCompleteStopsMutationVariables>(ForceCompleteStopsDocument, options);
      }
export type ForceCompleteStopsMutationHookResult = ReturnType<typeof useForceCompleteStopsMutation>;
export type ForceCompleteStopsMutationResult = Apollo.MutationResult<ForceCompleteStopsMutation>;
export type ForceCompleteStopsMutationOptions = Apollo.BaseMutationOptions<ForceCompleteStopsMutation, ForceCompleteStopsMutationVariables>;
export const MemorizationsDocument = gql`
    query memorizations($courierId: ID!, $driverIds: [ID!], $dayOfWeeks: [DayOfTheWeek!]) {
  memorizations(
    courierId: $courierId
    driverIds: $driverIds
    dayOfWeeks: $dayOfWeeks
  ) {
    days {
      dayOfWeek
      stopTemplateSequenceNumbers {
        id
        courierId
        stopTemplateId
        dayOfWeek
        sequenceNumber
        stopTemplate {
          ...StopTemplateFragment
          shipmentTemplate {
            ...ShipmentTemplateFragment
            order {
              id
              serviceType {
                ...ServiceTypeFragment
              }
            }
          }
        }
      }
      unmemorizedShipmentTemplates {
        ...ShipmentTemplateFragment
        order {
          ...OrderFragment
        }
        stopTemplates {
          ...StopTemplateFragment
          shipmentTemplate {
            ...ShipmentTemplateFragment
            order {
              id
              serviceType {
                ...ServiceTypeFragment
              }
            }
          }
        }
        driver {
          ...DriverFragment
        }
      }
    }
  }
}
    ${StopTemplateFragmentFragmentDoc}
${ShipmentTemplateFragmentFragmentDoc}
${ServiceTypeFragmentFragmentDoc}
${OrderFragmentFragmentDoc}
${DriverFragmentFragmentDoc}`;

/**
 * __useMemorizationsQuery__
 *
 * To run a query within a React component, call `useMemorizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemorizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemorizationsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      driverIds: // value for 'driverIds'
 *      dayOfWeeks: // value for 'dayOfWeeks'
 *   },
 * });
 */
export function useMemorizationsQuery(baseOptions: Apollo.QueryHookOptions<MemorizationsQuery, MemorizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemorizationsQuery, MemorizationsQueryVariables>(MemorizationsDocument, options);
      }
export function useMemorizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemorizationsQuery, MemorizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemorizationsQuery, MemorizationsQueryVariables>(MemorizationsDocument, options);
        }
export type MemorizationsQueryHookResult = ReturnType<typeof useMemorizationsQuery>;
export type MemorizationsLazyQueryHookResult = ReturnType<typeof useMemorizationsLazyQuery>;
export type MemorizationsQueryResult = Apollo.QueryResult<MemorizationsQuery, MemorizationsQueryVariables>;
export const UniqueStopDatesDocument = gql`
    query UniqueStopDates($courierId: ID!, $shipmentStatusFilter: [ShipmentStatus!], $maxShipmentDate: Date, $minExpectedCompletionDate: Date) {
  uniqueStopDates(
    courierId: $courierId
    shipmentStatusFilter: $shipmentStatusFilter
    maxShipmentDate: $maxShipmentDate
    minExpectedCompletionDate: $minExpectedCompletionDate
  )
}
    `;

/**
 * __useUniqueStopDatesQuery__
 *
 * To run a query within a React component, call `useUniqueStopDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniqueStopDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniqueStopDatesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      shipmentStatusFilter: // value for 'shipmentStatusFilter'
 *      maxShipmentDate: // value for 'maxShipmentDate'
 *      minExpectedCompletionDate: // value for 'minExpectedCompletionDate'
 *   },
 * });
 */
export function useUniqueStopDatesQuery(baseOptions: Apollo.QueryHookOptions<UniqueStopDatesQuery, UniqueStopDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniqueStopDatesQuery, UniqueStopDatesQueryVariables>(UniqueStopDatesDocument, options);
      }
export function useUniqueStopDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniqueStopDatesQuery, UniqueStopDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniqueStopDatesQuery, UniqueStopDatesQueryVariables>(UniqueStopDatesDocument, options);
        }
export type UniqueStopDatesQueryHookResult = ReturnType<typeof useUniqueStopDatesQuery>;
export type UniqueStopDatesLazyQueryHookResult = ReturnType<typeof useUniqueStopDatesLazyQuery>;
export type UniqueStopDatesQueryResult = Apollo.QueryResult<UniqueStopDatesQuery, UniqueStopDatesQueryVariables>;
export const ReplaceRouteDocument = gql`
    mutation ReplaceRoute($driverId: ID!, $newStopIds: [ID!]!, $shipmentDate: Date!, $replacedBy: String, $orderingAlgorithmType: OrderingAlgorithmType, $autoRoutedStopIds: [ID!], $dispatchSource: DispatchSource) {
  replaceRoute(
    driverId: $driverId
    newStopIds: $newStopIds
    shipmentDate: $shipmentDate
    replacedBy: $replacedBy
    orderingAlgorithmType: $orderingAlgorithmType
    autoRoutedStopIds: $autoRoutedStopIds
    dispatchSource: $dispatchSource
  ) {
    ...TaskFragment
  }
}
    ${TaskFragmentFragmentDoc}`;
export type ReplaceRouteMutationFn = Apollo.MutationFunction<ReplaceRouteMutation, ReplaceRouteMutationVariables>;

/**
 * __useReplaceRouteMutation__
 *
 * To run a mutation, you first call `useReplaceRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceRouteMutation, { data, loading, error }] = useReplaceRouteMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      newStopIds: // value for 'newStopIds'
 *      shipmentDate: // value for 'shipmentDate'
 *      replacedBy: // value for 'replacedBy'
 *      orderingAlgorithmType: // value for 'orderingAlgorithmType'
 *      autoRoutedStopIds: // value for 'autoRoutedStopIds'
 *      dispatchSource: // value for 'dispatchSource'
 *   },
 * });
 */
export function useReplaceRouteMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceRouteMutation, ReplaceRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceRouteMutation, ReplaceRouteMutationVariables>(ReplaceRouteDocument, options);
      }
export type ReplaceRouteMutationHookResult = ReturnType<typeof useReplaceRouteMutation>;
export type ReplaceRouteMutationResult = Apollo.MutationResult<ReplaceRouteMutation>;
export type ReplaceRouteMutationOptions = Apollo.BaseMutationOptions<ReplaceRouteMutation, ReplaceRouteMutationVariables>;
export const RefreshEtaStaleDocument = gql`
    mutation RefreshEtaStale($driverId: ID!) {
  refreshEtaStale(driverId: $driverId) {
    ...DriverFragment
  }
}
    ${DriverFragmentFragmentDoc}`;
export type RefreshEtaStaleMutationFn = Apollo.MutationFunction<RefreshEtaStaleMutation, RefreshEtaStaleMutationVariables>;

/**
 * __useRefreshEtaStaleMutation__
 *
 * To run a mutation, you first call `useRefreshEtaStaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshEtaStaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshEtaStaleMutation, { data, loading, error }] = useRefreshEtaStaleMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useRefreshEtaStaleMutation(baseOptions?: Apollo.MutationHookOptions<RefreshEtaStaleMutation, RefreshEtaStaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshEtaStaleMutation, RefreshEtaStaleMutationVariables>(RefreshEtaStaleDocument, options);
      }
export type RefreshEtaStaleMutationHookResult = ReturnType<typeof useRefreshEtaStaleMutation>;
export type RefreshEtaStaleMutationResult = Apollo.MutationResult<RefreshEtaStaleMutation>;
export type RefreshEtaStaleMutationOptions = Apollo.BaseMutationOptions<RefreshEtaStaleMutation, RefreshEtaStaleMutationVariables>;
export const PreviewEtaForRouteDocument = gql`
    query PreviewEtaForRoute($driverId: ID!, $stopIds: [ID!]!, $baseTime: Timestamp) {
  previewEtaForRoute(driverId: $driverId, stopIds: $stopIds, baseTime: $baseTime) {
    stopEtas {
      ...StopEtaFragment
    }
  }
}
    ${StopEtaFragmentFragmentDoc}`;

/**
 * __usePreviewEtaForRouteQuery__
 *
 * To run a query within a React component, call `usePreviewEtaForRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewEtaForRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewEtaForRouteQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      stopIds: // value for 'stopIds'
 *      baseTime: // value for 'baseTime'
 *   },
 * });
 */
export function usePreviewEtaForRouteQuery(baseOptions: Apollo.QueryHookOptions<PreviewEtaForRouteQuery, PreviewEtaForRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewEtaForRouteQuery, PreviewEtaForRouteQueryVariables>(PreviewEtaForRouteDocument, options);
      }
export function usePreviewEtaForRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewEtaForRouteQuery, PreviewEtaForRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewEtaForRouteQuery, PreviewEtaForRouteQueryVariables>(PreviewEtaForRouteDocument, options);
        }
export type PreviewEtaForRouteQueryHookResult = ReturnType<typeof usePreviewEtaForRouteQuery>;
export type PreviewEtaForRouteLazyQueryHookResult = ReturnType<typeof usePreviewEtaForRouteLazyQuery>;
export type PreviewEtaForRouteQueryResult = Apollo.QueryResult<PreviewEtaForRouteQuery, PreviewEtaForRouteQueryVariables>;
export const FullUpdateColumnVisibilityDocument = gql`
    mutation FullUpdateColumnVisibility($courierId: String!, $salesReportColumnIds: [SalesReportColumnId!], $driverReportColumnIds: [DriverReportColumnId!], $userOrEmployeeId: String!, $updatedBy: String!) {
  fullUpdateColumnVisibility(
    courierId: $courierId
    salesReportColumnIds: $salesReportColumnIds
    driverReportColumnIds: $driverReportColumnIds
    userOrEmployeeId: $userOrEmployeeId
    updatedBy: $updatedBy
  ) {
    ...VisibleColumnsConfigFragment
  }
}
    ${VisibleColumnsConfigFragmentFragmentDoc}`;
export type FullUpdateColumnVisibilityMutationFn = Apollo.MutationFunction<FullUpdateColumnVisibilityMutation, FullUpdateColumnVisibilityMutationVariables>;

/**
 * __useFullUpdateColumnVisibilityMutation__
 *
 * To run a mutation, you first call `useFullUpdateColumnVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateColumnVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateColumnVisibilityMutation, { data, loading, error }] = useFullUpdateColumnVisibilityMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      salesReportColumnIds: // value for 'salesReportColumnIds'
 *      driverReportColumnIds: // value for 'driverReportColumnIds'
 *      userOrEmployeeId: // value for 'userOrEmployeeId'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useFullUpdateColumnVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateColumnVisibilityMutation, FullUpdateColumnVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateColumnVisibilityMutation, FullUpdateColumnVisibilityMutationVariables>(FullUpdateColumnVisibilityDocument, options);
      }
export type FullUpdateColumnVisibilityMutationHookResult = ReturnType<typeof useFullUpdateColumnVisibilityMutation>;
export type FullUpdateColumnVisibilityMutationResult = Apollo.MutationResult<FullUpdateColumnVisibilityMutation>;
export type FullUpdateColumnVisibilityMutationOptions = Apollo.BaseMutationOptions<FullUpdateColumnVisibilityMutation, FullUpdateColumnVisibilityMutationVariables>;
export const GetVisibleColumnsDocument = gql`
    query GetVisibleColumns($courierId: String!, $userOrEmployeeId: String!) {
  getVisibleColumns(courierId: $courierId, userOrEmployeeId: $userOrEmployeeId) {
    ...VisibleColumnsConfigFragment
  }
}
    ${VisibleColumnsConfigFragmentFragmentDoc}`;

/**
 * __useGetVisibleColumnsQuery__
 *
 * To run a query within a React component, call `useGetVisibleColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisibleColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisibleColumnsQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      userOrEmployeeId: // value for 'userOrEmployeeId'
 *   },
 * });
 */
export function useGetVisibleColumnsQuery(baseOptions: Apollo.QueryHookOptions<GetVisibleColumnsQuery, GetVisibleColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisibleColumnsQuery, GetVisibleColumnsQueryVariables>(GetVisibleColumnsDocument, options);
      }
export function useGetVisibleColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisibleColumnsQuery, GetVisibleColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisibleColumnsQuery, GetVisibleColumnsQueryVariables>(GetVisibleColumnsDocument, options);
        }
export type GetVisibleColumnsQueryHookResult = ReturnType<typeof useGetVisibleColumnsQuery>;
export type GetVisibleColumnsLazyQueryHookResult = ReturnType<typeof useGetVisibleColumnsLazyQuery>;
export type GetVisibleColumnsQueryResult = Apollo.QueryResult<GetVisibleColumnsQuery, GetVisibleColumnsQueryVariables>;
export const SyncUserWithFirebaseDocument = gql`
    mutation syncUserWithFirebase($email: String!, $firebaseUid: String!) {
  syncUserWithFirebase(email: $email, firebaseUid: $firebaseUid) {
    user {
      ...CourieUserFragment
    }
    isEmployee
    error
    employeeId
  }
}
    ${CourieUserFragmentFragmentDoc}`;
export type SyncUserWithFirebaseMutationFn = Apollo.MutationFunction<SyncUserWithFirebaseMutation, SyncUserWithFirebaseMutationVariables>;

/**
 * __useSyncUserWithFirebaseMutation__
 *
 * To run a mutation, you first call `useSyncUserWithFirebaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncUserWithFirebaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncUserWithFirebaseMutation, { data, loading, error }] = useSyncUserWithFirebaseMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firebaseUid: // value for 'firebaseUid'
 *   },
 * });
 */
export function useSyncUserWithFirebaseMutation(baseOptions?: Apollo.MutationHookOptions<SyncUserWithFirebaseMutation, SyncUserWithFirebaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncUserWithFirebaseMutation, SyncUserWithFirebaseMutationVariables>(SyncUserWithFirebaseDocument, options);
      }
export type SyncUserWithFirebaseMutationHookResult = ReturnType<typeof useSyncUserWithFirebaseMutation>;
export type SyncUserWithFirebaseMutationResult = Apollo.MutationResult<SyncUserWithFirebaseMutation>;
export type SyncUserWithFirebaseMutationOptions = Apollo.BaseMutationOptions<SyncUserWithFirebaseMutation, SyncUserWithFirebaseMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($email: String!, $courierId: String!) {
  createUser(email: $email, courierId: $courierId) {
    ...CourieUserFragment
  }
}
    ${CourieUserFragmentFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const GetUsersDocument = gql`
    query GetUsers($courierId: ID!, $after: Int!, $limit: Int!) {
  users(courierId: $courierId, after: $after, limit: $limit) {
    edges {
      node {
        ...CourieUserFragment
      }
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${CourieUserFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const FullUpdateVehicleTypeDocument = gql`
    mutation fullUpdateVehicleType($courierId: ID!, $id: ID!, $name: String!, $shortCode: String!) {
  fullUpdateVehicleType(
    courierId: $courierId
    id: $id
    name: $name
    shortCode: $shortCode
  ) {
    ...VehicleTypeFragment
  }
}
    ${VehicleTypeFragmentFragmentDoc}`;
export type FullUpdateVehicleTypeMutationFn = Apollo.MutationFunction<FullUpdateVehicleTypeMutation, FullUpdateVehicleTypeMutationVariables>;

/**
 * __useFullUpdateVehicleTypeMutation__
 *
 * To run a mutation, you first call `useFullUpdateVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullUpdateVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullUpdateVehicleTypeMutation, { data, loading, error }] = useFullUpdateVehicleTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      shortCode: // value for 'shortCode'
 *   },
 * });
 */
export function useFullUpdateVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<FullUpdateVehicleTypeMutation, FullUpdateVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullUpdateVehicleTypeMutation, FullUpdateVehicleTypeMutationVariables>(FullUpdateVehicleTypeDocument, options);
      }
export type FullUpdateVehicleTypeMutationHookResult = ReturnType<typeof useFullUpdateVehicleTypeMutation>;
export type FullUpdateVehicleTypeMutationResult = Apollo.MutationResult<FullUpdateVehicleTypeMutation>;
export type FullUpdateVehicleTypeMutationOptions = Apollo.BaseMutationOptions<FullUpdateVehicleTypeMutation, FullUpdateVehicleTypeMutationVariables>;
export const CreateVehicleTypeDocument = gql`
    mutation createVehicleType($courierId: ID!, $name: String!, $shortCode: String!) {
  createVehicleType(courierId: $courierId, name: $name, shortCode: $shortCode) {
    ...VehicleTypeFragment
  }
}
    ${VehicleTypeFragmentFragmentDoc}`;
export type CreateVehicleTypeMutationFn = Apollo.MutationFunction<CreateVehicleTypeMutation, CreateVehicleTypeMutationVariables>;

/**
 * __useCreateVehicleTypeMutation__
 *
 * To run a mutation, you first call `useCreateVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehicleTypeMutation, { data, loading, error }] = useCreateVehicleTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      name: // value for 'name'
 *      shortCode: // value for 'shortCode'
 *   },
 * });
 */
export function useCreateVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateVehicleTypeMutation, CreateVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVehicleTypeMutation, CreateVehicleTypeMutationVariables>(CreateVehicleTypeDocument, options);
      }
export type CreateVehicleTypeMutationHookResult = ReturnType<typeof useCreateVehicleTypeMutation>;
export type CreateVehicleTypeMutationResult = Apollo.MutationResult<CreateVehicleTypeMutation>;
export type CreateVehicleTypeMutationOptions = Apollo.BaseMutationOptions<CreateVehicleTypeMutation, CreateVehicleTypeMutationVariables>;
export const DeleteVehicleTypeDocument = gql`
    mutation deleteVehicleType($courierId: ID!, $id: ID!) {
  deleteVehicleType(courierId: $courierId, id: $id) {
    ...VehicleTypeFragment
  }
}
    ${VehicleTypeFragmentFragmentDoc}`;
export type DeleteVehicleTypeMutationFn = Apollo.MutationFunction<DeleteVehicleTypeMutation, DeleteVehicleTypeMutationVariables>;

/**
 * __useDeleteVehicleTypeMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleTypeMutation, { data, loading, error }] = useDeleteVehicleTypeMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehicleTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVehicleTypeMutation, DeleteVehicleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVehicleTypeMutation, DeleteVehicleTypeMutationVariables>(DeleteVehicleTypeDocument, options);
      }
export type DeleteVehicleTypeMutationHookResult = ReturnType<typeof useDeleteVehicleTypeMutation>;
export type DeleteVehicleTypeMutationResult = Apollo.MutationResult<DeleteVehicleTypeMutation>;
export type DeleteVehicleTypeMutationOptions = Apollo.BaseMutationOptions<DeleteVehicleTypeMutation, DeleteVehicleTypeMutationVariables>;
export const CreateZonesDocument = gql`
    mutation CreateZones($courierId: ID!, $zones: [ZoneCreate!]!) {
  createZones(courierId: $courierId, zones: $zones) {
    ...ZoneFragment
  }
}
    ${ZoneFragmentFragmentDoc}`;
export type CreateZonesMutationFn = Apollo.MutationFunction<CreateZonesMutation, CreateZonesMutationVariables>;

/**
 * __useCreateZonesMutation__
 *
 * To run a mutation, you first call `useCreateZonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZonesMutation, { data, loading, error }] = useCreateZonesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      zones: // value for 'zones'
 *   },
 * });
 */
export function useCreateZonesMutation(baseOptions?: Apollo.MutationHookOptions<CreateZonesMutation, CreateZonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZonesMutation, CreateZonesMutationVariables>(CreateZonesDocument, options);
      }
export type CreateZonesMutationHookResult = ReturnType<typeof useCreateZonesMutation>;
export type CreateZonesMutationResult = Apollo.MutationResult<CreateZonesMutation>;
export type CreateZonesMutationOptions = Apollo.BaseMutationOptions<CreateZonesMutation, CreateZonesMutationVariables>;
export const UpdateZonesDocument = gql`
    mutation UpdateZones($courierId: ID!, $zones: [ZoneUpdate!]!) {
  updateZones(courierId: $courierId, zones: $zones) {
    ...ZoneFragment
  }
}
    ${ZoneFragmentFragmentDoc}`;
export type UpdateZonesMutationFn = Apollo.MutationFunction<UpdateZonesMutation, UpdateZonesMutationVariables>;

/**
 * __useUpdateZonesMutation__
 *
 * To run a mutation, you first call `useUpdateZonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZonesMutation, { data, loading, error }] = useUpdateZonesMutation({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      zones: // value for 'zones'
 *   },
 * });
 */
export function useUpdateZonesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZonesMutation, UpdateZonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateZonesMutation, UpdateZonesMutationVariables>(UpdateZonesDocument, options);
      }
export type UpdateZonesMutationHookResult = ReturnType<typeof useUpdateZonesMutation>;
export type UpdateZonesMutationResult = Apollo.MutationResult<UpdateZonesMutation>;
export type UpdateZonesMutationOptions = Apollo.BaseMutationOptions<UpdateZonesMutation, UpdateZonesMutationVariables>;
export const ZonesDocument = gql`
    query Zones($courierId: ID!, $type: ZoneType!) {
  zones(courierId: $courierId, type: $type) {
    ...ZoneFragment
  }
}
    ${ZoneFragmentFragmentDoc}`;

/**
 * __useZonesQuery__
 *
 * To run a query within a React component, call `useZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesQuery({
 *   variables: {
 *      courierId: // value for 'courierId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useZonesQuery(baseOptions: Apollo.QueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, options);
      }
export function useZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, options);
        }
export type ZonesQueryHookResult = ReturnType<typeof useZonesQuery>;
export type ZonesLazyQueryHookResult = ReturnType<typeof useZonesLazyQuery>;
export type ZonesQueryResult = Apollo.QueryResult<ZonesQuery, ZonesQueryVariables>;